function Dm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var uf = { exports: {} }, oe = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var uo = Symbol.for("react.element"), zm = Symbol.for("react.portal"), Mm = Symbol.for("react.fragment"), Um = Symbol.for("react.strict_mode"), Vm = Symbol.for("react.profiler"), $m = Symbol.for("react.provider"), Bm = Symbol.for("react.context"), Hm = Symbol.for("react.forward_ref"), Wm = Symbol.for("react.suspense"), Zm = Symbol.for("react.memo"), Qm = Symbol.for("react.lazy"), wc = Symbol.iterator;
function qm(e) {
  return e === null || typeof e != "object" ? null : (e = wc && e[wc] || e["@@iterator"], typeof e == "function" ? e : null);
}
var cf = { isMounted: function() {
  return !1;
}, enqueueForceUpdate: function() {
}, enqueueReplaceState: function() {
}, enqueueSetState: function() {
} }, df = Object.assign, ff = {};
function Xr(e, t, n) {
  this.props = e, this.context = t, this.refs = ff, this.updater = n || cf;
}
Xr.prototype.isReactComponent = {};
Xr.prototype.setState = function(e, t) {
  if (typeof e != "object" && typeof e != "function" && e != null) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
  this.updater.enqueueSetState(this, e, t, "setState");
};
Xr.prototype.forceUpdate = function(e) {
  this.updater.enqueueForceUpdate(this, e, "forceUpdate");
};
function pf() {
}
pf.prototype = Xr.prototype;
function pu(e, t, n) {
  this.props = e, this.context = t, this.refs = ff, this.updater = n || cf;
}
var hu = pu.prototype = new pf();
hu.constructor = pu;
df(hu, Xr.prototype);
hu.isPureReactComponent = !0;
var xc = Array.isArray, hf = Object.prototype.hasOwnProperty, mu = { current: null }, mf = { key: !0, ref: !0, __self: !0, __source: !0 };
function gf(e, t, n) {
  var r, i = {}, o = null, s = null;
  if (t != null) for (r in t.ref !== void 0 && (s = t.ref), t.key !== void 0 && (o = "" + t.key), t) hf.call(t, r) && !mf.hasOwnProperty(r) && (i[r] = t[r]);
  var a = arguments.length - 2;
  if (a === 1) i.children = n;
  else if (1 < a) {
    for (var l = Array(a), u = 0; u < a; u++) l[u] = arguments[u + 2];
    i.children = l;
  }
  if (e && e.defaultProps) for (r in a = e.defaultProps, a) i[r] === void 0 && (i[r] = a[r]);
  return { $$typeof: uo, type: e, key: o, ref: s, props: i, _owner: mu.current };
}
function Jm(e, t) {
  return { $$typeof: uo, type: e.type, key: t, ref: e.ref, props: e.props, _owner: e._owner };
}
function gu(e) {
  return typeof e == "object" && e !== null && e.$$typeof === uo;
}
function Km(e) {
  var t = { "=": "=0", ":": "=2" };
  return "$" + e.replace(/[=:]/g, function(n) {
    return t[n];
  });
}
var bc = /\/+/g;
function Sa(e, t) {
  return typeof e == "object" && e !== null && e.key != null ? Km("" + e.key) : t.toString(36);
}
function Uo(e, t, n, r, i) {
  var o = typeof e;
  (o === "undefined" || o === "boolean") && (e = null);
  var s = !1;
  if (e === null) s = !0;
  else switch (o) {
    case "string":
    case "number":
      s = !0;
      break;
    case "object":
      switch (e.$$typeof) {
        case uo:
        case zm:
          s = !0;
      }
  }
  if (s) return s = e, i = i(s), e = r === "" ? "." + Sa(s, 0) : r, xc(i) ? (n = "", e != null && (n = e.replace(bc, "$&/") + "/"), Uo(i, t, n, "", function(u) {
    return u;
  })) : i != null && (gu(i) && (i = Jm(i, n + (!i.key || s && s.key === i.key ? "" : ("" + i.key).replace(bc, "$&/") + "/") + e)), t.push(i)), 1;
  if (s = 0, r = r === "" ? "." : r + ":", xc(e)) for (var a = 0; a < e.length; a++) {
    o = e[a];
    var l = r + Sa(o, a);
    s += Uo(o, t, n, l, i);
  }
  else if (l = qm(e), typeof l == "function") for (e = l.call(e), a = 0; !(o = e.next()).done; ) o = o.value, l = r + Sa(o, a++), s += Uo(o, t, n, l, i);
  else if (o === "object") throw t = String(e), Error("Objects are not valid as a React child (found: " + (t === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : t) + "). If you meant to render a collection of children, use an array instead.");
  return s;
}
function ko(e, t, n) {
  if (e == null) return e;
  var r = [], i = 0;
  return Uo(e, r, "", "", function(o) {
    return t.call(n, o, i++);
  }), r;
}
function Gm(e) {
  if (e._status === -1) {
    var t = e._result;
    t = t(), t.then(function(n) {
      (e._status === 0 || e._status === -1) && (e._status = 1, e._result = n);
    }, function(n) {
      (e._status === 0 || e._status === -1) && (e._status = 2, e._result = n);
    }), e._status === -1 && (e._status = 0, e._result = t);
  }
  if (e._status === 1) return e._result.default;
  throw e._result;
}
var st = { current: null }, Vo = { transition: null }, Ym = { ReactCurrentDispatcher: st, ReactCurrentBatchConfig: Vo, ReactCurrentOwner: mu };
function yf() {
  throw Error("act(...) is not supported in production builds of React.");
}
oe.Children = { map: ko, forEach: function(e, t, n) {
  ko(e, function() {
    t.apply(this, arguments);
  }, n);
}, count: function(e) {
  var t = 0;
  return ko(e, function() {
    t++;
  }), t;
}, toArray: function(e) {
  return ko(e, function(t) {
    return t;
  }) || [];
}, only: function(e) {
  if (!gu(e)) throw Error("React.Children.only expected to receive a single React element child.");
  return e;
} };
oe.Component = Xr;
oe.Fragment = Mm;
oe.Profiler = Vm;
oe.PureComponent = pu;
oe.StrictMode = Um;
oe.Suspense = Wm;
oe.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Ym;
oe.act = yf;
oe.cloneElement = function(e, t, n) {
  if (e == null) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + e + ".");
  var r = df({}, e.props), i = e.key, o = e.ref, s = e._owner;
  if (t != null) {
    if (t.ref !== void 0 && (o = t.ref, s = mu.current), t.key !== void 0 && (i = "" + t.key), e.type && e.type.defaultProps) var a = e.type.defaultProps;
    for (l in t) hf.call(t, l) && !mf.hasOwnProperty(l) && (r[l] = t[l] === void 0 && a !== void 0 ? a[l] : t[l]);
  }
  var l = arguments.length - 2;
  if (l === 1) r.children = n;
  else if (1 < l) {
    a = Array(l);
    for (var u = 0; u < l; u++) a[u] = arguments[u + 2];
    r.children = a;
  }
  return { $$typeof: uo, type: e.type, key: i, ref: o, props: r, _owner: s };
};
oe.createContext = function(e) {
  return e = { $$typeof: Bm, _currentValue: e, _currentValue2: e, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, e.Provider = { $$typeof: $m, _context: e }, e.Consumer = e;
};
oe.createElement = gf;
oe.createFactory = function(e) {
  var t = gf.bind(null, e);
  return t.type = e, t;
};
oe.createRef = function() {
  return { current: null };
};
oe.forwardRef = function(e) {
  return { $$typeof: Hm, render: e };
};
oe.isValidElement = gu;
oe.lazy = function(e) {
  return { $$typeof: Qm, _payload: { _status: -1, _result: e }, _init: Gm };
};
oe.memo = function(e, t) {
  return { $$typeof: Zm, type: e, compare: t === void 0 ? null : t };
};
oe.startTransition = function(e) {
  var t = Vo.transition;
  Vo.transition = {};
  try {
    e();
  } finally {
    Vo.transition = t;
  }
};
oe.unstable_act = yf;
oe.useCallback = function(e, t) {
  return st.current.useCallback(e, t);
};
oe.useContext = function(e) {
  return st.current.useContext(e);
};
oe.useDebugValue = function() {
};
oe.useDeferredValue = function(e) {
  return st.current.useDeferredValue(e);
};
oe.useEffect = function(e, t) {
  return st.current.useEffect(e, t);
};
oe.useId = function() {
  return st.current.useId();
};
oe.useImperativeHandle = function(e, t, n) {
  return st.current.useImperativeHandle(e, t, n);
};
oe.useInsertionEffect = function(e, t) {
  return st.current.useInsertionEffect(e, t);
};
oe.useLayoutEffect = function(e, t) {
  return st.current.useLayoutEffect(e, t);
};
oe.useMemo = function(e, t) {
  return st.current.useMemo(e, t);
};
oe.useReducer = function(e, t, n) {
  return st.current.useReducer(e, t, n);
};
oe.useRef = function(e) {
  return st.current.useRef(e);
};
oe.useState = function(e) {
  return st.current.useState(e);
};
oe.useSyncExternalStore = function(e, t, n) {
  return st.current.useSyncExternalStore(e, t, n);
};
oe.useTransition = function() {
  return st.current.useTransition();
};
oe.version = "18.3.1";
uf.exports = oe;
var S = uf.exports;
const ue = /* @__PURE__ */ Dm(S);
var rl = {}, vf = { exports: {} }, _t = {}, wf = { exports: {} }, xf = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
(function(e) {
  function t(F, Q) {
    var J = F.length;
    F.push(Q);
    e: for (; 0 < J; ) {
      var re = J - 1 >>> 1, me = F[re];
      if (0 < i(me, Q)) F[re] = Q, F[J] = me, J = re;
      else break e;
    }
  }
  function n(F) {
    return F.length === 0 ? null : F[0];
  }
  function r(F) {
    if (F.length === 0) return null;
    var Q = F[0], J = F.pop();
    if (J !== Q) {
      F[0] = J;
      e: for (var re = 0, me = F.length, Pt = me >>> 1; re < Pt; ) {
        var Xe = 2 * (re + 1) - 1, jt = F[Xe], Qe = Xe + 1, Et = F[Qe];
        if (0 > i(jt, J)) Qe < me && 0 > i(Et, jt) ? (F[re] = Et, F[Qe] = J, re = Qe) : (F[re] = jt, F[Xe] = J, re = Xe);
        else if (Qe < me && 0 > i(Et, J)) F[re] = Et, F[Qe] = J, re = Qe;
        else break e;
      }
    }
    return Q;
  }
  function i(F, Q) {
    var J = F.sortIndex - Q.sortIndex;
    return J !== 0 ? J : F.id - Q.id;
  }
  if (typeof performance == "object" && typeof performance.now == "function") {
    var o = performance;
    e.unstable_now = function() {
      return o.now();
    };
  } else {
    var s = Date, a = s.now();
    e.unstable_now = function() {
      return s.now() - a;
    };
  }
  var l = [], u = [], c = 1, p = null, h = 3, x = !1, v = !1, w = !1, _ = typeof setTimeout == "function" ? setTimeout : null, m = typeof clearTimeout == "function" ? clearTimeout : null, d = typeof setImmediate < "u" ? setImmediate : null;
  typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
  function y(F) {
    for (var Q = n(u); Q !== null; ) {
      if (Q.callback === null) r(u);
      else if (Q.startTime <= F) r(u), Q.sortIndex = Q.expirationTime, t(l, Q);
      else break;
      Q = n(u);
    }
  }
  function b(F) {
    if (w = !1, y(F), !v) if (n(l) !== null) v = !0, fe(f);
    else {
      var Q = n(u);
      Q !== null && ke(b, Q.startTime - F);
    }
  }
  function f(F, Q) {
    v = !1, w && (w = !1, m(R), R = -1), x = !0;
    var J = h;
    try {
      for (y(Q), p = n(l); p !== null && (!(p.expirationTime > Q) || F && !U()); ) {
        var re = p.callback;
        if (typeof re == "function") {
          p.callback = null, h = p.priorityLevel;
          var me = re(p.expirationTime <= Q);
          Q = e.unstable_now(), typeof me == "function" ? p.callback = me : p === n(l) && r(l), y(Q);
        } else r(l);
        p = n(l);
      }
      if (p !== null) var Pt = !0;
      else {
        var Xe = n(u);
        Xe !== null && ke(b, Xe.startTime - Q), Pt = !1;
      }
      return Pt;
    } finally {
      p = null, h = J, x = !1;
    }
  }
  var A = !1, N = null, R = -1, j = 5, T = -1;
  function U() {
    return !(e.unstable_now() - T < j);
  }
  function z() {
    if (N !== null) {
      var F = e.unstable_now();
      T = F;
      var Q = !0;
      try {
        Q = N(!0, F);
      } finally {
        Q ? K() : (A = !1, N = null);
      }
    } else A = !1;
  }
  var K;
  if (typeof d == "function") K = function() {
    d(z);
  };
  else if (typeof MessageChannel < "u") {
    var ne = new MessageChannel(), le = ne.port2;
    ne.port1.onmessage = z, K = function() {
      le.postMessage(null);
    };
  } else K = function() {
    _(z, 0);
  };
  function fe(F) {
    N = F, A || (A = !0, K());
  }
  function ke(F, Q) {
    R = _(function() {
      F(e.unstable_now());
    }, Q);
  }
  e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(F) {
    F.callback = null;
  }, e.unstable_continueExecution = function() {
    v || x || (v = !0, fe(f));
  }, e.unstable_forceFrameRate = function(F) {
    0 > F || 125 < F ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : j = 0 < F ? Math.floor(1e3 / F) : 5;
  }, e.unstable_getCurrentPriorityLevel = function() {
    return h;
  }, e.unstable_getFirstCallbackNode = function() {
    return n(l);
  }, e.unstable_next = function(F) {
    switch (h) {
      case 1:
      case 2:
      case 3:
        var Q = 3;
        break;
      default:
        Q = h;
    }
    var J = h;
    h = Q;
    try {
      return F();
    } finally {
      h = J;
    }
  }, e.unstable_pauseExecution = function() {
  }, e.unstable_requestPaint = function() {
  }, e.unstable_runWithPriority = function(F, Q) {
    switch (F) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;
      default:
        F = 3;
    }
    var J = h;
    h = F;
    try {
      return Q();
    } finally {
      h = J;
    }
  }, e.unstable_scheduleCallback = function(F, Q, J) {
    var re = e.unstable_now();
    switch (typeof J == "object" && J !== null ? (J = J.delay, J = typeof J == "number" && 0 < J ? re + J : re) : J = re, F) {
      case 1:
        var me = -1;
        break;
      case 2:
        me = 250;
        break;
      case 5:
        me = 1073741823;
        break;
      case 4:
        me = 1e4;
        break;
      default:
        me = 5e3;
    }
    return me = J + me, F = { id: c++, callback: Q, priorityLevel: F, startTime: J, expirationTime: me, sortIndex: -1 }, J > re ? (F.sortIndex = J, t(u, F), n(l) === null && F === n(u) && (w ? (m(R), R = -1) : w = !0, ke(b, J - re))) : (F.sortIndex = me, t(l, F), v || x || (v = !0, fe(f))), F;
  }, e.unstable_shouldYield = U, e.unstable_wrapCallback = function(F) {
    var Q = h;
    return function() {
      var J = h;
      h = Q;
      try {
        return F.apply(this, arguments);
      } finally {
        h = J;
      }
    };
  };
})(xf);
wf.exports = xf;
var Xm = wf.exports;
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var eg = S, bt = Xm;
function P(e) {
  for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var bf = /* @__PURE__ */ new Set(), $i = {};
function hr(e, t) {
  $r(e, t), $r(e + "Capture", t);
}
function $r(e, t) {
  for ($i[e] = t, e = 0; e < t.length; e++) bf.add(t[e]);
}
var pn = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), il = Object.prototype.hasOwnProperty, tg = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, _c = {}, kc = {};
function ng(e) {
  return il.call(kc, e) ? !0 : il.call(_c, e) ? !1 : tg.test(e) ? kc[e] = !0 : (_c[e] = !0, !1);
}
function rg(e, t, n, r) {
  if (n !== null && n.type === 0) return !1;
  switch (typeof t) {
    case "function":
    case "symbol":
      return !0;
    case "boolean":
      return r ? !1 : n !== null ? !n.acceptsBooleans : (e = e.toLowerCase().slice(0, 5), e !== "data-" && e !== "aria-");
    default:
      return !1;
  }
}
function ig(e, t, n, r) {
  if (t === null || typeof t > "u" || rg(e, t, n, r)) return !0;
  if (r) return !1;
  if (n !== null) switch (n.type) {
    case 3:
      return !t;
    case 4:
      return t === !1;
    case 5:
      return isNaN(t);
    case 6:
      return isNaN(t) || 1 > t;
  }
  return !1;
}
function at(e, t, n, r, i, o, s) {
  this.acceptsBooleans = t === 2 || t === 3 || t === 4, this.attributeName = r, this.attributeNamespace = i, this.mustUseProperty = n, this.propertyName = e, this.type = t, this.sanitizeURL = o, this.removeEmptyString = s;
}
var Ze = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(e) {
  Ze[e] = new at(e, 0, !1, e, null, !1, !1);
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(e) {
  var t = e[0];
  Ze[t] = new at(t, 1, !1, e[1], null, !1, !1);
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function(e) {
  Ze[e] = new at(e, 2, !1, e.toLowerCase(), null, !1, !1);
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(e) {
  Ze[e] = new at(e, 2, !1, e, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(e) {
  Ze[e] = new at(e, 3, !1, e.toLowerCase(), null, !1, !1);
});
["checked", "multiple", "muted", "selected"].forEach(function(e) {
  Ze[e] = new at(e, 3, !0, e, null, !1, !1);
});
["capture", "download"].forEach(function(e) {
  Ze[e] = new at(e, 4, !1, e, null, !1, !1);
});
["cols", "rows", "size", "span"].forEach(function(e) {
  Ze[e] = new at(e, 6, !1, e, null, !1, !1);
});
["rowSpan", "start"].forEach(function(e) {
  Ze[e] = new at(e, 5, !1, e.toLowerCase(), null, !1, !1);
});
var yu = /[\-:]([a-z])/g;
function vu(e) {
  return e[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(e) {
  var t = e.replace(
    yu,
    vu
  );
  Ze[t] = new at(t, 1, !1, e, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(e) {
  var t = e.replace(yu, vu);
  Ze[t] = new at(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1, !1);
});
["xml:base", "xml:lang", "xml:space"].forEach(function(e) {
  var t = e.replace(yu, vu);
  Ze[t] = new at(t, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
["tabIndex", "crossOrigin"].forEach(function(e) {
  Ze[e] = new at(e, 1, !1, e.toLowerCase(), null, !1, !1);
});
Ze.xlinkHref = new at("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
["src", "href", "action", "formAction"].forEach(function(e) {
  Ze[e] = new at(e, 1, !1, e.toLowerCase(), null, !0, !0);
});
function wu(e, t, n, r) {
  var i = Ze.hasOwnProperty(t) ? Ze[t] : null;
  (i !== null ? i.type !== 0 : r || !(2 < t.length) || t[0] !== "o" && t[0] !== "O" || t[1] !== "n" && t[1] !== "N") && (ig(t, n, i, r) && (n = null), r || i === null ? ng(t) && (n === null ? e.removeAttribute(t) : e.setAttribute(t, "" + n)) : i.mustUseProperty ? e[i.propertyName] = n === null ? i.type === 3 ? !1 : "" : n : (t = i.attributeName, r = i.attributeNamespace, n === null ? e.removeAttribute(t) : (i = i.type, n = i === 3 || i === 4 && n === !0 ? "" : "" + n, r ? e.setAttributeNS(r, t, n) : e.setAttribute(t, n))));
}
var wn = eg.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, So = Symbol.for("react.element"), _r = Symbol.for("react.portal"), kr = Symbol.for("react.fragment"), xu = Symbol.for("react.strict_mode"), ol = Symbol.for("react.profiler"), _f = Symbol.for("react.provider"), kf = Symbol.for("react.context"), bu = Symbol.for("react.forward_ref"), sl = Symbol.for("react.suspense"), al = Symbol.for("react.suspense_list"), _u = Symbol.for("react.memo"), Cn = Symbol.for("react.lazy"), Sf = Symbol.for("react.offscreen"), Sc = Symbol.iterator;
function ai(e) {
  return e === null || typeof e != "object" ? null : (e = Sc && e[Sc] || e["@@iterator"], typeof e == "function" ? e : null);
}
var Ce = Object.assign, Ea;
function xi(e) {
  if (Ea === void 0) try {
    throw Error();
  } catch (n) {
    var t = n.stack.trim().match(/\n( *(at )?)/);
    Ea = t && t[1] || "";
  }
  return `
` + Ea + e;
}
var Ca = !1;
function Na(e, t) {
  if (!e || Ca) return "";
  Ca = !0;
  var n = Error.prepareStackTrace;
  Error.prepareStackTrace = void 0;
  try {
    if (t) if (t = function() {
      throw Error();
    }, Object.defineProperty(t.prototype, "props", { set: function() {
      throw Error();
    } }), typeof Reflect == "object" && Reflect.construct) {
      try {
        Reflect.construct(t, []);
      } catch (u) {
        var r = u;
      }
      Reflect.construct(e, [], t);
    } else {
      try {
        t.call();
      } catch (u) {
        r = u;
      }
      e.call(t.prototype);
    }
    else {
      try {
        throw Error();
      } catch (u) {
        r = u;
      }
      e();
    }
  } catch (u) {
    if (u && r && typeof u.stack == "string") {
      for (var i = u.stack.split(`
`), o = r.stack.split(`
`), s = i.length - 1, a = o.length - 1; 1 <= s && 0 <= a && i[s] !== o[a]; ) a--;
      for (; 1 <= s && 0 <= a; s--, a--) if (i[s] !== o[a]) {
        if (s !== 1 || a !== 1)
          do
            if (s--, a--, 0 > a || i[s] !== o[a]) {
              var l = `
` + i[s].replace(" at new ", " at ");
              return e.displayName && l.includes("<anonymous>") && (l = l.replace("<anonymous>", e.displayName)), l;
            }
          while (1 <= s && 0 <= a);
        break;
      }
    }
  } finally {
    Ca = !1, Error.prepareStackTrace = n;
  }
  return (e = e ? e.displayName || e.name : "") ? xi(e) : "";
}
function og(e) {
  switch (e.tag) {
    case 5:
      return xi(e.type);
    case 16:
      return xi("Lazy");
    case 13:
      return xi("Suspense");
    case 19:
      return xi("SuspenseList");
    case 0:
    case 2:
    case 15:
      return e = Na(e.type, !1), e;
    case 11:
      return e = Na(e.type.render, !1), e;
    case 1:
      return e = Na(e.type, !0), e;
    default:
      return "";
  }
}
function ll(e) {
  if (e == null) return null;
  if (typeof e == "function") return e.displayName || e.name || null;
  if (typeof e == "string") return e;
  switch (e) {
    case kr:
      return "Fragment";
    case _r:
      return "Portal";
    case ol:
      return "Profiler";
    case xu:
      return "StrictMode";
    case sl:
      return "Suspense";
    case al:
      return "SuspenseList";
  }
  if (typeof e == "object") switch (e.$$typeof) {
    case kf:
      return (e.displayName || "Context") + ".Consumer";
    case _f:
      return (e._context.displayName || "Context") + ".Provider";
    case bu:
      var t = e.render;
      return e = e.displayName, e || (e = t.displayName || t.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
    case _u:
      return t = e.displayName || null, t !== null ? t : ll(e.type) || "Memo";
    case Cn:
      t = e._payload, e = e._init;
      try {
        return ll(e(t));
      } catch {
      }
  }
  return null;
}
function sg(e) {
  var t = e.type;
  switch (e.tag) {
    case 24:
      return "Cache";
    case 9:
      return (t.displayName || "Context") + ".Consumer";
    case 10:
      return (t._context.displayName || "Context") + ".Provider";
    case 18:
      return "DehydratedFragment";
    case 11:
      return e = t.render, e = e.displayName || e.name || "", t.displayName || (e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef");
    case 7:
      return "Fragment";
    case 5:
      return t;
    case 4:
      return "Portal";
    case 3:
      return "Root";
    case 6:
      return "Text";
    case 16:
      return ll(t);
    case 8:
      return t === xu ? "StrictMode" : "Mode";
    case 22:
      return "Offscreen";
    case 12:
      return "Profiler";
    case 21:
      return "Scope";
    case 13:
      return "Suspense";
    case 19:
      return "SuspenseList";
    case 25:
      return "TracingMarker";
    case 1:
    case 0:
    case 17:
    case 2:
    case 14:
    case 15:
      if (typeof t == "function") return t.displayName || t.name || null;
      if (typeof t == "string") return t;
  }
  return null;
}
function Vn(e) {
  switch (typeof e) {
    case "boolean":
    case "number":
    case "string":
    case "undefined":
      return e;
    case "object":
      return e;
    default:
      return "";
  }
}
function Ef(e) {
  var t = e.type;
  return (e = e.nodeName) && e.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
}
function ag(e) {
  var t = Ef(e) ? "checked" : "value", n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t), r = "" + e[t];
  if (!e.hasOwnProperty(t) && typeof n < "u" && typeof n.get == "function" && typeof n.set == "function") {
    var i = n.get, o = n.set;
    return Object.defineProperty(e, t, { configurable: !0, get: function() {
      return i.call(this);
    }, set: function(s) {
      r = "" + s, o.call(this, s);
    } }), Object.defineProperty(e, t, { enumerable: n.enumerable }), { getValue: function() {
      return r;
    }, setValue: function(s) {
      r = "" + s;
    }, stopTracking: function() {
      e._valueTracker = null, delete e[t];
    } };
  }
}
function Eo(e) {
  e._valueTracker || (e._valueTracker = ag(e));
}
function Cf(e) {
  if (!e) return !1;
  var t = e._valueTracker;
  if (!t) return !0;
  var n = t.getValue(), r = "";
  return e && (r = Ef(e) ? e.checked ? "true" : "false" : e.value), e = r, e !== n ? (t.setValue(e), !0) : !1;
}
function ns(e) {
  if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u") return null;
  try {
    return e.activeElement || e.body;
  } catch {
    return e.body;
  }
}
function ul(e, t) {
  var n = t.checked;
  return Ce({}, t, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: n ?? e._wrapperState.initialChecked });
}
function Ec(e, t) {
  var n = t.defaultValue == null ? "" : t.defaultValue, r = t.checked != null ? t.checked : t.defaultChecked;
  n = Vn(t.value != null ? t.value : n), e._wrapperState = { initialChecked: r, initialValue: n, controlled: t.type === "checkbox" || t.type === "radio" ? t.checked != null : t.value != null };
}
function Nf(e, t) {
  t = t.checked, t != null && wu(e, "checked", t, !1);
}
function cl(e, t) {
  Nf(e, t);
  var n = Vn(t.value), r = t.type;
  if (n != null) r === "number" ? (n === 0 && e.value === "" || e.value != n) && (e.value = "" + n) : e.value !== "" + n && (e.value = "" + n);
  else if (r === "submit" || r === "reset") {
    e.removeAttribute("value");
    return;
  }
  t.hasOwnProperty("value") ? dl(e, t.type, n) : t.hasOwnProperty("defaultValue") && dl(e, t.type, Vn(t.defaultValue)), t.checked == null && t.defaultChecked != null && (e.defaultChecked = !!t.defaultChecked);
}
function Cc(e, t, n) {
  if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
    var r = t.type;
    if (!(r !== "submit" && r !== "reset" || t.value !== void 0 && t.value !== null)) return;
    t = "" + e._wrapperState.initialValue, n || t === e.value || (e.value = t), e.defaultValue = t;
  }
  n = e.name, n !== "" && (e.name = ""), e.defaultChecked = !!e._wrapperState.initialChecked, n !== "" && (e.name = n);
}
function dl(e, t, n) {
  (t !== "number" || ns(e.ownerDocument) !== e) && (n == null ? e.defaultValue = "" + e._wrapperState.initialValue : e.defaultValue !== "" + n && (e.defaultValue = "" + n));
}
var bi = Array.isArray;
function jr(e, t, n, r) {
  if (e = e.options, t) {
    t = {};
    for (var i = 0; i < n.length; i++) t["$" + n[i]] = !0;
    for (n = 0; n < e.length; n++) i = t.hasOwnProperty("$" + e[n].value), e[n].selected !== i && (e[n].selected = i), i && r && (e[n].defaultSelected = !0);
  } else {
    for (n = "" + Vn(n), t = null, i = 0; i < e.length; i++) {
      if (e[i].value === n) {
        e[i].selected = !0, r && (e[i].defaultSelected = !0);
        return;
      }
      t !== null || e[i].disabled || (t = e[i]);
    }
    t !== null && (t.selected = !0);
  }
}
function fl(e, t) {
  if (t.dangerouslySetInnerHTML != null) throw Error(P(91));
  return Ce({}, t, { value: void 0, defaultValue: void 0, children: "" + e._wrapperState.initialValue });
}
function Nc(e, t) {
  var n = t.value;
  if (n == null) {
    if (n = t.children, t = t.defaultValue, n != null) {
      if (t != null) throw Error(P(92));
      if (bi(n)) {
        if (1 < n.length) throw Error(P(93));
        n = n[0];
      }
      t = n;
    }
    t == null && (t = ""), n = t;
  }
  e._wrapperState = { initialValue: Vn(n) };
}
function Tf(e, t) {
  var n = Vn(t.value), r = Vn(t.defaultValue);
  n != null && (n = "" + n, n !== e.value && (e.value = n), t.defaultValue == null && e.defaultValue !== n && (e.defaultValue = n)), r != null && (e.defaultValue = "" + r);
}
function Tc(e) {
  var t = e.textContent;
  t === e._wrapperState.initialValue && t !== "" && t !== null && (e.value = t);
}
function Rf(e) {
  switch (e) {
    case "svg":
      return "http://www.w3.org/2000/svg";
    case "math":
      return "http://www.w3.org/1998/Math/MathML";
    default:
      return "http://www.w3.org/1999/xhtml";
  }
}
function pl(e, t) {
  return e == null || e === "http://www.w3.org/1999/xhtml" ? Rf(t) : e === "http://www.w3.org/2000/svg" && t === "foreignObject" ? "http://www.w3.org/1999/xhtml" : e;
}
var Co, If = function(e) {
  return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(t, n, r, i) {
    MSApp.execUnsafeLocalFunction(function() {
      return e(t, n, r, i);
    });
  } : e;
}(function(e, t) {
  if (e.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in e) e.innerHTML = t;
  else {
    for (Co = Co || document.createElement("div"), Co.innerHTML = "<svg>" + t.valueOf().toString() + "</svg>", t = Co.firstChild; e.firstChild; ) e.removeChild(e.firstChild);
    for (; t.firstChild; ) e.appendChild(t.firstChild);
  }
});
function Bi(e, t) {
  if (t) {
    var n = e.firstChild;
    if (n && n === e.lastChild && n.nodeType === 3) {
      n.nodeValue = t;
      return;
    }
  }
  e.textContent = t;
}
var Ni = {
  animationIterationCount: !0,
  aspectRatio: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  columns: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridArea: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
}, lg = ["Webkit", "ms", "Moz", "O"];
Object.keys(Ni).forEach(function(e) {
  lg.forEach(function(t) {
    t = t + e.charAt(0).toUpperCase() + e.substring(1), Ni[t] = Ni[e];
  });
});
function Af(e, t, n) {
  return t == null || typeof t == "boolean" || t === "" ? "" : n || typeof t != "number" || t === 0 || Ni.hasOwnProperty(e) && Ni[e] ? ("" + t).trim() : t + "px";
}
function Of(e, t) {
  e = e.style;
  for (var n in t) if (t.hasOwnProperty(n)) {
    var r = n.indexOf("--") === 0, i = Af(n, t[n], r);
    n === "float" && (n = "cssFloat"), r ? e.setProperty(n, i) : e[n] = i;
  }
}
var ug = Ce({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
function hl(e, t) {
  if (t) {
    if (ug[e] && (t.children != null || t.dangerouslySetInnerHTML != null)) throw Error(P(137, e));
    if (t.dangerouslySetInnerHTML != null) {
      if (t.children != null) throw Error(P(60));
      if (typeof t.dangerouslySetInnerHTML != "object" || !("__html" in t.dangerouslySetInnerHTML)) throw Error(P(61));
    }
    if (t.style != null && typeof t.style != "object") throw Error(P(62));
  }
}
function ml(e, t) {
  if (e.indexOf("-") === -1) return typeof t.is == "string";
  switch (e) {
    case "annotation-xml":
    case "color-profile":
    case "font-face":
    case "font-face-src":
    case "font-face-uri":
    case "font-face-format":
    case "font-face-name":
    case "missing-glyph":
      return !1;
    default:
      return !0;
  }
}
var gl = null;
function ku(e) {
  return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
}
var yl = null, Lr = null, Fr = null;
function Rc(e) {
  if (e = po(e)) {
    if (typeof yl != "function") throw Error(P(280));
    var t = e.stateNode;
    t && (t = Js(t), yl(e.stateNode, e.type, t));
  }
}
function Pf(e) {
  Lr ? Fr ? Fr.push(e) : Fr = [e] : Lr = e;
}
function jf() {
  if (Lr) {
    var e = Lr, t = Fr;
    if (Fr = Lr = null, Rc(e), t) for (e = 0; e < t.length; e++) Rc(t[e]);
  }
}
function Lf(e, t) {
  return e(t);
}
function Ff() {
}
var Ta = !1;
function Df(e, t, n) {
  if (Ta) return e(t, n);
  Ta = !0;
  try {
    return Lf(e, t, n);
  } finally {
    Ta = !1, (Lr !== null || Fr !== null) && (Ff(), jf());
  }
}
function Hi(e, t) {
  var n = e.stateNode;
  if (n === null) return null;
  var r = Js(n);
  if (r === null) return null;
  n = r[t];
  e: switch (t) {
    case "onClick":
    case "onClickCapture":
    case "onDoubleClick":
    case "onDoubleClickCapture":
    case "onMouseDown":
    case "onMouseDownCapture":
    case "onMouseMove":
    case "onMouseMoveCapture":
    case "onMouseUp":
    case "onMouseUpCapture":
    case "onMouseEnter":
      (r = !r.disabled) || (e = e.type, r = !(e === "button" || e === "input" || e === "select" || e === "textarea")), e = !r;
      break e;
    default:
      e = !1;
  }
  if (e) return null;
  if (n && typeof n != "function") throw Error(P(231, t, typeof n));
  return n;
}
var vl = !1;
if (pn) try {
  var li = {};
  Object.defineProperty(li, "passive", { get: function() {
    vl = !0;
  } }), window.addEventListener("test", li, li), window.removeEventListener("test", li, li);
} catch {
  vl = !1;
}
function cg(e, t, n, r, i, o, s, a, l) {
  var u = Array.prototype.slice.call(arguments, 3);
  try {
    t.apply(n, u);
  } catch (c) {
    this.onError(c);
  }
}
var Ti = !1, rs = null, is = !1, wl = null, dg = { onError: function(e) {
  Ti = !0, rs = e;
} };
function fg(e, t, n, r, i, o, s, a, l) {
  Ti = !1, rs = null, cg.apply(dg, arguments);
}
function pg(e, t, n, r, i, o, s, a, l) {
  if (fg.apply(this, arguments), Ti) {
    if (Ti) {
      var u = rs;
      Ti = !1, rs = null;
    } else throw Error(P(198));
    is || (is = !0, wl = u);
  }
}
function mr(e) {
  var t = e, n = e;
  if (e.alternate) for (; t.return; ) t = t.return;
  else {
    e = t;
    do
      t = e, t.flags & 4098 && (n = t.return), e = t.return;
    while (e);
  }
  return t.tag === 3 ? n : null;
}
function zf(e) {
  if (e.tag === 13) {
    var t = e.memoizedState;
    if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
  }
  return null;
}
function Ic(e) {
  if (mr(e) !== e) throw Error(P(188));
}
function hg(e) {
  var t = e.alternate;
  if (!t) {
    if (t = mr(e), t === null) throw Error(P(188));
    return t !== e ? null : e;
  }
  for (var n = e, r = t; ; ) {
    var i = n.return;
    if (i === null) break;
    var o = i.alternate;
    if (o === null) {
      if (r = i.return, r !== null) {
        n = r;
        continue;
      }
      break;
    }
    if (i.child === o.child) {
      for (o = i.child; o; ) {
        if (o === n) return Ic(i), e;
        if (o === r) return Ic(i), t;
        o = o.sibling;
      }
      throw Error(P(188));
    }
    if (n.return !== r.return) n = i, r = o;
    else {
      for (var s = !1, a = i.child; a; ) {
        if (a === n) {
          s = !0, n = i, r = o;
          break;
        }
        if (a === r) {
          s = !0, r = i, n = o;
          break;
        }
        a = a.sibling;
      }
      if (!s) {
        for (a = o.child; a; ) {
          if (a === n) {
            s = !0, n = o, r = i;
            break;
          }
          if (a === r) {
            s = !0, r = o, n = i;
            break;
          }
          a = a.sibling;
        }
        if (!s) throw Error(P(189));
      }
    }
    if (n.alternate !== r) throw Error(P(190));
  }
  if (n.tag !== 3) throw Error(P(188));
  return n.stateNode.current === n ? e : t;
}
function Mf(e) {
  return e = hg(e), e !== null ? Uf(e) : null;
}
function Uf(e) {
  if (e.tag === 5 || e.tag === 6) return e;
  for (e = e.child; e !== null; ) {
    var t = Uf(e);
    if (t !== null) return t;
    e = e.sibling;
  }
  return null;
}
var Vf = bt.unstable_scheduleCallback, Ac = bt.unstable_cancelCallback, mg = bt.unstable_shouldYield, gg = bt.unstable_requestPaint, Ae = bt.unstable_now, yg = bt.unstable_getCurrentPriorityLevel, Su = bt.unstable_ImmediatePriority, $f = bt.unstable_UserBlockingPriority, os = bt.unstable_NormalPriority, vg = bt.unstable_LowPriority, Bf = bt.unstable_IdlePriority, Ws = null, Kt = null;
function wg(e) {
  if (Kt && typeof Kt.onCommitFiberRoot == "function") try {
    Kt.onCommitFiberRoot(Ws, e, void 0, (e.current.flags & 128) === 128);
  } catch {
  }
}
var Vt = Math.clz32 ? Math.clz32 : _g, xg = Math.log, bg = Math.LN2;
function _g(e) {
  return e >>>= 0, e === 0 ? 32 : 31 - (xg(e) / bg | 0) | 0;
}
var No = 64, To = 4194304;
function _i(e) {
  switch (e & -e) {
    case 1:
      return 1;
    case 2:
      return 2;
    case 4:
      return 4;
    case 8:
      return 8;
    case 16:
      return 16;
    case 32:
      return 32;
    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return e & 4194240;
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return e & 130023424;
    case 134217728:
      return 134217728;
    case 268435456:
      return 268435456;
    case 536870912:
      return 536870912;
    case 1073741824:
      return 1073741824;
    default:
      return e;
  }
}
function ss(e, t) {
  var n = e.pendingLanes;
  if (n === 0) return 0;
  var r = 0, i = e.suspendedLanes, o = e.pingedLanes, s = n & 268435455;
  if (s !== 0) {
    var a = s & ~i;
    a !== 0 ? r = _i(a) : (o &= s, o !== 0 && (r = _i(o)));
  } else s = n & ~i, s !== 0 ? r = _i(s) : o !== 0 && (r = _i(o));
  if (r === 0) return 0;
  if (t !== 0 && t !== r && !(t & i) && (i = r & -r, o = t & -t, i >= o || i === 16 && (o & 4194240) !== 0)) return t;
  if (r & 4 && (r |= n & 16), t = e.entangledLanes, t !== 0) for (e = e.entanglements, t &= r; 0 < t; ) n = 31 - Vt(t), i = 1 << n, r |= e[n], t &= ~i;
  return r;
}
function kg(e, t) {
  switch (e) {
    case 1:
    case 2:
    case 4:
      return t + 250;
    case 8:
    case 16:
    case 32:
    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return t + 5e3;
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return -1;
    case 134217728:
    case 268435456:
    case 536870912:
    case 1073741824:
      return -1;
    default:
      return -1;
  }
}
function Sg(e, t) {
  for (var n = e.suspendedLanes, r = e.pingedLanes, i = e.expirationTimes, o = e.pendingLanes; 0 < o; ) {
    var s = 31 - Vt(o), a = 1 << s, l = i[s];
    l === -1 ? (!(a & n) || a & r) && (i[s] = kg(a, t)) : l <= t && (e.expiredLanes |= a), o &= ~a;
  }
}
function xl(e) {
  return e = e.pendingLanes & -1073741825, e !== 0 ? e : e & 1073741824 ? 1073741824 : 0;
}
function Hf() {
  var e = No;
  return No <<= 1, !(No & 4194240) && (No = 64), e;
}
function Ra(e) {
  for (var t = [], n = 0; 31 > n; n++) t.push(e);
  return t;
}
function co(e, t, n) {
  e.pendingLanes |= t, t !== 536870912 && (e.suspendedLanes = 0, e.pingedLanes = 0), e = e.eventTimes, t = 31 - Vt(t), e[t] = n;
}
function Eg(e, t) {
  var n = e.pendingLanes & ~t;
  e.pendingLanes = t, e.suspendedLanes = 0, e.pingedLanes = 0, e.expiredLanes &= t, e.mutableReadLanes &= t, e.entangledLanes &= t, t = e.entanglements;
  var r = e.eventTimes;
  for (e = e.expirationTimes; 0 < n; ) {
    var i = 31 - Vt(n), o = 1 << i;
    t[i] = 0, r[i] = -1, e[i] = -1, n &= ~o;
  }
}
function Eu(e, t) {
  var n = e.entangledLanes |= t;
  for (e = e.entanglements; n; ) {
    var r = 31 - Vt(n), i = 1 << r;
    i & t | e[r] & t && (e[r] |= t), n &= ~i;
  }
}
var he = 0;
function Wf(e) {
  return e &= -e, 1 < e ? 4 < e ? e & 268435455 ? 16 : 536870912 : 4 : 1;
}
var Zf, Cu, Qf, qf, Jf, bl = !1, Ro = [], Pn = null, jn = null, Ln = null, Wi = /* @__PURE__ */ new Map(), Zi = /* @__PURE__ */ new Map(), Rn = [], Cg = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Oc(e, t) {
  switch (e) {
    case "focusin":
    case "focusout":
      Pn = null;
      break;
    case "dragenter":
    case "dragleave":
      jn = null;
      break;
    case "mouseover":
    case "mouseout":
      Ln = null;
      break;
    case "pointerover":
    case "pointerout":
      Wi.delete(t.pointerId);
      break;
    case "gotpointercapture":
    case "lostpointercapture":
      Zi.delete(t.pointerId);
  }
}
function ui(e, t, n, r, i, o) {
  return e === null || e.nativeEvent !== o ? (e = { blockedOn: t, domEventName: n, eventSystemFlags: r, nativeEvent: o, targetContainers: [i] }, t !== null && (t = po(t), t !== null && Cu(t)), e) : (e.eventSystemFlags |= r, t = e.targetContainers, i !== null && t.indexOf(i) === -1 && t.push(i), e);
}
function Ng(e, t, n, r, i) {
  switch (t) {
    case "focusin":
      return Pn = ui(Pn, e, t, n, r, i), !0;
    case "dragenter":
      return jn = ui(jn, e, t, n, r, i), !0;
    case "mouseover":
      return Ln = ui(Ln, e, t, n, r, i), !0;
    case "pointerover":
      var o = i.pointerId;
      return Wi.set(o, ui(Wi.get(o) || null, e, t, n, r, i)), !0;
    case "gotpointercapture":
      return o = i.pointerId, Zi.set(o, ui(Zi.get(o) || null, e, t, n, r, i)), !0;
  }
  return !1;
}
function Kf(e) {
  var t = Kn(e.target);
  if (t !== null) {
    var n = mr(t);
    if (n !== null) {
      if (t = n.tag, t === 13) {
        if (t = zf(n), t !== null) {
          e.blockedOn = t, Jf(e.priority, function() {
            Qf(n);
          });
          return;
        }
      } else if (t === 3 && n.stateNode.current.memoizedState.isDehydrated) {
        e.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
        return;
      }
    }
  }
  e.blockedOn = null;
}
function $o(e) {
  if (e.blockedOn !== null) return !1;
  for (var t = e.targetContainers; 0 < t.length; ) {
    var n = _l(e.domEventName, e.eventSystemFlags, t[0], e.nativeEvent);
    if (n === null) {
      n = e.nativeEvent;
      var r = new n.constructor(n.type, n);
      gl = r, n.target.dispatchEvent(r), gl = null;
    } else return t = po(n), t !== null && Cu(t), e.blockedOn = n, !1;
    t.shift();
  }
  return !0;
}
function Pc(e, t, n) {
  $o(e) && n.delete(t);
}
function Tg() {
  bl = !1, Pn !== null && $o(Pn) && (Pn = null), jn !== null && $o(jn) && (jn = null), Ln !== null && $o(Ln) && (Ln = null), Wi.forEach(Pc), Zi.forEach(Pc);
}
function ci(e, t) {
  e.blockedOn === t && (e.blockedOn = null, bl || (bl = !0, bt.unstable_scheduleCallback(bt.unstable_NormalPriority, Tg)));
}
function Qi(e) {
  function t(i) {
    return ci(i, e);
  }
  if (0 < Ro.length) {
    ci(Ro[0], e);
    for (var n = 1; n < Ro.length; n++) {
      var r = Ro[n];
      r.blockedOn === e && (r.blockedOn = null);
    }
  }
  for (Pn !== null && ci(Pn, e), jn !== null && ci(jn, e), Ln !== null && ci(Ln, e), Wi.forEach(t), Zi.forEach(t), n = 0; n < Rn.length; n++) r = Rn[n], r.blockedOn === e && (r.blockedOn = null);
  for (; 0 < Rn.length && (n = Rn[0], n.blockedOn === null); ) Kf(n), n.blockedOn === null && Rn.shift();
}
var Dr = wn.ReactCurrentBatchConfig, as = !0;
function Rg(e, t, n, r) {
  var i = he, o = Dr.transition;
  Dr.transition = null;
  try {
    he = 1, Nu(e, t, n, r);
  } finally {
    he = i, Dr.transition = o;
  }
}
function Ig(e, t, n, r) {
  var i = he, o = Dr.transition;
  Dr.transition = null;
  try {
    he = 4, Nu(e, t, n, r);
  } finally {
    he = i, Dr.transition = o;
  }
}
function Nu(e, t, n, r) {
  if (as) {
    var i = _l(e, t, n, r);
    if (i === null) Ma(e, t, r, ls, n), Oc(e, r);
    else if (Ng(i, e, t, n, r)) r.stopPropagation();
    else if (Oc(e, r), t & 4 && -1 < Cg.indexOf(e)) {
      for (; i !== null; ) {
        var o = po(i);
        if (o !== null && Zf(o), o = _l(e, t, n, r), o === null && Ma(e, t, r, ls, n), o === i) break;
        i = o;
      }
      i !== null && r.stopPropagation();
    } else Ma(e, t, r, null, n);
  }
}
var ls = null;
function _l(e, t, n, r) {
  if (ls = null, e = ku(r), e = Kn(e), e !== null) if (t = mr(e), t === null) e = null;
  else if (n = t.tag, n === 13) {
    if (e = zf(t), e !== null) return e;
    e = null;
  } else if (n === 3) {
    if (t.stateNode.current.memoizedState.isDehydrated) return t.tag === 3 ? t.stateNode.containerInfo : null;
    e = null;
  } else t !== e && (e = null);
  return ls = e, null;
}
function Gf(e) {
  switch (e) {
    case "cancel":
    case "click":
    case "close":
    case "contextmenu":
    case "copy":
    case "cut":
    case "auxclick":
    case "dblclick":
    case "dragend":
    case "dragstart":
    case "drop":
    case "focusin":
    case "focusout":
    case "input":
    case "invalid":
    case "keydown":
    case "keypress":
    case "keyup":
    case "mousedown":
    case "mouseup":
    case "paste":
    case "pause":
    case "play":
    case "pointercancel":
    case "pointerdown":
    case "pointerup":
    case "ratechange":
    case "reset":
    case "resize":
    case "seeked":
    case "submit":
    case "touchcancel":
    case "touchend":
    case "touchstart":
    case "volumechange":
    case "change":
    case "selectionchange":
    case "textInput":
    case "compositionstart":
    case "compositionend":
    case "compositionupdate":
    case "beforeblur":
    case "afterblur":
    case "beforeinput":
    case "blur":
    case "fullscreenchange":
    case "focus":
    case "hashchange":
    case "popstate":
    case "select":
    case "selectstart":
      return 1;
    case "drag":
    case "dragenter":
    case "dragexit":
    case "dragleave":
    case "dragover":
    case "mousemove":
    case "mouseout":
    case "mouseover":
    case "pointermove":
    case "pointerout":
    case "pointerover":
    case "scroll":
    case "toggle":
    case "touchmove":
    case "wheel":
    case "mouseenter":
    case "mouseleave":
    case "pointerenter":
    case "pointerleave":
      return 4;
    case "message":
      switch (yg()) {
        case Su:
          return 1;
        case $f:
          return 4;
        case os:
        case vg:
          return 16;
        case Bf:
          return 536870912;
        default:
          return 16;
      }
    default:
      return 16;
  }
}
var An = null, Tu = null, Bo = null;
function Yf() {
  if (Bo) return Bo;
  var e, t = Tu, n = t.length, r, i = "value" in An ? An.value : An.textContent, o = i.length;
  for (e = 0; e < n && t[e] === i[e]; e++) ;
  var s = n - e;
  for (r = 1; r <= s && t[n - r] === i[o - r]; r++) ;
  return Bo = i.slice(e, 1 < r ? 1 - r : void 0);
}
function Ho(e) {
  var t = e.keyCode;
  return "charCode" in e ? (e = e.charCode, e === 0 && t === 13 && (e = 13)) : e = t, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
}
function Io() {
  return !0;
}
function jc() {
  return !1;
}
function kt(e) {
  function t(n, r, i, o, s) {
    this._reactName = n, this._targetInst = i, this.type = r, this.nativeEvent = o, this.target = s, this.currentTarget = null;
    for (var a in e) e.hasOwnProperty(a) && (n = e[a], this[a] = n ? n(o) : o[a]);
    return this.isDefaultPrevented = (o.defaultPrevented != null ? o.defaultPrevented : o.returnValue === !1) ? Io : jc, this.isPropagationStopped = jc, this;
  }
  return Ce(t.prototype, { preventDefault: function() {
    this.defaultPrevented = !0;
    var n = this.nativeEvent;
    n && (n.preventDefault ? n.preventDefault() : typeof n.returnValue != "unknown" && (n.returnValue = !1), this.isDefaultPrevented = Io);
  }, stopPropagation: function() {
    var n = this.nativeEvent;
    n && (n.stopPropagation ? n.stopPropagation() : typeof n.cancelBubble != "unknown" && (n.cancelBubble = !0), this.isPropagationStopped = Io);
  }, persist: function() {
  }, isPersistent: Io }), t;
}
var ei = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(e) {
  return e.timeStamp || Date.now();
}, defaultPrevented: 0, isTrusted: 0 }, Ru = kt(ei), fo = Ce({}, ei, { view: 0, detail: 0 }), Ag = kt(fo), Ia, Aa, di, Zs = Ce({}, fo, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: Iu, button: 0, buttons: 0, relatedTarget: function(e) {
  return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
}, movementX: function(e) {
  return "movementX" in e ? e.movementX : (e !== di && (di && e.type === "mousemove" ? (Ia = e.screenX - di.screenX, Aa = e.screenY - di.screenY) : Aa = Ia = 0, di = e), Ia);
}, movementY: function(e) {
  return "movementY" in e ? e.movementY : Aa;
} }), Lc = kt(Zs), Og = Ce({}, Zs, { dataTransfer: 0 }), Pg = kt(Og), jg = Ce({}, fo, { relatedTarget: 0 }), Oa = kt(jg), Lg = Ce({}, ei, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), Fg = kt(Lg), Dg = Ce({}, ei, { clipboardData: function(e) {
  return "clipboardData" in e ? e.clipboardData : window.clipboardData;
} }), zg = kt(Dg), Mg = Ce({}, ei, { data: 0 }), Fc = kt(Mg), Ug = {
  Esc: "Escape",
  Spacebar: " ",
  Left: "ArrowLeft",
  Up: "ArrowUp",
  Right: "ArrowRight",
  Down: "ArrowDown",
  Del: "Delete",
  Win: "OS",
  Menu: "ContextMenu",
  Apps: "ContextMenu",
  Scroll: "ScrollLock",
  MozPrintableKey: "Unidentified"
}, Vg = {
  8: "Backspace",
  9: "Tab",
  12: "Clear",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  19: "Pause",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  45: "Insert",
  46: "Delete",
  112: "F1",
  113: "F2",
  114: "F3",
  115: "F4",
  116: "F5",
  117: "F6",
  118: "F7",
  119: "F8",
  120: "F9",
  121: "F10",
  122: "F11",
  123: "F12",
  144: "NumLock",
  145: "ScrollLock",
  224: "Meta"
}, $g = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
function Bg(e) {
  var t = this.nativeEvent;
  return t.getModifierState ? t.getModifierState(e) : (e = $g[e]) ? !!t[e] : !1;
}
function Iu() {
  return Bg;
}
var Hg = Ce({}, fo, { key: function(e) {
  if (e.key) {
    var t = Ug[e.key] || e.key;
    if (t !== "Unidentified") return t;
  }
  return e.type === "keypress" ? (e = Ho(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? Vg[e.keyCode] || "Unidentified" : "";
}, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: Iu, charCode: function(e) {
  return e.type === "keypress" ? Ho(e) : 0;
}, keyCode: function(e) {
  return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
}, which: function(e) {
  return e.type === "keypress" ? Ho(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
} }), Wg = kt(Hg), Zg = Ce({}, Zs, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), Dc = kt(Zg), Qg = Ce({}, fo, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: Iu }), qg = kt(Qg), Jg = Ce({}, ei, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), Kg = kt(Jg), Gg = Ce({}, Zs, {
  deltaX: function(e) {
    return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
  },
  deltaY: function(e) {
    return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
  },
  deltaZ: 0,
  deltaMode: 0
}), Yg = kt(Gg), Xg = [9, 13, 27, 32], Au = pn && "CompositionEvent" in window, Ri = null;
pn && "documentMode" in document && (Ri = document.documentMode);
var ey = pn && "TextEvent" in window && !Ri, Xf = pn && (!Au || Ri && 8 < Ri && 11 >= Ri), zc = " ", Mc = !1;
function ep(e, t) {
  switch (e) {
    case "keyup":
      return Xg.indexOf(t.keyCode) !== -1;
    case "keydown":
      return t.keyCode !== 229;
    case "keypress":
    case "mousedown":
    case "focusout":
      return !0;
    default:
      return !1;
  }
}
function tp(e) {
  return e = e.detail, typeof e == "object" && "data" in e ? e.data : null;
}
var Sr = !1;
function ty(e, t) {
  switch (e) {
    case "compositionend":
      return tp(t);
    case "keypress":
      return t.which !== 32 ? null : (Mc = !0, zc);
    case "textInput":
      return e = t.data, e === zc && Mc ? null : e;
    default:
      return null;
  }
}
function ny(e, t) {
  if (Sr) return e === "compositionend" || !Au && ep(e, t) ? (e = Yf(), Bo = Tu = An = null, Sr = !1, e) : null;
  switch (e) {
    case "paste":
      return null;
    case "keypress":
      if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
        if (t.char && 1 < t.char.length) return t.char;
        if (t.which) return String.fromCharCode(t.which);
      }
      return null;
    case "compositionend":
      return Xf && t.locale !== "ko" ? null : t.data;
    default:
      return null;
  }
}
var ry = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
function Uc(e) {
  var t = e && e.nodeName && e.nodeName.toLowerCase();
  return t === "input" ? !!ry[e.type] : t === "textarea";
}
function np(e, t, n, r) {
  Pf(r), t = us(t, "onChange"), 0 < t.length && (n = new Ru("onChange", "change", null, n, r), e.push({ event: n, listeners: t }));
}
var Ii = null, qi = null;
function iy(e) {
  pp(e, 0);
}
function Qs(e) {
  var t = Nr(e);
  if (Cf(t)) return e;
}
function oy(e, t) {
  if (e === "change") return t;
}
var rp = !1;
if (pn) {
  var Pa;
  if (pn) {
    var ja = "oninput" in document;
    if (!ja) {
      var Vc = document.createElement("div");
      Vc.setAttribute("oninput", "return;"), ja = typeof Vc.oninput == "function";
    }
    Pa = ja;
  } else Pa = !1;
  rp = Pa && (!document.documentMode || 9 < document.documentMode);
}
function $c() {
  Ii && (Ii.detachEvent("onpropertychange", ip), qi = Ii = null);
}
function ip(e) {
  if (e.propertyName === "value" && Qs(qi)) {
    var t = [];
    np(t, qi, e, ku(e)), Df(iy, t);
  }
}
function sy(e, t, n) {
  e === "focusin" ? ($c(), Ii = t, qi = n, Ii.attachEvent("onpropertychange", ip)) : e === "focusout" && $c();
}
function ay(e) {
  if (e === "selectionchange" || e === "keyup" || e === "keydown") return Qs(qi);
}
function ly(e, t) {
  if (e === "click") return Qs(t);
}
function uy(e, t) {
  if (e === "input" || e === "change") return Qs(t);
}
function cy(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var Bt = typeof Object.is == "function" ? Object.is : cy;
function Ji(e, t) {
  if (Bt(e, t)) return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null) return !1;
  var n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  for (r = 0; r < n.length; r++) {
    var i = n[r];
    if (!il.call(t, i) || !Bt(e[i], t[i])) return !1;
  }
  return !0;
}
function Bc(e) {
  for (; e && e.firstChild; ) e = e.firstChild;
  return e;
}
function Hc(e, t) {
  var n = Bc(e);
  e = 0;
  for (var r; n; ) {
    if (n.nodeType === 3) {
      if (r = e + n.textContent.length, e <= t && r >= t) return { node: n, offset: t - e };
      e = r;
    }
    e: {
      for (; n; ) {
        if (n.nextSibling) {
          n = n.nextSibling;
          break e;
        }
        n = n.parentNode;
      }
      n = void 0;
    }
    n = Bc(n);
  }
}
function op(e, t) {
  return e && t ? e === t ? !0 : e && e.nodeType === 3 ? !1 : t && t.nodeType === 3 ? op(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1 : !1;
}
function sp() {
  for (var e = window, t = ns(); t instanceof e.HTMLIFrameElement; ) {
    try {
      var n = typeof t.contentWindow.location.href == "string";
    } catch {
      n = !1;
    }
    if (n) e = t.contentWindow;
    else break;
    t = ns(e.document);
  }
  return t;
}
function Ou(e) {
  var t = e && e.nodeName && e.nodeName.toLowerCase();
  return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
}
function dy(e) {
  var t = sp(), n = e.focusedElem, r = e.selectionRange;
  if (t !== n && n && n.ownerDocument && op(n.ownerDocument.documentElement, n)) {
    if (r !== null && Ou(n)) {
      if (t = r.start, e = r.end, e === void 0 && (e = t), "selectionStart" in n) n.selectionStart = t, n.selectionEnd = Math.min(e, n.value.length);
      else if (e = (t = n.ownerDocument || document) && t.defaultView || window, e.getSelection) {
        e = e.getSelection();
        var i = n.textContent.length, o = Math.min(r.start, i);
        r = r.end === void 0 ? o : Math.min(r.end, i), !e.extend && o > r && (i = r, r = o, o = i), i = Hc(n, o);
        var s = Hc(
          n,
          r
        );
        i && s && (e.rangeCount !== 1 || e.anchorNode !== i.node || e.anchorOffset !== i.offset || e.focusNode !== s.node || e.focusOffset !== s.offset) && (t = t.createRange(), t.setStart(i.node, i.offset), e.removeAllRanges(), o > r ? (e.addRange(t), e.extend(s.node, s.offset)) : (t.setEnd(s.node, s.offset), e.addRange(t)));
      }
    }
    for (t = [], e = n; e = e.parentNode; ) e.nodeType === 1 && t.push({ element: e, left: e.scrollLeft, top: e.scrollTop });
    for (typeof n.focus == "function" && n.focus(), n = 0; n < t.length; n++) e = t[n], e.element.scrollLeft = e.left, e.element.scrollTop = e.top;
  }
}
var fy = pn && "documentMode" in document && 11 >= document.documentMode, Er = null, kl = null, Ai = null, Sl = !1;
function Wc(e, t, n) {
  var r = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
  Sl || Er == null || Er !== ns(r) || (r = Er, "selectionStart" in r && Ou(r) ? r = { start: r.selectionStart, end: r.selectionEnd } : (r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection(), r = { anchorNode: r.anchorNode, anchorOffset: r.anchorOffset, focusNode: r.focusNode, focusOffset: r.focusOffset }), Ai && Ji(Ai, r) || (Ai = r, r = us(kl, "onSelect"), 0 < r.length && (t = new Ru("onSelect", "select", null, t, n), e.push({ event: t, listeners: r }), t.target = Er)));
}
function Ao(e, t) {
  var n = {};
  return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
}
var Cr = { animationend: Ao("Animation", "AnimationEnd"), animationiteration: Ao("Animation", "AnimationIteration"), animationstart: Ao("Animation", "AnimationStart"), transitionend: Ao("Transition", "TransitionEnd") }, La = {}, ap = {};
pn && (ap = document.createElement("div").style, "AnimationEvent" in window || (delete Cr.animationend.animation, delete Cr.animationiteration.animation, delete Cr.animationstart.animation), "TransitionEvent" in window || delete Cr.transitionend.transition);
function qs(e) {
  if (La[e]) return La[e];
  if (!Cr[e]) return e;
  var t = Cr[e], n;
  for (n in t) if (t.hasOwnProperty(n) && n in ap) return La[e] = t[n];
  return e;
}
var lp = qs("animationend"), up = qs("animationiteration"), cp = qs("animationstart"), dp = qs("transitionend"), fp = /* @__PURE__ */ new Map(), Zc = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function Hn(e, t) {
  fp.set(e, t), hr(t, [e]);
}
for (var Fa = 0; Fa < Zc.length; Fa++) {
  var Da = Zc[Fa], py = Da.toLowerCase(), hy = Da[0].toUpperCase() + Da.slice(1);
  Hn(py, "on" + hy);
}
Hn(lp, "onAnimationEnd");
Hn(up, "onAnimationIteration");
Hn(cp, "onAnimationStart");
Hn("dblclick", "onDoubleClick");
Hn("focusin", "onFocus");
Hn("focusout", "onBlur");
Hn(dp, "onTransitionEnd");
$r("onMouseEnter", ["mouseout", "mouseover"]);
$r("onMouseLeave", ["mouseout", "mouseover"]);
$r("onPointerEnter", ["pointerout", "pointerover"]);
$r("onPointerLeave", ["pointerout", "pointerover"]);
hr("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
hr("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
hr("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]);
hr("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
hr("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
hr("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var ki = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), my = new Set("cancel close invalid load scroll toggle".split(" ").concat(ki));
function Qc(e, t, n) {
  var r = e.type || "unknown-event";
  e.currentTarget = n, pg(r, t, void 0, e), e.currentTarget = null;
}
function pp(e, t) {
  t = (t & 4) !== 0;
  for (var n = 0; n < e.length; n++) {
    var r = e[n], i = r.event;
    r = r.listeners;
    e: {
      var o = void 0;
      if (t) for (var s = r.length - 1; 0 <= s; s--) {
        var a = r[s], l = a.instance, u = a.currentTarget;
        if (a = a.listener, l !== o && i.isPropagationStopped()) break e;
        Qc(i, a, u), o = l;
      }
      else for (s = 0; s < r.length; s++) {
        if (a = r[s], l = a.instance, u = a.currentTarget, a = a.listener, l !== o && i.isPropagationStopped()) break e;
        Qc(i, a, u), o = l;
      }
    }
  }
  if (is) throw e = wl, is = !1, wl = null, e;
}
function xe(e, t) {
  var n = t[Rl];
  n === void 0 && (n = t[Rl] = /* @__PURE__ */ new Set());
  var r = e + "__bubble";
  n.has(r) || (hp(t, e, 2, !1), n.add(r));
}
function za(e, t, n) {
  var r = 0;
  t && (r |= 4), hp(n, e, r, t);
}
var Oo = "_reactListening" + Math.random().toString(36).slice(2);
function Ki(e) {
  if (!e[Oo]) {
    e[Oo] = !0, bf.forEach(function(n) {
      n !== "selectionchange" && (my.has(n) || za(n, !1, e), za(n, !0, e));
    });
    var t = e.nodeType === 9 ? e : e.ownerDocument;
    t === null || t[Oo] || (t[Oo] = !0, za("selectionchange", !1, t));
  }
}
function hp(e, t, n, r) {
  switch (Gf(t)) {
    case 1:
      var i = Rg;
      break;
    case 4:
      i = Ig;
      break;
    default:
      i = Nu;
  }
  n = i.bind(null, t, n, e), i = void 0, !vl || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (i = !0), r ? i !== void 0 ? e.addEventListener(t, n, { capture: !0, passive: i }) : e.addEventListener(t, n, !0) : i !== void 0 ? e.addEventListener(t, n, { passive: i }) : e.addEventListener(t, n, !1);
}
function Ma(e, t, n, r, i) {
  var o = r;
  if (!(t & 1) && !(t & 2) && r !== null) e: for (; ; ) {
    if (r === null) return;
    var s = r.tag;
    if (s === 3 || s === 4) {
      var a = r.stateNode.containerInfo;
      if (a === i || a.nodeType === 8 && a.parentNode === i) break;
      if (s === 4) for (s = r.return; s !== null; ) {
        var l = s.tag;
        if ((l === 3 || l === 4) && (l = s.stateNode.containerInfo, l === i || l.nodeType === 8 && l.parentNode === i)) return;
        s = s.return;
      }
      for (; a !== null; ) {
        if (s = Kn(a), s === null) return;
        if (l = s.tag, l === 5 || l === 6) {
          r = o = s;
          continue e;
        }
        a = a.parentNode;
      }
    }
    r = r.return;
  }
  Df(function() {
    var u = o, c = ku(n), p = [];
    e: {
      var h = fp.get(e);
      if (h !== void 0) {
        var x = Ru, v = e;
        switch (e) {
          case "keypress":
            if (Ho(n) === 0) break e;
          case "keydown":
          case "keyup":
            x = Wg;
            break;
          case "focusin":
            v = "focus", x = Oa;
            break;
          case "focusout":
            v = "blur", x = Oa;
            break;
          case "beforeblur":
          case "afterblur":
            x = Oa;
            break;
          case "click":
            if (n.button === 2) break e;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            x = Lc;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            x = Pg;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            x = qg;
            break;
          case lp:
          case up:
          case cp:
            x = Fg;
            break;
          case dp:
            x = Kg;
            break;
          case "scroll":
            x = Ag;
            break;
          case "wheel":
            x = Yg;
            break;
          case "copy":
          case "cut":
          case "paste":
            x = zg;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            x = Dc;
        }
        var w = (t & 4) !== 0, _ = !w && e === "scroll", m = w ? h !== null ? h + "Capture" : null : h;
        w = [];
        for (var d = u, y; d !== null; ) {
          y = d;
          var b = y.stateNode;
          if (y.tag === 5 && b !== null && (y = b, m !== null && (b = Hi(d, m), b != null && w.push(Gi(d, b, y)))), _) break;
          d = d.return;
        }
        0 < w.length && (h = new x(h, v, null, n, c), p.push({ event: h, listeners: w }));
      }
    }
    if (!(t & 7)) {
      e: {
        if (h = e === "mouseover" || e === "pointerover", x = e === "mouseout" || e === "pointerout", h && n !== gl && (v = n.relatedTarget || n.fromElement) && (Kn(v) || v[hn])) break e;
        if ((x || h) && (h = c.window === c ? c : (h = c.ownerDocument) ? h.defaultView || h.parentWindow : window, x ? (v = n.relatedTarget || n.toElement, x = u, v = v ? Kn(v) : null, v !== null && (_ = mr(v), v !== _ || v.tag !== 5 && v.tag !== 6) && (v = null)) : (x = null, v = u), x !== v)) {
          if (w = Lc, b = "onMouseLeave", m = "onMouseEnter", d = "mouse", (e === "pointerout" || e === "pointerover") && (w = Dc, b = "onPointerLeave", m = "onPointerEnter", d = "pointer"), _ = x == null ? h : Nr(x), y = v == null ? h : Nr(v), h = new w(b, d + "leave", x, n, c), h.target = _, h.relatedTarget = y, b = null, Kn(c) === u && (w = new w(m, d + "enter", v, n, c), w.target = y, w.relatedTarget = _, b = w), _ = b, x && v) t: {
            for (w = x, m = v, d = 0, y = w; y; y = wr(y)) d++;
            for (y = 0, b = m; b; b = wr(b)) y++;
            for (; 0 < d - y; ) w = wr(w), d--;
            for (; 0 < y - d; ) m = wr(m), y--;
            for (; d--; ) {
              if (w === m || m !== null && w === m.alternate) break t;
              w = wr(w), m = wr(m);
            }
            w = null;
          }
          else w = null;
          x !== null && qc(p, h, x, w, !1), v !== null && _ !== null && qc(p, _, v, w, !0);
        }
      }
      e: {
        if (h = u ? Nr(u) : window, x = h.nodeName && h.nodeName.toLowerCase(), x === "select" || x === "input" && h.type === "file") var f = oy;
        else if (Uc(h)) if (rp) f = uy;
        else {
          f = ay;
          var A = sy;
        }
        else (x = h.nodeName) && x.toLowerCase() === "input" && (h.type === "checkbox" || h.type === "radio") && (f = ly);
        if (f && (f = f(e, u))) {
          np(p, f, n, c);
          break e;
        }
        A && A(e, h, u), e === "focusout" && (A = h._wrapperState) && A.controlled && h.type === "number" && dl(h, "number", h.value);
      }
      switch (A = u ? Nr(u) : window, e) {
        case "focusin":
          (Uc(A) || A.contentEditable === "true") && (Er = A, kl = u, Ai = null);
          break;
        case "focusout":
          Ai = kl = Er = null;
          break;
        case "mousedown":
          Sl = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          Sl = !1, Wc(p, n, c);
          break;
        case "selectionchange":
          if (fy) break;
        case "keydown":
        case "keyup":
          Wc(p, n, c);
      }
      var N;
      if (Au) e: {
        switch (e) {
          case "compositionstart":
            var R = "onCompositionStart";
            break e;
          case "compositionend":
            R = "onCompositionEnd";
            break e;
          case "compositionupdate":
            R = "onCompositionUpdate";
            break e;
        }
        R = void 0;
      }
      else Sr ? ep(e, n) && (R = "onCompositionEnd") : e === "keydown" && n.keyCode === 229 && (R = "onCompositionStart");
      R && (Xf && n.locale !== "ko" && (Sr || R !== "onCompositionStart" ? R === "onCompositionEnd" && Sr && (N = Yf()) : (An = c, Tu = "value" in An ? An.value : An.textContent, Sr = !0)), A = us(u, R), 0 < A.length && (R = new Fc(R, e, null, n, c), p.push({ event: R, listeners: A }), N ? R.data = N : (N = tp(n), N !== null && (R.data = N)))), (N = ey ? ty(e, n) : ny(e, n)) && (u = us(u, "onBeforeInput"), 0 < u.length && (c = new Fc("onBeforeInput", "beforeinput", null, n, c), p.push({ event: c, listeners: u }), c.data = N));
    }
    pp(p, t);
  });
}
function Gi(e, t, n) {
  return { instance: e, listener: t, currentTarget: n };
}
function us(e, t) {
  for (var n = t + "Capture", r = []; e !== null; ) {
    var i = e, o = i.stateNode;
    i.tag === 5 && o !== null && (i = o, o = Hi(e, n), o != null && r.unshift(Gi(e, o, i)), o = Hi(e, t), o != null && r.push(Gi(e, o, i))), e = e.return;
  }
  return r;
}
function wr(e) {
  if (e === null) return null;
  do
    e = e.return;
  while (e && e.tag !== 5);
  return e || null;
}
function qc(e, t, n, r, i) {
  for (var o = t._reactName, s = []; n !== null && n !== r; ) {
    var a = n, l = a.alternate, u = a.stateNode;
    if (l !== null && l === r) break;
    a.tag === 5 && u !== null && (a = u, i ? (l = Hi(n, o), l != null && s.unshift(Gi(n, l, a))) : i || (l = Hi(n, o), l != null && s.push(Gi(n, l, a)))), n = n.return;
  }
  s.length !== 0 && e.push({ event: t, listeners: s });
}
var gy = /\r\n?/g, yy = /\u0000|\uFFFD/g;
function Jc(e) {
  return (typeof e == "string" ? e : "" + e).replace(gy, `
`).replace(yy, "");
}
function Po(e, t, n) {
  if (t = Jc(t), Jc(e) !== t && n) throw Error(P(425));
}
function cs() {
}
var El = null, Cl = null;
function Nl(e, t) {
  return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
}
var Tl = typeof setTimeout == "function" ? setTimeout : void 0, vy = typeof clearTimeout == "function" ? clearTimeout : void 0, Kc = typeof Promise == "function" ? Promise : void 0, wy = typeof queueMicrotask == "function" ? queueMicrotask : typeof Kc < "u" ? function(e) {
  return Kc.resolve(null).then(e).catch(xy);
} : Tl;
function xy(e) {
  setTimeout(function() {
    throw e;
  });
}
function Ua(e, t) {
  var n = t, r = 0;
  do {
    var i = n.nextSibling;
    if (e.removeChild(n), i && i.nodeType === 8) if (n = i.data, n === "/$") {
      if (r === 0) {
        e.removeChild(i), Qi(t);
        return;
      }
      r--;
    } else n !== "$" && n !== "$?" && n !== "$!" || r++;
    n = i;
  } while (n);
  Qi(t);
}
function Fn(e) {
  for (; e != null; e = e.nextSibling) {
    var t = e.nodeType;
    if (t === 1 || t === 3) break;
    if (t === 8) {
      if (t = e.data, t === "$" || t === "$!" || t === "$?") break;
      if (t === "/$") return null;
    }
  }
  return e;
}
function Gc(e) {
  e = e.previousSibling;
  for (var t = 0; e; ) {
    if (e.nodeType === 8) {
      var n = e.data;
      if (n === "$" || n === "$!" || n === "$?") {
        if (t === 0) return e;
        t--;
      } else n === "/$" && t++;
    }
    e = e.previousSibling;
  }
  return null;
}
var ti = Math.random().toString(36).slice(2), qt = "__reactFiber$" + ti, Yi = "__reactProps$" + ti, hn = "__reactContainer$" + ti, Rl = "__reactEvents$" + ti, by = "__reactListeners$" + ti, _y = "__reactHandles$" + ti;
function Kn(e) {
  var t = e[qt];
  if (t) return t;
  for (var n = e.parentNode; n; ) {
    if (t = n[hn] || n[qt]) {
      if (n = t.alternate, t.child !== null || n !== null && n.child !== null) for (e = Gc(e); e !== null; ) {
        if (n = e[qt]) return n;
        e = Gc(e);
      }
      return t;
    }
    e = n, n = e.parentNode;
  }
  return null;
}
function po(e) {
  return e = e[qt] || e[hn], !e || e.tag !== 5 && e.tag !== 6 && e.tag !== 13 && e.tag !== 3 ? null : e;
}
function Nr(e) {
  if (e.tag === 5 || e.tag === 6) return e.stateNode;
  throw Error(P(33));
}
function Js(e) {
  return e[Yi] || null;
}
var Il = [], Tr = -1;
function Wn(e) {
  return { current: e };
}
function be(e) {
  0 > Tr || (e.current = Il[Tr], Il[Tr] = null, Tr--);
}
function ye(e, t) {
  Tr++, Il[Tr] = e.current, e.current = t;
}
var $n = {}, Ye = Wn($n), ct = Wn(!1), sr = $n;
function Br(e, t) {
  var n = e.type.contextTypes;
  if (!n) return $n;
  var r = e.stateNode;
  if (r && r.__reactInternalMemoizedUnmaskedChildContext === t) return r.__reactInternalMemoizedMaskedChildContext;
  var i = {}, o;
  for (o in n) i[o] = t[o];
  return r && (e = e.stateNode, e.__reactInternalMemoizedUnmaskedChildContext = t, e.__reactInternalMemoizedMaskedChildContext = i), i;
}
function dt(e) {
  return e = e.childContextTypes, e != null;
}
function ds() {
  be(ct), be(Ye);
}
function Yc(e, t, n) {
  if (Ye.current !== $n) throw Error(P(168));
  ye(Ye, t), ye(ct, n);
}
function mp(e, t, n) {
  var r = e.stateNode;
  if (t = t.childContextTypes, typeof r.getChildContext != "function") return n;
  r = r.getChildContext();
  for (var i in r) if (!(i in t)) throw Error(P(108, sg(e) || "Unknown", i));
  return Ce({}, n, r);
}
function fs(e) {
  return e = (e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext || $n, sr = Ye.current, ye(Ye, e), ye(ct, ct.current), !0;
}
function Xc(e, t, n) {
  var r = e.stateNode;
  if (!r) throw Error(P(169));
  n ? (e = mp(e, t, sr), r.__reactInternalMemoizedMergedChildContext = e, be(ct), be(Ye), ye(Ye, e)) : be(ct), ye(ct, n);
}
var sn = null, Ks = !1, Va = !1;
function gp(e) {
  sn === null ? sn = [e] : sn.push(e);
}
function ky(e) {
  Ks = !0, gp(e);
}
function Zn() {
  if (!Va && sn !== null) {
    Va = !0;
    var e = 0, t = he;
    try {
      var n = sn;
      for (he = 1; e < n.length; e++) {
        var r = n[e];
        do
          r = r(!0);
        while (r !== null);
      }
      sn = null, Ks = !1;
    } catch (i) {
      throw sn !== null && (sn = sn.slice(e + 1)), Vf(Su, Zn), i;
    } finally {
      he = t, Va = !1;
    }
  }
  return null;
}
var Rr = [], Ir = 0, ps = null, hs = 0, Ct = [], Nt = 0, ar = null, ln = 1, un = "";
function qn(e, t) {
  Rr[Ir++] = hs, Rr[Ir++] = ps, ps = e, hs = t;
}
function yp(e, t, n) {
  Ct[Nt++] = ln, Ct[Nt++] = un, Ct[Nt++] = ar, ar = e;
  var r = ln;
  e = un;
  var i = 32 - Vt(r) - 1;
  r &= ~(1 << i), n += 1;
  var o = 32 - Vt(t) + i;
  if (30 < o) {
    var s = i - i % 5;
    o = (r & (1 << s) - 1).toString(32), r >>= s, i -= s, ln = 1 << 32 - Vt(t) + i | n << i | r, un = o + e;
  } else ln = 1 << o | n << i | r, un = e;
}
function Pu(e) {
  e.return !== null && (qn(e, 1), yp(e, 1, 0));
}
function ju(e) {
  for (; e === ps; ) ps = Rr[--Ir], Rr[Ir] = null, hs = Rr[--Ir], Rr[Ir] = null;
  for (; e === ar; ) ar = Ct[--Nt], Ct[Nt] = null, un = Ct[--Nt], Ct[Nt] = null, ln = Ct[--Nt], Ct[Nt] = null;
}
var wt = null, vt = null, _e = !1, zt = null;
function vp(e, t) {
  var n = Tt(5, null, null, 0);
  n.elementType = "DELETED", n.stateNode = t, n.return = e, t = e.deletions, t === null ? (e.deletions = [n], e.flags |= 16) : t.push(n);
}
function ed(e, t) {
  switch (e.tag) {
    case 5:
      var n = e.type;
      return t = t.nodeType !== 1 || n.toLowerCase() !== t.nodeName.toLowerCase() ? null : t, t !== null ? (e.stateNode = t, wt = e, vt = Fn(t.firstChild), !0) : !1;
    case 6:
      return t = e.pendingProps === "" || t.nodeType !== 3 ? null : t, t !== null ? (e.stateNode = t, wt = e, vt = null, !0) : !1;
    case 13:
      return t = t.nodeType !== 8 ? null : t, t !== null ? (n = ar !== null ? { id: ln, overflow: un } : null, e.memoizedState = { dehydrated: t, treeContext: n, retryLane: 1073741824 }, n = Tt(18, null, null, 0), n.stateNode = t, n.return = e, e.child = n, wt = e, vt = null, !0) : !1;
    default:
      return !1;
  }
}
function Al(e) {
  return (e.mode & 1) !== 0 && (e.flags & 128) === 0;
}
function Ol(e) {
  if (_e) {
    var t = vt;
    if (t) {
      var n = t;
      if (!ed(e, t)) {
        if (Al(e)) throw Error(P(418));
        t = Fn(n.nextSibling);
        var r = wt;
        t && ed(e, t) ? vp(r, n) : (e.flags = e.flags & -4097 | 2, _e = !1, wt = e);
      }
    } else {
      if (Al(e)) throw Error(P(418));
      e.flags = e.flags & -4097 | 2, _e = !1, wt = e;
    }
  }
}
function td(e) {
  for (e = e.return; e !== null && e.tag !== 5 && e.tag !== 3 && e.tag !== 13; ) e = e.return;
  wt = e;
}
function jo(e) {
  if (e !== wt) return !1;
  if (!_e) return td(e), _e = !0, !1;
  var t;
  if ((t = e.tag !== 3) && !(t = e.tag !== 5) && (t = e.type, t = t !== "head" && t !== "body" && !Nl(e.type, e.memoizedProps)), t && (t = vt)) {
    if (Al(e)) throw wp(), Error(P(418));
    for (; t; ) vp(e, t), t = Fn(t.nextSibling);
  }
  if (td(e), e.tag === 13) {
    if (e = e.memoizedState, e = e !== null ? e.dehydrated : null, !e) throw Error(P(317));
    e: {
      for (e = e.nextSibling, t = 0; e; ) {
        if (e.nodeType === 8) {
          var n = e.data;
          if (n === "/$") {
            if (t === 0) {
              vt = Fn(e.nextSibling);
              break e;
            }
            t--;
          } else n !== "$" && n !== "$!" && n !== "$?" || t++;
        }
        e = e.nextSibling;
      }
      vt = null;
    }
  } else vt = wt ? Fn(e.stateNode.nextSibling) : null;
  return !0;
}
function wp() {
  for (var e = vt; e; ) e = Fn(e.nextSibling);
}
function Hr() {
  vt = wt = null, _e = !1;
}
function Lu(e) {
  zt === null ? zt = [e] : zt.push(e);
}
var Sy = wn.ReactCurrentBatchConfig;
function fi(e, t, n) {
  if (e = n.ref, e !== null && typeof e != "function" && typeof e != "object") {
    if (n._owner) {
      if (n = n._owner, n) {
        if (n.tag !== 1) throw Error(P(309));
        var r = n.stateNode;
      }
      if (!r) throw Error(P(147, e));
      var i = r, o = "" + e;
      return t !== null && t.ref !== null && typeof t.ref == "function" && t.ref._stringRef === o ? t.ref : (t = function(s) {
        var a = i.refs;
        s === null ? delete a[o] : a[o] = s;
      }, t._stringRef = o, t);
    }
    if (typeof e != "string") throw Error(P(284));
    if (!n._owner) throw Error(P(290, e));
  }
  return e;
}
function Lo(e, t) {
  throw e = Object.prototype.toString.call(t), Error(P(31, e === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : e));
}
function nd(e) {
  var t = e._init;
  return t(e._payload);
}
function xp(e) {
  function t(m, d) {
    if (e) {
      var y = m.deletions;
      y === null ? (m.deletions = [d], m.flags |= 16) : y.push(d);
    }
  }
  function n(m, d) {
    if (!e) return null;
    for (; d !== null; ) t(m, d), d = d.sibling;
    return null;
  }
  function r(m, d) {
    for (m = /* @__PURE__ */ new Map(); d !== null; ) d.key !== null ? m.set(d.key, d) : m.set(d.index, d), d = d.sibling;
    return m;
  }
  function i(m, d) {
    return m = Un(m, d), m.index = 0, m.sibling = null, m;
  }
  function o(m, d, y) {
    return m.index = y, e ? (y = m.alternate, y !== null ? (y = y.index, y < d ? (m.flags |= 2, d) : y) : (m.flags |= 2, d)) : (m.flags |= 1048576, d);
  }
  function s(m) {
    return e && m.alternate === null && (m.flags |= 2), m;
  }
  function a(m, d, y, b) {
    return d === null || d.tag !== 6 ? (d = qa(y, m.mode, b), d.return = m, d) : (d = i(d, y), d.return = m, d);
  }
  function l(m, d, y, b) {
    var f = y.type;
    return f === kr ? c(m, d, y.props.children, b, y.key) : d !== null && (d.elementType === f || typeof f == "object" && f !== null && f.$$typeof === Cn && nd(f) === d.type) ? (b = i(d, y.props), b.ref = fi(m, d, y), b.return = m, b) : (b = Go(y.type, y.key, y.props, null, m.mode, b), b.ref = fi(m, d, y), b.return = m, b);
  }
  function u(m, d, y, b) {
    return d === null || d.tag !== 4 || d.stateNode.containerInfo !== y.containerInfo || d.stateNode.implementation !== y.implementation ? (d = Ja(y, m.mode, b), d.return = m, d) : (d = i(d, y.children || []), d.return = m, d);
  }
  function c(m, d, y, b, f) {
    return d === null || d.tag !== 7 ? (d = nr(y, m.mode, b, f), d.return = m, d) : (d = i(d, y), d.return = m, d);
  }
  function p(m, d, y) {
    if (typeof d == "string" && d !== "" || typeof d == "number") return d = qa("" + d, m.mode, y), d.return = m, d;
    if (typeof d == "object" && d !== null) {
      switch (d.$$typeof) {
        case So:
          return y = Go(d.type, d.key, d.props, null, m.mode, y), y.ref = fi(m, null, d), y.return = m, y;
        case _r:
          return d = Ja(d, m.mode, y), d.return = m, d;
        case Cn:
          var b = d._init;
          return p(m, b(d._payload), y);
      }
      if (bi(d) || ai(d)) return d = nr(d, m.mode, y, null), d.return = m, d;
      Lo(m, d);
    }
    return null;
  }
  function h(m, d, y, b) {
    var f = d !== null ? d.key : null;
    if (typeof y == "string" && y !== "" || typeof y == "number") return f !== null ? null : a(m, d, "" + y, b);
    if (typeof y == "object" && y !== null) {
      switch (y.$$typeof) {
        case So:
          return y.key === f ? l(m, d, y, b) : null;
        case _r:
          return y.key === f ? u(m, d, y, b) : null;
        case Cn:
          return f = y._init, h(
            m,
            d,
            f(y._payload),
            b
          );
      }
      if (bi(y) || ai(y)) return f !== null ? null : c(m, d, y, b, null);
      Lo(m, y);
    }
    return null;
  }
  function x(m, d, y, b, f) {
    if (typeof b == "string" && b !== "" || typeof b == "number") return m = m.get(y) || null, a(d, m, "" + b, f);
    if (typeof b == "object" && b !== null) {
      switch (b.$$typeof) {
        case So:
          return m = m.get(b.key === null ? y : b.key) || null, l(d, m, b, f);
        case _r:
          return m = m.get(b.key === null ? y : b.key) || null, u(d, m, b, f);
        case Cn:
          var A = b._init;
          return x(m, d, y, A(b._payload), f);
      }
      if (bi(b) || ai(b)) return m = m.get(y) || null, c(d, m, b, f, null);
      Lo(d, b);
    }
    return null;
  }
  function v(m, d, y, b) {
    for (var f = null, A = null, N = d, R = d = 0, j = null; N !== null && R < y.length; R++) {
      N.index > R ? (j = N, N = null) : j = N.sibling;
      var T = h(m, N, y[R], b);
      if (T === null) {
        N === null && (N = j);
        break;
      }
      e && N && T.alternate === null && t(m, N), d = o(T, d, R), A === null ? f = T : A.sibling = T, A = T, N = j;
    }
    if (R === y.length) return n(m, N), _e && qn(m, R), f;
    if (N === null) {
      for (; R < y.length; R++) N = p(m, y[R], b), N !== null && (d = o(N, d, R), A === null ? f = N : A.sibling = N, A = N);
      return _e && qn(m, R), f;
    }
    for (N = r(m, N); R < y.length; R++) j = x(N, m, R, y[R], b), j !== null && (e && j.alternate !== null && N.delete(j.key === null ? R : j.key), d = o(j, d, R), A === null ? f = j : A.sibling = j, A = j);
    return e && N.forEach(function(U) {
      return t(m, U);
    }), _e && qn(m, R), f;
  }
  function w(m, d, y, b) {
    var f = ai(y);
    if (typeof f != "function") throw Error(P(150));
    if (y = f.call(y), y == null) throw Error(P(151));
    for (var A = f = null, N = d, R = d = 0, j = null, T = y.next(); N !== null && !T.done; R++, T = y.next()) {
      N.index > R ? (j = N, N = null) : j = N.sibling;
      var U = h(m, N, T.value, b);
      if (U === null) {
        N === null && (N = j);
        break;
      }
      e && N && U.alternate === null && t(m, N), d = o(U, d, R), A === null ? f = U : A.sibling = U, A = U, N = j;
    }
    if (T.done) return n(
      m,
      N
    ), _e && qn(m, R), f;
    if (N === null) {
      for (; !T.done; R++, T = y.next()) T = p(m, T.value, b), T !== null && (d = o(T, d, R), A === null ? f = T : A.sibling = T, A = T);
      return _e && qn(m, R), f;
    }
    for (N = r(m, N); !T.done; R++, T = y.next()) T = x(N, m, R, T.value, b), T !== null && (e && T.alternate !== null && N.delete(T.key === null ? R : T.key), d = o(T, d, R), A === null ? f = T : A.sibling = T, A = T);
    return e && N.forEach(function(z) {
      return t(m, z);
    }), _e && qn(m, R), f;
  }
  function _(m, d, y, b) {
    if (typeof y == "object" && y !== null && y.type === kr && y.key === null && (y = y.props.children), typeof y == "object" && y !== null) {
      switch (y.$$typeof) {
        case So:
          e: {
            for (var f = y.key, A = d; A !== null; ) {
              if (A.key === f) {
                if (f = y.type, f === kr) {
                  if (A.tag === 7) {
                    n(m, A.sibling), d = i(A, y.props.children), d.return = m, m = d;
                    break e;
                  }
                } else if (A.elementType === f || typeof f == "object" && f !== null && f.$$typeof === Cn && nd(f) === A.type) {
                  n(m, A.sibling), d = i(A, y.props), d.ref = fi(m, A, y), d.return = m, m = d;
                  break e;
                }
                n(m, A);
                break;
              } else t(m, A);
              A = A.sibling;
            }
            y.type === kr ? (d = nr(y.props.children, m.mode, b, y.key), d.return = m, m = d) : (b = Go(y.type, y.key, y.props, null, m.mode, b), b.ref = fi(m, d, y), b.return = m, m = b);
          }
          return s(m);
        case _r:
          e: {
            for (A = y.key; d !== null; ) {
              if (d.key === A) if (d.tag === 4 && d.stateNode.containerInfo === y.containerInfo && d.stateNode.implementation === y.implementation) {
                n(m, d.sibling), d = i(d, y.children || []), d.return = m, m = d;
                break e;
              } else {
                n(m, d);
                break;
              }
              else t(m, d);
              d = d.sibling;
            }
            d = Ja(y, m.mode, b), d.return = m, m = d;
          }
          return s(m);
        case Cn:
          return A = y._init, _(m, d, A(y._payload), b);
      }
      if (bi(y)) return v(m, d, y, b);
      if (ai(y)) return w(m, d, y, b);
      Lo(m, y);
    }
    return typeof y == "string" && y !== "" || typeof y == "number" ? (y = "" + y, d !== null && d.tag === 6 ? (n(m, d.sibling), d = i(d, y), d.return = m, m = d) : (n(m, d), d = qa(y, m.mode, b), d.return = m, m = d), s(m)) : n(m, d);
  }
  return _;
}
var Wr = xp(!0), bp = xp(!1), ms = Wn(null), gs = null, Ar = null, Fu = null;
function Du() {
  Fu = Ar = gs = null;
}
function zu(e) {
  var t = ms.current;
  be(ms), e._currentValue = t;
}
function Pl(e, t, n) {
  for (; e !== null; ) {
    var r = e.alternate;
    if ((e.childLanes & t) !== t ? (e.childLanes |= t, r !== null && (r.childLanes |= t)) : r !== null && (r.childLanes & t) !== t && (r.childLanes |= t), e === n) break;
    e = e.return;
  }
}
function zr(e, t) {
  gs = e, Fu = Ar = null, e = e.dependencies, e !== null && e.firstContext !== null && (e.lanes & t && (ut = !0), e.firstContext = null);
}
function At(e) {
  var t = e._currentValue;
  if (Fu !== e) if (e = { context: e, memoizedValue: t, next: null }, Ar === null) {
    if (gs === null) throw Error(P(308));
    Ar = e, gs.dependencies = { lanes: 0, firstContext: e };
  } else Ar = Ar.next = e;
  return t;
}
var Gn = null;
function Mu(e) {
  Gn === null ? Gn = [e] : Gn.push(e);
}
function _p(e, t, n, r) {
  var i = t.interleaved;
  return i === null ? (n.next = n, Mu(t)) : (n.next = i.next, i.next = n), t.interleaved = n, mn(e, r);
}
function mn(e, t) {
  e.lanes |= t;
  var n = e.alternate;
  for (n !== null && (n.lanes |= t), n = e, e = e.return; e !== null; ) e.childLanes |= t, n = e.alternate, n !== null && (n.childLanes |= t), n = e, e = e.return;
  return n.tag === 3 ? n.stateNode : null;
}
var Nn = !1;
function Uu(e) {
  e.updateQueue = { baseState: e.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
}
function kp(e, t) {
  e = e.updateQueue, t.updateQueue === e && (t.updateQueue = { baseState: e.baseState, firstBaseUpdate: e.firstBaseUpdate, lastBaseUpdate: e.lastBaseUpdate, shared: e.shared, effects: e.effects });
}
function dn(e, t) {
  return { eventTime: e, lane: t, tag: 0, payload: null, callback: null, next: null };
}
function Dn(e, t, n) {
  var r = e.updateQueue;
  if (r === null) return null;
  if (r = r.shared, de & 2) {
    var i = r.pending;
    return i === null ? t.next = t : (t.next = i.next, i.next = t), r.pending = t, mn(e, n);
  }
  return i = r.interleaved, i === null ? (t.next = t, Mu(r)) : (t.next = i.next, i.next = t), r.interleaved = t, mn(e, n);
}
function Wo(e, t, n) {
  if (t = t.updateQueue, t !== null && (t = t.shared, (n & 4194240) !== 0)) {
    var r = t.lanes;
    r &= e.pendingLanes, n |= r, t.lanes = n, Eu(e, n);
  }
}
function rd(e, t) {
  var n = e.updateQueue, r = e.alternate;
  if (r !== null && (r = r.updateQueue, n === r)) {
    var i = null, o = null;
    if (n = n.firstBaseUpdate, n !== null) {
      do {
        var s = { eventTime: n.eventTime, lane: n.lane, tag: n.tag, payload: n.payload, callback: n.callback, next: null };
        o === null ? i = o = s : o = o.next = s, n = n.next;
      } while (n !== null);
      o === null ? i = o = t : o = o.next = t;
    } else i = o = t;
    n = { baseState: r.baseState, firstBaseUpdate: i, lastBaseUpdate: o, shared: r.shared, effects: r.effects }, e.updateQueue = n;
    return;
  }
  e = n.lastBaseUpdate, e === null ? n.firstBaseUpdate = t : e.next = t, n.lastBaseUpdate = t;
}
function ys(e, t, n, r) {
  var i = e.updateQueue;
  Nn = !1;
  var o = i.firstBaseUpdate, s = i.lastBaseUpdate, a = i.shared.pending;
  if (a !== null) {
    i.shared.pending = null;
    var l = a, u = l.next;
    l.next = null, s === null ? o = u : s.next = u, s = l;
    var c = e.alternate;
    c !== null && (c = c.updateQueue, a = c.lastBaseUpdate, a !== s && (a === null ? c.firstBaseUpdate = u : a.next = u, c.lastBaseUpdate = l));
  }
  if (o !== null) {
    var p = i.baseState;
    s = 0, c = u = l = null, a = o;
    do {
      var h = a.lane, x = a.eventTime;
      if ((r & h) === h) {
        c !== null && (c = c.next = {
          eventTime: x,
          lane: 0,
          tag: a.tag,
          payload: a.payload,
          callback: a.callback,
          next: null
        });
        e: {
          var v = e, w = a;
          switch (h = t, x = n, w.tag) {
            case 1:
              if (v = w.payload, typeof v == "function") {
                p = v.call(x, p, h);
                break e;
              }
              p = v;
              break e;
            case 3:
              v.flags = v.flags & -65537 | 128;
            case 0:
              if (v = w.payload, h = typeof v == "function" ? v.call(x, p, h) : v, h == null) break e;
              p = Ce({}, p, h);
              break e;
            case 2:
              Nn = !0;
          }
        }
        a.callback !== null && a.lane !== 0 && (e.flags |= 64, h = i.effects, h === null ? i.effects = [a] : h.push(a));
      } else x = { eventTime: x, lane: h, tag: a.tag, payload: a.payload, callback: a.callback, next: null }, c === null ? (u = c = x, l = p) : c = c.next = x, s |= h;
      if (a = a.next, a === null) {
        if (a = i.shared.pending, a === null) break;
        h = a, a = h.next, h.next = null, i.lastBaseUpdate = h, i.shared.pending = null;
      }
    } while (!0);
    if (c === null && (l = p), i.baseState = l, i.firstBaseUpdate = u, i.lastBaseUpdate = c, t = i.shared.interleaved, t !== null) {
      i = t;
      do
        s |= i.lane, i = i.next;
      while (i !== t);
    } else o === null && (i.shared.lanes = 0);
    ur |= s, e.lanes = s, e.memoizedState = p;
  }
}
function id(e, t, n) {
  if (e = t.effects, t.effects = null, e !== null) for (t = 0; t < e.length; t++) {
    var r = e[t], i = r.callback;
    if (i !== null) {
      if (r.callback = null, r = n, typeof i != "function") throw Error(P(191, i));
      i.call(r);
    }
  }
}
var ho = {}, Gt = Wn(ho), Xi = Wn(ho), eo = Wn(ho);
function Yn(e) {
  if (e === ho) throw Error(P(174));
  return e;
}
function Vu(e, t) {
  switch (ye(eo, t), ye(Xi, e), ye(Gt, ho), e = t.nodeType, e) {
    case 9:
    case 11:
      t = (t = t.documentElement) ? t.namespaceURI : pl(null, "");
      break;
    default:
      e = e === 8 ? t.parentNode : t, t = e.namespaceURI || null, e = e.tagName, t = pl(t, e);
  }
  be(Gt), ye(Gt, t);
}
function Zr() {
  be(Gt), be(Xi), be(eo);
}
function Sp(e) {
  Yn(eo.current);
  var t = Yn(Gt.current), n = pl(t, e.type);
  t !== n && (ye(Xi, e), ye(Gt, n));
}
function $u(e) {
  Xi.current === e && (be(Gt), be(Xi));
}
var Se = Wn(0);
function vs(e) {
  for (var t = e; t !== null; ) {
    if (t.tag === 13) {
      var n = t.memoizedState;
      if (n !== null && (n = n.dehydrated, n === null || n.data === "$?" || n.data === "$!")) return t;
    } else if (t.tag === 19 && t.memoizedProps.revealOrder !== void 0) {
      if (t.flags & 128) return t;
    } else if (t.child !== null) {
      t.child.return = t, t = t.child;
      continue;
    }
    if (t === e) break;
    for (; t.sibling === null; ) {
      if (t.return === null || t.return === e) return null;
      t = t.return;
    }
    t.sibling.return = t.return, t = t.sibling;
  }
  return null;
}
var $a = [];
function Bu() {
  for (var e = 0; e < $a.length; e++) $a[e]._workInProgressVersionPrimary = null;
  $a.length = 0;
}
var Zo = wn.ReactCurrentDispatcher, Ba = wn.ReactCurrentBatchConfig, lr = 0, Ee = null, De = null, Ue = null, ws = !1, Oi = !1, to = 0, Ey = 0;
function qe() {
  throw Error(P(321));
}
function Hu(e, t) {
  if (t === null) return !1;
  for (var n = 0; n < t.length && n < e.length; n++) if (!Bt(e[n], t[n])) return !1;
  return !0;
}
function Wu(e, t, n, r, i, o) {
  if (lr = o, Ee = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, Zo.current = e === null || e.memoizedState === null ? Ry : Iy, e = n(r, i), Oi) {
    o = 0;
    do {
      if (Oi = !1, to = 0, 25 <= o) throw Error(P(301));
      o += 1, Ue = De = null, t.updateQueue = null, Zo.current = Ay, e = n(r, i);
    } while (Oi);
  }
  if (Zo.current = xs, t = De !== null && De.next !== null, lr = 0, Ue = De = Ee = null, ws = !1, t) throw Error(P(300));
  return e;
}
function Zu() {
  var e = to !== 0;
  return to = 0, e;
}
function Qt() {
  var e = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
  return Ue === null ? Ee.memoizedState = Ue = e : Ue = Ue.next = e, Ue;
}
function Ot() {
  if (De === null) {
    var e = Ee.alternate;
    e = e !== null ? e.memoizedState : null;
  } else e = De.next;
  var t = Ue === null ? Ee.memoizedState : Ue.next;
  if (t !== null) Ue = t, De = e;
  else {
    if (e === null) throw Error(P(310));
    De = e, e = { memoizedState: De.memoizedState, baseState: De.baseState, baseQueue: De.baseQueue, queue: De.queue, next: null }, Ue === null ? Ee.memoizedState = Ue = e : Ue = Ue.next = e;
  }
  return Ue;
}
function no(e, t) {
  return typeof t == "function" ? t(e) : t;
}
function Ha(e) {
  var t = Ot(), n = t.queue;
  if (n === null) throw Error(P(311));
  n.lastRenderedReducer = e;
  var r = De, i = r.baseQueue, o = n.pending;
  if (o !== null) {
    if (i !== null) {
      var s = i.next;
      i.next = o.next, o.next = s;
    }
    r.baseQueue = i = o, n.pending = null;
  }
  if (i !== null) {
    o = i.next, r = r.baseState;
    var a = s = null, l = null, u = o;
    do {
      var c = u.lane;
      if ((lr & c) === c) l !== null && (l = l.next = { lane: 0, action: u.action, hasEagerState: u.hasEagerState, eagerState: u.eagerState, next: null }), r = u.hasEagerState ? u.eagerState : e(r, u.action);
      else {
        var p = {
          lane: c,
          action: u.action,
          hasEagerState: u.hasEagerState,
          eagerState: u.eagerState,
          next: null
        };
        l === null ? (a = l = p, s = r) : l = l.next = p, Ee.lanes |= c, ur |= c;
      }
      u = u.next;
    } while (u !== null && u !== o);
    l === null ? s = r : l.next = a, Bt(r, t.memoizedState) || (ut = !0), t.memoizedState = r, t.baseState = s, t.baseQueue = l, n.lastRenderedState = r;
  }
  if (e = n.interleaved, e !== null) {
    i = e;
    do
      o = i.lane, Ee.lanes |= o, ur |= o, i = i.next;
    while (i !== e);
  } else i === null && (n.lanes = 0);
  return [t.memoizedState, n.dispatch];
}
function Wa(e) {
  var t = Ot(), n = t.queue;
  if (n === null) throw Error(P(311));
  n.lastRenderedReducer = e;
  var r = n.dispatch, i = n.pending, o = t.memoizedState;
  if (i !== null) {
    n.pending = null;
    var s = i = i.next;
    do
      o = e(o, s.action), s = s.next;
    while (s !== i);
    Bt(o, t.memoizedState) || (ut = !0), t.memoizedState = o, t.baseQueue === null && (t.baseState = o), n.lastRenderedState = o;
  }
  return [o, r];
}
function Ep() {
}
function Cp(e, t) {
  var n = Ee, r = Ot(), i = t(), o = !Bt(r.memoizedState, i);
  if (o && (r.memoizedState = i, ut = !0), r = r.queue, Qu(Rp.bind(null, n, r, e), [e]), r.getSnapshot !== t || o || Ue !== null && Ue.memoizedState.tag & 1) {
    if (n.flags |= 2048, ro(9, Tp.bind(null, n, r, i, t), void 0, null), Ve === null) throw Error(P(349));
    lr & 30 || Np(n, t, i);
  }
  return i;
}
function Np(e, t, n) {
  e.flags |= 16384, e = { getSnapshot: t, value: n }, t = Ee.updateQueue, t === null ? (t = { lastEffect: null, stores: null }, Ee.updateQueue = t, t.stores = [e]) : (n = t.stores, n === null ? t.stores = [e] : n.push(e));
}
function Tp(e, t, n, r) {
  t.value = n, t.getSnapshot = r, Ip(t) && Ap(e);
}
function Rp(e, t, n) {
  return n(function() {
    Ip(t) && Ap(e);
  });
}
function Ip(e) {
  var t = e.getSnapshot;
  e = e.value;
  try {
    var n = t();
    return !Bt(e, n);
  } catch {
    return !0;
  }
}
function Ap(e) {
  var t = mn(e, 1);
  t !== null && $t(t, e, 1, -1);
}
function od(e) {
  var t = Qt();
  return typeof e == "function" && (e = e()), t.memoizedState = t.baseState = e, e = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: no, lastRenderedState: e }, t.queue = e, e = e.dispatch = Ty.bind(null, Ee, e), [t.memoizedState, e];
}
function ro(e, t, n, r) {
  return e = { tag: e, create: t, destroy: n, deps: r, next: null }, t = Ee.updateQueue, t === null ? (t = { lastEffect: null, stores: null }, Ee.updateQueue = t, t.lastEffect = e.next = e) : (n = t.lastEffect, n === null ? t.lastEffect = e.next = e : (r = n.next, n.next = e, e.next = r, t.lastEffect = e)), e;
}
function Op() {
  return Ot().memoizedState;
}
function Qo(e, t, n, r) {
  var i = Qt();
  Ee.flags |= e, i.memoizedState = ro(1 | t, n, void 0, r === void 0 ? null : r);
}
function Gs(e, t, n, r) {
  var i = Ot();
  r = r === void 0 ? null : r;
  var o = void 0;
  if (De !== null) {
    var s = De.memoizedState;
    if (o = s.destroy, r !== null && Hu(r, s.deps)) {
      i.memoizedState = ro(t, n, o, r);
      return;
    }
  }
  Ee.flags |= e, i.memoizedState = ro(1 | t, n, o, r);
}
function sd(e, t) {
  return Qo(8390656, 8, e, t);
}
function Qu(e, t) {
  return Gs(2048, 8, e, t);
}
function Pp(e, t) {
  return Gs(4, 2, e, t);
}
function jp(e, t) {
  return Gs(4, 4, e, t);
}
function Lp(e, t) {
  if (typeof t == "function") return e = e(), t(e), function() {
    t(null);
  };
  if (t != null) return e = e(), t.current = e, function() {
    t.current = null;
  };
}
function Fp(e, t, n) {
  return n = n != null ? n.concat([e]) : null, Gs(4, 4, Lp.bind(null, t, e), n);
}
function qu() {
}
function Dp(e, t) {
  var n = Ot();
  t = t === void 0 ? null : t;
  var r = n.memoizedState;
  return r !== null && t !== null && Hu(t, r[1]) ? r[0] : (n.memoizedState = [e, t], e);
}
function zp(e, t) {
  var n = Ot();
  t = t === void 0 ? null : t;
  var r = n.memoizedState;
  return r !== null && t !== null && Hu(t, r[1]) ? r[0] : (e = e(), n.memoizedState = [e, t], e);
}
function Mp(e, t, n) {
  return lr & 21 ? (Bt(n, t) || (n = Hf(), Ee.lanes |= n, ur |= n, e.baseState = !0), t) : (e.baseState && (e.baseState = !1, ut = !0), e.memoizedState = n);
}
function Cy(e, t) {
  var n = he;
  he = n !== 0 && 4 > n ? n : 4, e(!0);
  var r = Ba.transition;
  Ba.transition = {};
  try {
    e(!1), t();
  } finally {
    he = n, Ba.transition = r;
  }
}
function Up() {
  return Ot().memoizedState;
}
function Ny(e, t, n) {
  var r = Mn(e);
  if (n = { lane: r, action: n, hasEagerState: !1, eagerState: null, next: null }, Vp(e)) $p(t, n);
  else if (n = _p(e, t, n, r), n !== null) {
    var i = it();
    $t(n, e, r, i), Bp(n, t, r);
  }
}
function Ty(e, t, n) {
  var r = Mn(e), i = { lane: r, action: n, hasEagerState: !1, eagerState: null, next: null };
  if (Vp(e)) $p(t, i);
  else {
    var o = e.alternate;
    if (e.lanes === 0 && (o === null || o.lanes === 0) && (o = t.lastRenderedReducer, o !== null)) try {
      var s = t.lastRenderedState, a = o(s, n);
      if (i.hasEagerState = !0, i.eagerState = a, Bt(a, s)) {
        var l = t.interleaved;
        l === null ? (i.next = i, Mu(t)) : (i.next = l.next, l.next = i), t.interleaved = i;
        return;
      }
    } catch {
    } finally {
    }
    n = _p(e, t, i, r), n !== null && (i = it(), $t(n, e, r, i), Bp(n, t, r));
  }
}
function Vp(e) {
  var t = e.alternate;
  return e === Ee || t !== null && t === Ee;
}
function $p(e, t) {
  Oi = ws = !0;
  var n = e.pending;
  n === null ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
}
function Bp(e, t, n) {
  if (n & 4194240) {
    var r = t.lanes;
    r &= e.pendingLanes, n |= r, t.lanes = n, Eu(e, n);
  }
}
var xs = { readContext: At, useCallback: qe, useContext: qe, useEffect: qe, useImperativeHandle: qe, useInsertionEffect: qe, useLayoutEffect: qe, useMemo: qe, useReducer: qe, useRef: qe, useState: qe, useDebugValue: qe, useDeferredValue: qe, useTransition: qe, useMutableSource: qe, useSyncExternalStore: qe, useId: qe, unstable_isNewReconciler: !1 }, Ry = { readContext: At, useCallback: function(e, t) {
  return Qt().memoizedState = [e, t === void 0 ? null : t], e;
}, useContext: At, useEffect: sd, useImperativeHandle: function(e, t, n) {
  return n = n != null ? n.concat([e]) : null, Qo(
    4194308,
    4,
    Lp.bind(null, t, e),
    n
  );
}, useLayoutEffect: function(e, t) {
  return Qo(4194308, 4, e, t);
}, useInsertionEffect: function(e, t) {
  return Qo(4, 2, e, t);
}, useMemo: function(e, t) {
  var n = Qt();
  return t = t === void 0 ? null : t, e = e(), n.memoizedState = [e, t], e;
}, useReducer: function(e, t, n) {
  var r = Qt();
  return t = n !== void 0 ? n(t) : t, r.memoizedState = r.baseState = t, e = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: e, lastRenderedState: t }, r.queue = e, e = e.dispatch = Ny.bind(null, Ee, e), [r.memoizedState, e];
}, useRef: function(e) {
  var t = Qt();
  return e = { current: e }, t.memoizedState = e;
}, useState: od, useDebugValue: qu, useDeferredValue: function(e) {
  return Qt().memoizedState = e;
}, useTransition: function() {
  var e = od(!1), t = e[0];
  return e = Cy.bind(null, e[1]), Qt().memoizedState = e, [t, e];
}, useMutableSource: function() {
}, useSyncExternalStore: function(e, t, n) {
  var r = Ee, i = Qt();
  if (_e) {
    if (n === void 0) throw Error(P(407));
    n = n();
  } else {
    if (n = t(), Ve === null) throw Error(P(349));
    lr & 30 || Np(r, t, n);
  }
  i.memoizedState = n;
  var o = { value: n, getSnapshot: t };
  return i.queue = o, sd(Rp.bind(
    null,
    r,
    o,
    e
  ), [e]), r.flags |= 2048, ro(9, Tp.bind(null, r, o, n, t), void 0, null), n;
}, useId: function() {
  var e = Qt(), t = Ve.identifierPrefix;
  if (_e) {
    var n = un, r = ln;
    n = (r & ~(1 << 32 - Vt(r) - 1)).toString(32) + n, t = ":" + t + "R" + n, n = to++, 0 < n && (t += "H" + n.toString(32)), t += ":";
  } else n = Ey++, t = ":" + t + "r" + n.toString(32) + ":";
  return e.memoizedState = t;
}, unstable_isNewReconciler: !1 }, Iy = {
  readContext: At,
  useCallback: Dp,
  useContext: At,
  useEffect: Qu,
  useImperativeHandle: Fp,
  useInsertionEffect: Pp,
  useLayoutEffect: jp,
  useMemo: zp,
  useReducer: Ha,
  useRef: Op,
  useState: function() {
    return Ha(no);
  },
  useDebugValue: qu,
  useDeferredValue: function(e) {
    var t = Ot();
    return Mp(t, De.memoizedState, e);
  },
  useTransition: function() {
    var e = Ha(no)[0], t = Ot().memoizedState;
    return [e, t];
  },
  useMutableSource: Ep,
  useSyncExternalStore: Cp,
  useId: Up,
  unstable_isNewReconciler: !1
}, Ay = { readContext: At, useCallback: Dp, useContext: At, useEffect: Qu, useImperativeHandle: Fp, useInsertionEffect: Pp, useLayoutEffect: jp, useMemo: zp, useReducer: Wa, useRef: Op, useState: function() {
  return Wa(no);
}, useDebugValue: qu, useDeferredValue: function(e) {
  var t = Ot();
  return De === null ? t.memoizedState = e : Mp(t, De.memoizedState, e);
}, useTransition: function() {
  var e = Wa(no)[0], t = Ot().memoizedState;
  return [e, t];
}, useMutableSource: Ep, useSyncExternalStore: Cp, useId: Up, unstable_isNewReconciler: !1 };
function Ft(e, t) {
  if (e && e.defaultProps) {
    t = Ce({}, t), e = e.defaultProps;
    for (var n in e) t[n] === void 0 && (t[n] = e[n]);
    return t;
  }
  return t;
}
function jl(e, t, n, r) {
  t = e.memoizedState, n = n(r, t), n = n == null ? t : Ce({}, t, n), e.memoizedState = n, e.lanes === 0 && (e.updateQueue.baseState = n);
}
var Ys = { isMounted: function(e) {
  return (e = e._reactInternals) ? mr(e) === e : !1;
}, enqueueSetState: function(e, t, n) {
  e = e._reactInternals;
  var r = it(), i = Mn(e), o = dn(r, i);
  o.payload = t, n != null && (o.callback = n), t = Dn(e, o, i), t !== null && ($t(t, e, i, r), Wo(t, e, i));
}, enqueueReplaceState: function(e, t, n) {
  e = e._reactInternals;
  var r = it(), i = Mn(e), o = dn(r, i);
  o.tag = 1, o.payload = t, n != null && (o.callback = n), t = Dn(e, o, i), t !== null && ($t(t, e, i, r), Wo(t, e, i));
}, enqueueForceUpdate: function(e, t) {
  e = e._reactInternals;
  var n = it(), r = Mn(e), i = dn(n, r);
  i.tag = 2, t != null && (i.callback = t), t = Dn(e, i, r), t !== null && ($t(t, e, r, n), Wo(t, e, r));
} };
function ad(e, t, n, r, i, o, s) {
  return e = e.stateNode, typeof e.shouldComponentUpdate == "function" ? e.shouldComponentUpdate(r, o, s) : t.prototype && t.prototype.isPureReactComponent ? !Ji(n, r) || !Ji(i, o) : !0;
}
function Hp(e, t, n) {
  var r = !1, i = $n, o = t.contextType;
  return typeof o == "object" && o !== null ? o = At(o) : (i = dt(t) ? sr : Ye.current, r = t.contextTypes, o = (r = r != null) ? Br(e, i) : $n), t = new t(n, o), e.memoizedState = t.state !== null && t.state !== void 0 ? t.state : null, t.updater = Ys, e.stateNode = t, t._reactInternals = e, r && (e = e.stateNode, e.__reactInternalMemoizedUnmaskedChildContext = i, e.__reactInternalMemoizedMaskedChildContext = o), t;
}
function ld(e, t, n, r) {
  e = t.state, typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(n, r), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && Ys.enqueueReplaceState(t, t.state, null);
}
function Ll(e, t, n, r) {
  var i = e.stateNode;
  i.props = n, i.state = e.memoizedState, i.refs = {}, Uu(e);
  var o = t.contextType;
  typeof o == "object" && o !== null ? i.context = At(o) : (o = dt(t) ? sr : Ye.current, i.context = Br(e, o)), i.state = e.memoizedState, o = t.getDerivedStateFromProps, typeof o == "function" && (jl(e, t, o, n), i.state = e.memoizedState), typeof t.getDerivedStateFromProps == "function" || typeof i.getSnapshotBeforeUpdate == "function" || typeof i.UNSAFE_componentWillMount != "function" && typeof i.componentWillMount != "function" || (t = i.state, typeof i.componentWillMount == "function" && i.componentWillMount(), typeof i.UNSAFE_componentWillMount == "function" && i.UNSAFE_componentWillMount(), t !== i.state && Ys.enqueueReplaceState(i, i.state, null), ys(e, n, i, r), i.state = e.memoizedState), typeof i.componentDidMount == "function" && (e.flags |= 4194308);
}
function Qr(e, t) {
  try {
    var n = "", r = t;
    do
      n += og(r), r = r.return;
    while (r);
    var i = n;
  } catch (o) {
    i = `
Error generating stack: ` + o.message + `
` + o.stack;
  }
  return { value: e, source: t, stack: i, digest: null };
}
function Za(e, t, n) {
  return { value: e, source: null, stack: n ?? null, digest: t ?? null };
}
function Fl(e, t) {
  try {
    console.error(t.value);
  } catch (n) {
    setTimeout(function() {
      throw n;
    });
  }
}
var Oy = typeof WeakMap == "function" ? WeakMap : Map;
function Wp(e, t, n) {
  n = dn(-1, n), n.tag = 3, n.payload = { element: null };
  var r = t.value;
  return n.callback = function() {
    _s || (_s = !0, Zl = r), Fl(e, t);
  }, n;
}
function Zp(e, t, n) {
  n = dn(-1, n), n.tag = 3;
  var r = e.type.getDerivedStateFromError;
  if (typeof r == "function") {
    var i = t.value;
    n.payload = function() {
      return r(i);
    }, n.callback = function() {
      Fl(e, t);
    };
  }
  var o = e.stateNode;
  return o !== null && typeof o.componentDidCatch == "function" && (n.callback = function() {
    Fl(e, t), typeof r != "function" && (zn === null ? zn = /* @__PURE__ */ new Set([this]) : zn.add(this));
    var s = t.stack;
    this.componentDidCatch(t.value, { componentStack: s !== null ? s : "" });
  }), n;
}
function ud(e, t, n) {
  var r = e.pingCache;
  if (r === null) {
    r = e.pingCache = new Oy();
    var i = /* @__PURE__ */ new Set();
    r.set(t, i);
  } else i = r.get(t), i === void 0 && (i = /* @__PURE__ */ new Set(), r.set(t, i));
  i.has(n) || (i.add(n), e = Zy.bind(null, e, t, n), t.then(e, e));
}
function cd(e) {
  do {
    var t;
    if ((t = e.tag === 13) && (t = e.memoizedState, t = t !== null ? t.dehydrated !== null : !0), t) return e;
    e = e.return;
  } while (e !== null);
  return null;
}
function dd(e, t, n, r, i) {
  return e.mode & 1 ? (e.flags |= 65536, e.lanes = i, e) : (e === t ? e.flags |= 65536 : (e.flags |= 128, n.flags |= 131072, n.flags &= -52805, n.tag === 1 && (n.alternate === null ? n.tag = 17 : (t = dn(-1, 1), t.tag = 2, Dn(n, t, 1))), n.lanes |= 1), e);
}
var Py = wn.ReactCurrentOwner, ut = !1;
function nt(e, t, n, r) {
  t.child = e === null ? bp(t, null, n, r) : Wr(t, e.child, n, r);
}
function fd(e, t, n, r, i) {
  n = n.render;
  var o = t.ref;
  return zr(t, i), r = Wu(e, t, n, r, o, i), n = Zu(), e !== null && !ut ? (t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~i, gn(e, t, i)) : (_e && n && Pu(t), t.flags |= 1, nt(e, t, r, i), t.child);
}
function pd(e, t, n, r, i) {
  if (e === null) {
    var o = n.type;
    return typeof o == "function" && !nc(o) && o.defaultProps === void 0 && n.compare === null && n.defaultProps === void 0 ? (t.tag = 15, t.type = o, Qp(e, t, o, r, i)) : (e = Go(n.type, null, r, t, t.mode, i), e.ref = t.ref, e.return = t, t.child = e);
  }
  if (o = e.child, !(e.lanes & i)) {
    var s = o.memoizedProps;
    if (n = n.compare, n = n !== null ? n : Ji, n(s, r) && e.ref === t.ref) return gn(e, t, i);
  }
  return t.flags |= 1, e = Un(o, r), e.ref = t.ref, e.return = t, t.child = e;
}
function Qp(e, t, n, r, i) {
  if (e !== null) {
    var o = e.memoizedProps;
    if (Ji(o, r) && e.ref === t.ref) if (ut = !1, t.pendingProps = r = o, (e.lanes & i) !== 0) e.flags & 131072 && (ut = !0);
    else return t.lanes = e.lanes, gn(e, t, i);
  }
  return Dl(e, t, n, r, i);
}
function qp(e, t, n) {
  var r = t.pendingProps, i = r.children, o = e !== null ? e.memoizedState : null;
  if (r.mode === "hidden") if (!(t.mode & 1)) t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, ye(Pr, gt), gt |= n;
  else {
    if (!(n & 1073741824)) return e = o !== null ? o.baseLanes | n : n, t.lanes = t.childLanes = 1073741824, t.memoizedState = { baseLanes: e, cachePool: null, transitions: null }, t.updateQueue = null, ye(Pr, gt), gt |= e, null;
    t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, r = o !== null ? o.baseLanes : n, ye(Pr, gt), gt |= r;
  }
  else o !== null ? (r = o.baseLanes | n, t.memoizedState = null) : r = n, ye(Pr, gt), gt |= r;
  return nt(e, t, i, n), t.child;
}
function Jp(e, t) {
  var n = t.ref;
  (e === null && n !== null || e !== null && e.ref !== n) && (t.flags |= 512, t.flags |= 2097152);
}
function Dl(e, t, n, r, i) {
  var o = dt(n) ? sr : Ye.current;
  return o = Br(t, o), zr(t, i), n = Wu(e, t, n, r, o, i), r = Zu(), e !== null && !ut ? (t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~i, gn(e, t, i)) : (_e && r && Pu(t), t.flags |= 1, nt(e, t, n, i), t.child);
}
function hd(e, t, n, r, i) {
  if (dt(n)) {
    var o = !0;
    fs(t);
  } else o = !1;
  if (zr(t, i), t.stateNode === null) qo(e, t), Hp(t, n, r), Ll(t, n, r, i), r = !0;
  else if (e === null) {
    var s = t.stateNode, a = t.memoizedProps;
    s.props = a;
    var l = s.context, u = n.contextType;
    typeof u == "object" && u !== null ? u = At(u) : (u = dt(n) ? sr : Ye.current, u = Br(t, u));
    var c = n.getDerivedStateFromProps, p = typeof c == "function" || typeof s.getSnapshotBeforeUpdate == "function";
    p || typeof s.UNSAFE_componentWillReceiveProps != "function" && typeof s.componentWillReceiveProps != "function" || (a !== r || l !== u) && ld(t, s, r, u), Nn = !1;
    var h = t.memoizedState;
    s.state = h, ys(t, r, s, i), l = t.memoizedState, a !== r || h !== l || ct.current || Nn ? (typeof c == "function" && (jl(t, n, c, r), l = t.memoizedState), (a = Nn || ad(t, n, a, r, h, l, u)) ? (p || typeof s.UNSAFE_componentWillMount != "function" && typeof s.componentWillMount != "function" || (typeof s.componentWillMount == "function" && s.componentWillMount(), typeof s.UNSAFE_componentWillMount == "function" && s.UNSAFE_componentWillMount()), typeof s.componentDidMount == "function" && (t.flags |= 4194308)) : (typeof s.componentDidMount == "function" && (t.flags |= 4194308), t.memoizedProps = r, t.memoizedState = l), s.props = r, s.state = l, s.context = u, r = a) : (typeof s.componentDidMount == "function" && (t.flags |= 4194308), r = !1);
  } else {
    s = t.stateNode, kp(e, t), a = t.memoizedProps, u = t.type === t.elementType ? a : Ft(t.type, a), s.props = u, p = t.pendingProps, h = s.context, l = n.contextType, typeof l == "object" && l !== null ? l = At(l) : (l = dt(n) ? sr : Ye.current, l = Br(t, l));
    var x = n.getDerivedStateFromProps;
    (c = typeof x == "function" || typeof s.getSnapshotBeforeUpdate == "function") || typeof s.UNSAFE_componentWillReceiveProps != "function" && typeof s.componentWillReceiveProps != "function" || (a !== p || h !== l) && ld(t, s, r, l), Nn = !1, h = t.memoizedState, s.state = h, ys(t, r, s, i);
    var v = t.memoizedState;
    a !== p || h !== v || ct.current || Nn ? (typeof x == "function" && (jl(t, n, x, r), v = t.memoizedState), (u = Nn || ad(t, n, u, r, h, v, l) || !1) ? (c || typeof s.UNSAFE_componentWillUpdate != "function" && typeof s.componentWillUpdate != "function" || (typeof s.componentWillUpdate == "function" && s.componentWillUpdate(r, v, l), typeof s.UNSAFE_componentWillUpdate == "function" && s.UNSAFE_componentWillUpdate(r, v, l)), typeof s.componentDidUpdate == "function" && (t.flags |= 4), typeof s.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof s.componentDidUpdate != "function" || a === e.memoizedProps && h === e.memoizedState || (t.flags |= 4), typeof s.getSnapshotBeforeUpdate != "function" || a === e.memoizedProps && h === e.memoizedState || (t.flags |= 1024), t.memoizedProps = r, t.memoizedState = v), s.props = r, s.state = v, s.context = l, r = u) : (typeof s.componentDidUpdate != "function" || a === e.memoizedProps && h === e.memoizedState || (t.flags |= 4), typeof s.getSnapshotBeforeUpdate != "function" || a === e.memoizedProps && h === e.memoizedState || (t.flags |= 1024), r = !1);
  }
  return zl(e, t, n, r, o, i);
}
function zl(e, t, n, r, i, o) {
  Jp(e, t);
  var s = (t.flags & 128) !== 0;
  if (!r && !s) return i && Xc(t, n, !1), gn(e, t, o);
  r = t.stateNode, Py.current = t;
  var a = s && typeof n.getDerivedStateFromError != "function" ? null : r.render();
  return t.flags |= 1, e !== null && s ? (t.child = Wr(t, e.child, null, o), t.child = Wr(t, null, a, o)) : nt(e, t, a, o), t.memoizedState = r.state, i && Xc(t, n, !0), t.child;
}
function Kp(e) {
  var t = e.stateNode;
  t.pendingContext ? Yc(e, t.pendingContext, t.pendingContext !== t.context) : t.context && Yc(e, t.context, !1), Vu(e, t.containerInfo);
}
function md(e, t, n, r, i) {
  return Hr(), Lu(i), t.flags |= 256, nt(e, t, n, r), t.child;
}
var Ml = { dehydrated: null, treeContext: null, retryLane: 0 };
function Ul(e) {
  return { baseLanes: e, cachePool: null, transitions: null };
}
function Gp(e, t, n) {
  var r = t.pendingProps, i = Se.current, o = !1, s = (t.flags & 128) !== 0, a;
  if ((a = s) || (a = e !== null && e.memoizedState === null ? !1 : (i & 2) !== 0), a ? (o = !0, t.flags &= -129) : (e === null || e.memoizedState !== null) && (i |= 1), ye(Se, i & 1), e === null)
    return Ol(t), e = t.memoizedState, e !== null && (e = e.dehydrated, e !== null) ? (t.mode & 1 ? e.data === "$!" ? t.lanes = 8 : t.lanes = 1073741824 : t.lanes = 1, null) : (s = r.children, e = r.fallback, o ? (r = t.mode, o = t.child, s = { mode: "hidden", children: s }, !(r & 1) && o !== null ? (o.childLanes = 0, o.pendingProps = s) : o = ta(s, r, 0, null), e = nr(e, r, n, null), o.return = t, e.return = t, o.sibling = e, t.child = o, t.child.memoizedState = Ul(n), t.memoizedState = Ml, e) : Ju(t, s));
  if (i = e.memoizedState, i !== null && (a = i.dehydrated, a !== null)) return jy(e, t, s, r, a, i, n);
  if (o) {
    o = r.fallback, s = t.mode, i = e.child, a = i.sibling;
    var l = { mode: "hidden", children: r.children };
    return !(s & 1) && t.child !== i ? (r = t.child, r.childLanes = 0, r.pendingProps = l, t.deletions = null) : (r = Un(i, l), r.subtreeFlags = i.subtreeFlags & 14680064), a !== null ? o = Un(a, o) : (o = nr(o, s, n, null), o.flags |= 2), o.return = t, r.return = t, r.sibling = o, t.child = r, r = o, o = t.child, s = e.child.memoizedState, s = s === null ? Ul(n) : { baseLanes: s.baseLanes | n, cachePool: null, transitions: s.transitions }, o.memoizedState = s, o.childLanes = e.childLanes & ~n, t.memoizedState = Ml, r;
  }
  return o = e.child, e = o.sibling, r = Un(o, { mode: "visible", children: r.children }), !(t.mode & 1) && (r.lanes = n), r.return = t, r.sibling = null, e !== null && (n = t.deletions, n === null ? (t.deletions = [e], t.flags |= 16) : n.push(e)), t.child = r, t.memoizedState = null, r;
}
function Ju(e, t) {
  return t = ta({ mode: "visible", children: t }, e.mode, 0, null), t.return = e, e.child = t;
}
function Fo(e, t, n, r) {
  return r !== null && Lu(r), Wr(t, e.child, null, n), e = Ju(t, t.pendingProps.children), e.flags |= 2, t.memoizedState = null, e;
}
function jy(e, t, n, r, i, o, s) {
  if (n)
    return t.flags & 256 ? (t.flags &= -257, r = Za(Error(P(422))), Fo(e, t, s, r)) : t.memoizedState !== null ? (t.child = e.child, t.flags |= 128, null) : (o = r.fallback, i = t.mode, r = ta({ mode: "visible", children: r.children }, i, 0, null), o = nr(o, i, s, null), o.flags |= 2, r.return = t, o.return = t, r.sibling = o, t.child = r, t.mode & 1 && Wr(t, e.child, null, s), t.child.memoizedState = Ul(s), t.memoizedState = Ml, o);
  if (!(t.mode & 1)) return Fo(e, t, s, null);
  if (i.data === "$!") {
    if (r = i.nextSibling && i.nextSibling.dataset, r) var a = r.dgst;
    return r = a, o = Error(P(419)), r = Za(o, r, void 0), Fo(e, t, s, r);
  }
  if (a = (s & e.childLanes) !== 0, ut || a) {
    if (r = Ve, r !== null) {
      switch (s & -s) {
        case 4:
          i = 2;
          break;
        case 16:
          i = 8;
          break;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
          i = 32;
          break;
        case 536870912:
          i = 268435456;
          break;
        default:
          i = 0;
      }
      i = i & (r.suspendedLanes | s) ? 0 : i, i !== 0 && i !== o.retryLane && (o.retryLane = i, mn(e, i), $t(r, e, i, -1));
    }
    return tc(), r = Za(Error(P(421))), Fo(e, t, s, r);
  }
  return i.data === "$?" ? (t.flags |= 128, t.child = e.child, t = Qy.bind(null, e), i._reactRetry = t, null) : (e = o.treeContext, vt = Fn(i.nextSibling), wt = t, _e = !0, zt = null, e !== null && (Ct[Nt++] = ln, Ct[Nt++] = un, Ct[Nt++] = ar, ln = e.id, un = e.overflow, ar = t), t = Ju(t, r.children), t.flags |= 4096, t);
}
function gd(e, t, n) {
  e.lanes |= t;
  var r = e.alternate;
  r !== null && (r.lanes |= t), Pl(e.return, t, n);
}
function Qa(e, t, n, r, i) {
  var o = e.memoizedState;
  o === null ? e.memoizedState = { isBackwards: t, rendering: null, renderingStartTime: 0, last: r, tail: n, tailMode: i } : (o.isBackwards = t, o.rendering = null, o.renderingStartTime = 0, o.last = r, o.tail = n, o.tailMode = i);
}
function Yp(e, t, n) {
  var r = t.pendingProps, i = r.revealOrder, o = r.tail;
  if (nt(e, t, r.children, n), r = Se.current, r & 2) r = r & 1 | 2, t.flags |= 128;
  else {
    if (e !== null && e.flags & 128) e: for (e = t.child; e !== null; ) {
      if (e.tag === 13) e.memoizedState !== null && gd(e, n, t);
      else if (e.tag === 19) gd(e, n, t);
      else if (e.child !== null) {
        e.child.return = e, e = e.child;
        continue;
      }
      if (e === t) break e;
      for (; e.sibling === null; ) {
        if (e.return === null || e.return === t) break e;
        e = e.return;
      }
      e.sibling.return = e.return, e = e.sibling;
    }
    r &= 1;
  }
  if (ye(Se, r), !(t.mode & 1)) t.memoizedState = null;
  else switch (i) {
    case "forwards":
      for (n = t.child, i = null; n !== null; ) e = n.alternate, e !== null && vs(e) === null && (i = n), n = n.sibling;
      n = i, n === null ? (i = t.child, t.child = null) : (i = n.sibling, n.sibling = null), Qa(t, !1, i, n, o);
      break;
    case "backwards":
      for (n = null, i = t.child, t.child = null; i !== null; ) {
        if (e = i.alternate, e !== null && vs(e) === null) {
          t.child = i;
          break;
        }
        e = i.sibling, i.sibling = n, n = i, i = e;
      }
      Qa(t, !0, n, null, o);
      break;
    case "together":
      Qa(t, !1, null, null, void 0);
      break;
    default:
      t.memoizedState = null;
  }
  return t.child;
}
function qo(e, t) {
  !(t.mode & 1) && e !== null && (e.alternate = null, t.alternate = null, t.flags |= 2);
}
function gn(e, t, n) {
  if (e !== null && (t.dependencies = e.dependencies), ur |= t.lanes, !(n & t.childLanes)) return null;
  if (e !== null && t.child !== e.child) throw Error(P(153));
  if (t.child !== null) {
    for (e = t.child, n = Un(e, e.pendingProps), t.child = n, n.return = t; e.sibling !== null; ) e = e.sibling, n = n.sibling = Un(e, e.pendingProps), n.return = t;
    n.sibling = null;
  }
  return t.child;
}
function Ly(e, t, n) {
  switch (t.tag) {
    case 3:
      Kp(t), Hr();
      break;
    case 5:
      Sp(t);
      break;
    case 1:
      dt(t.type) && fs(t);
      break;
    case 4:
      Vu(t, t.stateNode.containerInfo);
      break;
    case 10:
      var r = t.type._context, i = t.memoizedProps.value;
      ye(ms, r._currentValue), r._currentValue = i;
      break;
    case 13:
      if (r = t.memoizedState, r !== null)
        return r.dehydrated !== null ? (ye(Se, Se.current & 1), t.flags |= 128, null) : n & t.child.childLanes ? Gp(e, t, n) : (ye(Se, Se.current & 1), e = gn(e, t, n), e !== null ? e.sibling : null);
      ye(Se, Se.current & 1);
      break;
    case 19:
      if (r = (n & t.childLanes) !== 0, e.flags & 128) {
        if (r) return Yp(e, t, n);
        t.flags |= 128;
      }
      if (i = t.memoizedState, i !== null && (i.rendering = null, i.tail = null, i.lastEffect = null), ye(Se, Se.current), r) break;
      return null;
    case 22:
    case 23:
      return t.lanes = 0, qp(e, t, n);
  }
  return gn(e, t, n);
}
var Xp, Vl, eh, th;
Xp = function(e, t) {
  for (var n = t.child; n !== null; ) {
    if (n.tag === 5 || n.tag === 6) e.appendChild(n.stateNode);
    else if (n.tag !== 4 && n.child !== null) {
      n.child.return = n, n = n.child;
      continue;
    }
    if (n === t) break;
    for (; n.sibling === null; ) {
      if (n.return === null || n.return === t) return;
      n = n.return;
    }
    n.sibling.return = n.return, n = n.sibling;
  }
};
Vl = function() {
};
eh = function(e, t, n, r) {
  var i = e.memoizedProps;
  if (i !== r) {
    e = t.stateNode, Yn(Gt.current);
    var o = null;
    switch (n) {
      case "input":
        i = ul(e, i), r = ul(e, r), o = [];
        break;
      case "select":
        i = Ce({}, i, { value: void 0 }), r = Ce({}, r, { value: void 0 }), o = [];
        break;
      case "textarea":
        i = fl(e, i), r = fl(e, r), o = [];
        break;
      default:
        typeof i.onClick != "function" && typeof r.onClick == "function" && (e.onclick = cs);
    }
    hl(n, r);
    var s;
    n = null;
    for (u in i) if (!r.hasOwnProperty(u) && i.hasOwnProperty(u) && i[u] != null) if (u === "style") {
      var a = i[u];
      for (s in a) a.hasOwnProperty(s) && (n || (n = {}), n[s] = "");
    } else u !== "dangerouslySetInnerHTML" && u !== "children" && u !== "suppressContentEditableWarning" && u !== "suppressHydrationWarning" && u !== "autoFocus" && ($i.hasOwnProperty(u) ? o || (o = []) : (o = o || []).push(u, null));
    for (u in r) {
      var l = r[u];
      if (a = i != null ? i[u] : void 0, r.hasOwnProperty(u) && l !== a && (l != null || a != null)) if (u === "style") if (a) {
        for (s in a) !a.hasOwnProperty(s) || l && l.hasOwnProperty(s) || (n || (n = {}), n[s] = "");
        for (s in l) l.hasOwnProperty(s) && a[s] !== l[s] && (n || (n = {}), n[s] = l[s]);
      } else n || (o || (o = []), o.push(
        u,
        n
      )), n = l;
      else u === "dangerouslySetInnerHTML" ? (l = l ? l.__html : void 0, a = a ? a.__html : void 0, l != null && a !== l && (o = o || []).push(u, l)) : u === "children" ? typeof l != "string" && typeof l != "number" || (o = o || []).push(u, "" + l) : u !== "suppressContentEditableWarning" && u !== "suppressHydrationWarning" && ($i.hasOwnProperty(u) ? (l != null && u === "onScroll" && xe("scroll", e), o || a === l || (o = [])) : (o = o || []).push(u, l));
    }
    n && (o = o || []).push("style", n);
    var u = o;
    (t.updateQueue = u) && (t.flags |= 4);
  }
};
th = function(e, t, n, r) {
  n !== r && (t.flags |= 4);
};
function pi(e, t) {
  if (!_e) switch (e.tailMode) {
    case "hidden":
      t = e.tail;
      for (var n = null; t !== null; ) t.alternate !== null && (n = t), t = t.sibling;
      n === null ? e.tail = null : n.sibling = null;
      break;
    case "collapsed":
      n = e.tail;
      for (var r = null; n !== null; ) n.alternate !== null && (r = n), n = n.sibling;
      r === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : r.sibling = null;
  }
}
function Je(e) {
  var t = e.alternate !== null && e.alternate.child === e.child, n = 0, r = 0;
  if (t) for (var i = e.child; i !== null; ) n |= i.lanes | i.childLanes, r |= i.subtreeFlags & 14680064, r |= i.flags & 14680064, i.return = e, i = i.sibling;
  else for (i = e.child; i !== null; ) n |= i.lanes | i.childLanes, r |= i.subtreeFlags, r |= i.flags, i.return = e, i = i.sibling;
  return e.subtreeFlags |= r, e.childLanes = n, t;
}
function Fy(e, t, n) {
  var r = t.pendingProps;
  switch (ju(t), t.tag) {
    case 2:
    case 16:
    case 15:
    case 0:
    case 11:
    case 7:
    case 8:
    case 12:
    case 9:
    case 14:
      return Je(t), null;
    case 1:
      return dt(t.type) && ds(), Je(t), null;
    case 3:
      return r = t.stateNode, Zr(), be(ct), be(Ye), Bu(), r.pendingContext && (r.context = r.pendingContext, r.pendingContext = null), (e === null || e.child === null) && (jo(t) ? t.flags |= 4 : e === null || e.memoizedState.isDehydrated && !(t.flags & 256) || (t.flags |= 1024, zt !== null && (Jl(zt), zt = null))), Vl(e, t), Je(t), null;
    case 5:
      $u(t);
      var i = Yn(eo.current);
      if (n = t.type, e !== null && t.stateNode != null) eh(e, t, n, r, i), e.ref !== t.ref && (t.flags |= 512, t.flags |= 2097152);
      else {
        if (!r) {
          if (t.stateNode === null) throw Error(P(166));
          return Je(t), null;
        }
        if (e = Yn(Gt.current), jo(t)) {
          r = t.stateNode, n = t.type;
          var o = t.memoizedProps;
          switch (r[qt] = t, r[Yi] = o, e = (t.mode & 1) !== 0, n) {
            case "dialog":
              xe("cancel", r), xe("close", r);
              break;
            case "iframe":
            case "object":
            case "embed":
              xe("load", r);
              break;
            case "video":
            case "audio":
              for (i = 0; i < ki.length; i++) xe(ki[i], r);
              break;
            case "source":
              xe("error", r);
              break;
            case "img":
            case "image":
            case "link":
              xe(
                "error",
                r
              ), xe("load", r);
              break;
            case "details":
              xe("toggle", r);
              break;
            case "input":
              Ec(r, o), xe("invalid", r);
              break;
            case "select":
              r._wrapperState = { wasMultiple: !!o.multiple }, xe("invalid", r);
              break;
            case "textarea":
              Nc(r, o), xe("invalid", r);
          }
          hl(n, o), i = null;
          for (var s in o) if (o.hasOwnProperty(s)) {
            var a = o[s];
            s === "children" ? typeof a == "string" ? r.textContent !== a && (o.suppressHydrationWarning !== !0 && Po(r.textContent, a, e), i = ["children", a]) : typeof a == "number" && r.textContent !== "" + a && (o.suppressHydrationWarning !== !0 && Po(
              r.textContent,
              a,
              e
            ), i = ["children", "" + a]) : $i.hasOwnProperty(s) && a != null && s === "onScroll" && xe("scroll", r);
          }
          switch (n) {
            case "input":
              Eo(r), Cc(r, o, !0);
              break;
            case "textarea":
              Eo(r), Tc(r);
              break;
            case "select":
            case "option":
              break;
            default:
              typeof o.onClick == "function" && (r.onclick = cs);
          }
          r = i, t.updateQueue = r, r !== null && (t.flags |= 4);
        } else {
          s = i.nodeType === 9 ? i : i.ownerDocument, e === "http://www.w3.org/1999/xhtml" && (e = Rf(n)), e === "http://www.w3.org/1999/xhtml" ? n === "script" ? (e = s.createElement("div"), e.innerHTML = "<script><\/script>", e = e.removeChild(e.firstChild)) : typeof r.is == "string" ? e = s.createElement(n, { is: r.is }) : (e = s.createElement(n), n === "select" && (s = e, r.multiple ? s.multiple = !0 : r.size && (s.size = r.size))) : e = s.createElementNS(e, n), e[qt] = t, e[Yi] = r, Xp(e, t, !1, !1), t.stateNode = e;
          e: {
            switch (s = ml(n, r), n) {
              case "dialog":
                xe("cancel", e), xe("close", e), i = r;
                break;
              case "iframe":
              case "object":
              case "embed":
                xe("load", e), i = r;
                break;
              case "video":
              case "audio":
                for (i = 0; i < ki.length; i++) xe(ki[i], e);
                i = r;
                break;
              case "source":
                xe("error", e), i = r;
                break;
              case "img":
              case "image":
              case "link":
                xe(
                  "error",
                  e
                ), xe("load", e), i = r;
                break;
              case "details":
                xe("toggle", e), i = r;
                break;
              case "input":
                Ec(e, r), i = ul(e, r), xe("invalid", e);
                break;
              case "option":
                i = r;
                break;
              case "select":
                e._wrapperState = { wasMultiple: !!r.multiple }, i = Ce({}, r, { value: void 0 }), xe("invalid", e);
                break;
              case "textarea":
                Nc(e, r), i = fl(e, r), xe("invalid", e);
                break;
              default:
                i = r;
            }
            hl(n, i), a = i;
            for (o in a) if (a.hasOwnProperty(o)) {
              var l = a[o];
              o === "style" ? Of(e, l) : o === "dangerouslySetInnerHTML" ? (l = l ? l.__html : void 0, l != null && If(e, l)) : o === "children" ? typeof l == "string" ? (n !== "textarea" || l !== "") && Bi(e, l) : typeof l == "number" && Bi(e, "" + l) : o !== "suppressContentEditableWarning" && o !== "suppressHydrationWarning" && o !== "autoFocus" && ($i.hasOwnProperty(o) ? l != null && o === "onScroll" && xe("scroll", e) : l != null && wu(e, o, l, s));
            }
            switch (n) {
              case "input":
                Eo(e), Cc(e, r, !1);
                break;
              case "textarea":
                Eo(e), Tc(e);
                break;
              case "option":
                r.value != null && e.setAttribute("value", "" + Vn(r.value));
                break;
              case "select":
                e.multiple = !!r.multiple, o = r.value, o != null ? jr(e, !!r.multiple, o, !1) : r.defaultValue != null && jr(
                  e,
                  !!r.multiple,
                  r.defaultValue,
                  !0
                );
                break;
              default:
                typeof i.onClick == "function" && (e.onclick = cs);
            }
            switch (n) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                r = !!r.autoFocus;
                break e;
              case "img":
                r = !0;
                break e;
              default:
                r = !1;
            }
          }
          r && (t.flags |= 4);
        }
        t.ref !== null && (t.flags |= 512, t.flags |= 2097152);
      }
      return Je(t), null;
    case 6:
      if (e && t.stateNode != null) th(e, t, e.memoizedProps, r);
      else {
        if (typeof r != "string" && t.stateNode === null) throw Error(P(166));
        if (n = Yn(eo.current), Yn(Gt.current), jo(t)) {
          if (r = t.stateNode, n = t.memoizedProps, r[qt] = t, (o = r.nodeValue !== n) && (e = wt, e !== null)) switch (e.tag) {
            case 3:
              Po(r.nodeValue, n, (e.mode & 1) !== 0);
              break;
            case 5:
              e.memoizedProps.suppressHydrationWarning !== !0 && Po(r.nodeValue, n, (e.mode & 1) !== 0);
          }
          o && (t.flags |= 4);
        } else r = (n.nodeType === 9 ? n : n.ownerDocument).createTextNode(r), r[qt] = t, t.stateNode = r;
      }
      return Je(t), null;
    case 13:
      if (be(Se), r = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
        if (_e && vt !== null && t.mode & 1 && !(t.flags & 128)) wp(), Hr(), t.flags |= 98560, o = !1;
        else if (o = jo(t), r !== null && r.dehydrated !== null) {
          if (e === null) {
            if (!o) throw Error(P(318));
            if (o = t.memoizedState, o = o !== null ? o.dehydrated : null, !o) throw Error(P(317));
            o[qt] = t;
          } else Hr(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4;
          Je(t), o = !1;
        } else zt !== null && (Jl(zt), zt = null), o = !0;
        if (!o) return t.flags & 65536 ? t : null;
      }
      return t.flags & 128 ? (t.lanes = n, t) : (r = r !== null, r !== (e !== null && e.memoizedState !== null) && r && (t.child.flags |= 8192, t.mode & 1 && (e === null || Se.current & 1 ? Me === 0 && (Me = 3) : tc())), t.updateQueue !== null && (t.flags |= 4), Je(t), null);
    case 4:
      return Zr(), Vl(e, t), e === null && Ki(t.stateNode.containerInfo), Je(t), null;
    case 10:
      return zu(t.type._context), Je(t), null;
    case 17:
      return dt(t.type) && ds(), Je(t), null;
    case 19:
      if (be(Se), o = t.memoizedState, o === null) return Je(t), null;
      if (r = (t.flags & 128) !== 0, s = o.rendering, s === null) if (r) pi(o, !1);
      else {
        if (Me !== 0 || e !== null && e.flags & 128) for (e = t.child; e !== null; ) {
          if (s = vs(e), s !== null) {
            for (t.flags |= 128, pi(o, !1), r = s.updateQueue, r !== null && (t.updateQueue = r, t.flags |= 4), t.subtreeFlags = 0, r = n, n = t.child; n !== null; ) o = n, e = r, o.flags &= 14680066, s = o.alternate, s === null ? (o.childLanes = 0, o.lanes = e, o.child = null, o.subtreeFlags = 0, o.memoizedProps = null, o.memoizedState = null, o.updateQueue = null, o.dependencies = null, o.stateNode = null) : (o.childLanes = s.childLanes, o.lanes = s.lanes, o.child = s.child, o.subtreeFlags = 0, o.deletions = null, o.memoizedProps = s.memoizedProps, o.memoizedState = s.memoizedState, o.updateQueue = s.updateQueue, o.type = s.type, e = s.dependencies, o.dependencies = e === null ? null : { lanes: e.lanes, firstContext: e.firstContext }), n = n.sibling;
            return ye(Se, Se.current & 1 | 2), t.child;
          }
          e = e.sibling;
        }
        o.tail !== null && Ae() > qr && (t.flags |= 128, r = !0, pi(o, !1), t.lanes = 4194304);
      }
      else {
        if (!r) if (e = vs(s), e !== null) {
          if (t.flags |= 128, r = !0, n = e.updateQueue, n !== null && (t.updateQueue = n, t.flags |= 4), pi(o, !0), o.tail === null && o.tailMode === "hidden" && !s.alternate && !_e) return Je(t), null;
        } else 2 * Ae() - o.renderingStartTime > qr && n !== 1073741824 && (t.flags |= 128, r = !0, pi(o, !1), t.lanes = 4194304);
        o.isBackwards ? (s.sibling = t.child, t.child = s) : (n = o.last, n !== null ? n.sibling = s : t.child = s, o.last = s);
      }
      return o.tail !== null ? (t = o.tail, o.rendering = t, o.tail = t.sibling, o.renderingStartTime = Ae(), t.sibling = null, n = Se.current, ye(Se, r ? n & 1 | 2 : n & 1), t) : (Je(t), null);
    case 22:
    case 23:
      return ec(), r = t.memoizedState !== null, e !== null && e.memoizedState !== null !== r && (t.flags |= 8192), r && t.mode & 1 ? gt & 1073741824 && (Je(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : Je(t), null;
    case 24:
      return null;
    case 25:
      return null;
  }
  throw Error(P(156, t.tag));
}
function Dy(e, t) {
  switch (ju(t), t.tag) {
    case 1:
      return dt(t.type) && ds(), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
    case 3:
      return Zr(), be(ct), be(Ye), Bu(), e = t.flags, e & 65536 && !(e & 128) ? (t.flags = e & -65537 | 128, t) : null;
    case 5:
      return $u(t), null;
    case 13:
      if (be(Se), e = t.memoizedState, e !== null && e.dehydrated !== null) {
        if (t.alternate === null) throw Error(P(340));
        Hr();
      }
      return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
    case 19:
      return be(Se), null;
    case 4:
      return Zr(), null;
    case 10:
      return zu(t.type._context), null;
    case 22:
    case 23:
      return ec(), null;
    case 24:
      return null;
    default:
      return null;
  }
}
var Do = !1, Ke = !1, zy = typeof WeakSet == "function" ? WeakSet : Set, W = null;
function Or(e, t) {
  var n = e.ref;
  if (n !== null) if (typeof n == "function") try {
    n(null);
  } catch (r) {
    Te(e, t, r);
  }
  else n.current = null;
}
function $l(e, t, n) {
  try {
    n();
  } catch (r) {
    Te(e, t, r);
  }
}
var yd = !1;
function My(e, t) {
  if (El = as, e = sp(), Ou(e)) {
    if ("selectionStart" in e) var n = { start: e.selectionStart, end: e.selectionEnd };
    else e: {
      n = (n = e.ownerDocument) && n.defaultView || window;
      var r = n.getSelection && n.getSelection();
      if (r && r.rangeCount !== 0) {
        n = r.anchorNode;
        var i = r.anchorOffset, o = r.focusNode;
        r = r.focusOffset;
        try {
          n.nodeType, o.nodeType;
        } catch {
          n = null;
          break e;
        }
        var s = 0, a = -1, l = -1, u = 0, c = 0, p = e, h = null;
        t: for (; ; ) {
          for (var x; p !== n || i !== 0 && p.nodeType !== 3 || (a = s + i), p !== o || r !== 0 && p.nodeType !== 3 || (l = s + r), p.nodeType === 3 && (s += p.nodeValue.length), (x = p.firstChild) !== null; )
            h = p, p = x;
          for (; ; ) {
            if (p === e) break t;
            if (h === n && ++u === i && (a = s), h === o && ++c === r && (l = s), (x = p.nextSibling) !== null) break;
            p = h, h = p.parentNode;
          }
          p = x;
        }
        n = a === -1 || l === -1 ? null : { start: a, end: l };
      } else n = null;
    }
    n = n || { start: 0, end: 0 };
  } else n = null;
  for (Cl = { focusedElem: e, selectionRange: n }, as = !1, W = t; W !== null; ) if (t = W, e = t.child, (t.subtreeFlags & 1028) !== 0 && e !== null) e.return = t, W = e;
  else for (; W !== null; ) {
    t = W;
    try {
      var v = t.alternate;
      if (t.flags & 1024) switch (t.tag) {
        case 0:
        case 11:
        case 15:
          break;
        case 1:
          if (v !== null) {
            var w = v.memoizedProps, _ = v.memoizedState, m = t.stateNode, d = m.getSnapshotBeforeUpdate(t.elementType === t.type ? w : Ft(t.type, w), _);
            m.__reactInternalSnapshotBeforeUpdate = d;
          }
          break;
        case 3:
          var y = t.stateNode.containerInfo;
          y.nodeType === 1 ? y.textContent = "" : y.nodeType === 9 && y.documentElement && y.removeChild(y.documentElement);
          break;
        case 5:
        case 6:
        case 4:
        case 17:
          break;
        default:
          throw Error(P(163));
      }
    } catch (b) {
      Te(t, t.return, b);
    }
    if (e = t.sibling, e !== null) {
      e.return = t.return, W = e;
      break;
    }
    W = t.return;
  }
  return v = yd, yd = !1, v;
}
function Pi(e, t, n) {
  var r = t.updateQueue;
  if (r = r !== null ? r.lastEffect : null, r !== null) {
    var i = r = r.next;
    do {
      if ((i.tag & e) === e) {
        var o = i.destroy;
        i.destroy = void 0, o !== void 0 && $l(t, n, o);
      }
      i = i.next;
    } while (i !== r);
  }
}
function Xs(e, t) {
  if (t = t.updateQueue, t = t !== null ? t.lastEffect : null, t !== null) {
    var n = t = t.next;
    do {
      if ((n.tag & e) === e) {
        var r = n.create;
        n.destroy = r();
      }
      n = n.next;
    } while (n !== t);
  }
}
function Bl(e) {
  var t = e.ref;
  if (t !== null) {
    var n = e.stateNode;
    switch (e.tag) {
      case 5:
        e = n;
        break;
      default:
        e = n;
    }
    typeof t == "function" ? t(e) : t.current = e;
  }
}
function nh(e) {
  var t = e.alternate;
  t !== null && (e.alternate = null, nh(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode, t !== null && (delete t[qt], delete t[Yi], delete t[Rl], delete t[by], delete t[_y])), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
}
function rh(e) {
  return e.tag === 5 || e.tag === 3 || e.tag === 4;
}
function vd(e) {
  e: for (; ; ) {
    for (; e.sibling === null; ) {
      if (e.return === null || rh(e.return)) return null;
      e = e.return;
    }
    for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18; ) {
      if (e.flags & 2 || e.child === null || e.tag === 4) continue e;
      e.child.return = e, e = e.child;
    }
    if (!(e.flags & 2)) return e.stateNode;
  }
}
function Hl(e, t, n) {
  var r = e.tag;
  if (r === 5 || r === 6) e = e.stateNode, t ? n.nodeType === 8 ? n.parentNode.insertBefore(e, t) : n.insertBefore(e, t) : (n.nodeType === 8 ? (t = n.parentNode, t.insertBefore(e, n)) : (t = n, t.appendChild(e)), n = n._reactRootContainer, n != null || t.onclick !== null || (t.onclick = cs));
  else if (r !== 4 && (e = e.child, e !== null)) for (Hl(e, t, n), e = e.sibling; e !== null; ) Hl(e, t, n), e = e.sibling;
}
function Wl(e, t, n) {
  var r = e.tag;
  if (r === 5 || r === 6) e = e.stateNode, t ? n.insertBefore(e, t) : n.appendChild(e);
  else if (r !== 4 && (e = e.child, e !== null)) for (Wl(e, t, n), e = e.sibling; e !== null; ) Wl(e, t, n), e = e.sibling;
}
var He = null, Dt = !1;
function kn(e, t, n) {
  for (n = n.child; n !== null; ) ih(e, t, n), n = n.sibling;
}
function ih(e, t, n) {
  if (Kt && typeof Kt.onCommitFiberUnmount == "function") try {
    Kt.onCommitFiberUnmount(Ws, n);
  } catch {
  }
  switch (n.tag) {
    case 5:
      Ke || Or(n, t);
    case 6:
      var r = He, i = Dt;
      He = null, kn(e, t, n), He = r, Dt = i, He !== null && (Dt ? (e = He, n = n.stateNode, e.nodeType === 8 ? e.parentNode.removeChild(n) : e.removeChild(n)) : He.removeChild(n.stateNode));
      break;
    case 18:
      He !== null && (Dt ? (e = He, n = n.stateNode, e.nodeType === 8 ? Ua(e.parentNode, n) : e.nodeType === 1 && Ua(e, n), Qi(e)) : Ua(He, n.stateNode));
      break;
    case 4:
      r = He, i = Dt, He = n.stateNode.containerInfo, Dt = !0, kn(e, t, n), He = r, Dt = i;
      break;
    case 0:
    case 11:
    case 14:
    case 15:
      if (!Ke && (r = n.updateQueue, r !== null && (r = r.lastEffect, r !== null))) {
        i = r = r.next;
        do {
          var o = i, s = o.destroy;
          o = o.tag, s !== void 0 && (o & 2 || o & 4) && $l(n, t, s), i = i.next;
        } while (i !== r);
      }
      kn(e, t, n);
      break;
    case 1:
      if (!Ke && (Or(n, t), r = n.stateNode, typeof r.componentWillUnmount == "function")) try {
        r.props = n.memoizedProps, r.state = n.memoizedState, r.componentWillUnmount();
      } catch (a) {
        Te(n, t, a);
      }
      kn(e, t, n);
      break;
    case 21:
      kn(e, t, n);
      break;
    case 22:
      n.mode & 1 ? (Ke = (r = Ke) || n.memoizedState !== null, kn(e, t, n), Ke = r) : kn(e, t, n);
      break;
    default:
      kn(e, t, n);
  }
}
function wd(e) {
  var t = e.updateQueue;
  if (t !== null) {
    e.updateQueue = null;
    var n = e.stateNode;
    n === null && (n = e.stateNode = new zy()), t.forEach(function(r) {
      var i = qy.bind(null, e, r);
      n.has(r) || (n.add(r), r.then(i, i));
    });
  }
}
function Lt(e, t) {
  var n = t.deletions;
  if (n !== null) for (var r = 0; r < n.length; r++) {
    var i = n[r];
    try {
      var o = e, s = t, a = s;
      e: for (; a !== null; ) {
        switch (a.tag) {
          case 5:
            He = a.stateNode, Dt = !1;
            break e;
          case 3:
            He = a.stateNode.containerInfo, Dt = !0;
            break e;
          case 4:
            He = a.stateNode.containerInfo, Dt = !0;
            break e;
        }
        a = a.return;
      }
      if (He === null) throw Error(P(160));
      ih(o, s, i), He = null, Dt = !1;
      var l = i.alternate;
      l !== null && (l.return = null), i.return = null;
    } catch (u) {
      Te(i, t, u);
    }
  }
  if (t.subtreeFlags & 12854) for (t = t.child; t !== null; ) oh(t, e), t = t.sibling;
}
function oh(e, t) {
  var n = e.alternate, r = e.flags;
  switch (e.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
      if (Lt(t, e), Wt(e), r & 4) {
        try {
          Pi(3, e, e.return), Xs(3, e);
        } catch (w) {
          Te(e, e.return, w);
        }
        try {
          Pi(5, e, e.return);
        } catch (w) {
          Te(e, e.return, w);
        }
      }
      break;
    case 1:
      Lt(t, e), Wt(e), r & 512 && n !== null && Or(n, n.return);
      break;
    case 5:
      if (Lt(t, e), Wt(e), r & 512 && n !== null && Or(n, n.return), e.flags & 32) {
        var i = e.stateNode;
        try {
          Bi(i, "");
        } catch (w) {
          Te(e, e.return, w);
        }
      }
      if (r & 4 && (i = e.stateNode, i != null)) {
        var o = e.memoizedProps, s = n !== null ? n.memoizedProps : o, a = e.type, l = e.updateQueue;
        if (e.updateQueue = null, l !== null) try {
          a === "input" && o.type === "radio" && o.name != null && Nf(i, o), ml(a, s);
          var u = ml(a, o);
          for (s = 0; s < l.length; s += 2) {
            var c = l[s], p = l[s + 1];
            c === "style" ? Of(i, p) : c === "dangerouslySetInnerHTML" ? If(i, p) : c === "children" ? Bi(i, p) : wu(i, c, p, u);
          }
          switch (a) {
            case "input":
              cl(i, o);
              break;
            case "textarea":
              Tf(i, o);
              break;
            case "select":
              var h = i._wrapperState.wasMultiple;
              i._wrapperState.wasMultiple = !!o.multiple;
              var x = o.value;
              x != null ? jr(i, !!o.multiple, x, !1) : h !== !!o.multiple && (o.defaultValue != null ? jr(
                i,
                !!o.multiple,
                o.defaultValue,
                !0
              ) : jr(i, !!o.multiple, o.multiple ? [] : "", !1));
          }
          i[Yi] = o;
        } catch (w) {
          Te(e, e.return, w);
        }
      }
      break;
    case 6:
      if (Lt(t, e), Wt(e), r & 4) {
        if (e.stateNode === null) throw Error(P(162));
        i = e.stateNode, o = e.memoizedProps;
        try {
          i.nodeValue = o;
        } catch (w) {
          Te(e, e.return, w);
        }
      }
      break;
    case 3:
      if (Lt(t, e), Wt(e), r & 4 && n !== null && n.memoizedState.isDehydrated) try {
        Qi(t.containerInfo);
      } catch (w) {
        Te(e, e.return, w);
      }
      break;
    case 4:
      Lt(t, e), Wt(e);
      break;
    case 13:
      Lt(t, e), Wt(e), i = e.child, i.flags & 8192 && (o = i.memoizedState !== null, i.stateNode.isHidden = o, !o || i.alternate !== null && i.alternate.memoizedState !== null || (Yu = Ae())), r & 4 && wd(e);
      break;
    case 22:
      if (c = n !== null && n.memoizedState !== null, e.mode & 1 ? (Ke = (u = Ke) || c, Lt(t, e), Ke = u) : Lt(t, e), Wt(e), r & 8192) {
        if (u = e.memoizedState !== null, (e.stateNode.isHidden = u) && !c && e.mode & 1) for (W = e, c = e.child; c !== null; ) {
          for (p = W = c; W !== null; ) {
            switch (h = W, x = h.child, h.tag) {
              case 0:
              case 11:
              case 14:
              case 15:
                Pi(4, h, h.return);
                break;
              case 1:
                Or(h, h.return);
                var v = h.stateNode;
                if (typeof v.componentWillUnmount == "function") {
                  r = h, n = h.return;
                  try {
                    t = r, v.props = t.memoizedProps, v.state = t.memoizedState, v.componentWillUnmount();
                  } catch (w) {
                    Te(r, n, w);
                  }
                }
                break;
              case 5:
                Or(h, h.return);
                break;
              case 22:
                if (h.memoizedState !== null) {
                  bd(p);
                  continue;
                }
            }
            x !== null ? (x.return = h, W = x) : bd(p);
          }
          c = c.sibling;
        }
        e: for (c = null, p = e; ; ) {
          if (p.tag === 5) {
            if (c === null) {
              c = p;
              try {
                i = p.stateNode, u ? (o = i.style, typeof o.setProperty == "function" ? o.setProperty("display", "none", "important") : o.display = "none") : (a = p.stateNode, l = p.memoizedProps.style, s = l != null && l.hasOwnProperty("display") ? l.display : null, a.style.display = Af("display", s));
              } catch (w) {
                Te(e, e.return, w);
              }
            }
          } else if (p.tag === 6) {
            if (c === null) try {
              p.stateNode.nodeValue = u ? "" : p.memoizedProps;
            } catch (w) {
              Te(e, e.return, w);
            }
          } else if ((p.tag !== 22 && p.tag !== 23 || p.memoizedState === null || p === e) && p.child !== null) {
            p.child.return = p, p = p.child;
            continue;
          }
          if (p === e) break e;
          for (; p.sibling === null; ) {
            if (p.return === null || p.return === e) break e;
            c === p && (c = null), p = p.return;
          }
          c === p && (c = null), p.sibling.return = p.return, p = p.sibling;
        }
      }
      break;
    case 19:
      Lt(t, e), Wt(e), r & 4 && wd(e);
      break;
    case 21:
      break;
    default:
      Lt(
        t,
        e
      ), Wt(e);
  }
}
function Wt(e) {
  var t = e.flags;
  if (t & 2) {
    try {
      e: {
        for (var n = e.return; n !== null; ) {
          if (rh(n)) {
            var r = n;
            break e;
          }
          n = n.return;
        }
        throw Error(P(160));
      }
      switch (r.tag) {
        case 5:
          var i = r.stateNode;
          r.flags & 32 && (Bi(i, ""), r.flags &= -33);
          var o = vd(e);
          Wl(e, o, i);
          break;
        case 3:
        case 4:
          var s = r.stateNode.containerInfo, a = vd(e);
          Hl(e, a, s);
          break;
        default:
          throw Error(P(161));
      }
    } catch (l) {
      Te(e, e.return, l);
    }
    e.flags &= -3;
  }
  t & 4096 && (e.flags &= -4097);
}
function Uy(e, t, n) {
  W = e, sh(e);
}
function sh(e, t, n) {
  for (var r = (e.mode & 1) !== 0; W !== null; ) {
    var i = W, o = i.child;
    if (i.tag === 22 && r) {
      var s = i.memoizedState !== null || Do;
      if (!s) {
        var a = i.alternate, l = a !== null && a.memoizedState !== null || Ke;
        a = Do;
        var u = Ke;
        if (Do = s, (Ke = l) && !u) for (W = i; W !== null; ) s = W, l = s.child, s.tag === 22 && s.memoizedState !== null ? _d(i) : l !== null ? (l.return = s, W = l) : _d(i);
        for (; o !== null; ) W = o, sh(o), o = o.sibling;
        W = i, Do = a, Ke = u;
      }
      xd(e);
    } else i.subtreeFlags & 8772 && o !== null ? (o.return = i, W = o) : xd(e);
  }
}
function xd(e) {
  for (; W !== null; ) {
    var t = W;
    if (t.flags & 8772) {
      var n = t.alternate;
      try {
        if (t.flags & 8772) switch (t.tag) {
          case 0:
          case 11:
          case 15:
            Ke || Xs(5, t);
            break;
          case 1:
            var r = t.stateNode;
            if (t.flags & 4 && !Ke) if (n === null) r.componentDidMount();
            else {
              var i = t.elementType === t.type ? n.memoizedProps : Ft(t.type, n.memoizedProps);
              r.componentDidUpdate(i, n.memoizedState, r.__reactInternalSnapshotBeforeUpdate);
            }
            var o = t.updateQueue;
            o !== null && id(t, o, r);
            break;
          case 3:
            var s = t.updateQueue;
            if (s !== null) {
              if (n = null, t.child !== null) switch (t.child.tag) {
                case 5:
                  n = t.child.stateNode;
                  break;
                case 1:
                  n = t.child.stateNode;
              }
              id(t, s, n);
            }
            break;
          case 5:
            var a = t.stateNode;
            if (n === null && t.flags & 4) {
              n = a;
              var l = t.memoizedProps;
              switch (t.type) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  l.autoFocus && n.focus();
                  break;
                case "img":
                  l.src && (n.src = l.src);
              }
            }
            break;
          case 6:
            break;
          case 4:
            break;
          case 12:
            break;
          case 13:
            if (t.memoizedState === null) {
              var u = t.alternate;
              if (u !== null) {
                var c = u.memoizedState;
                if (c !== null) {
                  var p = c.dehydrated;
                  p !== null && Qi(p);
                }
              }
            }
            break;
          case 19:
          case 17:
          case 21:
          case 22:
          case 23:
          case 25:
            break;
          default:
            throw Error(P(163));
        }
        Ke || t.flags & 512 && Bl(t);
      } catch (h) {
        Te(t, t.return, h);
      }
    }
    if (t === e) {
      W = null;
      break;
    }
    if (n = t.sibling, n !== null) {
      n.return = t.return, W = n;
      break;
    }
    W = t.return;
  }
}
function bd(e) {
  for (; W !== null; ) {
    var t = W;
    if (t === e) {
      W = null;
      break;
    }
    var n = t.sibling;
    if (n !== null) {
      n.return = t.return, W = n;
      break;
    }
    W = t.return;
  }
}
function _d(e) {
  for (; W !== null; ) {
    var t = W;
    try {
      switch (t.tag) {
        case 0:
        case 11:
        case 15:
          var n = t.return;
          try {
            Xs(4, t);
          } catch (l) {
            Te(t, n, l);
          }
          break;
        case 1:
          var r = t.stateNode;
          if (typeof r.componentDidMount == "function") {
            var i = t.return;
            try {
              r.componentDidMount();
            } catch (l) {
              Te(t, i, l);
            }
          }
          var o = t.return;
          try {
            Bl(t);
          } catch (l) {
            Te(t, o, l);
          }
          break;
        case 5:
          var s = t.return;
          try {
            Bl(t);
          } catch (l) {
            Te(t, s, l);
          }
      }
    } catch (l) {
      Te(t, t.return, l);
    }
    if (t === e) {
      W = null;
      break;
    }
    var a = t.sibling;
    if (a !== null) {
      a.return = t.return, W = a;
      break;
    }
    W = t.return;
  }
}
var Vy = Math.ceil, bs = wn.ReactCurrentDispatcher, Ku = wn.ReactCurrentOwner, Rt = wn.ReactCurrentBatchConfig, de = 0, Ve = null, Le = null, We = 0, gt = 0, Pr = Wn(0), Me = 0, io = null, ur = 0, ea = 0, Gu = 0, ji = null, lt = null, Yu = 0, qr = 1 / 0, on = null, _s = !1, Zl = null, zn = null, zo = !1, On = null, ks = 0, Li = 0, Ql = null, Jo = -1, Ko = 0;
function it() {
  return de & 6 ? Ae() : Jo !== -1 ? Jo : Jo = Ae();
}
function Mn(e) {
  return e.mode & 1 ? de & 2 && We !== 0 ? We & -We : Sy.transition !== null ? (Ko === 0 && (Ko = Hf()), Ko) : (e = he, e !== 0 || (e = window.event, e = e === void 0 ? 16 : Gf(e.type)), e) : 1;
}
function $t(e, t, n, r) {
  if (50 < Li) throw Li = 0, Ql = null, Error(P(185));
  co(e, n, r), (!(de & 2) || e !== Ve) && (e === Ve && (!(de & 2) && (ea |= n), Me === 4 && In(e, We)), ft(e, r), n === 1 && de === 0 && !(t.mode & 1) && (qr = Ae() + 500, Ks && Zn()));
}
function ft(e, t) {
  var n = e.callbackNode;
  Sg(e, t);
  var r = ss(e, e === Ve ? We : 0);
  if (r === 0) n !== null && Ac(n), e.callbackNode = null, e.callbackPriority = 0;
  else if (t = r & -r, e.callbackPriority !== t) {
    if (n != null && Ac(n), t === 1) e.tag === 0 ? ky(kd.bind(null, e)) : gp(kd.bind(null, e)), wy(function() {
      !(de & 6) && Zn();
    }), n = null;
    else {
      switch (Wf(r)) {
        case 1:
          n = Su;
          break;
        case 4:
          n = $f;
          break;
        case 16:
          n = os;
          break;
        case 536870912:
          n = Bf;
          break;
        default:
          n = os;
      }
      n = hh(n, ah.bind(null, e));
    }
    e.callbackPriority = t, e.callbackNode = n;
  }
}
function ah(e, t) {
  if (Jo = -1, Ko = 0, de & 6) throw Error(P(327));
  var n = e.callbackNode;
  if (Mr() && e.callbackNode !== n) return null;
  var r = ss(e, e === Ve ? We : 0);
  if (r === 0) return null;
  if (r & 30 || r & e.expiredLanes || t) t = Ss(e, r);
  else {
    t = r;
    var i = de;
    de |= 2;
    var o = uh();
    (Ve !== e || We !== t) && (on = null, qr = Ae() + 500, tr(e, t));
    do
      try {
        Hy();
        break;
      } catch (a) {
        lh(e, a);
      }
    while (!0);
    Du(), bs.current = o, de = i, Le !== null ? t = 0 : (Ve = null, We = 0, t = Me);
  }
  if (t !== 0) {
    if (t === 2 && (i = xl(e), i !== 0 && (r = i, t = ql(e, i))), t === 1) throw n = io, tr(e, 0), In(e, r), ft(e, Ae()), n;
    if (t === 6) In(e, r);
    else {
      if (i = e.current.alternate, !(r & 30) && !$y(i) && (t = Ss(e, r), t === 2 && (o = xl(e), o !== 0 && (r = o, t = ql(e, o))), t === 1)) throw n = io, tr(e, 0), In(e, r), ft(e, Ae()), n;
      switch (e.finishedWork = i, e.finishedLanes = r, t) {
        case 0:
        case 1:
          throw Error(P(345));
        case 2:
          Jn(e, lt, on);
          break;
        case 3:
          if (In(e, r), (r & 130023424) === r && (t = Yu + 500 - Ae(), 10 < t)) {
            if (ss(e, 0) !== 0) break;
            if (i = e.suspendedLanes, (i & r) !== r) {
              it(), e.pingedLanes |= e.suspendedLanes & i;
              break;
            }
            e.timeoutHandle = Tl(Jn.bind(null, e, lt, on), t);
            break;
          }
          Jn(e, lt, on);
          break;
        case 4:
          if (In(e, r), (r & 4194240) === r) break;
          for (t = e.eventTimes, i = -1; 0 < r; ) {
            var s = 31 - Vt(r);
            o = 1 << s, s = t[s], s > i && (i = s), r &= ~o;
          }
          if (r = i, r = Ae() - r, r = (120 > r ? 120 : 480 > r ? 480 : 1080 > r ? 1080 : 1920 > r ? 1920 : 3e3 > r ? 3e3 : 4320 > r ? 4320 : 1960 * Vy(r / 1960)) - r, 10 < r) {
            e.timeoutHandle = Tl(Jn.bind(null, e, lt, on), r);
            break;
          }
          Jn(e, lt, on);
          break;
        case 5:
          Jn(e, lt, on);
          break;
        default:
          throw Error(P(329));
      }
    }
  }
  return ft(e, Ae()), e.callbackNode === n ? ah.bind(null, e) : null;
}
function ql(e, t) {
  var n = ji;
  return e.current.memoizedState.isDehydrated && (tr(e, t).flags |= 256), e = Ss(e, t), e !== 2 && (t = lt, lt = n, t !== null && Jl(t)), e;
}
function Jl(e) {
  lt === null ? lt = e : lt.push.apply(lt, e);
}
function $y(e) {
  for (var t = e; ; ) {
    if (t.flags & 16384) {
      var n = t.updateQueue;
      if (n !== null && (n = n.stores, n !== null)) for (var r = 0; r < n.length; r++) {
        var i = n[r], o = i.getSnapshot;
        i = i.value;
        try {
          if (!Bt(o(), i)) return !1;
        } catch {
          return !1;
        }
      }
    }
    if (n = t.child, t.subtreeFlags & 16384 && n !== null) n.return = t, t = n;
    else {
      if (t === e) break;
      for (; t.sibling === null; ) {
        if (t.return === null || t.return === e) return !0;
        t = t.return;
      }
      t.sibling.return = t.return, t = t.sibling;
    }
  }
  return !0;
}
function In(e, t) {
  for (t &= ~Gu, t &= ~ea, e.suspendedLanes |= t, e.pingedLanes &= ~t, e = e.expirationTimes; 0 < t; ) {
    var n = 31 - Vt(t), r = 1 << n;
    e[n] = -1, t &= ~r;
  }
}
function kd(e) {
  if (de & 6) throw Error(P(327));
  Mr();
  var t = ss(e, 0);
  if (!(t & 1)) return ft(e, Ae()), null;
  var n = Ss(e, t);
  if (e.tag !== 0 && n === 2) {
    var r = xl(e);
    r !== 0 && (t = r, n = ql(e, r));
  }
  if (n === 1) throw n = io, tr(e, 0), In(e, t), ft(e, Ae()), n;
  if (n === 6) throw Error(P(345));
  return e.finishedWork = e.current.alternate, e.finishedLanes = t, Jn(e, lt, on), ft(e, Ae()), null;
}
function Xu(e, t) {
  var n = de;
  de |= 1;
  try {
    return e(t);
  } finally {
    de = n, de === 0 && (qr = Ae() + 500, Ks && Zn());
  }
}
function cr(e) {
  On !== null && On.tag === 0 && !(de & 6) && Mr();
  var t = de;
  de |= 1;
  var n = Rt.transition, r = he;
  try {
    if (Rt.transition = null, he = 1, e) return e();
  } finally {
    he = r, Rt.transition = n, de = t, !(de & 6) && Zn();
  }
}
function ec() {
  gt = Pr.current, be(Pr);
}
function tr(e, t) {
  e.finishedWork = null, e.finishedLanes = 0;
  var n = e.timeoutHandle;
  if (n !== -1 && (e.timeoutHandle = -1, vy(n)), Le !== null) for (n = Le.return; n !== null; ) {
    var r = n;
    switch (ju(r), r.tag) {
      case 1:
        r = r.type.childContextTypes, r != null && ds();
        break;
      case 3:
        Zr(), be(ct), be(Ye), Bu();
        break;
      case 5:
        $u(r);
        break;
      case 4:
        Zr();
        break;
      case 13:
        be(Se);
        break;
      case 19:
        be(Se);
        break;
      case 10:
        zu(r.type._context);
        break;
      case 22:
      case 23:
        ec();
    }
    n = n.return;
  }
  if (Ve = e, Le = e = Un(e.current, null), We = gt = t, Me = 0, io = null, Gu = ea = ur = 0, lt = ji = null, Gn !== null) {
    for (t = 0; t < Gn.length; t++) if (n = Gn[t], r = n.interleaved, r !== null) {
      n.interleaved = null;
      var i = r.next, o = n.pending;
      if (o !== null) {
        var s = o.next;
        o.next = i, r.next = s;
      }
      n.pending = r;
    }
    Gn = null;
  }
  return e;
}
function lh(e, t) {
  do {
    var n = Le;
    try {
      if (Du(), Zo.current = xs, ws) {
        for (var r = Ee.memoizedState; r !== null; ) {
          var i = r.queue;
          i !== null && (i.pending = null), r = r.next;
        }
        ws = !1;
      }
      if (lr = 0, Ue = De = Ee = null, Oi = !1, to = 0, Ku.current = null, n === null || n.return === null) {
        Me = 1, io = t, Le = null;
        break;
      }
      e: {
        var o = e, s = n.return, a = n, l = t;
        if (t = We, a.flags |= 32768, l !== null && typeof l == "object" && typeof l.then == "function") {
          var u = l, c = a, p = c.tag;
          if (!(c.mode & 1) && (p === 0 || p === 11 || p === 15)) {
            var h = c.alternate;
            h ? (c.updateQueue = h.updateQueue, c.memoizedState = h.memoizedState, c.lanes = h.lanes) : (c.updateQueue = null, c.memoizedState = null);
          }
          var x = cd(s);
          if (x !== null) {
            x.flags &= -257, dd(x, s, a, o, t), x.mode & 1 && ud(o, u, t), t = x, l = u;
            var v = t.updateQueue;
            if (v === null) {
              var w = /* @__PURE__ */ new Set();
              w.add(l), t.updateQueue = w;
            } else v.add(l);
            break e;
          } else {
            if (!(t & 1)) {
              ud(o, u, t), tc();
              break e;
            }
            l = Error(P(426));
          }
        } else if (_e && a.mode & 1) {
          var _ = cd(s);
          if (_ !== null) {
            !(_.flags & 65536) && (_.flags |= 256), dd(_, s, a, o, t), Lu(Qr(l, a));
            break e;
          }
        }
        o = l = Qr(l, a), Me !== 4 && (Me = 2), ji === null ? ji = [o] : ji.push(o), o = s;
        do {
          switch (o.tag) {
            case 3:
              o.flags |= 65536, t &= -t, o.lanes |= t;
              var m = Wp(o, l, t);
              rd(o, m);
              break e;
            case 1:
              a = l;
              var d = o.type, y = o.stateNode;
              if (!(o.flags & 128) && (typeof d.getDerivedStateFromError == "function" || y !== null && typeof y.componentDidCatch == "function" && (zn === null || !zn.has(y)))) {
                o.flags |= 65536, t &= -t, o.lanes |= t;
                var b = Zp(o, a, t);
                rd(o, b);
                break e;
              }
          }
          o = o.return;
        } while (o !== null);
      }
      dh(n);
    } catch (f) {
      t = f, Le === n && n !== null && (Le = n = n.return);
      continue;
    }
    break;
  } while (!0);
}
function uh() {
  var e = bs.current;
  return bs.current = xs, e === null ? xs : e;
}
function tc() {
  (Me === 0 || Me === 3 || Me === 2) && (Me = 4), Ve === null || !(ur & 268435455) && !(ea & 268435455) || In(Ve, We);
}
function Ss(e, t) {
  var n = de;
  de |= 2;
  var r = uh();
  (Ve !== e || We !== t) && (on = null, tr(e, t));
  do
    try {
      By();
      break;
    } catch (i) {
      lh(e, i);
    }
  while (!0);
  if (Du(), de = n, bs.current = r, Le !== null) throw Error(P(261));
  return Ve = null, We = 0, Me;
}
function By() {
  for (; Le !== null; ) ch(Le);
}
function Hy() {
  for (; Le !== null && !mg(); ) ch(Le);
}
function ch(e) {
  var t = ph(e.alternate, e, gt);
  e.memoizedProps = e.pendingProps, t === null ? dh(e) : Le = t, Ku.current = null;
}
function dh(e) {
  var t = e;
  do {
    var n = t.alternate;
    if (e = t.return, t.flags & 32768) {
      if (n = Dy(n, t), n !== null) {
        n.flags &= 32767, Le = n;
        return;
      }
      if (e !== null) e.flags |= 32768, e.subtreeFlags = 0, e.deletions = null;
      else {
        Me = 6, Le = null;
        return;
      }
    } else if (n = Fy(n, t, gt), n !== null) {
      Le = n;
      return;
    }
    if (t = t.sibling, t !== null) {
      Le = t;
      return;
    }
    Le = t = e;
  } while (t !== null);
  Me === 0 && (Me = 5);
}
function Jn(e, t, n) {
  var r = he, i = Rt.transition;
  try {
    Rt.transition = null, he = 1, Wy(e, t, n, r);
  } finally {
    Rt.transition = i, he = r;
  }
  return null;
}
function Wy(e, t, n, r) {
  do
    Mr();
  while (On !== null);
  if (de & 6) throw Error(P(327));
  n = e.finishedWork;
  var i = e.finishedLanes;
  if (n === null) return null;
  if (e.finishedWork = null, e.finishedLanes = 0, n === e.current) throw Error(P(177));
  e.callbackNode = null, e.callbackPriority = 0;
  var o = n.lanes | n.childLanes;
  if (Eg(e, o), e === Ve && (Le = Ve = null, We = 0), !(n.subtreeFlags & 2064) && !(n.flags & 2064) || zo || (zo = !0, hh(os, function() {
    return Mr(), null;
  })), o = (n.flags & 15990) !== 0, n.subtreeFlags & 15990 || o) {
    o = Rt.transition, Rt.transition = null;
    var s = he;
    he = 1;
    var a = de;
    de |= 4, Ku.current = null, My(e, n), oh(n, e), dy(Cl), as = !!El, Cl = El = null, e.current = n, Uy(n), gg(), de = a, he = s, Rt.transition = o;
  } else e.current = n;
  if (zo && (zo = !1, On = e, ks = i), o = e.pendingLanes, o === 0 && (zn = null), wg(n.stateNode), ft(e, Ae()), t !== null) for (r = e.onRecoverableError, n = 0; n < t.length; n++) i = t[n], r(i.value, { componentStack: i.stack, digest: i.digest });
  if (_s) throw _s = !1, e = Zl, Zl = null, e;
  return ks & 1 && e.tag !== 0 && Mr(), o = e.pendingLanes, o & 1 ? e === Ql ? Li++ : (Li = 0, Ql = e) : Li = 0, Zn(), null;
}
function Mr() {
  if (On !== null) {
    var e = Wf(ks), t = Rt.transition, n = he;
    try {
      if (Rt.transition = null, he = 16 > e ? 16 : e, On === null) var r = !1;
      else {
        if (e = On, On = null, ks = 0, de & 6) throw Error(P(331));
        var i = de;
        for (de |= 4, W = e.current; W !== null; ) {
          var o = W, s = o.child;
          if (W.flags & 16) {
            var a = o.deletions;
            if (a !== null) {
              for (var l = 0; l < a.length; l++) {
                var u = a[l];
                for (W = u; W !== null; ) {
                  var c = W;
                  switch (c.tag) {
                    case 0:
                    case 11:
                    case 15:
                      Pi(8, c, o);
                  }
                  var p = c.child;
                  if (p !== null) p.return = c, W = p;
                  else for (; W !== null; ) {
                    c = W;
                    var h = c.sibling, x = c.return;
                    if (nh(c), c === u) {
                      W = null;
                      break;
                    }
                    if (h !== null) {
                      h.return = x, W = h;
                      break;
                    }
                    W = x;
                  }
                }
              }
              var v = o.alternate;
              if (v !== null) {
                var w = v.child;
                if (w !== null) {
                  v.child = null;
                  do {
                    var _ = w.sibling;
                    w.sibling = null, w = _;
                  } while (w !== null);
                }
              }
              W = o;
            }
          }
          if (o.subtreeFlags & 2064 && s !== null) s.return = o, W = s;
          else e: for (; W !== null; ) {
            if (o = W, o.flags & 2048) switch (o.tag) {
              case 0:
              case 11:
              case 15:
                Pi(9, o, o.return);
            }
            var m = o.sibling;
            if (m !== null) {
              m.return = o.return, W = m;
              break e;
            }
            W = o.return;
          }
        }
        var d = e.current;
        for (W = d; W !== null; ) {
          s = W;
          var y = s.child;
          if (s.subtreeFlags & 2064 && y !== null) y.return = s, W = y;
          else e: for (s = d; W !== null; ) {
            if (a = W, a.flags & 2048) try {
              switch (a.tag) {
                case 0:
                case 11:
                case 15:
                  Xs(9, a);
              }
            } catch (f) {
              Te(a, a.return, f);
            }
            if (a === s) {
              W = null;
              break e;
            }
            var b = a.sibling;
            if (b !== null) {
              b.return = a.return, W = b;
              break e;
            }
            W = a.return;
          }
        }
        if (de = i, Zn(), Kt && typeof Kt.onPostCommitFiberRoot == "function") try {
          Kt.onPostCommitFiberRoot(Ws, e);
        } catch {
        }
        r = !0;
      }
      return r;
    } finally {
      he = n, Rt.transition = t;
    }
  }
  return !1;
}
function Sd(e, t, n) {
  t = Qr(n, t), t = Wp(e, t, 1), e = Dn(e, t, 1), t = it(), e !== null && (co(e, 1, t), ft(e, t));
}
function Te(e, t, n) {
  if (e.tag === 3) Sd(e, e, n);
  else for (; t !== null; ) {
    if (t.tag === 3) {
      Sd(t, e, n);
      break;
    } else if (t.tag === 1) {
      var r = t.stateNode;
      if (typeof t.type.getDerivedStateFromError == "function" || typeof r.componentDidCatch == "function" && (zn === null || !zn.has(r))) {
        e = Qr(n, e), e = Zp(t, e, 1), t = Dn(t, e, 1), e = it(), t !== null && (co(t, 1, e), ft(t, e));
        break;
      }
    }
    t = t.return;
  }
}
function Zy(e, t, n) {
  var r = e.pingCache;
  r !== null && r.delete(t), t = it(), e.pingedLanes |= e.suspendedLanes & n, Ve === e && (We & n) === n && (Me === 4 || Me === 3 && (We & 130023424) === We && 500 > Ae() - Yu ? tr(e, 0) : Gu |= n), ft(e, t);
}
function fh(e, t) {
  t === 0 && (e.mode & 1 ? (t = To, To <<= 1, !(To & 130023424) && (To = 4194304)) : t = 1);
  var n = it();
  e = mn(e, t), e !== null && (co(e, t, n), ft(e, n));
}
function Qy(e) {
  var t = e.memoizedState, n = 0;
  t !== null && (n = t.retryLane), fh(e, n);
}
function qy(e, t) {
  var n = 0;
  switch (e.tag) {
    case 13:
      var r = e.stateNode, i = e.memoizedState;
      i !== null && (n = i.retryLane);
      break;
    case 19:
      r = e.stateNode;
      break;
    default:
      throw Error(P(314));
  }
  r !== null && r.delete(t), fh(e, n);
}
var ph;
ph = function(e, t, n) {
  if (e !== null) if (e.memoizedProps !== t.pendingProps || ct.current) ut = !0;
  else {
    if (!(e.lanes & n) && !(t.flags & 128)) return ut = !1, Ly(e, t, n);
    ut = !!(e.flags & 131072);
  }
  else ut = !1, _e && t.flags & 1048576 && yp(t, hs, t.index);
  switch (t.lanes = 0, t.tag) {
    case 2:
      var r = t.type;
      qo(e, t), e = t.pendingProps;
      var i = Br(t, Ye.current);
      zr(t, n), i = Wu(null, t, r, e, i, n);
      var o = Zu();
      return t.flags |= 1, typeof i == "object" && i !== null && typeof i.render == "function" && i.$$typeof === void 0 ? (t.tag = 1, t.memoizedState = null, t.updateQueue = null, dt(r) ? (o = !0, fs(t)) : o = !1, t.memoizedState = i.state !== null && i.state !== void 0 ? i.state : null, Uu(t), i.updater = Ys, t.stateNode = i, i._reactInternals = t, Ll(t, r, e, n), t = zl(null, t, r, !0, o, n)) : (t.tag = 0, _e && o && Pu(t), nt(null, t, i, n), t = t.child), t;
    case 16:
      r = t.elementType;
      e: {
        switch (qo(e, t), e = t.pendingProps, i = r._init, r = i(r._payload), t.type = r, i = t.tag = Ky(r), e = Ft(r, e), i) {
          case 0:
            t = Dl(null, t, r, e, n);
            break e;
          case 1:
            t = hd(null, t, r, e, n);
            break e;
          case 11:
            t = fd(null, t, r, e, n);
            break e;
          case 14:
            t = pd(null, t, r, Ft(r.type, e), n);
            break e;
        }
        throw Error(P(
          306,
          r,
          ""
        ));
      }
      return t;
    case 0:
      return r = t.type, i = t.pendingProps, i = t.elementType === r ? i : Ft(r, i), Dl(e, t, r, i, n);
    case 1:
      return r = t.type, i = t.pendingProps, i = t.elementType === r ? i : Ft(r, i), hd(e, t, r, i, n);
    case 3:
      e: {
        if (Kp(t), e === null) throw Error(P(387));
        r = t.pendingProps, o = t.memoizedState, i = o.element, kp(e, t), ys(t, r, null, n);
        var s = t.memoizedState;
        if (r = s.element, o.isDehydrated) if (o = { element: r, isDehydrated: !1, cache: s.cache, pendingSuspenseBoundaries: s.pendingSuspenseBoundaries, transitions: s.transitions }, t.updateQueue.baseState = o, t.memoizedState = o, t.flags & 256) {
          i = Qr(Error(P(423)), t), t = md(e, t, r, n, i);
          break e;
        } else if (r !== i) {
          i = Qr(Error(P(424)), t), t = md(e, t, r, n, i);
          break e;
        } else for (vt = Fn(t.stateNode.containerInfo.firstChild), wt = t, _e = !0, zt = null, n = bp(t, null, r, n), t.child = n; n; ) n.flags = n.flags & -3 | 4096, n = n.sibling;
        else {
          if (Hr(), r === i) {
            t = gn(e, t, n);
            break e;
          }
          nt(e, t, r, n);
        }
        t = t.child;
      }
      return t;
    case 5:
      return Sp(t), e === null && Ol(t), r = t.type, i = t.pendingProps, o = e !== null ? e.memoizedProps : null, s = i.children, Nl(r, i) ? s = null : o !== null && Nl(r, o) && (t.flags |= 32), Jp(e, t), nt(e, t, s, n), t.child;
    case 6:
      return e === null && Ol(t), null;
    case 13:
      return Gp(e, t, n);
    case 4:
      return Vu(t, t.stateNode.containerInfo), r = t.pendingProps, e === null ? t.child = Wr(t, null, r, n) : nt(e, t, r, n), t.child;
    case 11:
      return r = t.type, i = t.pendingProps, i = t.elementType === r ? i : Ft(r, i), fd(e, t, r, i, n);
    case 7:
      return nt(e, t, t.pendingProps, n), t.child;
    case 8:
      return nt(e, t, t.pendingProps.children, n), t.child;
    case 12:
      return nt(e, t, t.pendingProps.children, n), t.child;
    case 10:
      e: {
        if (r = t.type._context, i = t.pendingProps, o = t.memoizedProps, s = i.value, ye(ms, r._currentValue), r._currentValue = s, o !== null) if (Bt(o.value, s)) {
          if (o.children === i.children && !ct.current) {
            t = gn(e, t, n);
            break e;
          }
        } else for (o = t.child, o !== null && (o.return = t); o !== null; ) {
          var a = o.dependencies;
          if (a !== null) {
            s = o.child;
            for (var l = a.firstContext; l !== null; ) {
              if (l.context === r) {
                if (o.tag === 1) {
                  l = dn(-1, n & -n), l.tag = 2;
                  var u = o.updateQueue;
                  if (u !== null) {
                    u = u.shared;
                    var c = u.pending;
                    c === null ? l.next = l : (l.next = c.next, c.next = l), u.pending = l;
                  }
                }
                o.lanes |= n, l = o.alternate, l !== null && (l.lanes |= n), Pl(
                  o.return,
                  n,
                  t
                ), a.lanes |= n;
                break;
              }
              l = l.next;
            }
          } else if (o.tag === 10) s = o.type === t.type ? null : o.child;
          else if (o.tag === 18) {
            if (s = o.return, s === null) throw Error(P(341));
            s.lanes |= n, a = s.alternate, a !== null && (a.lanes |= n), Pl(s, n, t), s = o.sibling;
          } else s = o.child;
          if (s !== null) s.return = o;
          else for (s = o; s !== null; ) {
            if (s === t) {
              s = null;
              break;
            }
            if (o = s.sibling, o !== null) {
              o.return = s.return, s = o;
              break;
            }
            s = s.return;
          }
          o = s;
        }
        nt(e, t, i.children, n), t = t.child;
      }
      return t;
    case 9:
      return i = t.type, r = t.pendingProps.children, zr(t, n), i = At(i), r = r(i), t.flags |= 1, nt(e, t, r, n), t.child;
    case 14:
      return r = t.type, i = Ft(r, t.pendingProps), i = Ft(r.type, i), pd(e, t, r, i, n);
    case 15:
      return Qp(e, t, t.type, t.pendingProps, n);
    case 17:
      return r = t.type, i = t.pendingProps, i = t.elementType === r ? i : Ft(r, i), qo(e, t), t.tag = 1, dt(r) ? (e = !0, fs(t)) : e = !1, zr(t, n), Hp(t, r, i), Ll(t, r, i, n), zl(null, t, r, !0, e, n);
    case 19:
      return Yp(e, t, n);
    case 22:
      return qp(e, t, n);
  }
  throw Error(P(156, t.tag));
};
function hh(e, t) {
  return Vf(e, t);
}
function Jy(e, t, n, r) {
  this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
}
function Tt(e, t, n, r) {
  return new Jy(e, t, n, r);
}
function nc(e) {
  return e = e.prototype, !(!e || !e.isReactComponent);
}
function Ky(e) {
  if (typeof e == "function") return nc(e) ? 1 : 0;
  if (e != null) {
    if (e = e.$$typeof, e === bu) return 11;
    if (e === _u) return 14;
  }
  return 2;
}
function Un(e, t) {
  var n = e.alternate;
  return n === null ? (n = Tt(e.tag, t, e.key, e.mode), n.elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.type = e.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = e.flags & 14680064, n.childLanes = e.childLanes, n.lanes = e.lanes, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = t === null ? null : { lanes: t.lanes, firstContext: t.firstContext }, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n;
}
function Go(e, t, n, r, i, o) {
  var s = 2;
  if (r = e, typeof e == "function") nc(e) && (s = 1);
  else if (typeof e == "string") s = 5;
  else e: switch (e) {
    case kr:
      return nr(n.children, i, o, t);
    case xu:
      s = 8, i |= 8;
      break;
    case ol:
      return e = Tt(12, n, t, i | 2), e.elementType = ol, e.lanes = o, e;
    case sl:
      return e = Tt(13, n, t, i), e.elementType = sl, e.lanes = o, e;
    case al:
      return e = Tt(19, n, t, i), e.elementType = al, e.lanes = o, e;
    case Sf:
      return ta(n, i, o, t);
    default:
      if (typeof e == "object" && e !== null) switch (e.$$typeof) {
        case _f:
          s = 10;
          break e;
        case kf:
          s = 9;
          break e;
        case bu:
          s = 11;
          break e;
        case _u:
          s = 14;
          break e;
        case Cn:
          s = 16, r = null;
          break e;
      }
      throw Error(P(130, e == null ? e : typeof e, ""));
  }
  return t = Tt(s, n, t, i), t.elementType = e, t.type = r, t.lanes = o, t;
}
function nr(e, t, n, r) {
  return e = Tt(7, e, r, t), e.lanes = n, e;
}
function ta(e, t, n, r) {
  return e = Tt(22, e, r, t), e.elementType = Sf, e.lanes = n, e.stateNode = { isHidden: !1 }, e;
}
function qa(e, t, n) {
  return e = Tt(6, e, null, t), e.lanes = n, e;
}
function Ja(e, t, n) {
  return t = Tt(4, e.children !== null ? e.children : [], e.key, t), t.lanes = n, t.stateNode = { containerInfo: e.containerInfo, pendingChildren: null, implementation: e.implementation }, t;
}
function Gy(e, t, n, r, i) {
  this.tag = t, this.containerInfo = e, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = Ra(0), this.expirationTimes = Ra(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Ra(0), this.identifierPrefix = r, this.onRecoverableError = i, this.mutableSourceEagerHydrationData = null;
}
function rc(e, t, n, r, i, o, s, a, l) {
  return e = new Gy(e, t, n, a, l), t === 1 ? (t = 1, o === !0 && (t |= 8)) : t = 0, o = Tt(3, null, null, t), e.current = o, o.stateNode = e, o.memoizedState = { element: r, isDehydrated: n, cache: null, transitions: null, pendingSuspenseBoundaries: null }, Uu(o), e;
}
function Yy(e, t, n) {
  var r = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
  return { $$typeof: _r, key: r == null ? null : "" + r, children: e, containerInfo: t, implementation: n };
}
function mh(e) {
  if (!e) return $n;
  e = e._reactInternals;
  e: {
    if (mr(e) !== e || e.tag !== 1) throw Error(P(170));
    var t = e;
    do {
      switch (t.tag) {
        case 3:
          t = t.stateNode.context;
          break e;
        case 1:
          if (dt(t.type)) {
            t = t.stateNode.__reactInternalMemoizedMergedChildContext;
            break e;
          }
      }
      t = t.return;
    } while (t !== null);
    throw Error(P(171));
  }
  if (e.tag === 1) {
    var n = e.type;
    if (dt(n)) return mp(e, n, t);
  }
  return t;
}
function gh(e, t, n, r, i, o, s, a, l) {
  return e = rc(n, r, !0, e, i, o, s, a, l), e.context = mh(null), n = e.current, r = it(), i = Mn(n), o = dn(r, i), o.callback = t ?? null, Dn(n, o, i), e.current.lanes = i, co(e, i, r), ft(e, r), e;
}
function na(e, t, n, r) {
  var i = t.current, o = it(), s = Mn(i);
  return n = mh(n), t.context === null ? t.context = n : t.pendingContext = n, t = dn(o, s), t.payload = { element: e }, r = r === void 0 ? null : r, r !== null && (t.callback = r), e = Dn(i, t, s), e !== null && ($t(e, i, s, o), Wo(e, i, s)), s;
}
function Es(e) {
  if (e = e.current, !e.child) return null;
  switch (e.child.tag) {
    case 5:
      return e.child.stateNode;
    default:
      return e.child.stateNode;
  }
}
function Ed(e, t) {
  if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
    var n = e.retryLane;
    e.retryLane = n !== 0 && n < t ? n : t;
  }
}
function ic(e, t) {
  Ed(e, t), (e = e.alternate) && Ed(e, t);
}
function Xy() {
  return null;
}
var yh = typeof reportError == "function" ? reportError : function(e) {
  console.error(e);
};
function oc(e) {
  this._internalRoot = e;
}
ra.prototype.render = oc.prototype.render = function(e) {
  var t = this._internalRoot;
  if (t === null) throw Error(P(409));
  na(e, t, null, null);
};
ra.prototype.unmount = oc.prototype.unmount = function() {
  var e = this._internalRoot;
  if (e !== null) {
    this._internalRoot = null;
    var t = e.containerInfo;
    cr(function() {
      na(null, e, null, null);
    }), t[hn] = null;
  }
};
function ra(e) {
  this._internalRoot = e;
}
ra.prototype.unstable_scheduleHydration = function(e) {
  if (e) {
    var t = qf();
    e = { blockedOn: null, target: e, priority: t };
    for (var n = 0; n < Rn.length && t !== 0 && t < Rn[n].priority; n++) ;
    Rn.splice(n, 0, e), n === 0 && Kf(e);
  }
};
function sc(e) {
  return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
}
function ia(e) {
  return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11 && (e.nodeType !== 8 || e.nodeValue !== " react-mount-point-unstable "));
}
function Cd() {
}
function ev(e, t, n, r, i) {
  if (i) {
    if (typeof r == "function") {
      var o = r;
      r = function() {
        var u = Es(s);
        o.call(u);
      };
    }
    var s = gh(t, r, e, 0, null, !1, !1, "", Cd);
    return e._reactRootContainer = s, e[hn] = s.current, Ki(e.nodeType === 8 ? e.parentNode : e), cr(), s;
  }
  for (; i = e.lastChild; ) e.removeChild(i);
  if (typeof r == "function") {
    var a = r;
    r = function() {
      var u = Es(l);
      a.call(u);
    };
  }
  var l = rc(e, 0, !1, null, null, !1, !1, "", Cd);
  return e._reactRootContainer = l, e[hn] = l.current, Ki(e.nodeType === 8 ? e.parentNode : e), cr(function() {
    na(t, l, n, r);
  }), l;
}
function oa(e, t, n, r, i) {
  var o = n._reactRootContainer;
  if (o) {
    var s = o;
    if (typeof i == "function") {
      var a = i;
      i = function() {
        var l = Es(s);
        a.call(l);
      };
    }
    na(t, s, e, i);
  } else s = ev(n, t, e, i, r);
  return Es(s);
}
Zf = function(e) {
  switch (e.tag) {
    case 3:
      var t = e.stateNode;
      if (t.current.memoizedState.isDehydrated) {
        var n = _i(t.pendingLanes);
        n !== 0 && (Eu(t, n | 1), ft(t, Ae()), !(de & 6) && (qr = Ae() + 500, Zn()));
      }
      break;
    case 13:
      cr(function() {
        var r = mn(e, 1);
        if (r !== null) {
          var i = it();
          $t(r, e, 1, i);
        }
      }), ic(e, 1);
  }
};
Cu = function(e) {
  if (e.tag === 13) {
    var t = mn(e, 134217728);
    if (t !== null) {
      var n = it();
      $t(t, e, 134217728, n);
    }
    ic(e, 134217728);
  }
};
Qf = function(e) {
  if (e.tag === 13) {
    var t = Mn(e), n = mn(e, t);
    if (n !== null) {
      var r = it();
      $t(n, e, t, r);
    }
    ic(e, t);
  }
};
qf = function() {
  return he;
};
Jf = function(e, t) {
  var n = he;
  try {
    return he = e, t();
  } finally {
    he = n;
  }
};
yl = function(e, t, n) {
  switch (t) {
    case "input":
      if (cl(e, n), t = n.name, n.type === "radio" && t != null) {
        for (n = e; n.parentNode; ) n = n.parentNode;
        for (n = n.querySelectorAll("input[name=" + JSON.stringify("" + t) + '][type="radio"]'), t = 0; t < n.length; t++) {
          var r = n[t];
          if (r !== e && r.form === e.form) {
            var i = Js(r);
            if (!i) throw Error(P(90));
            Cf(r), cl(r, i);
          }
        }
      }
      break;
    case "textarea":
      Tf(e, n);
      break;
    case "select":
      t = n.value, t != null && jr(e, !!n.multiple, t, !1);
  }
};
Lf = Xu;
Ff = cr;
var tv = { usingClientEntryPoint: !1, Events: [po, Nr, Js, Pf, jf, Xu] }, hi = { findFiberByHostInstance: Kn, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, nv = { bundleType: hi.bundleType, version: hi.version, rendererPackageName: hi.rendererPackageName, rendererConfig: hi.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: wn.ReactCurrentDispatcher, findHostInstanceByFiber: function(e) {
  return e = Mf(e), e === null ? null : e.stateNode;
}, findFiberByHostInstance: hi.findFiberByHostInstance || Xy, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
  var Mo = __REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (!Mo.isDisabled && Mo.supportsFiber) try {
    Ws = Mo.inject(nv), Kt = Mo;
  } catch {
  }
}
_t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = tv;
_t.createPortal = function(e, t) {
  var n = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
  if (!sc(t)) throw Error(P(200));
  return Yy(e, t, null, n);
};
_t.createRoot = function(e, t) {
  if (!sc(e)) throw Error(P(299));
  var n = !1, r = "", i = yh;
  return t != null && (t.unstable_strictMode === !0 && (n = !0), t.identifierPrefix !== void 0 && (r = t.identifierPrefix), t.onRecoverableError !== void 0 && (i = t.onRecoverableError)), t = rc(e, 1, !1, null, null, n, !1, r, i), e[hn] = t.current, Ki(e.nodeType === 8 ? e.parentNode : e), new oc(t);
};
_t.findDOMNode = function(e) {
  if (e == null) return null;
  if (e.nodeType === 1) return e;
  var t = e._reactInternals;
  if (t === void 0)
    throw typeof e.render == "function" ? Error(P(188)) : (e = Object.keys(e).join(","), Error(P(268, e)));
  return e = Mf(t), e = e === null ? null : e.stateNode, e;
};
_t.flushSync = function(e) {
  return cr(e);
};
_t.hydrate = function(e, t, n) {
  if (!ia(t)) throw Error(P(200));
  return oa(null, e, t, !0, n);
};
_t.hydrateRoot = function(e, t, n) {
  if (!sc(e)) throw Error(P(405));
  var r = n != null && n.hydratedSources || null, i = !1, o = "", s = yh;
  if (n != null && (n.unstable_strictMode === !0 && (i = !0), n.identifierPrefix !== void 0 && (o = n.identifierPrefix), n.onRecoverableError !== void 0 && (s = n.onRecoverableError)), t = gh(t, null, e, 1, n ?? null, i, !1, o, s), e[hn] = t.current, Ki(e), r) for (e = 0; e < r.length; e++) n = r[e], i = n._getVersion, i = i(n._source), t.mutableSourceEagerHydrationData == null ? t.mutableSourceEagerHydrationData = [n, i] : t.mutableSourceEagerHydrationData.push(
    n,
    i
  );
  return new ra(t);
};
_t.render = function(e, t, n) {
  if (!ia(t)) throw Error(P(200));
  return oa(null, e, t, !1, n);
};
_t.unmountComponentAtNode = function(e) {
  if (!ia(e)) throw Error(P(40));
  return e._reactRootContainer ? (cr(function() {
    oa(null, null, e, !1, function() {
      e._reactRootContainer = null, e[hn] = null;
    });
  }), !0) : !1;
};
_t.unstable_batchedUpdates = Xu;
_t.unstable_renderSubtreeIntoContainer = function(e, t, n, r) {
  if (!ia(n)) throw Error(P(200));
  if (e == null || e._reactInternals === void 0) throw Error(P(38));
  return oa(e, t, n, !1, r);
};
_t.version = "18.3.1-next-f1338f8080-20240426";
function vh() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(vh);
    } catch (e) {
      console.error(e);
    }
}
vh(), vf.exports = _t;
var wh = vf.exports, Nd = wh;
rl.createRoot = Nd.createRoot, rl.hydrateRoot = Nd.hydrateRoot;
var xh = { exports: {} }, sa = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rv = S, iv = Symbol.for("react.element"), ov = Symbol.for("react.fragment"), sv = Object.prototype.hasOwnProperty, av = rv.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, lv = { key: !0, ref: !0, __self: !0, __source: !0 };
function bh(e, t, n) {
  var r, i = {}, o = null, s = null;
  n !== void 0 && (o = "" + n), t.key !== void 0 && (o = "" + t.key), t.ref !== void 0 && (s = t.ref);
  for (r in t) sv.call(t, r) && !lv.hasOwnProperty(r) && (i[r] = t[r]);
  if (e && e.defaultProps) for (r in t = e.defaultProps, t) i[r] === void 0 && (i[r] = t[r]);
  return { $$typeof: iv, type: e, key: o, ref: s, props: i, _owner: av.current };
}
sa.Fragment = ov;
sa.jsx = bh;
sa.jsxs = bh;
xh.exports = sa;
var I = xh.exports;
function _h(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var i = e.length;
    for (t = 0; t < i; t++) e[t] && (n = _h(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function kh() {
  for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = _h(e)) && (r && (r += " "), r += t);
  return r;
}
const ac = "-", uv = (e) => {
  const t = dv(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (s) => {
      const a = s.split(ac);
      return a[0] === "" && a.length !== 1 && a.shift(), Sh(a, t) || cv(s);
    },
    getConflictingClassGroupIds: (s, a) => {
      const l = n[s] || [];
      return a && r[s] ? [...l, ...r[s]] : l;
    }
  };
}, Sh = (e, t) => {
  var s;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), i = r ? Sh(e.slice(1), r) : void 0;
  if (i)
    return i;
  if (t.validators.length === 0)
    return;
  const o = e.join(ac);
  return (s = t.validators.find(({
    validator: a
  }) => a(o))) == null ? void 0 : s.classGroupId;
}, Td = /^\[(.+)\]$/, cv = (e) => {
  if (Td.test(e)) {
    const t = Td.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, dv = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return pv(Object.entries(e.classGroups), n).forEach(([o, s]) => {
    Kl(s, r, o, t);
  }), r;
}, Kl = (e, t, n, r) => {
  e.forEach((i) => {
    if (typeof i == "string") {
      const o = i === "" ? t : Rd(t, i);
      o.classGroupId = n;
      return;
    }
    if (typeof i == "function") {
      if (fv(i)) {
        Kl(i(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: i,
        classGroupId: n
      });
      return;
    }
    Object.entries(i).forEach(([o, s]) => {
      Kl(s, Rd(t, o), n, r);
    });
  });
}, Rd = (e, t) => {
  let n = e;
  return t.split(ac).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, fv = (e) => e.isThemeGetter, pv = (e, t) => t ? e.map(([n, r]) => {
  const i = r.map((o) => typeof o == "string" ? t + o : typeof o == "object" ? Object.fromEntries(Object.entries(o).map(([s, a]) => [t + s, a])) : o);
  return [n, i];
}) : e, hv = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const i = (o, s) => {
    n.set(o, s), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(o) {
      let s = n.get(o);
      if (s !== void 0)
        return s;
      if ((s = r.get(o)) !== void 0)
        return i(o, s), s;
    },
    set(o, s) {
      n.has(o) ? n.set(o, s) : i(o, s);
    }
  };
}, Eh = "!", mv = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, i = t[0], o = t.length, s = (a) => {
    const l = [];
    let u = 0, c = 0, p;
    for (let _ = 0; _ < a.length; _++) {
      let m = a[_];
      if (u === 0) {
        if (m === i && (r || a.slice(_, _ + o) === t)) {
          l.push(a.slice(c, _)), c = _ + o;
          continue;
        }
        if (m === "/") {
          p = _;
          continue;
        }
      }
      m === "[" ? u++ : m === "]" && u--;
    }
    const h = l.length === 0 ? a : a.substring(c), x = h.startsWith(Eh), v = x ? h.substring(1) : h, w = p && p > c ? p - c : void 0;
    return {
      modifiers: l,
      hasImportantModifier: x,
      baseClassName: v,
      maybePostfixModifierPosition: w
    };
  };
  return n ? (a) => n({
    className: a,
    parseClassName: s
  }) : s;
}, gv = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, yv = (e) => ({
  cache: hv(e.cacheSize),
  parseClassName: mv(e),
  ...uv(e)
}), vv = /\s+/, wv = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: i
  } = t, o = [], s = e.trim().split(vv);
  let a = "";
  for (let l = s.length - 1; l >= 0; l -= 1) {
    const u = s[l], {
      modifiers: c,
      hasImportantModifier: p,
      baseClassName: h,
      maybePostfixModifierPosition: x
    } = n(u);
    let v = !!x, w = r(v ? h.substring(0, x) : h);
    if (!w) {
      if (!v) {
        a = u + (a.length > 0 ? " " + a : a);
        continue;
      }
      if (w = r(h), !w) {
        a = u + (a.length > 0 ? " " + a : a);
        continue;
      }
      v = !1;
    }
    const _ = gv(c).join(":"), m = p ? _ + Eh : _, d = m + w;
    if (o.includes(d))
      continue;
    o.push(d);
    const y = i(w, v);
    for (let b = 0; b < y.length; ++b) {
      const f = y[b];
      o.push(m + f);
    }
    a = u + (a.length > 0 ? " " + a : a);
  }
  return a;
};
function xv() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = Ch(t)) && (r && (r += " "), r += n);
  return r;
}
const Ch = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = Ch(e[r])) && (n && (n += " "), n += t);
  return n;
};
function bv(e, ...t) {
  let n, r, i, o = s;
  function s(l) {
    const u = t.reduce((c, p) => p(c), e());
    return n = yv(u), r = n.cache.get, i = n.cache.set, o = a, a(l);
  }
  function a(l) {
    const u = r(l);
    if (u)
      return u;
    const c = wv(l, n);
    return i(l, c), c;
  }
  return function() {
    return o(xv.apply(null, arguments));
  };
}
const we = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, Nh = /^\[(?:([a-z-]+):)?(.+)\]$/i, _v = /^\d+\/\d+$/, kv = /* @__PURE__ */ new Set(["px", "full", "screen"]), Sv = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Ev = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Cv = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, Nv = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Tv = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, tn = (e) => Ur(e) || kv.has(e) || _v.test(e), Sn = (e) => ni(e, "length", Fv), Ur = (e) => !!e && !Number.isNaN(Number(e)), Ka = (e) => ni(e, "number", Ur), mi = (e) => !!e && Number.isInteger(Number(e)), Rv = (e) => e.endsWith("%") && Ur(e.slice(0, -1)), te = (e) => Nh.test(e), En = (e) => Sv.test(e), Iv = /* @__PURE__ */ new Set(["length", "size", "percentage"]), Av = (e) => ni(e, Iv, Th), Ov = (e) => ni(e, "position", Th), Pv = /* @__PURE__ */ new Set(["image", "url"]), jv = (e) => ni(e, Pv, zv), Lv = (e) => ni(e, "", Dv), gi = () => !0, ni = (e, t, n) => {
  const r = Nh.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, Fv = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Ev.test(e) && !Cv.test(e)
), Th = () => !1, Dv = (e) => Nv.test(e), zv = (e) => Tv.test(e), Mv = () => {
  const e = we("colors"), t = we("spacing"), n = we("blur"), r = we("brightness"), i = we("borderColor"), o = we("borderRadius"), s = we("borderSpacing"), a = we("borderWidth"), l = we("contrast"), u = we("grayscale"), c = we("hueRotate"), p = we("invert"), h = we("gap"), x = we("gradientColorStops"), v = we("gradientColorStopPositions"), w = we("inset"), _ = we("margin"), m = we("opacity"), d = we("padding"), y = we("saturate"), b = we("scale"), f = we("sepia"), A = we("skew"), N = we("space"), R = we("translate"), j = () => ["auto", "contain", "none"], T = () => ["auto", "hidden", "clip", "visible", "scroll"], U = () => ["auto", te, t], z = () => [te, t], K = () => ["", tn, Sn], ne = () => ["auto", Ur, te], le = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], fe = () => ["solid", "dashed", "dotted", "double", "none"], ke = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], F = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], Q = () => ["", "0", te], J = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], re = () => [Ur, te];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [gi],
      spacing: [tn, Sn],
      blur: ["none", "", En, te],
      brightness: re(),
      borderColor: [e],
      borderRadius: ["none", "", "full", En, te],
      borderSpacing: z(),
      borderWidth: K(),
      contrast: re(),
      grayscale: Q(),
      hueRotate: re(),
      invert: Q(),
      gap: z(),
      gradientColorStops: [e],
      gradientColorStopPositions: [Rv, Sn],
      inset: U(),
      margin: U(),
      opacity: re(),
      padding: z(),
      saturate: re(),
      scale: re(),
      sepia: Q(),
      skew: re(),
      space: z(),
      translate: z()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", te]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [En]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": J()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": J()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...le(), te]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: T()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": T()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": T()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: j()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": j()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": j()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [w]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [w]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [w]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [w]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [w]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [w]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [w]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [w]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [w]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", mi, te]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: U()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", te]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: Q()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: Q()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", mi, te]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [gi]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", mi, te]
        }, te]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": ne()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": ne()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [gi]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [mi, te]
        }, te]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": ne()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": ne()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", te]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", te]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [h]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [h]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [h]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...F()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...F(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...F(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [d]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [d]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [d]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [d]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [d]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [d]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [d]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [d]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [d]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [_]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [_]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [_]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [_]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [_]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [_]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [_]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [_]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [_]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [N]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [N]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", te, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [te, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [te, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [En]
        }, En]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [te, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [te, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [te, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [te, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", En, Sn]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Ka]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [gi]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", te]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Ur, Ka]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", tn, te]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", te]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", te]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [m]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [m]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...fe(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", tn, Sn]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", tn, te]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: z()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", te]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", te]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [m]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...le(), Ov]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", Av]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, jv]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [v]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [v]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [v]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [x]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [x]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [x]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [o]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [o]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [o]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [o]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [o]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [o]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [o]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [o]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [o]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [o]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [o]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [o]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [o]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [o]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [o]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [a]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [a]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [a]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [a]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [a]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [a]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [a]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [a]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [a]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [m]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...fe(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [a]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [a]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [m]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: fe()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [i]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [i]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [i]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [i]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [i]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [i]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [i]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [i]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [i]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [i]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...fe()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [tn, te]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [tn, Sn]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: K()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [m]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [tn, Sn]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", En, Lv]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [gi]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [m]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...ke(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": ke()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", En, te]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [c]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [p]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [y]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [f]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [c]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [p]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [m]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [y]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [f]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [s]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [s]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [s]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", te]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: re()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", te]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: re()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", te]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [b]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [b]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [b]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [mi, te]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [R]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [R]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [A]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [A]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", te]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", te]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": z()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": z()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": z()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": z()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": z()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": z()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": z()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": z()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": z()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": z()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": z()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": z()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": z()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": z()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": z()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": z()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": z()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": z()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", te]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [tn, Sn, Ka]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, Uv = /* @__PURE__ */ bv(Mv);
function St(...e) {
  return Uv(kh(e));
}
const Rh = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ I.jsx(
  "div",
  {
    ref: n,
    className: St(
      "rounded-xl border bg-card text-card-foreground shadow",
      e
    ),
    ...t
  }
));
Rh.displayName = "Card";
const Vv = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ I.jsx(
  "div",
  {
    ref: n,
    className: St("flex flex-col space-y-1.5 p-6", e),
    ...t
  }
));
Vv.displayName = "CardHeader";
const $v = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ I.jsx(
  "div",
  {
    ref: n,
    className: St("font-semibold leading-none tracking-tight", e),
    ...t
  }
));
$v.displayName = "CardTitle";
const Bv = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ I.jsx(
  "div",
  {
    ref: n,
    className: St("text-sm text-muted-foreground", e),
    ...t
  }
));
Bv.displayName = "CardDescription";
const Ih = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ I.jsx("div", { ref: n, className: St("p-6 pt-0", e), ...t }));
Ih.displayName = "CardContent";
const Hv = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ I.jsx(
  "div",
  {
    ref: n,
    className: St("flex items-center p-6 pt-0", e),
    ...t
  }
));
Hv.displayName = "CardFooter";
const Ah = S.createContext(void 0), Wv = ({
  children: e,
  onUpdateClassificationData: t,
  onReset: n,
  showInitialMessage: r = !1,
  showLastMessage: i = !0,
  events: o = {}
}) => {
  const s = S.useRef(null), [a, l] = S.useState("new_issue"), [u, c] = S.useState(null), [p, h] = S.useState(null), [x, v] = S.useState(null), [w, _] = S.useState([]), [m, d] = S.useState(0), [y, b] = S.useState({}), [f, A] = S.useState(null), [N, R] = S.useState(null), [j, T] = S.useState(null), [U, z] = S.useState([]), [K, ne] = S.useState(null), [le, fe] = S.useState(null), [ke, F] = S.useState(null), [Q, J] = S.useState(null), [re, me] = S.useState(""), [Pt, Xe] = S.useState(""), [jt, Qe] = S.useState(null), [Et, q] = S.useState(null), [se, ge] = S.useState(null), [$e, Re] = S.useState(
    r ? [{ type: "system", content: "What do you need legal help with?" }] : []
  ), [Qn, xn] = S.useState(!0), [gr, et] = S.useState(!1), [bn, _n] = S.useState(!1), [xa, xo] = S.useState(!1), [bo, g] = S.useState(!1), [k, C] = S.useState(!1), [$, D] = S.useState(-1), [L, H] = S.useState(!1), [ae, ve] = S.useState(!1), [je, yr] = S.useState(!1);
  S.useEffect(() => {
    a === "contact_info" && (ve(!0), H(!0), setTimeout(() => {
      const mt = document.getElementById("contact-name-input");
      mt && !je && (mt.focus(), yr(!0));
    }, 100));
  }, [a, je]);
  const vr = () => {
    !Qn && s.current && (s.current.scrollTop = s.current.scrollHeight);
  }, oi = () => {
    l("new_issue"), c(null), h(null), _([]), d(0), A(null), R(null), T(null), z([]), ne(null), q(null), me(""), Xe(""), Qe(null), fe(null), F(null), xo(!1), J(null), g(!1), et(!1), ge(null), H(!1), ve(!1), yr(!1), _n(!1), Re(r ? [{ type: "system", content: "What do you need legal help with?" }] : []), xn(!0), t({
      submissionId: null,
      classifiedDivision: null,
      chainOfThought: null,
      summary: null,
      issue: null,
      divisionResolutionLog: [],
      jurisdictionRegion: null,
      jurisdictionState: null,
      locationName: null,
      contactInfo: null,
      uaDivisionId: null,
      uaRegionId: null
    }), n();
    const mt = () => {
      const si = document.getElementById("issue-input");
      si instanceof HTMLInputElement ? si.focus() : setTimeout(mt, 100);
    };
    setTimeout(mt, 50);
  }, ba = () => {
    (a === "contact_info" || a === "jurisdiction" || a === "completed") && (et(!0), l("jurisdiction"), me(""), Xe(""), Qe(null), q(null), xo(!0), Re((mt) => mt.filter((si) => !(si.type === "system" && si.content.includes("share your contact details")))));
  }, _o = () => {
    (a === "contact_info" || a === "completed") && !bn && (_n(!0), yr(!1), a === "completed" && l("contact_info"), H(!0), ve(!0), setTimeout(() => {
      vr();
    }, 100));
  }, _a = () => {
    setTimeout(() => {
      const mt = document.getElementById("jurisdiction-input");
      mt instanceof HTMLInputElement && mt.focus();
    }, 100);
  }, Fm = {
    formState: a,
    setFormState: l,
    submissionId: u,
    setSubmissionId: c,
    classifiedDivision: p,
    setClassifiedDivision: h,
    uaDivisionId: x,
    setUaDivisionId: v,
    clarifyingQuestions: w,
    setClarifyingQuestions: _,
    questionRounds: m,
    setQuestionRounds: d,
    clarifyingSchema: y,
    setClarifyingSchema: b,
    chainOfThought: f,
    setChainOfThought: A,
    summary: N,
    setSummary: R,
    issue: j,
    setIssue: T,
    divisionResolutionLog: U,
    setDivisionResolutionLog: z,
    languageCode: K,
    setLanguageCode: ne,
    jurisdictionRegion: le,
    setJurisdictionRegion: fe,
    jurisdictionState: ke,
    setJurisdictionState: F,
    jurisdictionUaRegionId: Q,
    setJurisdictionUaRegionId: J,
    searchQuery: re,
    setSearchQuery: me,
    locationInputValue: Pt,
    setLocationInputValue: Xe,
    locationError: jt,
    setLocationError: Qe,
    selectedLocation: Et,
    setSelectedLocation: q,
    contactInfo: se,
    setContactInfo: ge,
    messages: $e,
    setMessages: Re,
    isInitialLoad: Qn,
    setIsInitialLoad: xn,
    editingJurisdiction: gr,
    setEditingJurisdiction: et,
    editingContact: bn,
    setEditingContact: _n,
    shouldRenderLocationInput: xa,
    setShouldRenderLocationInput: xo,
    jurisdictionQuestionDisplayed: bo,
    setJurisdictionQuestionDisplayed: (mt) => {
      g(mt), mt && _a();
    },
    isDropdownOpen: k,
    setIsDropdownOpen: C,
    selectedLocationIndex: $,
    setSelectedLocationIndex: D,
    showContactForm: L,
    setShowContactForm: H,
    shouldRenderContactForm: ae,
    setShouldRenderContactForm: ve,
    hasContactFormBeenFocused: je,
    setHasContactFormBeenFocused: yr,
    resetFormState: oi,
    onUpdateClassificationData: t,
    onReset: n,
    scrollToBottom: vr,
    handleEditJurisdiction: ba,
    handleEditContact: _o,
    scrollContainerRef: s,
    events: o,
    showInitialMessage: r,
    showLastMessage: i
  };
  return /* @__PURE__ */ I.jsx(Ah.Provider, { value: Fm, children: e });
}, en = () => {
  const e = S.useContext(Ah);
  if (e === void 0)
    throw new Error("useIntakeFormContext must be used within an IntakeFormProvider");
  return e;
};
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zv = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), Oh = (...e) => e.filter((t, n, r) => !!t && t.trim() !== "" && r.indexOf(t) === n).join(" ").trim();
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var Qv = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qv = S.forwardRef(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: r,
    className: i = "",
    children: o,
    iconNode: s,
    ...a
  }, l) => S.createElement(
    "svg",
    {
      ref: l,
      ...Qv,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: r ? Number(n) * 24 / Number(t) : n,
      className: Oh("lucide", i),
      ...a
    },
    [
      ...s.map(([u, c]) => S.createElement(u, c)),
      ...Array.isArray(o) ? o : [o]
    ]
  )
);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aa = (e, t) => {
  const n = S.forwardRef(
    ({ className: r, ...i }, o) => S.createElement(qv, {
      ref: o,
      iconNode: t,
      className: Oh(`lucide-${Zv(e)}`, r),
      ...i
    })
  );
  return n.displayName = `${e}`, n;
};
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jv = aa("Pencil", [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
]), Kv = () => {
  const {
    messages: e,
    handleEditJurisdiction: t,
    handleEditContact: n
  } = en(), r = S.useRef(null);
  return /* @__PURE__ */ I.jsxs("div", { className: "space-y-4", children: [
    e.map((i, o) => /* @__PURE__ */ I.jsx(
      "div",
      {
        className: `flex pb-0 ${i.type === "user" ? "justify-end" : "justify-start"}`,
        children: i.type === "loading" ? /* @__PURE__ */ I.jsx("div", { className: "text-neutral-600 rounded-lg px-4 py-2 max-w-[80%]", children: /* @__PURE__ */ I.jsxs("div", { className: "flex space-x-1", children: [
          /* @__PURE__ */ I.jsx("div", { className: "h-2 w-2 bg-neutral-400 rounded-full animate-bounce", style: { animationDelay: "0ms" } }),
          /* @__PURE__ */ I.jsx("div", { className: "h-2 w-2 bg-neutral-400 rounded-full animate-bounce", style: { animationDelay: "150ms" } }),
          /* @__PURE__ */ I.jsx("div", { className: "h-2 w-2 bg-neutral-400 rounded-full animate-bounce", style: { animationDelay: "300ms" } })
        ] }) }) : /* @__PURE__ */ I.jsxs(
          "div",
          {
            className: `relative rounded-lg px-4 py-2 max-w-[80%] ${i.type === "user" ? `bg-[#0a6fc2] text-white ${i.editable ? "pr-10" : ""}` : "bg-neutral-100 text-neutral-800"}`,
            children: [
              /* @__PURE__ */ I.jsx("div", { className: "break-words whitespace-pre-line", children: i.content }),
              i.type === "user" && i.editable && /* @__PURE__ */ I.jsx(
                "button",
                {
                  className: "absolute right-2 top-2 p-1.5 rounded-md hover:bg-[#035398] transition-colors",
                  onClick: () => {
                    i.editType === "jurisdiction" ? t() : i.editType === "contact" && n();
                  },
                  "aria-label": `Edit ${i.editType}`,
                  children: /* @__PURE__ */ I.jsx(Jv, { className: "h-3.5 w-3.5 text-white" })
                }
              )
            ]
          }
        )
      },
      o
    )),
    /* @__PURE__ */ I.jsx("div", { ref: r })
  ] });
};
function Id(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Gv(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((i) => {
      const o = Id(i, t);
      return !n && typeof o == "function" && (n = !0), o;
    });
    if (n)
      return () => {
        for (let i = 0; i < r.length; i++) {
          const o = r[i];
          typeof o == "function" ? o() : Id(e[i], null);
        }
      };
  };
}
// @__NO_SIDE_EFFECTS__
function Ph(e) {
  const t = /* @__PURE__ */ Yv(e), n = S.forwardRef((r, i) => {
    const { children: o, ...s } = r, a = S.Children.toArray(o), l = a.find(ew);
    if (l) {
      const u = l.props.children, c = a.map((p) => p === l ? S.Children.count(u) > 1 ? S.Children.only(null) : S.isValidElement(u) ? u.props.children : null : p);
      return /* @__PURE__ */ I.jsx(t, { ...s, ref: i, children: S.isValidElement(u) ? S.cloneElement(u, void 0, c) : null });
    }
    return /* @__PURE__ */ I.jsx(t, { ...s, ref: i, children: o });
  });
  return n.displayName = `${e}.Slot`, n;
}
var jh = /* @__PURE__ */ Ph("Slot");
// @__NO_SIDE_EFFECTS__
function Yv(e) {
  const t = S.forwardRef((n, r) => {
    const { children: i, ...o } = n;
    if (S.isValidElement(i)) {
      const s = nw(i), a = tw(o, i.props);
      return i.type !== S.Fragment && (a.ref = r ? Gv(r, s) : s), S.cloneElement(i, a);
    }
    return S.Children.count(i) > 1 ? S.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Xv = Symbol("radix.slottable");
function ew(e) {
  return S.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Xv;
}
function tw(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...a) => {
      o(...a), i(...a);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function nw(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var mo = (e) => e.type === "checkbox", Xn = (e) => e instanceof Date, rt = (e) => e == null;
const Lh = (e) => typeof e == "object";
var Oe = (e) => !rt(e) && !Array.isArray(e) && Lh(e) && !Xn(e), Fh = (e) => Oe(e) && e.target ? mo(e.target) ? e.target.checked : e.target.value : e, rw = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, Dh = (e, t) => e.has(rw(t)), iw = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return Oe(t) && t.hasOwnProperty("isPrototypeOf");
}, lc = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Be(e) {
  let t;
  const n = Array.isArray(e), r = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    t = new Date(e);
  else if (e instanceof Set)
    t = new Set(e);
  else if (!(lc && (e instanceof Blob || r)) && (n || Oe(e)))
    if (t = n ? [] : {}, !n && !iw(e))
      t = e;
    else
      for (const i in e)
        e.hasOwnProperty(i) && (t[i] = Be(e[i]));
  else
    return e;
  return t;
}
var la = (e) => Array.isArray(e) ? e.filter(Boolean) : [], Ie = (e) => e === void 0, M = (e, t, n) => {
  if (!t || !Oe(e))
    return n;
  const r = la(t.split(/[,[\].]+?/)).reduce((i, o) => rt(i) ? i : i[o], e);
  return Ie(r) || r === e ? Ie(e[t]) ? n : e[t] : r;
}, yt = (e) => typeof e == "boolean", uc = (e) => /^\w*$/.test(e), zh = (e) => la(e.replace(/["|']|\]/g, "").split(/\.|\[/)), pe = (e, t, n) => {
  let r = -1;
  const i = uc(t) ? [t] : zh(t), o = i.length, s = o - 1;
  for (; ++r < o; ) {
    const a = i[r];
    let l = n;
    if (r !== s) {
      const u = e[a];
      l = Oe(u) || Array.isArray(u) ? u : isNaN(+i[r + 1]) ? {} : [];
    }
    if (a === "__proto__" || a === "constructor" || a === "prototype")
      return;
    e[a] = l, e = e[a];
  }
};
const Cs = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, Mt = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, nn = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, Mh = ue.createContext(null), ua = () => ue.useContext(Mh), ow = (e) => {
  const { children: t, ...n } = e;
  return ue.createElement(Mh.Provider, { value: n }, t);
};
var Uh = (e, t, n, r = !0) => {
  const i = {
    defaultValues: t._defaultValues
  };
  for (const o in e)
    Object.defineProperty(i, o, {
      get: () => {
        const s = o;
        return t._proxyFormState[s] !== Mt.all && (t._proxyFormState[s] = !r || Mt.all), n && (n[s] = !0), e[s];
      }
    });
  return i;
}, Gl = (e) => rt(e) || !Lh(e);
function an(e, t) {
  if (Gl(e) || Gl(t))
    return e === t;
  if (Xn(e) && Xn(t))
    return e.getTime() === t.getTime();
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length)
    return !1;
  for (const i of n) {
    const o = e[i];
    if (!r.includes(i))
      return !1;
    if (i !== "ref") {
      const s = t[i];
      if (Xn(o) && Xn(s) || Oe(o) && Oe(s) || Array.isArray(o) && Array.isArray(s) ? !an(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
const Vh = (e, t) => {
  const n = S.useRef(t);
  an(t, n.current) || (n.current = t), S.useEffect(e, n.current);
};
function sw(e) {
  const t = ua(), { control: n = t.control, disabled: r, name: i, exact: o } = e || {}, [s, a] = ue.useState(n._formState), l = ue.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  });
  return Vh(() => n._subscribe({
    name: i,
    formState: l.current,
    exact: o,
    callback: (u) => {
      !r && a({
        ...n._formState,
        ...u
      });
    }
  }), [i, r, o]), ue.useEffect(() => {
    l.current.isValid && n._setValid(!0);
  }, [n]), ue.useMemo(() => Uh(s, n, l.current, !1), [s, n]);
}
var Jt = (e) => typeof e == "string", $h = (e, t, n, r, i) => Jt(e) ? (r && t.watch.add(e), M(n, e, i)) : Array.isArray(e) ? e.map((o) => (r && t.watch.add(o), M(n, o))) : (r && (t.watchAll = !0), n);
function aw(e) {
  const t = ua(), { control: n = t.control, name: r, defaultValue: i, disabled: o, exact: s } = e || {}, [a, l] = ue.useState(n._getWatch(r, i));
  return Vh(() => n._subscribe({
    name: r,
    formState: {
      values: !0
    },
    exact: s,
    callback: (u) => !o && l($h(r, n._names, u.values || n._formValues, !1, i))
  }), [r, i, o, s]), ue.useEffect(() => n._removeUnmounted()), a;
}
function lw(e) {
  const t = ua(), { name: n, disabled: r, control: i = t.control, shouldUnregister: o } = e, s = Dh(i._names.array, n), a = aw({
    control: i,
    name: n,
    defaultValue: M(i._formValues, n, M(i._defaultValues, n, e.defaultValue)),
    exact: !0
  }), l = sw({
    control: i,
    name: n,
    exact: !0
  }), u = ue.useRef(e), c = ue.useRef(i.register(n, {
    ...e.rules,
    value: a,
    ...yt(e.disabled) ? { disabled: e.disabled } : {}
  })), p = ue.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!M(l.errors, n)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!M(l.dirtyFields, n)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!M(l.touchedFields, n)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!M(l.validatingFields, n)
    },
    error: {
      enumerable: !0,
      get: () => M(l.errors, n)
    }
  }), [l, n]), h = ue.useCallback((_) => c.current.onChange({
    target: {
      value: Fh(_),
      name: n
    },
    type: Cs.CHANGE
  }), [n]), x = ue.useCallback(() => c.current.onBlur({
    target: {
      value: M(i._formValues, n),
      name: n
    },
    type: Cs.BLUR
  }), [n, i._formValues]), v = ue.useCallback((_) => {
    const m = M(i._fields, n);
    m && _ && (m._f.ref = {
      focus: () => _.focus(),
      select: () => _.select(),
      setCustomValidity: (d) => _.setCustomValidity(d),
      reportValidity: () => _.reportValidity()
    });
  }, [i._fields, n]), w = ue.useMemo(() => ({
    name: n,
    value: a,
    ...yt(r) || l.disabled ? { disabled: l.disabled || r } : {},
    onChange: h,
    onBlur: x,
    ref: v
  }), [n, r, l.disabled, h, x, v, a]);
  return ue.useEffect(() => {
    const _ = i._options.shouldUnregister || o;
    i.register(n, {
      ...u.current.rules,
      ...yt(u.current.disabled) ? { disabled: u.current.disabled } : {}
    });
    const m = (d, y) => {
      const b = M(i._fields, d);
      b && b._f && (b._f.mount = y);
    };
    if (m(n, !0), _) {
      const d = Be(M(i._options.defaultValues, n));
      pe(i._defaultValues, n, d), Ie(M(i._formValues, n)) && pe(i._formValues, n, d);
    }
    return !s && i.register(n), () => {
      (s ? _ && !i._state.action : _) ? i.unregister(n) : m(n, !1);
    };
  }, [n, i, s, o]), ue.useEffect(() => {
    i._setDisabledField({
      disabled: r,
      name: n
    });
  }, [r, n, i]), ue.useMemo(() => ({
    field: w,
    formState: l,
    fieldState: p
  }), [w, l, p]);
}
const uw = (e) => e.render(lw(e));
var Bh = (e, t, n, r, i) => t ? {
  ...n[e],
  types: {
    ...n[e] && n[e].types ? n[e].types : {},
    [r]: i || !0
  }
} : {}, Fi = (e) => Array.isArray(e) ? e : [e], Ad = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (i) => {
      for (const o of e)
        o.next && o.next(i);
    },
    subscribe: (i) => (e.push(i), {
      unsubscribe: () => {
        e = e.filter((o) => o !== i);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, tt = (e) => Oe(e) && !Object.keys(e).length, cc = (e) => e.type === "file", Ut = (e) => typeof e == "function", Ns = (e) => {
  if (!lc)
    return !1;
  const t = e ? e.ownerDocument : 0;
  return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, Hh = (e) => e.type === "select-multiple", dc = (e) => e.type === "radio", cw = (e) => dc(e) || mo(e), Ga = (e) => Ns(e) && e.isConnected;
function dw(e, t) {
  const n = t.slice(0, -1).length;
  let r = 0;
  for (; r < n; )
    e = Ie(e) ? r++ : e[t[r++]];
  return e;
}
function fw(e) {
  for (const t in e)
    if (e.hasOwnProperty(t) && !Ie(e[t]))
      return !1;
  return !0;
}
function Fe(e, t) {
  const n = Array.isArray(t) ? t : uc(t) ? [t] : zh(t), r = n.length === 1 ? e : dw(e, n), i = n.length - 1, o = n[i];
  return r && delete r[o], i !== 0 && (Oe(r) && tt(r) || Array.isArray(r) && fw(r)) && Fe(e, n.slice(0, -1)), e;
}
var Wh = (e) => {
  for (const t in e)
    if (Ut(e[t]))
      return !0;
  return !1;
};
function Ts(e, t = {}) {
  const n = Array.isArray(e);
  if (Oe(e) || n)
    for (const r in e)
      Array.isArray(e[r]) || Oe(e[r]) && !Wh(e[r]) ? (t[r] = Array.isArray(e[r]) ? [] : {}, Ts(e[r], t[r])) : rt(e[r]) || (t[r] = !0);
  return t;
}
function Zh(e, t, n) {
  const r = Array.isArray(e);
  if (Oe(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || Oe(e[i]) && !Wh(e[i]) ? Ie(t) || Gl(n[i]) ? n[i] = Array.isArray(e[i]) ? Ts(e[i], []) : { ...Ts(e[i]) } : Zh(e[i], rt(t) ? {} : t[i], n[i]) : n[i] = !an(e[i], t[i]);
  return n;
}
var yi = (e, t) => Zh(e, t, Ts(t));
const Od = {
  value: !1,
  isValid: !1
}, Pd = { value: !0, isValid: !0 };
var Qh = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const t = e.filter((n) => n && n.checked && !n.disabled).map((n) => n.value);
      return { value: t, isValid: !!t.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !Ie(e[0].attributes.value) ? Ie(e[0].value) || e[0].value === "" ? Pd : { value: e[0].value, isValid: !0 } : Pd
    ) : Od;
  }
  return Od;
}, qh = (e, { valueAsNumber: t, valueAsDate: n, setValueAs: r }) => Ie(e) ? e : t ? e === "" ? NaN : e && +e : n && Jt(e) ? new Date(e) : r ? r(e) : e;
const jd = {
  isValid: !1,
  value: null
};
var Jh = (e) => Array.isArray(e) ? e.reduce((t, n) => n && n.checked && !n.disabled ? {
  isValid: !0,
  value: n.value
} : t, jd) : jd;
function Ld(e) {
  const t = e.ref;
  return cc(t) ? t.files : dc(t) ? Jh(e.refs).value : Hh(t) ? [...t.selectedOptions].map(({ value: n }) => n) : mo(t) ? Qh(e.refs).value : qh(Ie(t.value) ? e.ref.value : t.value, e);
}
var pw = (e, t, n, r) => {
  const i = {};
  for (const o of e) {
    const s = M(t, o);
    s && pe(i, o, s._f);
  }
  return {
    criteriaMode: n,
    names: [...e],
    fields: i,
    shouldUseNativeValidation: r
  };
}, Rs = (e) => e instanceof RegExp, vi = (e) => Ie(e) ? e : Rs(e) ? e.source : Oe(e) ? Rs(e.value) ? e.value.source : e.value : e, Fd = (e) => ({
  isOnSubmit: !e || e === Mt.onSubmit,
  isOnBlur: e === Mt.onBlur,
  isOnChange: e === Mt.onChange,
  isOnAll: e === Mt.all,
  isOnTouch: e === Mt.onTouched
});
const Dd = "AsyncFunction";
var hw = (e) => !!e && !!e.validate && !!(Ut(e.validate) && e.validate.constructor.name === Dd || Oe(e.validate) && Object.values(e.validate).find((t) => t.constructor.name === Dd)), mw = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), zd = (e, t, n) => !n && (t.watchAll || t.watch.has(e) || [...t.watch].some((r) => e.startsWith(r) && /^\.\w+/.test(e.slice(r.length))));
const Di = (e, t, n, r) => {
  for (const i of n || Object.keys(e)) {
    const o = M(e, i);
    if (o) {
      const { _f: s, ...a } = o;
      if (s) {
        if (s.refs && s.refs[0] && t(s.refs[0], i) && !r)
          return !0;
        if (s.ref && t(s.ref, s.name) && !r)
          return !0;
        if (Di(a, t))
          break;
      } else if (Oe(a) && Di(a, t))
        break;
    }
  }
};
function Md(e, t, n) {
  const r = M(e, n);
  if (r || uc(n))
    return {
      error: r,
      name: n
    };
  const i = n.split(".");
  for (; i.length; ) {
    const o = i.join("."), s = M(t, o), a = M(e, o);
    if (s && !Array.isArray(s) && n !== o)
      return { name: n };
    if (a && a.type)
      return {
        name: o,
        error: a
      };
    i.pop();
  }
  return {
    name: n
  };
}
var gw = (e, t, n, r) => {
  n(e);
  const { name: i, ...o } = e;
  return tt(o) || Object.keys(o).length >= Object.keys(t).length || Object.keys(o).find((s) => t[s] === (!r || Mt.all));
}, yw = (e, t, n) => !e || !t || e === t || Fi(e).some((r) => r && (n ? r === t : r.startsWith(t) || t.startsWith(r))), vw = (e, t, n, r, i) => i.isOnAll ? !1 : !n && i.isOnTouch ? !(t || e) : (n ? r.isOnBlur : i.isOnBlur) ? !e : (n ? r.isOnChange : i.isOnChange) ? e : !0, ww = (e, t) => !la(M(e, t)).length && Fe(e, t), xw = (e, t, n) => {
  const r = Fi(M(e, n));
  return pe(r, "root", t[n]), pe(e, n, r), e;
}, Yo = (e) => Jt(e);
function Ud(e, t, n = "validate") {
  if (Yo(e) || Array.isArray(e) && e.every(Yo) || yt(e) && !e)
    return {
      type: n,
      message: Yo(e) ? e : "",
      ref: t
    };
}
var xr = (e) => Oe(e) && !Rs(e) ? e : {
  value: e,
  message: ""
}, Vd = async (e, t, n, r, i, o) => {
  const { ref: s, refs: a, required: l, maxLength: u, minLength: c, min: p, max: h, pattern: x, validate: v, name: w, valueAsNumber: _, mount: m } = e._f, d = M(n, w);
  if (!m || t.has(w))
    return {};
  const y = a ? a[0] : s, b = (z) => {
    i && y.reportValidity && (y.setCustomValidity(yt(z) ? "" : z || ""), y.reportValidity());
  }, f = {}, A = dc(s), N = mo(s), R = A || N, j = (_ || cc(s)) && Ie(s.value) && Ie(d) || Ns(s) && s.value === "" || d === "" || Array.isArray(d) && !d.length, T = Bh.bind(null, w, r, f), U = (z, K, ne, le = nn.maxLength, fe = nn.minLength) => {
    const ke = z ? K : ne;
    f[w] = {
      type: z ? le : fe,
      message: ke,
      ref: s,
      ...T(z ? le : fe, ke)
    };
  };
  if (o ? !Array.isArray(d) || !d.length : l && (!R && (j || rt(d)) || yt(d) && !d || N && !Qh(a).isValid || A && !Jh(a).isValid)) {
    const { value: z, message: K } = Yo(l) ? { value: !!l, message: l } : xr(l);
    if (z && (f[w] = {
      type: nn.required,
      message: K,
      ref: y,
      ...T(nn.required, K)
    }, !r))
      return b(K), f;
  }
  if (!j && (!rt(p) || !rt(h))) {
    let z, K;
    const ne = xr(h), le = xr(p);
    if (!rt(d) && !isNaN(d)) {
      const fe = s.valueAsNumber || d && +d;
      rt(ne.value) || (z = fe > ne.value), rt(le.value) || (K = fe < le.value);
    } else {
      const fe = s.valueAsDate || new Date(d), ke = (J) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + J), F = s.type == "time", Q = s.type == "week";
      Jt(ne.value) && d && (z = F ? ke(d) > ke(ne.value) : Q ? d > ne.value : fe > new Date(ne.value)), Jt(le.value) && d && (K = F ? ke(d) < ke(le.value) : Q ? d < le.value : fe < new Date(le.value));
    }
    if ((z || K) && (U(!!z, ne.message, le.message, nn.max, nn.min), !r))
      return b(f[w].message), f;
  }
  if ((u || c) && !j && (Jt(d) || o && Array.isArray(d))) {
    const z = xr(u), K = xr(c), ne = !rt(z.value) && d.length > +z.value, le = !rt(K.value) && d.length < +K.value;
    if ((ne || le) && (U(ne, z.message, K.message), !r))
      return b(f[w].message), f;
  }
  if (x && !j && Jt(d)) {
    const { value: z, message: K } = xr(x);
    if (Rs(z) && !d.match(z) && (f[w] = {
      type: nn.pattern,
      message: K,
      ref: s,
      ...T(nn.pattern, K)
    }, !r))
      return b(K), f;
  }
  if (v) {
    if (Ut(v)) {
      const z = await v(d, n), K = Ud(z, y);
      if (K && (f[w] = {
        ...K,
        ...T(nn.validate, K.message)
      }, !r))
        return b(K.message), f;
    } else if (Oe(v)) {
      let z = {};
      for (const K in v) {
        if (!tt(z) && !r)
          break;
        const ne = Ud(await v[K](d, n), y, K);
        ne && (z = {
          ...ne,
          ...T(K, ne.message)
        }, b(ne.message), r && (f[w] = z));
      }
      if (!tt(z) && (f[w] = {
        ref: y,
        ...z
      }, !r))
        return f;
    }
  }
  return b(!0), f;
};
const bw = {
  mode: Mt.onSubmit,
  reValidateMode: Mt.onChange,
  shouldFocusError: !0
};
function _w(e = {}) {
  let t = {
    ...bw,
    ...e
  }, n = {
    submitCount: 0,
    isDirty: !1,
    isReady: !1,
    isLoading: Ut(t.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: t.errors || {},
    disabled: t.disabled || !1
  };
  const r = {};
  let i = Oe(t.defaultValues) || Oe(t.values) ? Be(t.values || t.defaultValues) || {} : {}, o = t.shouldUnregister ? {} : Be(i), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, a = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, l, u = 0;
  const c = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let p = {
    ...c
  };
  const h = {
    array: Ad(),
    state: Ad()
  }, x = Fd(t.mode), v = Fd(t.reValidateMode), w = t.criteriaMode === Mt.all, _ = (g) => (k) => {
    clearTimeout(u), u = setTimeout(g, k);
  }, m = async (g) => {
    if (!t.disabled && (c.isValid || p.isValid || g)) {
      const k = t.resolver ? tt((await j()).errors) : await U(r, !0);
      k !== n.isValid && h.state.next({
        isValid: k
      });
    }
  }, d = (g, k) => {
    !t.disabled && (c.isValidating || c.validatingFields || p.isValidating || p.validatingFields) && ((g || Array.from(a.mount)).forEach((C) => {
      C && (k ? pe(n.validatingFields, C, k) : Fe(n.validatingFields, C));
    }), h.state.next({
      validatingFields: n.validatingFields,
      isValidating: !tt(n.validatingFields)
    }));
  }, y = (g, k = [], C, $, D = !0, L = !0) => {
    if ($ && C && !t.disabled) {
      if (s.action = !0, L && Array.isArray(M(r, g))) {
        const H = C(M(r, g), $.argA, $.argB);
        D && pe(r, g, H);
      }
      if (L && Array.isArray(M(n.errors, g))) {
        const H = C(M(n.errors, g), $.argA, $.argB);
        D && pe(n.errors, g, H), ww(n.errors, g);
      }
      if ((c.touchedFields || p.touchedFields) && L && Array.isArray(M(n.touchedFields, g))) {
        const H = C(M(n.touchedFields, g), $.argA, $.argB);
        D && pe(n.touchedFields, g, H);
      }
      (c.dirtyFields || p.dirtyFields) && (n.dirtyFields = yi(i, o)), h.state.next({
        name: g,
        isDirty: K(g, k),
        dirtyFields: n.dirtyFields,
        errors: n.errors,
        isValid: n.isValid
      });
    } else
      pe(o, g, k);
  }, b = (g, k) => {
    pe(n.errors, g, k), h.state.next({
      errors: n.errors
    });
  }, f = (g) => {
    n.errors = g, h.state.next({
      errors: n.errors,
      isValid: !1
    });
  }, A = (g, k, C, $) => {
    const D = M(r, g);
    if (D) {
      const L = M(o, g, Ie(C) ? M(i, g) : C);
      Ie(L) || $ && $.defaultChecked || k ? pe(o, g, k ? L : Ld(D._f)) : fe(g, L), s.mount && m();
    }
  }, N = (g, k, C, $, D) => {
    let L = !1, H = !1;
    const ae = {
      name: g
    };
    if (!t.disabled) {
      if (!C || $) {
        (c.isDirty || p.isDirty) && (H = n.isDirty, n.isDirty = ae.isDirty = K(), L = H !== ae.isDirty);
        const ve = an(M(i, g), k);
        H = !!M(n.dirtyFields, g), ve ? Fe(n.dirtyFields, g) : pe(n.dirtyFields, g, !0), ae.dirtyFields = n.dirtyFields, L = L || (c.dirtyFields || p.dirtyFields) && H !== !ve;
      }
      if (C) {
        const ve = M(n.touchedFields, g);
        ve || (pe(n.touchedFields, g, C), ae.touchedFields = n.touchedFields, L = L || (c.touchedFields || p.touchedFields) && ve !== C);
      }
      L && D && h.state.next(ae);
    }
    return L ? ae : {};
  }, R = (g, k, C, $) => {
    const D = M(n.errors, g), L = (c.isValid || p.isValid) && yt(k) && n.isValid !== k;
    if (t.delayError && C ? (l = _(() => b(g, C)), l(t.delayError)) : (clearTimeout(u), l = null, C ? pe(n.errors, g, C) : Fe(n.errors, g)), (C ? !an(D, C) : D) || !tt($) || L) {
      const H = {
        ...$,
        ...L && yt(k) ? { isValid: k } : {},
        errors: n.errors,
        name: g
      };
      n = {
        ...n,
        ...H
      }, h.state.next(H);
    }
  }, j = async (g) => {
    d(g, !0);
    const k = await t.resolver(o, t.context, pw(g || a.mount, r, t.criteriaMode, t.shouldUseNativeValidation));
    return d(g), k;
  }, T = async (g) => {
    const { errors: k } = await j(g);
    if (g)
      for (const C of g) {
        const $ = M(k, C);
        $ ? pe(n.errors, C, $) : Fe(n.errors, C);
      }
    else
      n.errors = k;
    return k;
  }, U = async (g, k, C = {
    valid: !0
  }) => {
    for (const $ in g) {
      const D = g[$];
      if (D) {
        const { _f: L, ...H } = D;
        if (L) {
          const ae = a.array.has(L.name), ve = D._f && hw(D._f);
          ve && c.validatingFields && d([$], !0);
          const je = await Vd(D, a.disabled, o, w, t.shouldUseNativeValidation && !k, ae);
          if (ve && c.validatingFields && d([$]), je[L.name] && (C.valid = !1, k))
            break;
          !k && (M(je, L.name) ? ae ? xw(n.errors, je, L.name) : pe(n.errors, L.name, je[L.name]) : Fe(n.errors, L.name));
        }
        !tt(H) && await U(H, k, C);
      }
    }
    return C.valid;
  }, z = () => {
    for (const g of a.unMount) {
      const k = M(r, g);
      k && (k._f.refs ? k._f.refs.every((C) => !Ga(C)) : !Ga(k._f.ref)) && se(g);
    }
    a.unMount = /* @__PURE__ */ new Set();
  }, K = (g, k) => !t.disabled && (g && k && pe(o, g, k), !an(me(), i)), ne = (g, k, C) => $h(g, a, {
    ...s.mount ? o : Ie(k) ? i : Jt(g) ? { [g]: k } : k
  }, C, k), le = (g) => la(M(s.mount ? o : i, g, t.shouldUnregister ? M(i, g, []) : [])), fe = (g, k, C = {}) => {
    const $ = M(r, g);
    let D = k;
    if ($) {
      const L = $._f;
      L && (!L.disabled && pe(o, g, qh(k, L)), D = Ns(L.ref) && rt(k) ? "" : k, Hh(L.ref) ? [...L.ref.options].forEach((H) => H.selected = D.includes(H.value)) : L.refs ? mo(L.ref) ? L.refs.length > 1 ? L.refs.forEach((H) => (!H.defaultChecked || !H.disabled) && (H.checked = Array.isArray(D) ? !!D.find((ae) => ae === H.value) : D === H.value)) : L.refs[0] && (L.refs[0].checked = !!D) : L.refs.forEach((H) => H.checked = H.value === D) : cc(L.ref) ? L.ref.value = "" : (L.ref.value = D, L.ref.type || h.state.next({
        name: g,
        values: Be(o)
      })));
    }
    (C.shouldDirty || C.shouldTouch) && N(g, D, C.shouldTouch, C.shouldDirty, !0), C.shouldValidate && re(g);
  }, ke = (g, k, C) => {
    for (const $ in k) {
      const D = k[$], L = `${g}.${$}`, H = M(r, L);
      (a.array.has(g) || Oe(D) || H && !H._f) && !Xn(D) ? ke(L, D, C) : fe(L, D, C);
    }
  }, F = (g, k, C = {}) => {
    const $ = M(r, g), D = a.array.has(g), L = Be(k);
    pe(o, g, L), D ? (h.array.next({
      name: g,
      values: Be(o)
    }), (c.isDirty || c.dirtyFields || p.isDirty || p.dirtyFields) && C.shouldDirty && h.state.next({
      name: g,
      dirtyFields: yi(i, o),
      isDirty: K(g, L)
    })) : $ && !$._f && !rt(L) ? ke(g, L, C) : fe(g, L, C), zd(g, a) && h.state.next({ ...n }), h.state.next({
      name: s.mount ? g : void 0,
      values: Be(o)
    });
  }, Q = async (g) => {
    s.mount = !0;
    const k = g.target;
    let C = k.name, $ = !0;
    const D = M(r, C), L = (H) => {
      $ = Number.isNaN(H) || Xn(H) && isNaN(H.getTime()) || an(H, M(o, C, H));
    };
    if (D) {
      let H, ae;
      const ve = k.type ? Ld(D._f) : Fh(g), je = g.type === Cs.BLUR || g.type === Cs.FOCUS_OUT, yr = !mw(D._f) && !t.resolver && !M(n.errors, C) && !D._f.deps || vw(je, M(n.touchedFields, C), n.isSubmitted, v, x), vr = zd(C, a, je);
      pe(o, C, ve), je ? (D._f.onBlur && D._f.onBlur(g), l && l(0)) : D._f.onChange && D._f.onChange(g);
      const oi = N(C, ve, je), ba = !tt(oi) || vr;
      if (!je && h.state.next({
        name: C,
        type: g.type,
        values: Be(o)
      }), yr)
        return (c.isValid || p.isValid) && (t.mode === "onBlur" ? je && m() : je || m()), ba && h.state.next({ name: C, ...vr ? {} : oi });
      if (!je && vr && h.state.next({ ...n }), t.resolver) {
        const { errors: _o } = await j([C]);
        if (L(ve), $) {
          const _a = Md(n.errors, r, C), ka = Md(_o, r, _a.name || C);
          H = ka.error, C = ka.name, ae = tt(_o);
        }
      } else
        d([C], !0), H = (await Vd(D, a.disabled, o, w, t.shouldUseNativeValidation))[C], d([C]), L(ve), $ && (H ? ae = !1 : (c.isValid || p.isValid) && (ae = await U(r, !0)));
      $ && (D._f.deps && re(D._f.deps), R(C, ae, H, oi));
    }
  }, J = (g, k) => {
    if (M(n.errors, k) && g.focus)
      return g.focus(), 1;
  }, re = async (g, k = {}) => {
    let C, $;
    const D = Fi(g);
    if (t.resolver) {
      const L = await T(Ie(g) ? g : D);
      C = tt(L), $ = g ? !D.some((H) => M(L, H)) : C;
    } else g ? ($ = (await Promise.all(D.map(async (L) => {
      const H = M(r, L);
      return await U(H && H._f ? { [L]: H } : H);
    }))).every(Boolean), !(!$ && !n.isValid) && m()) : $ = C = await U(r);
    return h.state.next({
      ...!Jt(g) || (c.isValid || p.isValid) && C !== n.isValid ? {} : { name: g },
      ...t.resolver || !g ? { isValid: C } : {},
      errors: n.errors
    }), k.shouldFocus && !$ && Di(r, J, g ? D : a.mount), $;
  }, me = (g) => {
    const k = {
      ...s.mount ? o : i
    };
    return Ie(g) ? k : Jt(g) ? M(k, g) : g.map((C) => M(k, C));
  }, Pt = (g, k) => ({
    invalid: !!M((k || n).errors, g),
    isDirty: !!M((k || n).dirtyFields, g),
    error: M((k || n).errors, g),
    isValidating: !!M(n.validatingFields, g),
    isTouched: !!M((k || n).touchedFields, g)
  }), Xe = (g) => {
    g && Fi(g).forEach((k) => Fe(n.errors, k)), h.state.next({
      errors: g ? n.errors : {}
    });
  }, jt = (g, k, C) => {
    const $ = (M(r, g, { _f: {} })._f || {}).ref, D = M(n.errors, g) || {}, { ref: L, message: H, type: ae, ...ve } = D;
    pe(n.errors, g, {
      ...ve,
      ...k,
      ref: $
    }), h.state.next({
      name: g,
      errors: n.errors,
      isValid: !1
    }), C && C.shouldFocus && $ && $.focus && $.focus();
  }, Qe = (g, k) => Ut(g) ? h.state.subscribe({
    next: (C) => g(ne(void 0, k), C)
  }) : ne(g, k, !0), Et = (g) => h.state.subscribe({
    next: (k) => {
      yw(g.name, k.name, g.exact) && gw(k, g.formState || c, xa, g.reRenderRoot) && g.callback({
        values: { ...o },
        ...n,
        ...k
      });
    }
  }).unsubscribe, q = (g) => (s.mount = !0, p = {
    ...p,
    ...g.formState
  }, Et({
    ...g,
    formState: p
  })), se = (g, k = {}) => {
    for (const C of g ? Fi(g) : a.mount)
      a.mount.delete(C), a.array.delete(C), k.keepValue || (Fe(r, C), Fe(o, C)), !k.keepError && Fe(n.errors, C), !k.keepDirty && Fe(n.dirtyFields, C), !k.keepTouched && Fe(n.touchedFields, C), !k.keepIsValidating && Fe(n.validatingFields, C), !t.shouldUnregister && !k.keepDefaultValue && Fe(i, C);
    h.state.next({
      values: Be(o)
    }), h.state.next({
      ...n,
      ...k.keepDirty ? { isDirty: K() } : {}
    }), !k.keepIsValid && m();
  }, ge = ({ disabled: g, name: k }) => {
    (yt(g) && s.mount || g || a.disabled.has(k)) && (g ? a.disabled.add(k) : a.disabled.delete(k));
  }, $e = (g, k = {}) => {
    let C = M(r, g);
    const $ = yt(k.disabled) || yt(t.disabled);
    return pe(r, g, {
      ...C || {},
      _f: {
        ...C && C._f ? C._f : { ref: { name: g } },
        name: g,
        mount: !0,
        ...k
      }
    }), a.mount.add(g), C ? ge({
      disabled: yt(k.disabled) ? k.disabled : t.disabled,
      name: g
    }) : A(g, !0, k.value), {
      ...$ ? { disabled: k.disabled || t.disabled } : {},
      ...t.progressive ? {
        required: !!k.required,
        min: vi(k.min),
        max: vi(k.max),
        minLength: vi(k.minLength),
        maxLength: vi(k.maxLength),
        pattern: vi(k.pattern)
      } : {},
      name: g,
      onChange: Q,
      onBlur: Q,
      ref: (D) => {
        if (D) {
          $e(g, k), C = M(r, g);
          const L = Ie(D.value) && D.querySelectorAll && D.querySelectorAll("input,select,textarea")[0] || D, H = cw(L), ae = C._f.refs || [];
          if (H ? ae.find((ve) => ve === L) : L === C._f.ref)
            return;
          pe(r, g, {
            _f: {
              ...C._f,
              ...H ? {
                refs: [
                  ...ae.filter(Ga),
                  L,
                  ...Array.isArray(M(i, g)) ? [{}] : []
                ],
                ref: { type: L.type, name: g }
              } : { ref: L }
            }
          }), A(g, !1, void 0, L);
        } else
          C = M(r, g, {}), C._f && (C._f.mount = !1), (t.shouldUnregister || k.shouldUnregister) && !(Dh(a.array, g) && s.action) && a.unMount.add(g);
      }
    };
  }, Re = () => t.shouldFocusError && Di(r, J, a.mount), Qn = (g) => {
    yt(g) && (h.state.next({ disabled: g }), Di(r, (k, C) => {
      const $ = M(r, C);
      $ && (k.disabled = $._f.disabled || g, Array.isArray($._f.refs) && $._f.refs.forEach((D) => {
        D.disabled = $._f.disabled || g;
      }));
    }, 0, !1));
  }, xn = (g, k) => async (C) => {
    let $;
    C && (C.preventDefault && C.preventDefault(), C.persist && C.persist());
    let D = Be(o);
    if (h.state.next({
      isSubmitting: !0
    }), t.resolver) {
      const { errors: L, values: H } = await j();
      n.errors = L, D = H;
    } else
      await U(r);
    if (a.disabled.size)
      for (const L of a.disabled)
        pe(D, L, void 0);
    if (Fe(n.errors, "root"), tt(n.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await g(D, C);
      } catch (L) {
        $ = L;
      }
    } else
      k && await k({ ...n.errors }, C), Re(), setTimeout(Re);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: tt(n.errors) && !$,
      submitCount: n.submitCount + 1,
      errors: n.errors
    }), $)
      throw $;
  }, gr = (g, k = {}) => {
    M(r, g) && (Ie(k.defaultValue) ? F(g, Be(M(i, g))) : (F(g, k.defaultValue), pe(i, g, Be(k.defaultValue))), k.keepTouched || Fe(n.touchedFields, g), k.keepDirty || (Fe(n.dirtyFields, g), n.isDirty = k.defaultValue ? K(g, Be(M(i, g))) : K()), k.keepError || (Fe(n.errors, g), c.isValid && m()), h.state.next({ ...n }));
  }, et = (g, k = {}) => {
    const C = g ? Be(g) : i, $ = Be(C), D = tt(g), L = D ? i : $;
    if (k.keepDefaultValues || (i = C), !k.keepValues) {
      if (k.keepDirtyValues) {
        const H = /* @__PURE__ */ new Set([
          ...a.mount,
          ...Object.keys(yi(i, o))
        ]);
        for (const ae of Array.from(H))
          M(n.dirtyFields, ae) ? pe(L, ae, M(o, ae)) : F(ae, M(L, ae));
      } else {
        if (lc && Ie(g))
          for (const H of a.mount) {
            const ae = M(r, H);
            if (ae && ae._f) {
              const ve = Array.isArray(ae._f.refs) ? ae._f.refs[0] : ae._f.ref;
              if (Ns(ve)) {
                const je = ve.closest("form");
                if (je) {
                  je.reset();
                  break;
                }
              }
            }
          }
        for (const H of a.mount)
          F(H, M(L, H));
      }
      o = Be(L), h.array.next({
        values: { ...L }
      }), h.state.next({
        values: { ...L }
      });
    }
    a = {
      mount: k.keepDirtyValues ? a.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !c.isValid || !!k.keepIsValid || !!k.keepDirtyValues, s.watch = !!t.shouldUnregister, h.state.next({
      submitCount: k.keepSubmitCount ? n.submitCount : 0,
      isDirty: D ? !1 : k.keepDirty ? n.isDirty : !!(k.keepDefaultValues && !an(g, i)),
      isSubmitted: k.keepIsSubmitted ? n.isSubmitted : !1,
      dirtyFields: D ? {} : k.keepDirtyValues ? k.keepDefaultValues && o ? yi(i, o) : n.dirtyFields : k.keepDefaultValues && g ? yi(i, g) : k.keepDirty ? n.dirtyFields : {},
      touchedFields: k.keepTouched ? n.touchedFields : {},
      errors: k.keepErrors ? n.errors : {},
      isSubmitSuccessful: k.keepIsSubmitSuccessful ? n.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, bn = (g, k) => et(Ut(g) ? g(o) : g, k), _n = (g, k = {}) => {
    const C = M(r, g), $ = C && C._f;
    if ($) {
      const D = $.refs ? $.refs[0] : $.ref;
      D.focus && (D.focus(), k.shouldSelect && Ut(D.select) && D.select());
    }
  }, xa = (g) => {
    n = {
      ...n,
      ...g
    };
  }, bo = {
    control: {
      register: $e,
      unregister: se,
      getFieldState: Pt,
      handleSubmit: xn,
      setError: jt,
      _subscribe: Et,
      _runSchema: j,
      _getWatch: ne,
      _getDirty: K,
      _setValid: m,
      _setFieldArray: y,
      _setDisabledField: ge,
      _setErrors: f,
      _getFieldArray: le,
      _reset: et,
      _resetDefaultValues: () => Ut(t.defaultValues) && t.defaultValues().then((g) => {
        bn(g, t.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: z,
      _disableForm: Qn,
      _subjects: h,
      _proxyFormState: c,
      get _fields() {
        return r;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(g) {
        s = g;
      },
      get _defaultValues() {
        return i;
      },
      get _names() {
        return a;
      },
      set _names(g) {
        a = g;
      },
      get _formState() {
        return n;
      },
      get _options() {
        return t;
      },
      set _options(g) {
        t = {
          ...t,
          ...g
        };
      }
    },
    subscribe: q,
    trigger: re,
    register: $e,
    handleSubmit: xn,
    watch: Qe,
    setValue: F,
    getValues: me,
    reset: bn,
    resetField: gr,
    clearErrors: Xe,
    unregister: se,
    setError: jt,
    setFocus: _n,
    getFieldState: Pt
  };
  return {
    ...bo,
    formControl: bo
  };
}
const kw = typeof window < "u" ? ue.useLayoutEffect : ue.useEffect;
function ca(e = {}) {
  const t = ue.useRef(void 0), n = ue.useRef(void 0), [r, i] = ue.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Ut(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    isReady: !1,
    defaultValues: Ut(e.defaultValues) ? void 0 : e.defaultValues
  });
  t.current || (t.current = {
    ...e.formControl ? e.formControl : _w(e),
    formState: r
  }, e.formControl && e.defaultValues && !Ut(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = t.current.control;
  return o._options = e, kw(() => {
    const s = o._subscribe({
      formState: o._proxyFormState,
      callback: () => i({ ...o._formState }),
      reRenderRoot: !0
    });
    return i((a) => ({
      ...a,
      isReady: !0
    })), o._formState.isReady = !0, s;
  }, [o]), ue.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), ue.useEffect(() => {
    e.mode && (o._options.mode = e.mode), e.reValidateMode && (o._options.reValidateMode = e.reValidateMode), e.errors && !tt(e.errors) && o._setErrors(e.errors);
  }, [o, e.errors, e.mode, e.reValidateMode]), ue.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [o, e.shouldUnregister]), ue.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== r.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, r.isDirty]), ue.useEffect(() => {
    e.values && !an(e.values, n.current) ? (o._reset(e.values, o._options.resetOptions), n.current = e.values, i((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [o, e.values]), ue.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), t.current.formState = Uh(r, o), t.current;
}
var Sw = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Ew = Sw.reduce((e, t) => {
  const n = /* @__PURE__ */ Ph(`Primitive.${t}`), r = S.forwardRef((i, o) => {
    const { asChild: s, ...a } = i, l = s ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ I.jsx(l, { ...a, ref: o });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {}), Cw = "Label", Kh = S.forwardRef((e, t) => /* @__PURE__ */ I.jsx(
  Ew.label,
  {
    ...e,
    ref: t,
    onMouseDown: (n) => {
      var i;
      n.target.closest("button, input, select, textarea") || ((i = e.onMouseDown) == null || i.call(e, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
Kh.displayName = Cw;
var Gh = Kh;
const $d = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Bd = kh, Yh = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null) return Bd(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: i, defaultVariants: o } = t, s = Object.keys(i).map((u) => {
    const c = n == null ? void 0 : n[u], p = o == null ? void 0 : o[u];
    if (c === null) return null;
    const h = $d(c) || $d(p);
    return i[u][h];
  }), a = n && Object.entries(n).reduce((u, c) => {
    let [p, h] = c;
    return h === void 0 || (u[p] = h), u;
  }, {}), l = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((u, c) => {
    let { class: p, className: h, ...x } = c;
    return Object.entries(x).every((v) => {
      let [w, _] = v;
      return Array.isArray(_) ? _.includes({
        ...o,
        ...a
      }[w]) : {
        ...o,
        ...a
      }[w] === _;
    }) ? [
      ...u,
      p,
      h
    ] : u;
  }, []);
  return Bd(e, s, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
}, Nw = Yh(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), Xh = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ I.jsx(
  Gh,
  {
    ref: n,
    className: St(Nw(), e),
    ...t
  }
));
Xh.displayName = Gh.displayName;
const fc = ow, em = S.createContext(
  {}
), zi = ({
  ...e
}) => /* @__PURE__ */ I.jsx(em.Provider, { value: { name: e.name }, children: /* @__PURE__ */ I.jsx(uw, { ...e }) }), da = () => {
  const e = S.useContext(em), t = S.useContext(tm), { getFieldState: n, formState: r } = ua(), i = n(e.name, r);
  if (!e)
    throw new Error("useFormField should be used within <FormField>");
  const { id: o } = t;
  return {
    id: o,
    name: e.name,
    formItemId: `${o}-form-item`,
    formDescriptionId: `${o}-form-item-description`,
    formMessageId: `${o}-form-item-message`,
    ...i
  };
}, tm = S.createContext(
  {}
), Mi = S.forwardRef(({ className: e, ...t }, n) => {
  const r = S.useId();
  return /* @__PURE__ */ I.jsx(tm.Provider, { value: { id: r }, children: /* @__PURE__ */ I.jsx("div", { ref: n, className: St("space-y-2", e), ...t }) });
});
Mi.displayName = "FormItem";
const Tw = S.forwardRef(({ className: e, ...t }, n) => {
  const { error: r, formItemId: i } = da();
  return /* @__PURE__ */ I.jsx(
    Xh,
    {
      ref: n,
      className: St(r && "text-destructive", e),
      htmlFor: i,
      ...t
    }
  );
});
Tw.displayName = "FormLabel";
const Rw = S.forwardRef(({ ...e }, t) => {
  const { error: n, formItemId: r, formDescriptionId: i, formMessageId: o } = da();
  return /* @__PURE__ */ I.jsx(
    jh,
    {
      ref: t,
      id: r,
      "aria-describedby": n ? `${i} ${o}` : `${i}`,
      "aria-invalid": !!n,
      ...e
    }
  );
});
Rw.displayName = "FormControl";
const Iw = S.forwardRef(({ className: e, ...t }, n) => {
  const { formDescriptionId: r } = da();
  return /* @__PURE__ */ I.jsx(
    "p",
    {
      ref: n,
      id: r,
      className: St("text-[0.8rem] text-muted-foreground", e),
      ...t
    }
  );
});
Iw.displayName = "FormDescription";
const Ui = S.forwardRef(({ className: e, children: t, ...n }, r) => {
  const { error: i, formMessageId: o } = da(), s = i ? String((i == null ? void 0 : i.message) ?? "") : t;
  return s ? /* @__PURE__ */ I.jsx(
    "p",
    {
      ref: r,
      id: o,
      className: St("text-[0.8rem] font-medium text-destructive", e),
      ...n,
      children: s
    }
  ) : null;
});
Ui.displayName = "FormMessage";
const rr = S.forwardRef(
  ({ className: e, type: t, ...n }, r) => /* @__PURE__ */ I.jsx(
    "input",
    {
      type: t,
      className: St(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        e
      ),
      ref: r,
      ...n
    }
  )
);
rr.displayName = "Input";
const Aw = Yh(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground shadow hover:bg-primary/90",
        destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline: "border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), go = S.forwardRef(
  ({ className: e, variant: t, size: n, asChild: r = !1, ...i }, o) => {
    const s = r ? jh : "button";
    return /* @__PURE__ */ I.jsx(
      s,
      {
        className: St(Aw({ variant: t, size: n, className: e })),
        ref: o,
        ...i
      }
    );
  }
);
go.displayName = "Button";
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pc = aa("SendHorizontal", [
  [
    "path",
    {
      d: "M3.714 3.048a.498.498 0 0 0-.683.627l2.843 7.627a2 2 0 0 1 0 1.396l-2.842 7.627a.498.498 0 0 0 .682.627l18-8.5a.5.5 0 0 0 0-.904z",
      key: "117uat"
    }
  ],
  ["path", { d: "M6 12h16", key: "s4cdu5" }]
]);
function nm(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: Ow } = Object.prototype, { getPrototypeOf: hc } = Object, fa = /* @__PURE__ */ ((e) => (t) => {
  const n = Ow.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Ht = (e) => (e = e.toLowerCase(), (t) => fa(t) === e), pa = (e) => (t) => typeof t === e, { isArray: ri } = Array, oo = pa("undefined");
function Pw(e) {
  return e !== null && !oo(e) && e.constructor !== null && !oo(e.constructor) && xt(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const rm = Ht("ArrayBuffer");
function jw(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && rm(e.buffer), t;
}
const Lw = pa("string"), xt = pa("function"), im = pa("number"), ha = (e) => e !== null && typeof e == "object", Fw = (e) => e === !0 || e === !1, Xo = (e) => {
  if (fa(e) !== "object")
    return !1;
  const t = hc(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, Dw = Ht("Date"), zw = Ht("File"), Mw = Ht("Blob"), Uw = Ht("FileList"), Vw = (e) => ha(e) && xt(e.pipe), $w = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || xt(e.append) && ((t = fa(e)) === "formdata" || // detect form-data instance
  t === "object" && xt(e.toString) && e.toString() === "[object FormData]"));
}, Bw = Ht("URLSearchParams"), [Hw, Ww, Zw, Qw] = ["ReadableStream", "Request", "Response", "Headers"].map(Ht), qw = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function yo(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, i;
  if (typeof e != "object" && (e = [e]), ri(e))
    for (r = 0, i = e.length; r < i; r++)
      t.call(null, e[r], r, e);
  else {
    const o = n ? Object.getOwnPropertyNames(e) : Object.keys(e), s = o.length;
    let a;
    for (r = 0; r < s; r++)
      a = o[r], t.call(null, e[a], a, e);
  }
}
function om(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, i;
  for (; r-- > 0; )
    if (i = n[r], t === i.toLowerCase())
      return i;
  return null;
}
const er = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, sm = (e) => !oo(e) && e !== er;
function Yl() {
  const { caseless: e } = sm(this) && this || {}, t = {}, n = (r, i) => {
    const o = e && om(t, i) || i;
    Xo(t[o]) && Xo(r) ? t[o] = Yl(t[o], r) : Xo(r) ? t[o] = Yl({}, r) : ri(r) ? t[o] = r.slice() : t[o] = r;
  };
  for (let r = 0, i = arguments.length; r < i; r++)
    arguments[r] && yo(arguments[r], n);
  return t;
}
const Jw = (e, t, n, { allOwnKeys: r } = {}) => (yo(t, (i, o) => {
  n && xt(i) ? e[o] = nm(i, n) : e[o] = i;
}, { allOwnKeys: r }), e), Kw = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Gw = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, Yw = (e, t, n, r) => {
  let i, o, s;
  const a = {};
  if (t = t || {}, e == null) return t;
  do {
    for (i = Object.getOwnPropertyNames(e), o = i.length; o-- > 0; )
      s = i[o], (!r || r(s, e, t)) && !a[s] && (t[s] = e[s], a[s] = !0);
    e = n !== !1 && hc(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, Xw = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, e0 = (e) => {
  if (!e) return null;
  if (ri(e)) return e;
  let t = e.length;
  if (!im(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, t0 = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && hc(Uint8Array)), n0 = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let i;
  for (; (i = r.next()) && !i.done; ) {
    const o = i.value;
    t.call(e, o[0], o[1]);
  }
}, r0 = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, i0 = Ht("HTMLFormElement"), o0 = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, i) {
    return r.toUpperCase() + i;
  }
), Hd = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), s0 = Ht("RegExp"), am = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  yo(n, (i, o) => {
    let s;
    (s = t(i, o, e)) !== !1 && (r[o] = s || i);
  }), Object.defineProperties(e, r);
}, a0 = (e) => {
  am(e, (t, n) => {
    if (xt(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (xt(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, l0 = (e, t) => {
  const n = {}, r = (i) => {
    i.forEach((o) => {
      n[o] = !0;
    });
  };
  return ri(e) ? r(e) : r(String(e).split(t)), n;
}, u0 = () => {
}, c0 = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function d0(e) {
  return !!(e && xt(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const f0 = (e) => {
  const t = new Array(10), n = (r, i) => {
    if (ha(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[i] = r;
        const o = ri(r) ? [] : {};
        return yo(r, (s, a) => {
          const l = n(s, i + 1);
          !oo(l) && (o[a] = l);
        }), t[i] = void 0, o;
      }
    }
    return r;
  };
  return n(e, 0);
}, p0 = Ht("AsyncFunction"), h0 = (e) => e && (ha(e) || xt(e)) && xt(e.then) && xt(e.catch), lm = ((e, t) => e ? setImmediate : t ? ((n, r) => (er.addEventListener("message", ({ source: i, data: o }) => {
  i === er && o === n && r.length && r.shift()();
}, !1), (i) => {
  r.push(i), er.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  xt(er.postMessage)
), m0 = typeof queueMicrotask < "u" ? queueMicrotask.bind(er) : typeof process < "u" && process.nextTick || lm, E = {
  isArray: ri,
  isArrayBuffer: rm,
  isBuffer: Pw,
  isFormData: $w,
  isArrayBufferView: jw,
  isString: Lw,
  isNumber: im,
  isBoolean: Fw,
  isObject: ha,
  isPlainObject: Xo,
  isReadableStream: Hw,
  isRequest: Ww,
  isResponse: Zw,
  isHeaders: Qw,
  isUndefined: oo,
  isDate: Dw,
  isFile: zw,
  isBlob: Mw,
  isRegExp: s0,
  isFunction: xt,
  isStream: Vw,
  isURLSearchParams: Bw,
  isTypedArray: t0,
  isFileList: Uw,
  forEach: yo,
  merge: Yl,
  extend: Jw,
  trim: qw,
  stripBOM: Kw,
  inherits: Gw,
  toFlatObject: Yw,
  kindOf: fa,
  kindOfTest: Ht,
  endsWith: Xw,
  toArray: e0,
  forEachEntry: n0,
  matchAll: r0,
  isHTMLForm: i0,
  hasOwnProperty: Hd,
  hasOwnProp: Hd,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: am,
  freezeMethods: a0,
  toObjectSet: l0,
  toCamelCase: o0,
  noop: u0,
  toFiniteNumber: c0,
  findKey: om,
  global: er,
  isContextDefined: sm,
  isSpecCompliantForm: d0,
  toJSONObject: f0,
  isAsyncFn: p0,
  isThenable: h0,
  setImmediate: lm,
  asap: m0
};
function X(e, t, n, r, i) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), i && (this.response = i, this.status = i.status ? i.status : null);
}
E.inherits(X, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: E.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const um = X.prototype, cm = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  cm[e] = { value: e };
});
Object.defineProperties(X, cm);
Object.defineProperty(um, "isAxiosError", { value: !0 });
X.from = (e, t, n, r, i, o) => {
  const s = Object.create(um);
  return E.toFlatObject(e, s, function(l) {
    return l !== Error.prototype;
  }, (a) => a !== "isAxiosError"), X.call(s, e.message, t, n, r, i), s.cause = e, s.name = e.name, o && Object.assign(s, o), s;
};
const g0 = null;
function Xl(e) {
  return E.isPlainObject(e) || E.isArray(e);
}
function dm(e) {
  return E.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Wd(e, t, n) {
  return e ? e.concat(t).map(function(i, o) {
    return i = dm(i), !n && o ? "[" + i + "]" : i;
  }).join(n ? "." : "") : t;
}
function y0(e) {
  return E.isArray(e) && !e.some(Xl);
}
const v0 = E.toFlatObject(E, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function ma(e, t, n) {
  if (!E.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = E.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(w, _) {
    return !E.isUndefined(_[w]);
  });
  const r = n.metaTokens, i = n.visitor || c, o = n.dots, s = n.indexes, l = (n.Blob || typeof Blob < "u" && Blob) && E.isSpecCompliantForm(t);
  if (!E.isFunction(i))
    throw new TypeError("visitor must be a function");
  function u(v) {
    if (v === null) return "";
    if (E.isDate(v))
      return v.toISOString();
    if (!l && E.isBlob(v))
      throw new X("Blob is not supported. Use a Buffer instead.");
    return E.isArrayBuffer(v) || E.isTypedArray(v) ? l && typeof Blob == "function" ? new Blob([v]) : Buffer.from(v) : v;
  }
  function c(v, w, _) {
    let m = v;
    if (v && !_ && typeof v == "object") {
      if (E.endsWith(w, "{}"))
        w = r ? w : w.slice(0, -2), v = JSON.stringify(v);
      else if (E.isArray(v) && y0(v) || (E.isFileList(v) || E.endsWith(w, "[]")) && (m = E.toArray(v)))
        return w = dm(w), m.forEach(function(y, b) {
          !(E.isUndefined(y) || y === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? Wd([w], b, o) : s === null ? w : w + "[]",
            u(y)
          );
        }), !1;
    }
    return Xl(v) ? !0 : (t.append(Wd(_, w, o), u(v)), !1);
  }
  const p = [], h = Object.assign(v0, {
    defaultVisitor: c,
    convertValue: u,
    isVisitable: Xl
  });
  function x(v, w) {
    if (!E.isUndefined(v)) {
      if (p.indexOf(v) !== -1)
        throw Error("Circular reference detected in " + w.join("."));
      p.push(v), E.forEach(v, function(m, d) {
        (!(E.isUndefined(m) || m === null) && i.call(
          t,
          m,
          E.isString(d) ? d.trim() : d,
          w,
          h
        )) === !0 && x(m, w ? w.concat(d) : [d]);
      }), p.pop();
    }
  }
  if (!E.isObject(e))
    throw new TypeError("data must be an object");
  return x(e), t;
}
function Zd(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function mc(e, t) {
  this._pairs = [], e && ma(e, this, t);
}
const fm = mc.prototype;
fm.append = function(t, n) {
  this._pairs.push([t, n]);
};
fm.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, Zd);
  } : Zd;
  return this._pairs.map(function(i) {
    return n(i[0]) + "=" + n(i[1]);
  }, "").join("&");
};
function w0(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function pm(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || w0;
  E.isFunction(n) && (n = {
    serialize: n
  });
  const i = n && n.serialize;
  let o;
  if (i ? o = i(t, n) : o = E.isURLSearchParams(t) ? t.toString() : new mc(t, n).toString(r), o) {
    const s = e.indexOf("#");
    s !== -1 && (e = e.slice(0, s)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return e;
}
class Qd {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    E.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const hm = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, x0 = typeof URLSearchParams < "u" ? URLSearchParams : mc, b0 = typeof FormData < "u" ? FormData : null, _0 = typeof Blob < "u" ? Blob : null, k0 = {
  isBrowser: !0,
  classes: {
    URLSearchParams: x0,
    FormData: b0,
    Blob: _0
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, gc = typeof window < "u" && typeof document < "u", eu = typeof navigator == "object" && navigator || void 0, S0 = gc && (!eu || ["ReactNative", "NativeScript", "NS"].indexOf(eu.product) < 0), E0 = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", C0 = gc && window.location.href || "http://localhost", N0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: gc,
  hasStandardBrowserEnv: S0,
  hasStandardBrowserWebWorkerEnv: E0,
  navigator: eu,
  origin: C0
}, Symbol.toStringTag, { value: "Module" })), Ge = {
  ...N0,
  ...k0
};
function T0(e, t) {
  return ma(e, new Ge.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, i, o) {
      return Ge.isNode && E.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function R0(e) {
  return E.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function I0(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const i = n.length;
  let o;
  for (r = 0; r < i; r++)
    o = n[r], t[o] = e[o];
  return t;
}
function mm(e) {
  function t(n, r, i, o) {
    let s = n[o++];
    if (s === "__proto__") return !0;
    const a = Number.isFinite(+s), l = o >= n.length;
    return s = !s && E.isArray(i) ? i.length : s, l ? (E.hasOwnProp(i, s) ? i[s] = [i[s], r] : i[s] = r, !a) : ((!i[s] || !E.isObject(i[s])) && (i[s] = []), t(n, r, i[s], o) && E.isArray(i[s]) && (i[s] = I0(i[s])), !a);
  }
  if (E.isFormData(e) && E.isFunction(e.entries)) {
    const n = {};
    return E.forEachEntry(e, (r, i) => {
      t(R0(r), i, n, 0);
    }), n;
  }
  return null;
}
function A0(e, t, n) {
  if (E.isString(e))
    try {
      return (t || JSON.parse)(e), E.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
const vo = {
  transitional: hm,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", i = r.indexOf("application/json") > -1, o = E.isObject(t);
    if (o && E.isHTMLForm(t) && (t = new FormData(t)), E.isFormData(t))
      return i ? JSON.stringify(mm(t)) : t;
    if (E.isArrayBuffer(t) || E.isBuffer(t) || E.isStream(t) || E.isFile(t) || E.isBlob(t) || E.isReadableStream(t))
      return t;
    if (E.isArrayBufferView(t))
      return t.buffer;
    if (E.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let a;
    if (o) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return T0(t, this.formSerializer).toString();
      if ((a = E.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return ma(
          a ? { "files[]": t } : t,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return o || i ? (n.setContentType("application/json", !1), A0(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || vo.transitional, r = n && n.forcedJSONParsing, i = this.responseType === "json";
    if (E.isResponse(t) || E.isReadableStream(t))
      return t;
    if (t && E.isString(t) && (r && !this.responseType || i)) {
      const s = !(n && n.silentJSONParsing) && i;
      try {
        return JSON.parse(t);
      } catch (a) {
        if (s)
          throw a.name === "SyntaxError" ? X.from(a, X.ERR_BAD_RESPONSE, this, null, this.response) : a;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Ge.classes.FormData,
    Blob: Ge.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
E.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  vo.headers[e] = {};
});
const O0 = E.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), P0 = (e) => {
  const t = {};
  let n, r, i;
  return e && e.split(`
`).forEach(function(s) {
    i = s.indexOf(":"), n = s.substring(0, i).trim().toLowerCase(), r = s.substring(i + 1).trim(), !(!n || t[n] && O0[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, qd = Symbol("internals");
function wi(e) {
  return e && String(e).trim().toLowerCase();
}
function es(e) {
  return e === !1 || e == null ? e : E.isArray(e) ? e.map(es) : String(e);
}
function j0(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const L0 = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Ya(e, t, n, r, i) {
  if (E.isFunction(r))
    return r.call(this, t, n);
  if (i && (t = n), !!E.isString(t)) {
    if (E.isString(r))
      return t.indexOf(r) !== -1;
    if (E.isRegExp(r))
      return r.test(t);
  }
}
function F0(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function D0(e, t) {
  const n = E.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(i, o, s) {
        return this[r].call(this, t, i, o, s);
      },
      configurable: !0
    });
  });
}
let pt = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const i = this;
    function o(a, l, u) {
      const c = wi(l);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const p = E.findKey(i, c);
      (!p || i[p] === void 0 || u === !0 || u === void 0 && i[p] !== !1) && (i[p || l] = es(a));
    }
    const s = (a, l) => E.forEach(a, (u, c) => o(u, c, l));
    if (E.isPlainObject(t) || t instanceof this.constructor)
      s(t, n);
    else if (E.isString(t) && (t = t.trim()) && !L0(t))
      s(P0(t), n);
    else if (E.isHeaders(t))
      for (const [a, l] of t.entries())
        o(l, a, r);
    else
      t != null && o(n, t, r);
    return this;
  }
  get(t, n) {
    if (t = wi(t), t) {
      const r = E.findKey(this, t);
      if (r) {
        const i = this[r];
        if (!n)
          return i;
        if (n === !0)
          return j0(i);
        if (E.isFunction(n))
          return n.call(this, i, r);
        if (E.isRegExp(n))
          return n.exec(i);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = wi(t), t) {
      const r = E.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || Ya(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let i = !1;
    function o(s) {
      if (s = wi(s), s) {
        const a = E.findKey(r, s);
        a && (!n || Ya(r, r[a], a, n)) && (delete r[a], i = !0);
      }
    }
    return E.isArray(t) ? t.forEach(o) : o(t), i;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, i = !1;
    for (; r--; ) {
      const o = n[r];
      (!t || Ya(this, this[o], o, t, !0)) && (delete this[o], i = !0);
    }
    return i;
  }
  normalize(t) {
    const n = this, r = {};
    return E.forEach(this, (i, o) => {
      const s = E.findKey(r, o);
      if (s) {
        n[s] = es(i), delete n[o];
        return;
      }
      const a = t ? F0(o) : String(o).trim();
      a !== o && delete n[o], n[a] = es(i), r[a] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return E.forEach(this, (r, i) => {
      r != null && r !== !1 && (n[i] = t && E.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((i) => r.set(i)), r;
  }
  static accessor(t) {
    const r = (this[qd] = this[qd] = {
      accessors: {}
    }).accessors, i = this.prototype;
    function o(s) {
      const a = wi(s);
      r[a] || (D0(i, s), r[a] = !0);
    }
    return E.isArray(t) ? t.forEach(o) : o(t), this;
  }
};
pt.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
E.reduceDescriptors(pt.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
E.freezeMethods(pt);
function Xa(e, t) {
  const n = this || vo, r = t || n, i = pt.from(r.headers);
  let o = r.data;
  return E.forEach(e, function(a) {
    o = a.call(n, o, i.normalize(), t ? t.status : void 0);
  }), i.normalize(), o;
}
function gm(e) {
  return !!(e && e.__CANCEL__);
}
function ii(e, t, n) {
  X.call(this, e ?? "canceled", X.ERR_CANCELED, t, n), this.name = "CanceledError";
}
E.inherits(ii, X, {
  __CANCEL__: !0
});
function ym(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new X(
    "Request failed with status code " + n.status,
    [X.ERR_BAD_REQUEST, X.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function z0(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function M0(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let i = 0, o = 0, s;
  return t = t !== void 0 ? t : 1e3, function(l) {
    const u = Date.now(), c = r[o];
    s || (s = u), n[i] = l, r[i] = u;
    let p = o, h = 0;
    for (; p !== i; )
      h += n[p++], p = p % e;
    if (i = (i + 1) % e, i === o && (o = (o + 1) % e), u - s < t)
      return;
    const x = c && u - c;
    return x ? Math.round(h * 1e3 / x) : void 0;
  };
}
function U0(e, t) {
  let n = 0, r = 1e3 / t, i, o;
  const s = (u, c = Date.now()) => {
    n = c, i = null, o && (clearTimeout(o), o = null), e.apply(null, u);
  };
  return [(...u) => {
    const c = Date.now(), p = c - n;
    p >= r ? s(u, c) : (i = u, o || (o = setTimeout(() => {
      o = null, s(i);
    }, r - p)));
  }, () => i && s(i)];
}
const Is = (e, t, n = 3) => {
  let r = 0;
  const i = M0(50, 250);
  return U0((o) => {
    const s = o.loaded, a = o.lengthComputable ? o.total : void 0, l = s - r, u = i(l), c = s <= a;
    r = s;
    const p = {
      loaded: s,
      total: a,
      progress: a ? s / a : void 0,
      bytes: l,
      rate: u || void 0,
      estimated: u && a && c ? (a - s) / u : void 0,
      event: o,
      lengthComputable: a != null,
      [t ? "download" : "upload"]: !0
    };
    e(p);
  }, n);
}, Jd = (e, t) => {
  const n = e != null;
  return [(r) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: r
  }), t[1]];
}, Kd = (e) => (...t) => E.asap(() => e(...t)), V0 = Ge.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (n) => (n = new URL(n, Ge.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(
  new URL(Ge.origin),
  Ge.navigator && /(msie|trident)/i.test(Ge.navigator.userAgent)
) : () => !0, $0 = Ge.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, i, o) {
      const s = [e + "=" + encodeURIComponent(t)];
      E.isNumber(n) && s.push("expires=" + new Date(n).toGMTString()), E.isString(r) && s.push("path=" + r), E.isString(i) && s.push("domain=" + i), o === !0 && s.push("secure"), document.cookie = s.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function B0(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function H0(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function vm(e, t, n) {
  let r = !B0(t);
  return e && (r || n == !1) ? H0(e, t) : t;
}
const Gd = (e) => e instanceof pt ? { ...e } : e;
function dr(e, t) {
  t = t || {};
  const n = {};
  function r(u, c, p, h) {
    return E.isPlainObject(u) && E.isPlainObject(c) ? E.merge.call({ caseless: h }, u, c) : E.isPlainObject(c) ? E.merge({}, c) : E.isArray(c) ? c.slice() : c;
  }
  function i(u, c, p, h) {
    if (E.isUndefined(c)) {
      if (!E.isUndefined(u))
        return r(void 0, u, p, h);
    } else return r(u, c, p, h);
  }
  function o(u, c) {
    if (!E.isUndefined(c))
      return r(void 0, c);
  }
  function s(u, c) {
    if (E.isUndefined(c)) {
      if (!E.isUndefined(u))
        return r(void 0, u);
    } else return r(void 0, c);
  }
  function a(u, c, p) {
    if (p in t)
      return r(u, c);
    if (p in e)
      return r(void 0, u);
  }
  const l = {
    url: o,
    method: o,
    data: o,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: a,
    headers: (u, c, p) => i(Gd(u), Gd(c), p, !0)
  };
  return E.forEach(Object.keys(Object.assign({}, e, t)), function(c) {
    const p = l[c] || i, h = p(e[c], t[c], c);
    E.isUndefined(h) && p !== a || (n[c] = h);
  }), n;
}
const wm = (e) => {
  const t = dr({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: i, xsrfCookieName: o, headers: s, auth: a } = t;
  t.headers = s = pt.from(s), t.url = pm(vm(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), a && s.set(
    "Authorization",
    "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))
  );
  let l;
  if (E.isFormData(n)) {
    if (Ge.hasStandardBrowserEnv || Ge.hasStandardBrowserWebWorkerEnv)
      s.setContentType(void 0);
    else if ((l = s.getContentType()) !== !1) {
      const [u, ...c] = l ? l.split(";").map((p) => p.trim()).filter(Boolean) : [];
      s.setContentType([u || "multipart/form-data", ...c].join("; "));
    }
  }
  if (Ge.hasStandardBrowserEnv && (r && E.isFunction(r) && (r = r(t)), r || r !== !1 && V0(t.url))) {
    const u = i && o && $0.read(o);
    u && s.set(i, u);
  }
  return t;
}, W0 = typeof XMLHttpRequest < "u", Z0 = W0 && function(e) {
  return new Promise(function(n, r) {
    const i = wm(e);
    let o = i.data;
    const s = pt.from(i.headers).normalize();
    let { responseType: a, onUploadProgress: l, onDownloadProgress: u } = i, c, p, h, x, v;
    function w() {
      x && x(), v && v(), i.cancelToken && i.cancelToken.unsubscribe(c), i.signal && i.signal.removeEventListener("abort", c);
    }
    let _ = new XMLHttpRequest();
    _.open(i.method.toUpperCase(), i.url, !0), _.timeout = i.timeout;
    function m() {
      if (!_)
        return;
      const y = pt.from(
        "getAllResponseHeaders" in _ && _.getAllResponseHeaders()
      ), f = {
        data: !a || a === "text" || a === "json" ? _.responseText : _.response,
        status: _.status,
        statusText: _.statusText,
        headers: y,
        config: e,
        request: _
      };
      ym(function(N) {
        n(N), w();
      }, function(N) {
        r(N), w();
      }, f), _ = null;
    }
    "onloadend" in _ ? _.onloadend = m : _.onreadystatechange = function() {
      !_ || _.readyState !== 4 || _.status === 0 && !(_.responseURL && _.responseURL.indexOf("file:") === 0) || setTimeout(m);
    }, _.onabort = function() {
      _ && (r(new X("Request aborted", X.ECONNABORTED, e, _)), _ = null);
    }, _.onerror = function() {
      r(new X("Network Error", X.ERR_NETWORK, e, _)), _ = null;
    }, _.ontimeout = function() {
      let b = i.timeout ? "timeout of " + i.timeout + "ms exceeded" : "timeout exceeded";
      const f = i.transitional || hm;
      i.timeoutErrorMessage && (b = i.timeoutErrorMessage), r(new X(
        b,
        f.clarifyTimeoutError ? X.ETIMEDOUT : X.ECONNABORTED,
        e,
        _
      )), _ = null;
    }, o === void 0 && s.setContentType(null), "setRequestHeader" in _ && E.forEach(s.toJSON(), function(b, f) {
      _.setRequestHeader(f, b);
    }), E.isUndefined(i.withCredentials) || (_.withCredentials = !!i.withCredentials), a && a !== "json" && (_.responseType = i.responseType), u && ([h, v] = Is(u, !0), _.addEventListener("progress", h)), l && _.upload && ([p, x] = Is(l), _.upload.addEventListener("progress", p), _.upload.addEventListener("loadend", x)), (i.cancelToken || i.signal) && (c = (y) => {
      _ && (r(!y || y.type ? new ii(null, e, _) : y), _.abort(), _ = null);
    }, i.cancelToken && i.cancelToken.subscribe(c), i.signal && (i.signal.aborted ? c() : i.signal.addEventListener("abort", c)));
    const d = z0(i.url);
    if (d && Ge.protocols.indexOf(d) === -1) {
      r(new X("Unsupported protocol " + d + ":", X.ERR_BAD_REQUEST, e));
      return;
    }
    _.send(o || null);
  });
}, Q0 = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let r = new AbortController(), i;
    const o = function(u) {
      if (!i) {
        i = !0, a();
        const c = u instanceof Error ? u : this.reason;
        r.abort(c instanceof X ? c : new ii(c instanceof Error ? c.message : c));
      }
    };
    let s = t && setTimeout(() => {
      s = null, o(new X(`timeout ${t} of ms exceeded`, X.ETIMEDOUT));
    }, t);
    const a = () => {
      e && (s && clearTimeout(s), s = null, e.forEach((u) => {
        u.unsubscribe ? u.unsubscribe(o) : u.removeEventListener("abort", o);
      }), e = null);
    };
    e.forEach((u) => u.addEventListener("abort", o));
    const { signal: l } = r;
    return l.unsubscribe = () => E.asap(a), l;
  }
}, q0 = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let r = 0, i;
  for (; r < n; )
    i = r + t, yield e.slice(r, i), r = i;
}, J0 = async function* (e, t) {
  for await (const n of K0(e))
    yield* q0(n, t);
}, K0 = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: n, value: r } = await t.read();
      if (n)
        break;
      yield r;
    }
  } finally {
    await t.cancel();
  }
}, Yd = (e, t, n, r) => {
  const i = J0(e, t);
  let o = 0, s, a = (l) => {
    s || (s = !0, r && r(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: u, value: c } = await i.next();
        if (u) {
          a(), l.close();
          return;
        }
        let p = c.byteLength;
        if (n) {
          let h = o += p;
          n(h);
        }
        l.enqueue(new Uint8Array(c));
      } catch (u) {
        throw a(u), u;
      }
    },
    cancel(l) {
      return a(l), i.return();
    }
  }, {
    highWaterMark: 2
  });
}, ga = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", xm = ga && typeof ReadableStream == "function", G0 = ga && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), bm = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, Y0 = xm && bm(() => {
  let e = !1;
  const t = new Request(Ge.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), Xd = 64 * 1024, tu = xm && bm(() => E.isReadableStream(new Response("").body)), As = {
  stream: tu && ((e) => e.body)
};
ga && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !As[t] && (As[t] = E.isFunction(e[t]) ? (n) => n[t]() : (n, r) => {
      throw new X(`Response type '${t}' is not supported`, X.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const X0 = async (e) => {
  if (e == null)
    return 0;
  if (E.isBlob(e))
    return e.size;
  if (E.isSpecCompliantForm(e))
    return (await new Request(Ge.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (E.isArrayBufferView(e) || E.isArrayBuffer(e))
    return e.byteLength;
  if (E.isURLSearchParams(e) && (e = e + ""), E.isString(e))
    return (await G0(e)).byteLength;
}, ex = async (e, t) => {
  const n = E.toFiniteNumber(e.getContentLength());
  return n ?? X0(t);
}, tx = ga && (async (e) => {
  let {
    url: t,
    method: n,
    data: r,
    signal: i,
    cancelToken: o,
    timeout: s,
    onDownloadProgress: a,
    onUploadProgress: l,
    responseType: u,
    headers: c,
    withCredentials: p = "same-origin",
    fetchOptions: h
  } = wm(e);
  u = u ? (u + "").toLowerCase() : "text";
  let x = Q0([i, o && o.toAbortSignal()], s), v;
  const w = x && x.unsubscribe && (() => {
    x.unsubscribe();
  });
  let _;
  try {
    if (l && Y0 && n !== "get" && n !== "head" && (_ = await ex(c, r)) !== 0) {
      let f = new Request(t, {
        method: "POST",
        body: r,
        duplex: "half"
      }), A;
      if (E.isFormData(r) && (A = f.headers.get("content-type")) && c.setContentType(A), f.body) {
        const [N, R] = Jd(
          _,
          Is(Kd(l))
        );
        r = Yd(f.body, Xd, N, R);
      }
    }
    E.isString(p) || (p = p ? "include" : "omit");
    const m = "credentials" in Request.prototype;
    v = new Request(t, {
      ...h,
      signal: x,
      method: n.toUpperCase(),
      headers: c.normalize().toJSON(),
      body: r,
      duplex: "half",
      credentials: m ? p : void 0
    });
    let d = await fetch(v);
    const y = tu && (u === "stream" || u === "response");
    if (tu && (a || y && w)) {
      const f = {};
      ["status", "statusText", "headers"].forEach((j) => {
        f[j] = d[j];
      });
      const A = E.toFiniteNumber(d.headers.get("content-length")), [N, R] = a && Jd(
        A,
        Is(Kd(a), !0)
      ) || [];
      d = new Response(
        Yd(d.body, Xd, N, () => {
          R && R(), w && w();
        }),
        f
      );
    }
    u = u || "text";
    let b = await As[E.findKey(As, u) || "text"](d, e);
    return !y && w && w(), await new Promise((f, A) => {
      ym(f, A, {
        data: b,
        headers: pt.from(d.headers),
        status: d.status,
        statusText: d.statusText,
        config: e,
        request: v
      });
    });
  } catch (m) {
    throw w && w(), m && m.name === "TypeError" && /fetch/i.test(m.message) ? Object.assign(
      new X("Network Error", X.ERR_NETWORK, e, v),
      {
        cause: m.cause || m
      }
    ) : X.from(m, m && m.code, e, v);
  }
}), nu = {
  http: g0,
  xhr: Z0,
  fetch: tx
};
E.forEach(nu, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const ef = (e) => `- ${e}`, nx = (e) => E.isFunction(e) || e === null || e === !1, _m = {
  getAdapter: (e) => {
    e = E.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    const i = {};
    for (let o = 0; o < t; o++) {
      n = e[o];
      let s;
      if (r = n, !nx(n) && (r = nu[(s = String(n)).toLowerCase()], r === void 0))
        throw new X(`Unknown adapter '${s}'`);
      if (r)
        break;
      i[s || "#" + o] = r;
    }
    if (!r) {
      const o = Object.entries(i).map(
        ([a, l]) => `adapter ${a} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let s = t ? o.length > 1 ? `since :
` + o.map(ef).join(`
`) : " " + ef(o[0]) : "as no adapter specified";
      throw new X(
        "There is no suitable adapter to dispatch the request " + s,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: nu
};
function el(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new ii(null, e);
}
function tf(e) {
  return el(e), e.headers = pt.from(e.headers), e.data = Xa.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), _m.getAdapter(e.adapter || vo.adapter)(e).then(function(r) {
    return el(e), r.data = Xa.call(
      e,
      e.transformResponse,
      r
    ), r.headers = pt.from(r.headers), r;
  }, function(r) {
    return gm(r) || (el(e), r && r.response && (r.response.data = Xa.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = pt.from(r.response.headers))), Promise.reject(r);
  });
}
const km = "1.8.4", ya = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  ya[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const nf = {};
ya.transitional = function(t, n, r) {
  function i(o, s) {
    return "[Axios v" + km + "] Transitional option '" + o + "'" + s + (r ? ". " + r : "");
  }
  return (o, s, a) => {
    if (t === !1)
      throw new X(
        i(s, " has been removed" + (n ? " in " + n : "")),
        X.ERR_DEPRECATED
      );
    return n && !nf[s] && (nf[s] = !0, console.warn(
      i(
        s,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(o, s, a) : !0;
  };
};
ya.spelling = function(t) {
  return (n, r) => (console.warn(`${r} is likely a misspelling of ${t}`), !0);
};
function rx(e, t, n) {
  if (typeof e != "object")
    throw new X("options must be an object", X.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let i = r.length;
  for (; i-- > 0; ) {
    const o = r[i], s = t[o];
    if (s) {
      const a = e[o], l = a === void 0 || s(a, o, e);
      if (l !== !0)
        throw new X("option " + o + " must be " + l, X.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new X("Unknown option " + o, X.ERR_BAD_OPTION);
  }
}
const ts = {
  assertOptions: rx,
  validators: ya
}, Zt = ts.validators;
let ir = class {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new Qd(),
      response: new Qd()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (r) {
      if (r instanceof Error) {
        let i = {};
        Error.captureStackTrace ? Error.captureStackTrace(i) : i = new Error();
        const o = i.stack ? i.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? o && !String(r.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + o) : r.stack = o;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = dr(this.defaults, n);
    const { transitional: r, paramsSerializer: i, headers: o } = n;
    r !== void 0 && ts.assertOptions(r, {
      silentJSONParsing: Zt.transitional(Zt.boolean),
      forcedJSONParsing: Zt.transitional(Zt.boolean),
      clarifyTimeoutError: Zt.transitional(Zt.boolean)
    }, !1), i != null && (E.isFunction(i) ? n.paramsSerializer = {
      serialize: i
    } : ts.assertOptions(i, {
      encode: Zt.function,
      serialize: Zt.function
    }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), ts.assertOptions(n, {
      baseUrl: Zt.spelling("baseURL"),
      withXsrfToken: Zt.spelling("withXSRFToken")
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let s = o && E.merge(
      o.common,
      o[n.method]
    );
    o && E.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (v) => {
        delete o[v];
      }
    ), n.headers = pt.concat(s, o);
    const a = [];
    let l = !0;
    this.interceptors.request.forEach(function(w) {
      typeof w.runWhen == "function" && w.runWhen(n) === !1 || (l = l && w.synchronous, a.unshift(w.fulfilled, w.rejected));
    });
    const u = [];
    this.interceptors.response.forEach(function(w) {
      u.push(w.fulfilled, w.rejected);
    });
    let c, p = 0, h;
    if (!l) {
      const v = [tf.bind(this), void 0];
      for (v.unshift.apply(v, a), v.push.apply(v, u), h = v.length, c = Promise.resolve(n); p < h; )
        c = c.then(v[p++], v[p++]);
      return c;
    }
    h = a.length;
    let x = n;
    for (p = 0; p < h; ) {
      const v = a[p++], w = a[p++];
      try {
        x = v(x);
      } catch (_) {
        w.call(this, _);
        break;
      }
    }
    try {
      c = tf.call(this, x);
    } catch (v) {
      return Promise.reject(v);
    }
    for (p = 0, h = u.length; p < h; )
      c = c.then(u[p++], u[p++]);
    return c;
  }
  getUri(t) {
    t = dr(this.defaults, t);
    const n = vm(t.baseURL, t.url, t.allowAbsoluteUrls);
    return pm(n, t.params, t.paramsSerializer);
  }
};
E.forEach(["delete", "get", "head", "options"], function(t) {
  ir.prototype[t] = function(n, r) {
    return this.request(dr(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
E.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(o, s, a) {
      return this.request(dr(a || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: s
      }));
    };
  }
  ir.prototype[t] = n(), ir.prototype[t + "Form"] = n(!0);
});
let ix = class Sm {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(o) {
      n = o;
    });
    const r = this;
    this.promise.then((i) => {
      if (!r._listeners) return;
      let o = r._listeners.length;
      for (; o-- > 0; )
        r._listeners[o](i);
      r._listeners = null;
    }), this.promise.then = (i) => {
      let o;
      const s = new Promise((a) => {
        r.subscribe(a), o = a;
      }).then(i);
      return s.cancel = function() {
        r.unsubscribe(o);
      }, s;
    }, t(function(o, s, a) {
      r.reason || (r.reason = new ii(o, s, a), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (r) => {
      t.abort(r);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Sm(function(i) {
        t = i;
      }),
      cancel: t
    };
  }
};
function ox(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function sx(e) {
  return E.isObject(e) && e.isAxiosError === !0;
}
const ru = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(ru).forEach(([e, t]) => {
  ru[t] = e;
});
function Em(e) {
  const t = new ir(e), n = nm(ir.prototype.request, t);
  return E.extend(n, ir.prototype, t, { allOwnKeys: !0 }), E.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(i) {
    return Em(dr(e, i));
  }, n;
}
const Pe = Em(vo);
Pe.Axios = ir;
Pe.CanceledError = ii;
Pe.CancelToken = ix;
Pe.isCancel = gm;
Pe.VERSION = km;
Pe.toFormData = ma;
Pe.AxiosError = X;
Pe.Cancel = Pe.CanceledError;
Pe.all = function(t) {
  return Promise.all(t);
};
Pe.spread = ox;
Pe.isAxiosError = sx;
Pe.mergeConfig = dr;
Pe.AxiosHeaders = pt;
Pe.formToJSON = (e) => mm(E.isHTMLForm(e) ? new FormData(e) : e);
Pe.getAdapter = _m.getAdapter;
Pe.HttpStatusCode = ru;
Pe.default = Pe;
const {
  Axios: g1,
  AxiosError: y1,
  CanceledError: v1,
  isCancel: w1,
  CancelToken: x1,
  VERSION: b1,
  all: _1,
  Cancel: k1,
  isAxiosError: S1,
  spread: E1,
  toFormData: C1,
  AxiosHeaders: N1,
  HttpStatusCode: T1,
  formToJSON: R1,
  getAdapter: I1,
  mergeConfig: A1
} = Pe, ze = Pe.create({
  baseURL: "http://al-client-intake.test/api/v1",
  headers: {
    "Content-Type": "application/json"
  }
});
ze.interceptors.request.use(
  (e) => e,
  (e) => Promise.reject(e)
);
ze.interceptors.response.use(
  (e) => e,
  (e) => Promise.reject(e)
);
const ax = async (e) => (await ze.post("/submissions/division", e)).data, lx = async (e) => (await ze.get(`/submissions/jurisdiction-question?submission_id=${e}`)).data, ux = async (e) => (await ze.post("/submissions/jurisdiction", e)).data, cx = async (e) => (await ze.get(`/locations?q=${encodeURIComponent(e)}`)).data, dx = async (e) => (await ze.post("/submissions/contact", e)).data;
function Cm(e, t) {
  const [n, r] = S.useState(null), [i, o] = S.useState(null), [s, a] = S.useState(!1), l = S.useCallback(async ({ body: u }) => {
    var c, p;
    a(!0);
    try {
      const h = await ax(u);
      r(h), o(null);
      const x = { data: h };
      (c = t == null ? void 0 : t.onSuccess) == null || c.call(t, x);
    } catch (h) {
      const x = h;
      o(x), (p = t == null ? void 0 : t.onError) == null || p.call(t, x);
    } finally {
      a(!1);
    }
  }, [t]);
  return {
    data: n,
    error: i,
    isPending: s,
    mutate: l
  };
}
function fx({ query: e }, t, n) {
  const [r, i] = S.useState(null), [o, s] = S.useState(null), [a, l] = S.useState(!1), u = S.useCallback(async () => {
    if (!(!e.submission_id || n && n.enabled === !1)) {
      l(!0);
      try {
        const c = await lx(e.submission_id);
        i(c), s(null);
      } catch (c) {
        s(c);
      } finally {
        l(!1);
      }
    }
  }, [e.submission_id, n == null ? void 0 : n.enabled]);
  return S.useEffect(() => {
  }, [u, n == null ? void 0 : n.refetchOnWindowFocus]), {
    data: r,
    error: o,
    isLoading: a,
    refetch: u
  };
}
function px(e, t) {
  const [n, r] = S.useState(null), [i, o] = S.useState(null), [s, a] = S.useState(!1), l = S.useCallback(async ({ body: u }) => {
    var c, p;
    a(!0);
    try {
      const h = await ux(u);
      r(h), o(null), (c = t == null ? void 0 : t.onSuccess) == null || c.call(t, h);
    } catch (h) {
      const x = h;
      o(x), (p = t == null ? void 0 : t.onError) == null || p.call(t, x);
    } finally {
      a(!1);
    }
  }, [t]);
  return {
    data: n,
    error: i,
    isPending: s,
    mutate: l
  };
}
function hx({ query: e }, t, n) {
  const [r, i] = S.useState(null), [o, s] = S.useState(null), [a, l] = S.useState(!1);
  return S.useEffect(() => {
    if (n && n.enabled === !1) return;
    (async () => {
      l(!0);
      try {
        const c = await cx(e.q);
        i(c), s(null);
      } catch (c) {
        s(c);
      } finally {
        l(!1);
      }
    })();
  }, [e.q, n == null ? void 0 : n.enabled]), {
    data: r,
    error: o,
    isLoading: a
  };
}
function mx(e, t) {
  const [n, r] = S.useState(null), [i, o] = S.useState(null), [s, a] = S.useState(!1), l = S.useCallback(async ({ body: u }) => {
    var c, p;
    a(!0);
    try {
      const h = await dx(u);
      r(h), o(null), (c = t == null ? void 0 : t.onSuccess) == null || c.call(t, h);
    } catch (h) {
      const x = h;
      o(x), (p = t == null ? void 0 : t.onError) == null || p.call(t, x);
    } finally {
      a(!1);
    }
  }, [t]);
  return {
    data: n,
    error: i,
    isPending: s,
    mutate: l
  };
}
const rf = (e, t, n) => {
  if (e && "reportValidity" in e) {
    const r = M(n, t);
    e.setCustomValidity(r && r.message || ""), e.reportValidity();
  }
}, Nm = (e, t) => {
  for (const n in t.fields) {
    const r = t.fields[n];
    r && r.ref && "reportValidity" in r.ref ? rf(r.ref, n, e) : r.refs && r.refs.forEach((i) => rf(i, n, e));
  }
}, gx = (e, t) => {
  t.shouldUseNativeValidation && Nm(e, t);
  const n = {};
  for (const r in e) {
    const i = M(t.fields, r), o = Object.assign(e[r] || {}, { ref: i && i.ref });
    if (yx(t.names || Object.keys(e), r)) {
      const s = Object.assign({}, M(n, r));
      pe(s, "root", o), pe(n, r, s);
    } else pe(n, r, o);
  }
  return n;
}, yx = (e, t) => e.some((n) => n.startsWith(t + "."));
var vx = function(e, t) {
  for (var n = {}; e.length; ) {
    var r = e[0], i = r.code, o = r.message, s = r.path.join(".");
    if (!n[s]) if ("unionErrors" in r) {
      var a = r.unionErrors[0].errors[0];
      n[s] = { message: a.message, type: a.code };
    } else n[s] = { message: o, type: i };
    if ("unionErrors" in r && r.unionErrors.forEach(function(c) {
      return c.errors.forEach(function(p) {
        return e.push(p);
      });
    }), t) {
      var l = n[s].types, u = l && l[r.code];
      n[s] = Bh(s, t, n, i, u ? [].concat(u, r.message) : r.message);
    }
    e.shift();
  }
  return n;
}, va = function(e, t, n) {
  return n === void 0 && (n = {}), function(r, i, o) {
    try {
      return Promise.resolve(function(s, a) {
        try {
          var l = Promise.resolve(e[n.mode === "sync" ? "parse" : "parseAsync"](r, t)).then(function(u) {
            return o.shouldUseNativeValidation && Nm({}, o), { errors: {}, values: n.raw ? r : u };
          });
        } catch (u) {
          return a(u);
        }
        return l && l.then ? l.then(void 0, a) : l;
      }(0, function(s) {
        if (function(a) {
          return Array.isArray(a == null ? void 0 : a.errors);
        }(s)) return { values: {}, errors: gx(vx(s.errors, !o.shouldUseNativeValidation && o.criteriaMode === "all"), o) };
        throw s;
      }));
    } catch (s) {
      return Promise.reject(s);
    }
  };
}, ce;
(function(e) {
  e.assertEqual = (i) => i;
  function t(i) {
  }
  e.assertIs = t;
  function n(i) {
    throw new Error();
  }
  e.assertNever = n, e.arrayToEnum = (i) => {
    const o = {};
    for (const s of i)
      o[s] = s;
    return o;
  }, e.getValidEnumValues = (i) => {
    const o = e.objectKeys(i).filter((a) => typeof i[i[a]] != "number"), s = {};
    for (const a of o)
      s[a] = i[a];
    return e.objectValues(s);
  }, e.objectValues = (i) => e.objectKeys(i).map(function(o) {
    return i[o];
  }), e.objectKeys = typeof Object.keys == "function" ? (i) => Object.keys(i) : (i) => {
    const o = [];
    for (const s in i)
      Object.prototype.hasOwnProperty.call(i, s) && o.push(s);
    return o;
  }, e.find = (i, o) => {
    for (const s of i)
      if (o(s))
        return s;
  }, e.isInteger = typeof Number.isInteger == "function" ? (i) => Number.isInteger(i) : (i) => typeof i == "number" && isFinite(i) && Math.floor(i) === i;
  function r(i, o = " | ") {
    return i.map((s) => typeof s == "string" ? `'${s}'` : s).join(o);
  }
  e.joinValues = r, e.jsonStringifyReplacer = (i, o) => typeof o == "bigint" ? o.toString() : o;
})(ce || (ce = {}));
var of;
(function(e) {
  e.mergeShapes = (t, n) => ({
    ...t,
    ...n
    // second overwrites first
  });
})(of || (of = {}));
const B = ce.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Tn = (e) => {
  switch (typeof e) {
    case "undefined":
      return B.undefined;
    case "string":
      return B.string;
    case "number":
      return isNaN(e) ? B.nan : B.number;
    case "boolean":
      return B.boolean;
    case "function":
      return B.function;
    case "bigint":
      return B.bigint;
    case "symbol":
      return B.symbol;
    case "object":
      return Array.isArray(e) ? B.array : e === null ? B.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? B.promise : typeof Map < "u" && e instanceof Map ? B.map : typeof Set < "u" && e instanceof Set ? B.set : typeof Date < "u" && e instanceof Date ? B.date : B.object;
    default:
      return B.unknown;
  }
}, O = ce.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class It extends Error {
  get errors() {
    return this.issues;
  }
  constructor(t) {
    super(), this.issues = [], this.addIssue = (r) => {
      this.issues = [...this.issues, r];
    }, this.addIssues = (r = []) => {
      this.issues = [...this.issues, ...r];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = t;
  }
  format(t) {
    const n = t || function(o) {
      return o.message;
    }, r = { _errors: [] }, i = (o) => {
      for (const s of o.issues)
        if (s.code === "invalid_union")
          s.unionErrors.map(i);
        else if (s.code === "invalid_return_type")
          i(s.returnTypeError);
        else if (s.code === "invalid_arguments")
          i(s.argumentsError);
        else if (s.path.length === 0)
          r._errors.push(n(s));
        else {
          let a = r, l = 0;
          for (; l < s.path.length; ) {
            const u = s.path[l];
            l === s.path.length - 1 ? (a[u] = a[u] || { _errors: [] }, a[u]._errors.push(n(s))) : a[u] = a[u] || { _errors: [] }, a = a[u], l++;
          }
        }
    };
    return i(this), r;
  }
  static assert(t) {
    if (!(t instanceof It))
      throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, ce.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (n) => n.message) {
    const n = {}, r = [];
    for (const i of this.issues)
      i.path.length > 0 ? (n[i.path[0]] = n[i.path[0]] || [], n[i.path[0]].push(t(i))) : r.push(t(i));
    return { formErrors: r, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
}
It.create = (e) => new It(e);
const so = (e, t) => {
  let n;
  switch (e.code) {
    case O.invalid_type:
      e.received === B.undefined ? n = "Required" : n = `Expected ${e.expected}, received ${e.received}`;
      break;
    case O.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(e.expected, ce.jsonStringifyReplacer)}`;
      break;
    case O.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${ce.joinValues(e.keys, ", ")}`;
      break;
    case O.invalid_union:
      n = "Invalid input";
      break;
    case O.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${ce.joinValues(e.options)}`;
      break;
    case O.invalid_enum_value:
      n = `Invalid enum value. Expected ${ce.joinValues(e.options)}, received '${e.received}'`;
      break;
    case O.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case O.invalid_return_type:
      n = "Invalid function return type";
      break;
    case O.invalid_date:
      n = "Invalid date";
      break;
    case O.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (n = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? n = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? n = `Invalid input: must end with "${e.validation.endsWith}"` : ce.assertNever(e.validation) : e.validation !== "regex" ? n = `Invalid ${e.validation}` : n = "Invalid";
      break;
    case O.too_small:
      e.type === "array" ? n = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? n = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? n = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? n = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : n = "Invalid input";
      break;
    case O.too_big:
      e.type === "array" ? n = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? n = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? n = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? n = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? n = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : n = "Invalid input";
      break;
    case O.custom:
      n = "Invalid input";
      break;
    case O.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case O.not_multiple_of:
      n = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case O.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = t.defaultError, ce.assertNever(e);
  }
  return { message: n };
};
let wx = so;
function iu() {
  return wx;
}
const ou = (e) => {
  const { data: t, path: n, errorMaps: r, issueData: i } = e, o = [...n, ...i.path || []], s = {
    ...i,
    path: o
  };
  if (i.message !== void 0)
    return {
      ...i,
      path: o,
      message: i.message
    };
  let a = "";
  const l = r.filter((u) => !!u).slice().reverse();
  for (const u of l)
    a = u(s, { data: t, defaultError: a }).message;
  return {
    ...i,
    path: o,
    message: a
  };
};
function V(e, t) {
  const n = iu(), r = ou({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      // contextual error map is first priority
      e.schemaErrorMap,
      // then schema-bound map if available
      n,
      // then global override map
      n === so ? void 0 : so
      // then global default map
    ].filter((i) => !!i)
  });
  e.common.issues.push(r);
}
class ot {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, n) {
    const r = [];
    for (const i of n) {
      if (i.status === "aborted")
        return Y;
      i.status === "dirty" && t.dirty(), r.push(i.value);
    }
    return { status: t.value, value: r };
  }
  static async mergeObjectAsync(t, n) {
    const r = [];
    for (const i of n) {
      const o = await i.key, s = await i.value;
      r.push({
        key: o,
        value: s
      });
    }
    return ot.mergeObjectSync(t, r);
  }
  static mergeObjectSync(t, n) {
    const r = {};
    for (const i of n) {
      const { key: o, value: s } = i;
      if (o.status === "aborted" || s.status === "aborted")
        return Y;
      o.status === "dirty" && t.dirty(), s.status === "dirty" && t.dirty(), o.value !== "__proto__" && (typeof s.value < "u" || i.alwaysSet) && (r[o.value] = s.value);
    }
    return { status: t.value, value: r };
  }
}
const Y = Object.freeze({
  status: "aborted"
}), Si = (e) => ({ status: "dirty", value: e }), ht = (e) => ({ status: "valid", value: e }), sf = (e) => e.status === "aborted", af = (e) => e.status === "dirty", Jr = (e) => e.status === "valid", Os = (e) => typeof Promise < "u" && e instanceof Promise;
function Ps(e, t, n, r) {
  if (typeof t == "function" ? e !== t || !0 : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return t.get(e);
}
function Tm(e, t, n, r, i) {
  if (typeof t == "function" ? e !== t || !0 : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return t.set(e, n), n;
}
var Z;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t == null ? void 0 : t.message;
})(Z || (Z = {}));
var Ei, Ci;
class Xt {
  constructor(t, n, r, i) {
    this._cachedPath = [], this.parent = t, this.data = n, this._path = r, this._key = i;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const lf = (e, t) => {
  if (Jr(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const n = new It(e.common.issues);
      return this._error = n, this._error;
    }
  };
};
function ee(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: n, required_error: r, description: i } = e;
  if (t && (n || r))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: i } : { errorMap: (s, a) => {
    var l, u;
    const { message: c } = e;
    return s.code === "invalid_enum_value" ? { message: c ?? a.defaultError } : typeof a.data > "u" ? { message: (l = c ?? r) !== null && l !== void 0 ? l : a.defaultError } : s.code !== "invalid_type" ? { message: a.defaultError } : { message: (u = c ?? n) !== null && u !== void 0 ? u : a.defaultError };
  }, description: i };
}
class ie {
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return Tn(t.data);
  }
  _getOrReturnCtx(t, n) {
    return n || {
      common: t.parent.common,
      data: t.data,
      parsedType: Tn(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new ot(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: Tn(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const n = this._parse(t);
    if (Os(n))
      throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(t) {
    const n = this._parse(t);
    return Promise.resolve(n);
  }
  parse(t, n) {
    const r = this.safeParse(t, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  safeParse(t, n) {
    var r;
    const i = {
      common: {
        issues: [],
        async: (r = n == null ? void 0 : n.async) !== null && r !== void 0 ? r : !1,
        contextualErrorMap: n == null ? void 0 : n.errorMap
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Tn(t)
    }, o = this._parseSync({ data: t, path: i.path, parent: i });
    return lf(i, o);
  }
  "~validate"(t) {
    var n, r;
    const i = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Tn(t)
    };
    if (!this["~standard"].async)
      try {
        const o = this._parseSync({ data: t, path: [], parent: i });
        return Jr(o) ? {
          value: o.value
        } : {
          issues: i.common.issues
        };
      } catch (o) {
        !((r = (n = o == null ? void 0 : o.message) === null || n === void 0 ? void 0 : n.toLowerCase()) === null || r === void 0) && r.includes("encountered") && (this["~standard"].async = !0), i.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: t, path: [], parent: i }).then((o) => Jr(o) ? {
      value: o.value
    } : {
      issues: i.common.issues
    });
  }
  async parseAsync(t, n) {
    const r = await this.safeParseAsync(t, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  async safeParseAsync(t, n) {
    const r = {
      common: {
        issues: [],
        contextualErrorMap: n == null ? void 0 : n.errorMap,
        async: !0
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Tn(t)
    }, i = this._parse({ data: t, path: r.path, parent: r }), o = await (Os(i) ? i : Promise.resolve(i));
    return lf(r, o);
  }
  refine(t, n) {
    const r = (i) => typeof n == "string" || typeof n > "u" ? { message: n } : typeof n == "function" ? n(i) : n;
    return this._refinement((i, o) => {
      const s = t(i), a = () => o.addIssue({
        code: O.custom,
        ...r(i)
      });
      return typeof Promise < "u" && s instanceof Promise ? s.then((l) => l ? !0 : (a(), !1)) : s ? !0 : (a(), !1);
    });
  }
  refinement(t, n) {
    return this._refinement((r, i) => t(r) ? !0 : (i.addIssue(typeof n == "function" ? n(r, i) : n), !1));
  }
  _refinement(t) {
    return new vn({
      schema: this,
      typeName: G.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (n) => this["~validate"](n)
    };
  }
  optional() {
    return fn.create(this, this._def);
  }
  nullable() {
    return pr.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return Yt.create(this);
  }
  promise() {
    return lo.create(this, this._def);
  }
  or(t) {
    return Fs.create([this, t], this._def);
  }
  and(t) {
    return Ds.create(this, t, this._def);
  }
  transform(t) {
    return new vn({
      ...ee(this._def),
      schema: this,
      typeName: G.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const n = typeof t == "function" ? t : () => t;
    return new $s({
      ...ee(this._def),
      innerType: this,
      defaultValue: n,
      typeName: G.ZodDefault
    });
  }
  brand() {
    return new Om({
      typeName: G.ZodBranded,
      type: this,
      ...ee(this._def)
    });
  }
  catch(t) {
    const n = typeof t == "function" ? t : () => t;
    return new Bs({
      ...ee(this._def),
      innerType: this,
      catchValue: n,
      typeName: G.ZodCatch
    });
  }
  describe(t) {
    const n = this.constructor;
    return new n({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return wa.create(this, t);
  }
  readonly() {
    return Hs.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const xx = /^c[^\s-]{8,}$/i, bx = /^[0-9a-z]+$/, _x = /^[0-9A-HJKMNP-TV-Z]{26}$/i, kx = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Sx = /^[a-z0-9_-]{21}$/i, Ex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, Cx = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, Nx = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, Tx = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let tl;
const Rx = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Ix = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, Ax = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, Ox = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Px = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, jx = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Rm = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Lx = new RegExp(`^${Rm}$`);
function Im(e) {
  let t = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`), t;
}
function Fx(e) {
  return new RegExp(`^${Im(e)}$`);
}
function Dx(e) {
  let t = `${Rm}T${Im(e)}`;
  const n = [];
  return n.push(e.local ? "Z?" : "Z"), e.offset && n.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${n.join("|")})`, new RegExp(`^${t}$`);
}
function zx(e, t) {
  return !!((t === "v4" || !t) && Rx.test(e) || (t === "v6" || !t) && Ax.test(e));
}
function Mx(e, t) {
  if (!Ex.test(e))
    return !1;
  try {
    const [n] = e.split("."), r = n.replace(/-/g, "+").replace(/_/g, "/").padEnd(n.length + (4 - n.length % 4) % 4, "="), i = JSON.parse(atob(r));
    return !(typeof i != "object" || i === null || !i.typ || !i.alg || t && i.alg !== t);
  } catch {
    return !1;
  }
}
function Ux(e, t) {
  return !!((t === "v4" || !t) && Ix.test(e) || (t === "v6" || !t) && Ox.test(e));
}
class cn extends ie {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== B.string) {
      const o = this._getOrReturnCtx(t);
      return V(o, {
        code: O.invalid_type,
        expected: B.string,
        received: o.parsedType
      }), Y;
    }
    const r = new ot();
    let i;
    for (const o of this._def.checks)
      if (o.kind === "min")
        t.data.length < o.value && (i = this._getOrReturnCtx(t, i), V(i, {
          code: O.too_small,
          minimum: o.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: o.message
        }), r.dirty());
      else if (o.kind === "max")
        t.data.length > o.value && (i = this._getOrReturnCtx(t, i), V(i, {
          code: O.too_big,
          maximum: o.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: o.message
        }), r.dirty());
      else if (o.kind === "length") {
        const s = t.data.length > o.value, a = t.data.length < o.value;
        (s || a) && (i = this._getOrReturnCtx(t, i), s ? V(i, {
          code: O.too_big,
          maximum: o.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: o.message
        }) : a && V(i, {
          code: O.too_small,
          minimum: o.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: o.message
        }), r.dirty());
      } else if (o.kind === "email")
        Nx.test(t.data) || (i = this._getOrReturnCtx(t, i), V(i, {
          validation: "email",
          code: O.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "emoji")
        tl || (tl = new RegExp(Tx, "u")), tl.test(t.data) || (i = this._getOrReturnCtx(t, i), V(i, {
          validation: "emoji",
          code: O.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "uuid")
        kx.test(t.data) || (i = this._getOrReturnCtx(t, i), V(i, {
          validation: "uuid",
          code: O.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "nanoid")
        Sx.test(t.data) || (i = this._getOrReturnCtx(t, i), V(i, {
          validation: "nanoid",
          code: O.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "cuid")
        xx.test(t.data) || (i = this._getOrReturnCtx(t, i), V(i, {
          validation: "cuid",
          code: O.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "cuid2")
        bx.test(t.data) || (i = this._getOrReturnCtx(t, i), V(i, {
          validation: "cuid2",
          code: O.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "ulid")
        _x.test(t.data) || (i = this._getOrReturnCtx(t, i), V(i, {
          validation: "ulid",
          code: O.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "url")
        try {
          new URL(t.data);
        } catch {
          i = this._getOrReturnCtx(t, i), V(i, {
            validation: "url",
            code: O.invalid_string,
            message: o.message
          }), r.dirty();
        }
      else o.kind === "regex" ? (o.regex.lastIndex = 0, o.regex.test(t.data) || (i = this._getOrReturnCtx(t, i), V(i, {
        validation: "regex",
        code: O.invalid_string,
        message: o.message
      }), r.dirty())) : o.kind === "trim" ? t.data = t.data.trim() : o.kind === "includes" ? t.data.includes(o.value, o.position) || (i = this._getOrReturnCtx(t, i), V(i, {
        code: O.invalid_string,
        validation: { includes: o.value, position: o.position },
        message: o.message
      }), r.dirty()) : o.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : o.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : o.kind === "startsWith" ? t.data.startsWith(o.value) || (i = this._getOrReturnCtx(t, i), V(i, {
        code: O.invalid_string,
        validation: { startsWith: o.value },
        message: o.message
      }), r.dirty()) : o.kind === "endsWith" ? t.data.endsWith(o.value) || (i = this._getOrReturnCtx(t, i), V(i, {
        code: O.invalid_string,
        validation: { endsWith: o.value },
        message: o.message
      }), r.dirty()) : o.kind === "datetime" ? Dx(o).test(t.data) || (i = this._getOrReturnCtx(t, i), V(i, {
        code: O.invalid_string,
        validation: "datetime",
        message: o.message
      }), r.dirty()) : o.kind === "date" ? Lx.test(t.data) || (i = this._getOrReturnCtx(t, i), V(i, {
        code: O.invalid_string,
        validation: "date",
        message: o.message
      }), r.dirty()) : o.kind === "time" ? Fx(o).test(t.data) || (i = this._getOrReturnCtx(t, i), V(i, {
        code: O.invalid_string,
        validation: "time",
        message: o.message
      }), r.dirty()) : o.kind === "duration" ? Cx.test(t.data) || (i = this._getOrReturnCtx(t, i), V(i, {
        validation: "duration",
        code: O.invalid_string,
        message: o.message
      }), r.dirty()) : o.kind === "ip" ? zx(t.data, o.version) || (i = this._getOrReturnCtx(t, i), V(i, {
        validation: "ip",
        code: O.invalid_string,
        message: o.message
      }), r.dirty()) : o.kind === "jwt" ? Mx(t.data, o.alg) || (i = this._getOrReturnCtx(t, i), V(i, {
        validation: "jwt",
        code: O.invalid_string,
        message: o.message
      }), r.dirty()) : o.kind === "cidr" ? Ux(t.data, o.version) || (i = this._getOrReturnCtx(t, i), V(i, {
        validation: "cidr",
        code: O.invalid_string,
        message: o.message
      }), r.dirty()) : o.kind === "base64" ? Px.test(t.data) || (i = this._getOrReturnCtx(t, i), V(i, {
        validation: "base64",
        code: O.invalid_string,
        message: o.message
      }), r.dirty()) : o.kind === "base64url" ? jx.test(t.data) || (i = this._getOrReturnCtx(t, i), V(i, {
        validation: "base64url",
        code: O.invalid_string,
        message: o.message
      }), r.dirty()) : ce.assertNever(o);
    return { status: r.value, value: t.data };
  }
  _regex(t, n, r) {
    return this.refinement((i) => t.test(i), {
      validation: n,
      code: O.invalid_string,
      ...Z.errToObj(r)
    });
  }
  _addCheck(t) {
    return new cn({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...Z.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...Z.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...Z.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...Z.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...Z.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...Z.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...Z.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...Z.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...Z.errToObj(t) });
  }
  base64url(t) {
    return this._addCheck({
      kind: "base64url",
      ...Z.errToObj(t)
    });
  }
  jwt(t) {
    return this._addCheck({ kind: "jwt", ...Z.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...Z.errToObj(t) });
  }
  cidr(t) {
    return this._addCheck({ kind: "cidr", ...Z.errToObj(t) });
  }
  datetime(t) {
    var n, r;
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      offset: (n = t == null ? void 0 : t.offset) !== null && n !== void 0 ? n : !1,
      local: (r = t == null ? void 0 : t.local) !== null && r !== void 0 ? r : !1,
      ...Z.errToObj(t == null ? void 0 : t.message)
    });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: t
    }) : this._addCheck({
      kind: "time",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      ...Z.errToObj(t == null ? void 0 : t.message)
    });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...Z.errToObj(t) });
  }
  regex(t, n) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...Z.errToObj(n)
    });
  }
  includes(t, n) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: n == null ? void 0 : n.position,
      ...Z.errToObj(n == null ? void 0 : n.message)
    });
  }
  startsWith(t, n) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...Z.errToObj(n)
    });
  }
  endsWith(t, n) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...Z.errToObj(n)
    });
  }
  min(t, n) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...Z.errToObj(n)
    });
  }
  max(t, n) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...Z.errToObj(n)
    });
  }
  length(t, n) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...Z.errToObj(n)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(t) {
    return this.min(1, Z.errToObj(t));
  }
  trim() {
    return new cn({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new cn({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new cn({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((t) => t.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((t) => t.kind === "base64url");
  }
  get minLength() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
}
cn.create = (e) => {
  var t;
  return new cn({
    checks: [],
    typeName: G.ZodString,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...ee(e)
  });
};
function Vx(e, t) {
  const n = (e.toString().split(".")[1] || "").length, r = (t.toString().split(".")[1] || "").length, i = n > r ? n : r, o = parseInt(e.toFixed(i).replace(".", "")), s = parseInt(t.toFixed(i).replace(".", ""));
  return o % s / Math.pow(10, i);
}
class Kr extends ie {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== B.number) {
      const o = this._getOrReturnCtx(t);
      return V(o, {
        code: O.invalid_type,
        expected: B.number,
        received: o.parsedType
      }), Y;
    }
    let r;
    const i = new ot();
    for (const o of this._def.checks)
      o.kind === "int" ? ce.isInteger(t.data) || (r = this._getOrReturnCtx(t, r), V(r, {
        code: O.invalid_type,
        expected: "integer",
        received: "float",
        message: o.message
      }), i.dirty()) : o.kind === "min" ? (o.inclusive ? t.data < o.value : t.data <= o.value) && (r = this._getOrReturnCtx(t, r), V(r, {
        code: O.too_small,
        minimum: o.value,
        type: "number",
        inclusive: o.inclusive,
        exact: !1,
        message: o.message
      }), i.dirty()) : o.kind === "max" ? (o.inclusive ? t.data > o.value : t.data >= o.value) && (r = this._getOrReturnCtx(t, r), V(r, {
        code: O.too_big,
        maximum: o.value,
        type: "number",
        inclusive: o.inclusive,
        exact: !1,
        message: o.message
      }), i.dirty()) : o.kind === "multipleOf" ? Vx(t.data, o.value) !== 0 && (r = this._getOrReturnCtx(t, r), V(r, {
        code: O.not_multiple_of,
        multipleOf: o.value,
        message: o.message
      }), i.dirty()) : o.kind === "finite" ? Number.isFinite(t.data) || (r = this._getOrReturnCtx(t, r), V(r, {
        code: O.not_finite,
        message: o.message
      }), i.dirty()) : ce.assertNever(o);
    return { status: i.value, value: t.data };
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, Z.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, Z.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, Z.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, Z.toString(n));
  }
  setLimit(t, n, r, i) {
    return new Kr({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: n,
          inclusive: r,
          message: Z.toString(i)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Kr({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: Z.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: Z.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: Z.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: Z.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: Z.toString(t)
    });
  }
  multipleOf(t, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: Z.toString(n)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: Z.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: Z.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: Z.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && ce.isInteger(t.value));
  }
  get isFinite() {
    let t = null, n = null;
    for (const r of this._def.checks) {
      if (r.kind === "finite" || r.kind === "int" || r.kind === "multipleOf")
        return !0;
      r.kind === "min" ? (n === null || r.value > n) && (n = r.value) : r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    }
    return Number.isFinite(n) && Number.isFinite(t);
  }
}
Kr.create = (e) => new Kr({
  checks: [],
  typeName: G.ZodNumber,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...ee(e)
});
class Gr extends ie {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce)
      try {
        t.data = BigInt(t.data);
      } catch {
        return this._getInvalidInput(t);
      }
    if (this._getType(t) !== B.bigint)
      return this._getInvalidInput(t);
    let r;
    const i = new ot();
    for (const o of this._def.checks)
      o.kind === "min" ? (o.inclusive ? t.data < o.value : t.data <= o.value) && (r = this._getOrReturnCtx(t, r), V(r, {
        code: O.too_small,
        type: "bigint",
        minimum: o.value,
        inclusive: o.inclusive,
        message: o.message
      }), i.dirty()) : o.kind === "max" ? (o.inclusive ? t.data > o.value : t.data >= o.value) && (r = this._getOrReturnCtx(t, r), V(r, {
        code: O.too_big,
        type: "bigint",
        maximum: o.value,
        inclusive: o.inclusive,
        message: o.message
      }), i.dirty()) : o.kind === "multipleOf" ? t.data % o.value !== BigInt(0) && (r = this._getOrReturnCtx(t, r), V(r, {
        code: O.not_multiple_of,
        multipleOf: o.value,
        message: o.message
      }), i.dirty()) : ce.assertNever(o);
    return { status: i.value, value: t.data };
  }
  _getInvalidInput(t) {
    const n = this._getOrReturnCtx(t);
    return V(n, {
      code: O.invalid_type,
      expected: B.bigint,
      received: n.parsedType
    }), Y;
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, Z.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, Z.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, Z.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, Z.toString(n));
  }
  setLimit(t, n, r, i) {
    return new Gr({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: n,
          inclusive: r,
          message: Z.toString(i)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Gr({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: Z.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: Z.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: Z.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: Z.toString(t)
    });
  }
  multipleOf(t, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: Z.toString(n)
    });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
}
Gr.create = (e) => {
  var t;
  return new Gr({
    checks: [],
    typeName: G.ZodBigInt,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...ee(e)
  });
};
class su extends ie {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== B.boolean) {
      const r = this._getOrReturnCtx(t);
      return V(r, {
        code: O.invalid_type,
        expected: B.boolean,
        received: r.parsedType
      }), Y;
    }
    return ht(t.data);
  }
}
su.create = (e) => new su({
  typeName: G.ZodBoolean,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...ee(e)
});
class ao extends ie {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== B.date) {
      const o = this._getOrReturnCtx(t);
      return V(o, {
        code: O.invalid_type,
        expected: B.date,
        received: o.parsedType
      }), Y;
    }
    if (isNaN(t.data.getTime())) {
      const o = this._getOrReturnCtx(t);
      return V(o, {
        code: O.invalid_date
      }), Y;
    }
    const r = new ot();
    let i;
    for (const o of this._def.checks)
      o.kind === "min" ? t.data.getTime() < o.value && (i = this._getOrReturnCtx(t, i), V(i, {
        code: O.too_small,
        message: o.message,
        inclusive: !0,
        exact: !1,
        minimum: o.value,
        type: "date"
      }), r.dirty()) : o.kind === "max" ? t.data.getTime() > o.value && (i = this._getOrReturnCtx(t, i), V(i, {
        code: O.too_big,
        message: o.message,
        inclusive: !0,
        exact: !1,
        maximum: o.value,
        type: "date"
      }), r.dirty()) : ce.assertNever(o);
    return {
      status: r.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new ao({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, n) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: Z.toString(n)
    });
  }
  max(t, n) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: Z.toString(n)
    });
  }
  get minDate() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
}
ao.create = (e) => new ao({
  checks: [],
  coerce: (e == null ? void 0 : e.coerce) || !1,
  typeName: G.ZodDate,
  ...ee(e)
});
class au extends ie {
  _parse(t) {
    if (this._getType(t) !== B.symbol) {
      const r = this._getOrReturnCtx(t);
      return V(r, {
        code: O.invalid_type,
        expected: B.symbol,
        received: r.parsedType
      }), Y;
    }
    return ht(t.data);
  }
}
au.create = (e) => new au({
  typeName: G.ZodSymbol,
  ...ee(e)
});
class js extends ie {
  _parse(t) {
    if (this._getType(t) !== B.undefined) {
      const r = this._getOrReturnCtx(t);
      return V(r, {
        code: O.invalid_type,
        expected: B.undefined,
        received: r.parsedType
      }), Y;
    }
    return ht(t.data);
  }
}
js.create = (e) => new js({
  typeName: G.ZodUndefined,
  ...ee(e)
});
class Ls extends ie {
  _parse(t) {
    if (this._getType(t) !== B.null) {
      const r = this._getOrReturnCtx(t);
      return V(r, {
        code: O.invalid_type,
        expected: B.null,
        received: r.parsedType
      }), Y;
    }
    return ht(t.data);
  }
}
Ls.create = (e) => new Ls({
  typeName: G.ZodNull,
  ...ee(e)
});
class lu extends ie {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return ht(t.data);
  }
}
lu.create = (e) => new lu({
  typeName: G.ZodAny,
  ...ee(e)
});
class Vr extends ie {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return ht(t.data);
  }
}
Vr.create = (e) => new Vr({
  typeName: G.ZodUnknown,
  ...ee(e)
});
class Bn extends ie {
  _parse(t) {
    const n = this._getOrReturnCtx(t);
    return V(n, {
      code: O.invalid_type,
      expected: B.never,
      received: n.parsedType
    }), Y;
  }
}
Bn.create = (e) => new Bn({
  typeName: G.ZodNever,
  ...ee(e)
});
class uu extends ie {
  _parse(t) {
    if (this._getType(t) !== B.undefined) {
      const r = this._getOrReturnCtx(t);
      return V(r, {
        code: O.invalid_type,
        expected: B.void,
        received: r.parsedType
      }), Y;
    }
    return ht(t.data);
  }
}
uu.create = (e) => new uu({
  typeName: G.ZodVoid,
  ...ee(e)
});
class Yt extends ie {
  _parse(t) {
    const { ctx: n, status: r } = this._processInputParams(t), i = this._def;
    if (n.parsedType !== B.array)
      return V(n, {
        code: O.invalid_type,
        expected: B.array,
        received: n.parsedType
      }), Y;
    if (i.exactLength !== null) {
      const s = n.data.length > i.exactLength.value, a = n.data.length < i.exactLength.value;
      (s || a) && (V(n, {
        code: s ? O.too_big : O.too_small,
        minimum: a ? i.exactLength.value : void 0,
        maximum: s ? i.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: i.exactLength.message
      }), r.dirty());
    }
    if (i.minLength !== null && n.data.length < i.minLength.value && (V(n, {
      code: O.too_small,
      minimum: i.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.minLength.message
    }), r.dirty()), i.maxLength !== null && n.data.length > i.maxLength.value && (V(n, {
      code: O.too_big,
      maximum: i.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.maxLength.message
    }), r.dirty()), n.common.async)
      return Promise.all([...n.data].map((s, a) => i.type._parseAsync(new Xt(n, s, n.path, a)))).then((s) => ot.mergeArray(r, s));
    const o = [...n.data].map((s, a) => i.type._parseSync(new Xt(n, s, n.path, a)));
    return ot.mergeArray(r, o);
  }
  get element() {
    return this._def.type;
  }
  min(t, n) {
    return new Yt({
      ...this._def,
      minLength: { value: t, message: Z.toString(n) }
    });
  }
  max(t, n) {
    return new Yt({
      ...this._def,
      maxLength: { value: t, message: Z.toString(n) }
    });
  }
  length(t, n) {
    return new Yt({
      ...this._def,
      exactLength: { value: t, message: Z.toString(n) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
Yt.create = (e, t) => new Yt({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: G.ZodArray,
  ...ee(t)
});
function br(e) {
  if (e instanceof Ne) {
    const t = {};
    for (const n in e.shape) {
      const r = e.shape[n];
      t[n] = fn.create(br(r));
    }
    return new Ne({
      ...e._def,
      shape: () => t
    });
  } else return e instanceof Yt ? new Yt({
    ...e._def,
    type: br(e.element)
  }) : e instanceof fn ? fn.create(br(e.unwrap())) : e instanceof pr ? pr.create(br(e.unwrap())) : e instanceof yn ? yn.create(e.items.map((t) => br(t))) : e;
}
class Ne extends ie {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), n = ce.objectKeys(t);
    return this._cached = { shape: t, keys: n };
  }
  _parse(t) {
    if (this._getType(t) !== B.object) {
      const u = this._getOrReturnCtx(t);
      return V(u, {
        code: O.invalid_type,
        expected: B.object,
        received: u.parsedType
      }), Y;
    }
    const { status: r, ctx: i } = this._processInputParams(t), { shape: o, keys: s } = this._getCached(), a = [];
    if (!(this._def.catchall instanceof Bn && this._def.unknownKeys === "strip"))
      for (const u in i.data)
        s.includes(u) || a.push(u);
    const l = [];
    for (const u of s) {
      const c = o[u], p = i.data[u];
      l.push({
        key: { status: "valid", value: u },
        value: c._parse(new Xt(i, p, i.path, u)),
        alwaysSet: u in i.data
      });
    }
    if (this._def.catchall instanceof Bn) {
      const u = this._def.unknownKeys;
      if (u === "passthrough")
        for (const c of a)
          l.push({
            key: { status: "valid", value: c },
            value: { status: "valid", value: i.data[c] }
          });
      else if (u === "strict")
        a.length > 0 && (V(i, {
          code: O.unrecognized_keys,
          keys: a
        }), r.dirty());
      else if (u !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const u = this._def.catchall;
      for (const c of a) {
        const p = i.data[c];
        l.push({
          key: { status: "valid", value: c },
          value: u._parse(
            new Xt(i, p, i.path, c)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: c in i.data
        });
      }
    }
    return i.common.async ? Promise.resolve().then(async () => {
      const u = [];
      for (const c of l) {
        const p = await c.key, h = await c.value;
        u.push({
          key: p,
          value: h,
          alwaysSet: c.alwaysSet
        });
      }
      return u;
    }).then((u) => ot.mergeObjectSync(r, u)) : ot.mergeObjectSync(r, l);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return Z.errToObj, new Ne({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (n, r) => {
          var i, o, s, a;
          const l = (s = (o = (i = this._def).errorMap) === null || o === void 0 ? void 0 : o.call(i, n, r).message) !== null && s !== void 0 ? s : r.defaultError;
          return n.code === "unrecognized_keys" ? {
            message: (a = Z.errToObj(t).message) !== null && a !== void 0 ? a : l
          } : {
            message: l
          };
        }
      } : {}
    });
  }
  strip() {
    return new Ne({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new Ne({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new Ne({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new Ne({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: G.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, n) {
    return this.augment({ [t]: n });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new Ne({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const n = {};
    return ce.objectKeys(t).forEach((r) => {
      t[r] && this.shape[r] && (n[r] = this.shape[r]);
    }), new Ne({
      ...this._def,
      shape: () => n
    });
  }
  omit(t) {
    const n = {};
    return ce.objectKeys(this.shape).forEach((r) => {
      t[r] || (n[r] = this.shape[r]);
    }), new Ne({
      ...this._def,
      shape: () => n
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return br(this);
  }
  partial(t) {
    const n = {};
    return ce.objectKeys(this.shape).forEach((r) => {
      const i = this.shape[r];
      t && !t[r] ? n[r] = i : n[r] = i.optional();
    }), new Ne({
      ...this._def,
      shape: () => n
    });
  }
  required(t) {
    const n = {};
    return ce.objectKeys(this.shape).forEach((r) => {
      if (t && !t[r])
        n[r] = this.shape[r];
      else {
        let o = this.shape[r];
        for (; o instanceof fn; )
          o = o._def.innerType;
        n[r] = o;
      }
    }), new Ne({
      ...this._def,
      shape: () => n
    });
  }
  keyof() {
    return Am(ce.objectKeys(this.shape));
  }
}
Ne.create = (e, t) => new Ne({
  shape: () => e,
  unknownKeys: "strip",
  catchall: Bn.create(),
  typeName: G.ZodObject,
  ...ee(t)
});
Ne.strictCreate = (e, t) => new Ne({
  shape: () => e,
  unknownKeys: "strict",
  catchall: Bn.create(),
  typeName: G.ZodObject,
  ...ee(t)
});
Ne.lazycreate = (e, t) => new Ne({
  shape: e,
  unknownKeys: "strip",
  catchall: Bn.create(),
  typeName: G.ZodObject,
  ...ee(t)
});
class Fs extends ie {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), r = this._def.options;
    function i(o) {
      for (const a of o)
        if (a.result.status === "valid")
          return a.result;
      for (const a of o)
        if (a.result.status === "dirty")
          return n.common.issues.push(...a.ctx.common.issues), a.result;
      const s = o.map((a) => new It(a.ctx.common.issues));
      return V(n, {
        code: O.invalid_union,
        unionErrors: s
      }), Y;
    }
    if (n.common.async)
      return Promise.all(r.map(async (o) => {
        const s = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await o._parseAsync({
            data: n.data,
            path: n.path,
            parent: s
          }),
          ctx: s
        };
      })).then(i);
    {
      let o;
      const s = [];
      for (const l of r) {
        const u = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        }, c = l._parseSync({
          data: n.data,
          path: n.path,
          parent: u
        });
        if (c.status === "valid")
          return c;
        c.status === "dirty" && !o && (o = { result: c, ctx: u }), u.common.issues.length && s.push(u.common.issues);
      }
      if (o)
        return n.common.issues.push(...o.ctx.common.issues), o.result;
      const a = s.map((l) => new It(l));
      return V(n, {
        code: O.invalid_union,
        unionErrors: a
      }), Y;
    }
  }
  get options() {
    return this._def.options;
  }
}
Fs.create = (e, t) => new Fs({
  options: e,
  typeName: G.ZodUnion,
  ...ee(t)
});
const rn = (e) => e instanceof Ms ? rn(e.schema) : e instanceof vn ? rn(e.innerType()) : e instanceof Us ? [e.value] : e instanceof fr ? e.options : e instanceof Vs ? ce.objectValues(e.enum) : e instanceof $s ? rn(e._def.innerType) : e instanceof js ? [void 0] : e instanceof Ls ? [null] : e instanceof fn ? [void 0, ...rn(e.unwrap())] : e instanceof pr ? [null, ...rn(e.unwrap())] : e instanceof Om || e instanceof Hs ? rn(e.unwrap()) : e instanceof Bs ? rn(e._def.innerType) : [];
class yc extends ie {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== B.object)
      return V(n, {
        code: O.invalid_type,
        expected: B.object,
        received: n.parsedType
      }), Y;
    const r = this.discriminator, i = n.data[r], o = this.optionsMap.get(i);
    return o ? n.common.async ? o._parseAsync({
      data: n.data,
      path: n.path,
      parent: n
    }) : o._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }) : (V(n, {
      code: O.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [r]
    }), Y);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(t, n, r) {
    const i = /* @__PURE__ */ new Map();
    for (const o of n) {
      const s = rn(o.shape[t]);
      if (!s.length)
        throw new Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      for (const a of s) {
        if (i.has(a))
          throw new Error(`Discriminator property ${String(t)} has duplicate value ${String(a)}`);
        i.set(a, o);
      }
    }
    return new yc({
      typeName: G.ZodDiscriminatedUnion,
      discriminator: t,
      options: n,
      optionsMap: i,
      ...ee(r)
    });
  }
}
function cu(e, t) {
  const n = Tn(e), r = Tn(t);
  if (e === t)
    return { valid: !0, data: e };
  if (n === B.object && r === B.object) {
    const i = ce.objectKeys(t), o = ce.objectKeys(e).filter((a) => i.indexOf(a) !== -1), s = { ...e, ...t };
    for (const a of o) {
      const l = cu(e[a], t[a]);
      if (!l.valid)
        return { valid: !1 };
      s[a] = l.data;
    }
    return { valid: !0, data: s };
  } else if (n === B.array && r === B.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const i = [];
    for (let o = 0; o < e.length; o++) {
      const s = e[o], a = t[o], l = cu(s, a);
      if (!l.valid)
        return { valid: !1 };
      i.push(l.data);
    }
    return { valid: !0, data: i };
  } else return n === B.date && r === B.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class Ds extends ie {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t), i = (o, s) => {
      if (sf(o) || sf(s))
        return Y;
      const a = cu(o.value, s.value);
      return a.valid ? ((af(o) || af(s)) && n.dirty(), { status: n.value, value: a.data }) : (V(r, {
        code: O.invalid_intersection_types
      }), Y);
    };
    return r.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      }),
      this._def.right._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      })
    ]).then(([o, s]) => i(o, s)) : i(this._def.left._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }), this._def.right._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }));
  }
}
Ds.create = (e, t, n) => new Ds({
  left: e,
  right: t,
  typeName: G.ZodIntersection,
  ...ee(n)
});
class yn extends ie {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== B.array)
      return V(r, {
        code: O.invalid_type,
        expected: B.array,
        received: r.parsedType
      }), Y;
    if (r.data.length < this._def.items.length)
      return V(r, {
        code: O.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), Y;
    !this._def.rest && r.data.length > this._def.items.length && (V(r, {
      code: O.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), n.dirty());
    const o = [...r.data].map((s, a) => {
      const l = this._def.items[a] || this._def.rest;
      return l ? l._parse(new Xt(r, s, r.path, a)) : null;
    }).filter((s) => !!s);
    return r.common.async ? Promise.all(o).then((s) => ot.mergeArray(n, s)) : ot.mergeArray(n, o);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new yn({
      ...this._def,
      rest: t
    });
  }
}
yn.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new yn({
    items: e,
    typeName: G.ZodTuple,
    rest: null,
    ...ee(t)
  });
};
class zs extends ie {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== B.object)
      return V(r, {
        code: O.invalid_type,
        expected: B.object,
        received: r.parsedType
      }), Y;
    const i = [], o = this._def.keyType, s = this._def.valueType;
    for (const a in r.data)
      i.push({
        key: o._parse(new Xt(r, a, r.path, a)),
        value: s._parse(new Xt(r, r.data[a], r.path, a)),
        alwaysSet: a in r.data
      });
    return r.common.async ? ot.mergeObjectAsync(n, i) : ot.mergeObjectSync(n, i);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, n, r) {
    return n instanceof ie ? new zs({
      keyType: t,
      valueType: n,
      typeName: G.ZodRecord,
      ...ee(r)
    }) : new zs({
      keyType: cn.create(),
      valueType: t,
      typeName: G.ZodRecord,
      ...ee(n)
    });
  }
}
class du extends ie {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== B.map)
      return V(r, {
        code: O.invalid_type,
        expected: B.map,
        received: r.parsedType
      }), Y;
    const i = this._def.keyType, o = this._def.valueType, s = [...r.data.entries()].map(([a, l], u) => ({
      key: i._parse(new Xt(r, a, r.path, [u, "key"])),
      value: o._parse(new Xt(r, l, r.path, [u, "value"]))
    }));
    if (r.common.async) {
      const a = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of s) {
          const u = await l.key, c = await l.value;
          if (u.status === "aborted" || c.status === "aborted")
            return Y;
          (u.status === "dirty" || c.status === "dirty") && n.dirty(), a.set(u.value, c.value);
        }
        return { status: n.value, value: a };
      });
    } else {
      const a = /* @__PURE__ */ new Map();
      for (const l of s) {
        const u = l.key, c = l.value;
        if (u.status === "aborted" || c.status === "aborted")
          return Y;
        (u.status === "dirty" || c.status === "dirty") && n.dirty(), a.set(u.value, c.value);
      }
      return { status: n.value, value: a };
    }
  }
}
du.create = (e, t, n) => new du({
  valueType: t,
  keyType: e,
  typeName: G.ZodMap,
  ...ee(n)
});
class Yr extends ie {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== B.set)
      return V(r, {
        code: O.invalid_type,
        expected: B.set,
        received: r.parsedType
      }), Y;
    const i = this._def;
    i.minSize !== null && r.data.size < i.minSize.value && (V(r, {
      code: O.too_small,
      minimum: i.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.minSize.message
    }), n.dirty()), i.maxSize !== null && r.data.size > i.maxSize.value && (V(r, {
      code: O.too_big,
      maximum: i.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.maxSize.message
    }), n.dirty());
    const o = this._def.valueType;
    function s(l) {
      const u = /* @__PURE__ */ new Set();
      for (const c of l) {
        if (c.status === "aborted")
          return Y;
        c.status === "dirty" && n.dirty(), u.add(c.value);
      }
      return { status: n.value, value: u };
    }
    const a = [...r.data.values()].map((l, u) => o._parse(new Xt(r, l, r.path, u)));
    return r.common.async ? Promise.all(a).then((l) => s(l)) : s(a);
  }
  min(t, n) {
    return new Yr({
      ...this._def,
      minSize: { value: t, message: Z.toString(n) }
    });
  }
  max(t, n) {
    return new Yr({
      ...this._def,
      maxSize: { value: t, message: Z.toString(n) }
    });
  }
  size(t, n) {
    return this.min(t, n).max(t, n);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
Yr.create = (e, t) => new Yr({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: G.ZodSet,
  ...ee(t)
});
class Vi extends ie {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== B.function)
      return V(n, {
        code: O.invalid_type,
        expected: B.function,
        received: n.parsedType
      }), Y;
    function r(a, l) {
      return ou({
        data: a,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          iu(),
          so
        ].filter((u) => !!u),
        issueData: {
          code: O.invalid_arguments,
          argumentsError: l
        }
      });
    }
    function i(a, l) {
      return ou({
        data: a,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          iu(),
          so
        ].filter((u) => !!u),
        issueData: {
          code: O.invalid_return_type,
          returnTypeError: l
        }
      });
    }
    const o = { errorMap: n.common.contextualErrorMap }, s = n.data;
    if (this._def.returns instanceof lo) {
      const a = this;
      return ht(async function(...l) {
        const u = new It([]), c = await a._def.args.parseAsync(l, o).catch((x) => {
          throw u.addIssue(r(l, x)), u;
        }), p = await Reflect.apply(s, this, c);
        return await a._def.returns._def.type.parseAsync(p, o).catch((x) => {
          throw u.addIssue(i(p, x)), u;
        });
      });
    } else {
      const a = this;
      return ht(function(...l) {
        const u = a._def.args.safeParse(l, o);
        if (!u.success)
          throw new It([r(l, u.error)]);
        const c = Reflect.apply(s, this, u.data), p = a._def.returns.safeParse(c, o);
        if (!p.success)
          throw new It([i(c, p.error)]);
        return p.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...t) {
    return new Vi({
      ...this._def,
      args: yn.create(t).rest(Vr.create())
    });
  }
  returns(t) {
    return new Vi({
      ...this._def,
      returns: t
    });
  }
  implement(t) {
    return this.parse(t);
  }
  strictImplement(t) {
    return this.parse(t);
  }
  static create(t, n, r) {
    return new Vi({
      args: t || yn.create([]).rest(Vr.create()),
      returns: n || Vr.create(),
      typeName: G.ZodFunction,
      ...ee(r)
    });
  }
}
class Ms extends ie {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
}
Ms.create = (e, t) => new Ms({
  getter: e,
  typeName: G.ZodLazy,
  ...ee(t)
});
class Us extends ie {
  _parse(t) {
    if (t.data !== this._def.value) {
      const n = this._getOrReturnCtx(t);
      return V(n, {
        received: n.data,
        code: O.invalid_literal,
        expected: this._def.value
      }), Y;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
Us.create = (e, t) => new Us({
  value: e,
  typeName: G.ZodLiteral,
  ...ee(t)
});
function Am(e, t) {
  return new fr({
    values: e,
    typeName: G.ZodEnum,
    ...ee(t)
  });
}
class fr extends ie {
  constructor() {
    super(...arguments), Ei.set(this, void 0);
  }
  _parse(t) {
    if (typeof t.data != "string") {
      const n = this._getOrReturnCtx(t), r = this._def.values;
      return V(n, {
        expected: ce.joinValues(r),
        received: n.parsedType,
        code: O.invalid_type
      }), Y;
    }
    if (Ps(this, Ei) || Tm(this, Ei, new Set(this._def.values)), !Ps(this, Ei).has(t.data)) {
      const n = this._getOrReturnCtx(t), r = this._def.values;
      return V(n, {
        received: n.data,
        code: O.invalid_enum_value,
        options: r
      }), Y;
    }
    return ht(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  get Values() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  get Enum() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  extract(t, n = this._def) {
    return fr.create(t, {
      ...this._def,
      ...n
    });
  }
  exclude(t, n = this._def) {
    return fr.create(this.options.filter((r) => !t.includes(r)), {
      ...this._def,
      ...n
    });
  }
}
Ei = /* @__PURE__ */ new WeakMap();
fr.create = Am;
class Vs extends ie {
  constructor() {
    super(...arguments), Ci.set(this, void 0);
  }
  _parse(t) {
    const n = ce.getValidEnumValues(this._def.values), r = this._getOrReturnCtx(t);
    if (r.parsedType !== B.string && r.parsedType !== B.number) {
      const i = ce.objectValues(n);
      return V(r, {
        expected: ce.joinValues(i),
        received: r.parsedType,
        code: O.invalid_type
      }), Y;
    }
    if (Ps(this, Ci) || Tm(this, Ci, new Set(ce.getValidEnumValues(this._def.values))), !Ps(this, Ci).has(t.data)) {
      const i = ce.objectValues(n);
      return V(r, {
        received: r.data,
        code: O.invalid_enum_value,
        options: i
      }), Y;
    }
    return ht(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
Ci = /* @__PURE__ */ new WeakMap();
Vs.create = (e, t) => new Vs({
  values: e,
  typeName: G.ZodNativeEnum,
  ...ee(t)
});
class lo extends ie {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== B.promise && n.common.async === !1)
      return V(n, {
        code: O.invalid_type,
        expected: B.promise,
        received: n.parsedType
      }), Y;
    const r = n.parsedType === B.promise ? n.data : Promise.resolve(n.data);
    return ht(r.then((i) => this._def.type.parseAsync(i, {
      path: n.path,
      errorMap: n.common.contextualErrorMap
    })));
  }
}
lo.create = (e, t) => new lo({
  type: e,
  typeName: G.ZodPromise,
  ...ee(t)
});
class vn extends ie {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === G.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t), i = this._def.effect || null, o = {
      addIssue: (s) => {
        V(r, s), s.fatal ? n.abort() : n.dirty();
      },
      get path() {
        return r.path;
      }
    };
    if (o.addIssue = o.addIssue.bind(o), i.type === "preprocess") {
      const s = i.transform(r.data, o);
      if (r.common.async)
        return Promise.resolve(s).then(async (a) => {
          if (n.value === "aborted")
            return Y;
          const l = await this._def.schema._parseAsync({
            data: a,
            path: r.path,
            parent: r
          });
          return l.status === "aborted" ? Y : l.status === "dirty" || n.value === "dirty" ? Si(l.value) : l;
        });
      {
        if (n.value === "aborted")
          return Y;
        const a = this._def.schema._parseSync({
          data: s,
          path: r.path,
          parent: r
        });
        return a.status === "aborted" ? Y : a.status === "dirty" || n.value === "dirty" ? Si(a.value) : a;
      }
    }
    if (i.type === "refinement") {
      const s = (a) => {
        const l = i.refinement(a, o);
        if (r.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return a;
      };
      if (r.common.async === !1) {
        const a = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return a.status === "aborted" ? Y : (a.status === "dirty" && n.dirty(), s(a.value), { status: n.value, value: a.value });
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((a) => a.status === "aborted" ? Y : (a.status === "dirty" && n.dirty(), s(a.value).then(() => ({ status: n.value, value: a.value }))));
    }
    if (i.type === "transform")
      if (r.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        if (!Jr(s))
          return s;
        const a = i.transform(s.value, o);
        if (a instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: a };
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((s) => Jr(s) ? Promise.resolve(i.transform(s.value, o)).then((a) => ({ status: n.value, value: a })) : s);
    ce.assertNever(i);
  }
}
vn.create = (e, t, n) => new vn({
  schema: e,
  typeName: G.ZodEffects,
  effect: t,
  ...ee(n)
});
vn.createWithPreprocess = (e, t, n) => new vn({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: G.ZodEffects,
  ...ee(n)
});
class fn extends ie {
  _parse(t) {
    return this._getType(t) === B.undefined ? ht(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
fn.create = (e, t) => new fn({
  innerType: e,
  typeName: G.ZodOptional,
  ...ee(t)
});
class pr extends ie {
  _parse(t) {
    return this._getType(t) === B.null ? ht(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
pr.create = (e, t) => new pr({
  innerType: e,
  typeName: G.ZodNullable,
  ...ee(t)
});
class $s extends ie {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    let r = n.data;
    return n.parsedType === B.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
$s.create = (e, t) => new $s({
  innerType: e,
  typeName: G.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...ee(t)
});
class Bs extends ie {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), r = {
      ...n,
      common: {
        ...n.common,
        issues: []
      }
    }, i = this._def.innerType._parse({
      data: r.data,
      path: r.path,
      parent: {
        ...r
      }
    });
    return Os(i) ? i.then((o) => ({
      status: "valid",
      value: o.status === "valid" ? o.value : this._def.catchValue({
        get error() {
          return new It(r.common.issues);
        },
        input: r.data
      })
    })) : {
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new It(r.common.issues);
        },
        input: r.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Bs.create = (e, t) => new Bs({
  innerType: e,
  typeName: G.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...ee(t)
});
class fu extends ie {
  _parse(t) {
    if (this._getType(t) !== B.nan) {
      const r = this._getOrReturnCtx(t);
      return V(r, {
        code: O.invalid_type,
        expected: B.nan,
        received: r.parsedType
      }), Y;
    }
    return { status: "valid", value: t.data };
  }
}
fu.create = (e) => new fu({
  typeName: G.ZodNaN,
  ...ee(e)
});
class Om extends ie {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), r = n.data;
    return this._def.type._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class wa extends ie {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.common.async)
      return (async () => {
        const o = await this._def.in._parseAsync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return o.status === "aborted" ? Y : o.status === "dirty" ? (n.dirty(), Si(o.value)) : this._def.out._parseAsync({
          data: o.value,
          path: r.path,
          parent: r
        });
      })();
    {
      const i = this._def.in._parseSync({
        data: r.data,
        path: r.path,
        parent: r
      });
      return i.status === "aborted" ? Y : i.status === "dirty" ? (n.dirty(), {
        status: "dirty",
        value: i.value
      }) : this._def.out._parseSync({
        data: i.value,
        path: r.path,
        parent: r
      });
    }
  }
  static create(t, n) {
    return new wa({
      in: t,
      out: n,
      typeName: G.ZodPipeline
    });
  }
}
class Hs extends ie {
  _parse(t) {
    const n = this._def.innerType._parse(t), r = (i) => (Jr(i) && (i.value = Object.freeze(i.value)), i);
    return Os(n) ? n.then((i) => r(i)) : r(n);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Hs.create = (e, t) => new Hs({
  innerType: e,
  typeName: G.ZodReadonly,
  ...ee(t)
});
Ne.lazycreate;
var G;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(G || (G = {}));
const or = cn.create;
Kr.create;
fu.create;
Gr.create;
su.create;
ao.create;
au.create;
js.create;
Ls.create;
lu.create;
Vr.create;
Bn.create;
uu.create;
Yt.create;
const wo = Ne.create;
Ne.strictCreate;
Fs.create;
yc.create;
Ds.create;
yn.create;
zs.create;
du.create;
Yr.create;
Vi.create;
Ms.create;
Us.create;
fr.create;
Vs.create;
lo.create;
vn.create;
fn.create;
pr.create;
vn.createWithPreprocess;
wa.create;
const $x = wo({
  issue: or().min(25, "Please provide a more detailed description of your legal issue (minimum 25 characters)")
}), Bx = wo({
  answer_0: or().min(1, "Please provide an answer")
}), Hx = (e) => {
  const t = {};
  return e.forEach((n, r) => {
    t[`answer_${r}`] = or().min(1, "Please provide an answer");
  }), wo(t);
}, Wx = wo({
  location: or().min(1, "Please specify where you need an attorney")
}), Zx = wo({
  fullName: or().min(1, "Full name is required"),
  email: or().email("Invalid email address"),
  phoneNumber: or().min(1, "Phone number is required").refine(
    (e) => e.replace(/\D/g, "").length === 10,
    {
      message: "Phone number must be 10 digits"
    }
  )
}), Qx = () => {
  const {
    setFormState: t,
    setSubmissionId: n,
    setClassifiedDivision: r,
    setChainOfThought: i,
    setSummary: o,
    setIssue: s,
    setDivisionResolutionLog: a,
    setClarifyingQuestions: l,
    setUaDivisionId: u,
    setLanguageCode: c,
    questionRounds: p,
    setQuestionRounds: h,
    setMessages: x,
    onUpdateClassificationData: v,
    events: w
    // Get events from context
  } = en(), _ = ca({
    resolver: va($x),
    defaultValues: {
      issue: ""
    },
    mode: "onTouched",
    // Only validate on blur/focus and submit, not onChange
    reValidateMode: "onBlur"
    // Only re-validate on blur, not while typing
  }), m = (b) => {
    const f = b.target.value;
    _.setValue("issue", f, { shouldValidate: !1 }), w.onIssueTextUpdated && w.onIssueTextUpdated(f);
  }, d = Cm(
    void 0,
    {
      onSuccess: (b) => {
        var A, N, R;
        const f = "data" in b ? b.data : b;
        if (f.submission_id && n(typeof f.submission_id == "string" ? parseInt(f.submission_id, 10) : f.submission_id), x((j) => j.filter((T) => T.type !== "loading")), c(f.language_code ?? null), f.division && !((A = f.clarifying_questions) != null && A.length) && f.division.toLowerCase() === "unserviceable") {
          r(f.division ?? null), i(f.chain_of_thought ?? null), o(f.summary ?? null), s(f.issue ?? null);
          const j = Array.isArray(f.division_resolution_log) ? f.division_resolution_log.map((T) => typeof T == "string" ? { question: T, answer: "" } : T) : Object.entries(f.division_resolution_log || {}).map(([T, U]) => ({
            question: T,
            answer: U || ""
          }));
          a(j), u(typeof f.ua_division_id == "string" ? parseInt(f.ua_division_id, 10) : f.ua_division_id ?? null), x((T) => [...T, {
            type: "system",
            content: "It doesn't look like this is something we can assist with. Please feel free to contact us again in the future for any legal matters."
          }]), t("completed"), v({
            submissionId: typeof f.submission_id == "string" ? parseInt(f.submission_id, 10) : f.submission_id ?? null,
            classifiedDivision: f.division ?? null,
            chainOfThought: f.chain_of_thought ?? null,
            summary: f.summary ?? null,
            issue: f.issue ?? null,
            divisionResolutionLog: j,
            uaDivisionId: typeof f.ua_division_id == "string" ? parseInt(f.ua_division_id, 10) : f.ua_division_id ?? null,
            languageCode: f.language_code ?? null
          });
        } else if (f.division && !((N = f.clarifying_questions) != null && N.length)) {
          r(f.division ?? null), i(f.chain_of_thought ?? null), o(f.summary ?? null), s(f.issue ?? null);
          const j = Array.isArray(f.division_resolution_log) ? f.division_resolution_log.map((T) => typeof T == "string" ? { question: T, answer: "" } : T) : Object.entries(f.division_resolution_log || {}).map(([T, U]) => ({
            question: T,
            answer: U || ""
          }));
          a(j), u(typeof f.ua_division_id == "string" ? parseInt(f.ua_division_id, 10) : f.ua_division_id ?? null), t("jurisdiction"), x((T) => [...T, {
            type: "system",
            content: "Thank you for providing this information."
          }]), v({
            submissionId: typeof f.submission_id == "string" ? parseInt(f.submission_id, 10) : f.submission_id ?? null,
            classifiedDivision: f.division,
            chainOfThought: f.chain_of_thought ?? null,
            summary: f.summary ?? null,
            issue: f.issue ?? null,
            divisionResolutionLog: j,
            uaDivisionId: typeof f.ua_division_id == "string" ? parseInt(f.ua_division_id, 10) : f.ua_division_id,
            languageCode: f.language_code ?? null
          });
        } else if ((R = f.clarifying_questions) != null && R.length)
          if (p >= 5) {
            t("classified"), i(f.chain_of_thought ?? null), o(f.summary ?? null), s(f.issue ?? null);
            const j = Array.isArray(f.division_resolution_log) ? f.division_resolution_log.map((T) => typeof T == "string" ? { question: T, answer: "" } : T) : Object.entries(f.division_resolution_log || {}).map(([T, U]) => ({
              question: T,
              answer: U || ""
            }));
            a(j), v({
              submissionId: typeof f.submission_id == "string" ? parseInt(f.submission_id, 10) : f.submission_id ?? null,
              classifiedDivision: f.division ?? null,
              chainOfThought: f.chain_of_thought ?? null,
              summary: f.summary ?? null,
              issue: f.issue ?? null,
              divisionResolutionLog: j,
              uaDivisionId: typeof f.ua_division_id == "string" ? parseInt(f.ua_division_id, 10) : f.ua_division_id,
              languageCode: f.language_code ?? null
            });
          } else {
            f.clarifying_questions.length > 0 && x((U) => {
              var z;
              return [...U, {
                type: "system",
                content: ((z = f.clarifying_questions) == null ? void 0 : z[0]) ?? "Additional information needed"
              }];
            });
            const j = Array.isArray(f.clarifying_questions) ? f.clarifying_questions : [f.clarifying_questions], T = Array.isArray(f.division_resolution_log) ? f.division_resolution_log.map((U) => typeof U == "string" ? { question: U, answer: "" } : U) : Object.entries(f.division_resolution_log || {}).map(([U, z]) => ({
              question: U,
              answer: z || ""
            }));
            l(j), i(f.chain_of_thought ?? null), t("clarifying_questions"), o(f.summary ?? null), s(f.issue ?? null), a(T), u(typeof f.ua_division_id == "string" ? parseInt(f.ua_division_id, 10) : f.ua_division_id ?? null), h(p + 1), v({
              submissionId: typeof f.submission_id == "string" ? parseInt(f.submission_id, 10) : f.submission_id ?? null,
              issue: f.issue ?? null,
              uaDivisionId: typeof f.ua_division_id == "string" ? parseInt(f.ua_division_id, 10) : f.ua_division_id,
              languageCode: f.language_code ?? null
            });
          }
      },
      onError: (b) => {
        x((f) => f.filter((A) => A.type !== "loading"));
      }
    }
  );
  return {
    issueForm: _,
    onIssueSubmit: (b) => {
      w.onIssueSubmitted && w.onIssueSubmitted(b.issue), x((A) => [
        ...A,
        { type: "user", content: b.issue },
        { type: "loading", content: "" }
      ]), _.reset({ issue: "" });
      const f = {
        issue: b.issue,
        test_mode: !0
      };
      d.mutate({
        body: f
      });
    },
    handleIssueChange: m,
    isPending: d.isPending
  };
}, qx = () => {
  const { issueForm: e, onIssueSubmit: t, handleIssueChange: n, isPending: r } = Qx(), { events: i } = en(), o = S.useRef(!1), s = S.useRef(!1), a = S.useRef(null);
  S.useEffect(() => {
    setTimeout(() => {
      const h = document.getElementById("issue-input");
      h instanceof HTMLInputElement && (h.focus(), o.current = !0);
    }, 0);
  }, []);
  const l = (h) => {
    a.current = h.target;
  }, u = (h) => {
    var x;
    o.current && (h.target !== a.current && !s.current && ((x = i.onLeadClickedIssueInput) == null || x.call(i, !1), s.current = !0), a.current = null);
  }, c = (h) => {
    var x;
    s.current || ((x = i.onLeadClickedIssueInput) == null || x.call(i, !1), s.current = !0);
  }, p = (h, x) => {
    s.current = !1, x();
  };
  return /* @__PURE__ */ I.jsx(fc, { ...e, children: /* @__PURE__ */ I.jsxs("form", { onSubmit: (h) => {
    h.preventDefault(), e.handleSubmit(t)(h);
  }, className: "space-y-2 px-4 my-1", children: [
    /* @__PURE__ */ I.jsxs("div", { className: "relative", children: [
      /* @__PURE__ */ I.jsx(
        zi,
        {
          control: e.control,
          name: "issue",
          render: ({ field: h }) => /* @__PURE__ */ I.jsx(
            rr,
            {
              id: "issue-input",
              placeholder: r ? "Please wait..." : "Describe your legal issue...",
              className: "w-full pr-16 rounded-b-lg border-2 border-gray-200 py-6 focus-visible:ring-2 focus-visible:ring-[#0a6fc2] focus-visible:ring-offset-2 focus-visible:ring-offset-white focus-visible:outline-none bg-white",
              onMouseDown: l,
              onFocus: u,
              onClick: c,
              onChange: n,
              onBlur: (x) => p(x, h.onBlur),
              value: h.value,
              name: h.name,
              ref: h.ref,
              disabled: r,
              autoFocus: !0
            }
          )
        }
      ),
      /* @__PURE__ */ I.jsx(
        go,
        {
          type: "submit",
          className: "absolute right-0 top-0 h-full w-12 rounded-r-lg rounded-l-none p-0 flex items-center justify-center bg-amber-400 hover:bg-amber-500",
          disabled: r,
          children: /* @__PURE__ */ I.jsx(pc, { className: "h-6 w-6", color: "#fff" })
        }
      )
    ] }),
    e.formState.errors.issue && /* @__PURE__ */ I.jsx("p", { className: "text-sm text-red-500", children: e.formState.errors.issue.message })
  ] }) });
}, Jx = () => {
  const [e, t] = S.useState(0), {
    submissionId: n,
    clarifyingQuestions: r,
    setClarifyingSchema: i,
    setMessages: o,
    setFormState: s,
    setClassifiedDivision: a,
    setChainOfThought: l,
    setSummary: u,
    setIssue: c,
    setDivisionResolutionLog: p,
    setUaDivisionId: h,
    onUpdateClassificationData: x,
    setClarifyingQuestions: v,
    questionRounds: w,
    setQuestionRounds: _
  } = en(), m = ca({
    resolver: va(Bx),
    defaultValues: {
      answer_0: ""
    },
    mode: "onChange"
  });
  S.useEffect(() => {
    if (r.length > 0) {
      const b = Hx(r);
      i(b);
      const f = { answer_0: "" };
      r.forEach((A, N) => {
        N > 0 && (f[`answer_${N}`] = "");
      }), m.reset(f, { keepDefaultValues: !0 }), m.clearErrors(), t((A) => A + 1);
    }
  }, [r, i]);
  const d = Cm(
    void 0,
    {
      onSuccess: (b) => {
        var A, N;
        const f = "data" in b ? b.data : b;
        if (o((R) => R.filter((j) => j.type !== "loading")), f.division && !((A = f.clarifying_questions) != null && A.length)) {
          a(f.division ?? null), l(f.chain_of_thought ?? null), u(f.summary ?? null), c(f.issue ?? null);
          const R = Array.isArray(f.division_resolution_log) ? f.division_resolution_log.map((j) => typeof j == "string" ? { question: j, answer: "" } : j) : Object.entries(f.division_resolution_log || {}).map(([j, T]) => ({
            question: j,
            answer: T || ""
          }));
          p(R), h(typeof f.ua_division_id == "string" ? parseInt(f.ua_division_id, 10) : f.ua_division_id ?? null), s("jurisdiction"), o((j) => [...j, {
            type: "system",
            content: "Thank you for providing this information."
          }]), x({
            submissionId: typeof f.submission_id == "string" ? parseInt(f.submission_id, 10) : f.submission_id ?? null,
            classifiedDivision: f.division,
            chainOfThought: f.chain_of_thought ?? null,
            summary: f.summary ?? null,
            issue: f.issue ?? null,
            divisionResolutionLog: R,
            uaDivisionId: typeof f.ua_division_id == "string" ? parseInt(f.ua_division_id, 10) : f.ua_division_id
          });
        } else if ((N = f.clarifying_questions) != null && N.length) {
          const R = Array.isArray(f.clarifying_questions) ? f.clarifying_questions : [f.clarifying_questions];
          R.length > 0 && (o((U) => [...U, {
            type: "system",
            content: R[0] ?? "Additional information needed"
          }]), setTimeout(() => {
            t((U) => U + 1);
          }, 0), setTimeout(() => {
            t((U) => U + 1);
          }, 250));
          const j = Array.isArray(f.division_resolution_log) ? f.division_resolution_log.map((U) => typeof U == "string" ? { question: U, answer: "" } : U) : Object.entries(f.division_resolution_log || {}).map(([U, z]) => ({
            question: U,
            answer: z || ""
          }));
          v(R), l(f.chain_of_thought ?? null), u(f.summary ?? null), c(f.issue ?? null), p(j), h(typeof f.ua_division_id == "string" ? parseInt(f.ua_division_id, 10) : f.ua_division_id ?? null);
          const T = w + 1;
          _(T), T >= 5 ? s("classified") : s("clarifying_questions"), x({
            submissionId: typeof f.submission_id == "string" ? parseInt(f.submission_id, 10) : f.submission_id ?? null,
            issue: f.issue ?? null,
            uaDivisionId: typeof f.ua_division_id == "string" ? parseInt(f.ua_division_id, 10) : f.ua_division_id
          }), t((U) => U + 1);
        }
      },
      onError: (b) => {
        o((f) => f.filter((A) => A.type !== "loading"));
      }
    }
  );
  return {
    clarifyingForm: m,
    onClarifyingSubmit: (b) => {
      if (!n)
        return;
      const f = m.getValues(), A = f.answer_0 || "";
      if (!A.trim())
        return;
      o((j) => [
        ...j,
        { type: "user", content: A },
        { type: "loading", content: "" }
      ]);
      const N = r.map((j, T) => {
        const U = `answer_${T}`;
        return {
          question: j,
          answer: T === 0 ? A : f[U] || ""
        };
      }), R = {
        submission_id: n,
        answers: N
      };
      d.mutate({
        body: R
      }), m.reset({ ...f, answer_0: "" }, { keepDefaultValues: !0 });
    },
    isPending: d.isPending,
    shouldFocusInput: e
  };
}, Kx = () => {
  const { clarifyingForm: e, onClarifyingSubmit: t, isPending: n, shouldFocusInput: r } = Jx(), { messages: i, scrollToBottom: o } = en(), s = S.useRef(null), [a, l] = S.useState(0), u = S.useCallback(() => {
    if (s.current)
      return s.current.focus(), !0;
    const c = document.getElementById("clarifying-input");
    return c instanceof HTMLInputElement ? (c.focus(), !0) : (a < 5 && (l((p) => p + 1), setTimeout(() => u(), 100)), !1);
  }, [a]);
  return S.useEffect(() => {
    n || (l(0), setTimeout(() => {
      u(), o && o();
    }, 100));
  }, [i, n, r, u, o]), S.useEffect(() => {
    a > 0 && u();
  }, [a, u]), /* @__PURE__ */ I.jsx(fc, { ...e, children: /* @__PURE__ */ I.jsx("form", { onSubmit: e.handleSubmit(t), className: "space-y-2 px-4 my-1", children: /* @__PURE__ */ I.jsxs("div", { className: "relative", children: [
    /* @__PURE__ */ I.jsx(
      zi,
      {
        control: e.control,
        name: "answer_0",
        render: ({ field: c }) => /* @__PURE__ */ I.jsxs(Mi, { children: [
          /* @__PURE__ */ I.jsx(
            rr,
            {
              id: "clarifying-input",
              placeholder: n ? "Please wait..." : "Your answer...",
              className: "w-full pr-16 rounded-lg border-2 border-gray-200 py-6 focus-visible:ring-2 focus-visible:ring-[#0a6fc2] focus-visible:ring-offset-2 focus-visible:ring-offset-white focus-visible:outline-none bg-white",
              ...c,
              ref: s,
              disabled: n,
              autoFocus: !0
            }
          ),
          /* @__PURE__ */ I.jsx(Ui, {})
        ] })
      }
    ),
    /* @__PURE__ */ I.jsx(
      go,
      {
        type: "submit",
        className: "absolute right-0 top-0 h-full w-12 rounded-r-lg rounded-l-none p-0 flex items-center justify-center bg-amber-400 hover:bg-amber-500",
        disabled: n,
        children: /* @__PURE__ */ I.jsx(pc, { className: "h-6 w-6", color: "#fff" })
      }
    )
  ] }) }) });
};
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gx = aa("Circle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
function Yx(e, t) {
  const [n, r] = S.useState(e);
  return S.useEffect(() => {
    const i = setTimeout(() => {
      r(e);
    }, t);
    return () => {
      clearTimeout(i);
    };
  }, [e, t]), n;
}
const Xx = () => {
  var Qe, Et;
  const {
    formState: e,
    submissionId: t,
    setFormState: n,
    searchQuery: r,
    setSearchQuery: i,
    locationInputValue: o,
    setLocationInputValue: s,
    locationError: a,
    setLocationError: l,
    selectedLocation: u,
    setSelectedLocation: c,
    selectedLocationIndex: p,
    setSelectedLocationIndex: h,
    setShouldRenderLocationInput: x,
    setMessages: v,
    classifiedDivision: w,
    setJurisdictionRegion: _,
    setJurisdictionState: m,
    setJurisdictionUaRegionId: d,
    editingJurisdiction: y,
    setJurisdictionQuestionDisplayed: b,
    setIsDropdownOpen: f,
    onUpdateClassificationData: A,
    setShouldRenderContactForm: N,
    setShowContactForm: R,
    events: j
  } = en(), T = S.useRef(null), [U, z] = S.useState(!1), K = ca({
    resolver: va(Wx),
    defaultValues: {
      location: ""
    },
    mode: "onTouched",
    reValidateMode: "onBlur"
  }), ne = Yx(r, 300), le = fx(
    {
      query: {
        submission_id: t || 0
      }
    },
    void 0,
    {
      enabled: e === "jurisdiction" && t !== null,
      refetchOnWindowFocus: !1
    }
  );
  S.useEffect(() => {
    e === "jurisdiction" ? (x(!0), setTimeout(() => {
      if (T.current)
        T.current.focus();
      else {
        const q = document.getElementById("jurisdiction-input");
        q instanceof HTMLInputElement && q.focus();
      }
      jt && jt();
    }, 100)) : x(!1);
  }, [e]), S.useEffect(() => {
    e === "jurisdiction" && t && !y && le.refetch();
  }, [e, t]), S.useEffect(() => {
    var se;
    const q = (se = le.data) == null ? void 0 : se.question;
    !le.isLoading && e === "jurisdiction" && q && !y && (v((ge) => [...ge.filter((Re) => Re.type !== "loading"), {
      type: "system",
      content: q
    }]), b(!0), setTimeout(() => {
      if (T.current)
        T.current.focus();
      else {
        const ge = document.getElementById("jurisdiction-input");
        ge instanceof HTMLInputElement && ge.focus();
      }
    }, 50));
  }, [le.data, le.isLoading, e]), S.useEffect(() => {
    e !== "jurisdiction" && b(!1);
  }, [e]), S.useEffect(() => {
    le.isLoading && e === "jurisdiction" && t && !y && v((q) => [...q, { type: "loading", content: "" }]);
  }, [le.isLoading, e, t]), S.useEffect(() => {
    le.error;
  }, [le.error, e]);
  const fe = hx(
    {
      query: {
        q: ne
      }
    },
    void 0,
    {
      // Enable the search when:
      // - We have a search query with at least 3 characters
      // - OR we don't have a search query but we're in jurisdiction state and haven't loaded nearby locations yet
      enabled: (ne.length >= 3 || ne === "" && e === "jurisdiction" && !U) && e === "jurisdiction"
    }
  );
  S.useEffect(() => {
    ne === "" && !fe.isLoading && fe.data && z(!0);
  }, [ne, fe.data, fe.isLoading]);
  const ke = px(void 0, {
    onSuccess: (q) => {
      v((ge) => ge.filter(($e) => $e.type !== "loading")), n("contact_info"), N(!0), R(!0);
      const se = q.ua_region_id || ((u == null ? void 0 : u.region_id) ?? null);
      u && (_(u.region_name || u.name), m(u.state_name || null), d(se), A({
        submissionId: t,
        classifiedDivision: w,
        chainOfThought: q.chainOfThought ?? null,
        summary: q.summary ?? null,
        issue: q.issue ?? null,
        divisionResolutionLog: q.divisionResolutionLog || [],
        jurisdictionRegion: u.region_name || u.name,
        jurisdictionState: u.state_name || null,
        locationName: u.name,
        uaRegionId: se
      }), j.onJurisdictionSelectionSubmitted && j.onJurisdictionSelectionSubmitted(u)), v((ge) => [...ge, {
        type: "system",
        content: "Thank you for providing this information! Can you please share your contact details so we can connect you to an attorney?"
      }]);
    },
    onError: (q) => {
      v((se) => se.filter((ge) => ge.type !== "loading"));
    }
  }), F = ((Et = (Qe = fe.data) == null ? void 0 : Qe.locations) == null ? void 0 : Et.flatMap((q) => {
    var $e, Re, Qn, xn, gr;
    const se = {
      id: q.region_id,
      name: q.name,
      region_id: q.region_id,
      state_id: q.state_id,
      region_name: (($e = q.region) == null ? void 0 : $e.name) || null,
      state_name: ((Re = q.state) == null ? void 0 : Re.name) || null,
      top_localities: ((Qn = q.region) == null ? void 0 : Qn.top_localities) || [],
      isRelated: !1
    }, ge = ((gr = (xn = q.region) == null ? void 0 : xn.related_regions) == null ? void 0 : gr.map((et) => {
      var bn, _n;
      return {
        id: et.id,
        name: `${et.name}, ${((bn = et.state) == null ? void 0 : bn.abbreviation) || ""}`,
        region_id: et.id,
        state_id: et.state_id,
        region_name: et.name,
        state_name: ((_n = et.state) == null ? void 0 : _n.name) || null,
        isRelated: !0,
        top_localities: et.top_localities
      };
    })) || [];
    return [se, ...ge];
  })) || [], Q = (q) => {
    if (c(q), h(-1), s(q.name), i(q.name), f(!1), l(null), j.onJurisdictionSelectionChange && j.onJurisdictionSelectionChange(q), t) {
      let se = !1;
      v((ge) => {
        const $e = ge.map((Re) => Re.type === "user" && Re.editType === "jurisdiction" ? (se = !0, {
          ...Re,
          content: q.name
        }) : Re);
        return se ? $e : [...$e, {
          type: "user",
          content: q.name,
          editable: !0,
          editType: "jurisdiction",
          id: "jurisdiction"
        }];
      }), v((ge) => [...ge, { type: "loading", content: "" }]), ke.mutate({
        body: {
          submission_id: t,
          region_id: q.id
        }
      });
    }
  }, J = () => {
    var q, se;
    (!o && U && (((se = (q = fe.data) == null ? void 0 : q.locations) == null ? void 0 : se.length) ?? 0) > 0 || o.length >= 3) && f(!0);
  }, re = (q) => {
    const se = q.target.value;
    i(se), s(se), f(se.length >= 3), j.onJurisdictionTextUpdated && j.onJurisdictionTextUpdated(se), a && l(null), u && u.name !== se && c(null);
  }, me = (q) => {
    if (q.preventDefault(), o && !u) {
      l("Please select a location from the dropdown");
      return;
    }
    if (!t) return;
    let se = !1;
    v((ge) => {
      const $e = ge.map((Re) => Re.type === "user" && Re.editType === "jurisdiction" ? (se = !0, {
        ...Re,
        content: o
      }) : Re);
      return se ? $e : [...$e, {
        type: "user",
        content: o,
        editable: !0,
        editType: "jurisdiction",
        id: "jurisdiction"
      }];
    }), v((ge) => [...ge, { type: "loading", content: "" }]), u && j.onJurisdictionSelectionSubmitted && j.onJurisdictionSelectionSubmitted(u), ke.mutate({
      body: {
        submission_id: t,
        region_id: u.id
      }
    });
  }, Pt = (q) => {
    if (!(!F.length && !u))
      switch (q.key) {
        case "ArrowDown":
          q.preventDefault(), h(
            p < F.length - 1 ? p + 1 : p
          );
          break;
        case "ArrowUp":
          q.preventDefault(), h(
            p > 0 ? p - 1 : p
          );
          break;
        case "Enter":
          if (q.preventDefault(), p >= 0 && p < F.length) {
            const se = F[p];
            Q(se);
          }
          break;
        case "Escape":
          q.preventDefault(), i(""), h(-1), f(!1);
          break;
      }
  }, Xe = () => {
    (e === "contact_info" || e === "jurisdiction" || e === "completed") && (n("jurisdiction"), i(""), s(""), l(null), c(null), K.reset({ location: "" }), x(!0), v((q) => q.filter((se) => !(se.type === "system" && se.content.includes("share your contact details")))), setTimeout(() => {
      var q;
      (q = T.current) == null || q.focus();
    }, 0));
  }, jt = () => {
  };
  return {
    jurisdictionForm: K,
    locationResults: F,
    jurisdictionInputRef: T,
    handleLocationSelect: Q,
    handleInputFocus: J,
    handleLocationInputChange: re,
    onLocationSubmit: me,
    handleLocationKeyDown: Pt,
    handleEditJurisdiction: Xe,
    isPending: ke.isPending,
    hasNearbyLocations: U
  };
}, e1 = ({
  show: e,
  inputRect: t,
  locations: n,
  selectedIndex: r,
  onSelectLocation: i
}) => {
  const o = S.useRef(null), s = S.useRef(null);
  if (S.useEffect(() => {
    r >= 0 && s.current && s.current.scrollIntoView({ block: "nearest" });
  }, [r]), !e || !t || n.length === 0) return null;
  const a = {
    position: "fixed",
    top: t.bottom + 12 + window.scrollY,
    left: t.left + window.scrollX,
    width: t.width,
    maxHeight: "240px",
    overflowY: "auto",
    backgroundColor: "white",
    border: "1px solid #e5e7eb",
    borderRadius: "0.5rem",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    zIndex: 9999,
    padding: "4px 0"
  };
  return wh.createPortal(
    /* @__PURE__ */ I.jsx(
      "div",
      {
        ref: o,
        "data-dropdown": !0,
        style: a,
        children: n.map((l, u) => /* @__PURE__ */ I.jsxs(
          "div",
          {
            ref: u === r ? s : null,
            style: {
              padding: "8px 16px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: u === r ? "#d1e5f7" : "transparent",
              paddingLeft: l.isRelated ? "24px" : "16px"
            },
            onClick: (c) => {
              c.preventDefault(), c.stopPropagation(), i(l, !0);
            },
            children: [
              /* @__PURE__ */ I.jsxs("span", { style: { display: "flex", flexDirection: "column" }, children: [
                l.name,
                l.top_localities && l.top_localities.length > 0 && /* @__PURE__ */ I.jsx("span", { style: { fontSize: "0.875rem", color: "#9ca3af" }, children: l.top_localities.slice(0, 3).join(", ") })
              ] }),
              u === r && /* @__PURE__ */ I.jsx(Gx, { color: "#0a6fc2", fill: "#0a6fc2", size: 8 })
            ]
          },
          l.region_id + "-" + l.state_id + "-" + l.name
        ))
      }
    ),
    document.body
  );
}, t1 = () => {
  const {
    locationResults: e,
    jurisdictionInputRef: t,
    handleLocationSelect: n,
    handleInputFocus: r,
    handleLocationInputChange: i,
    onLocationSubmit: o,
    handleLocationKeyDown: s,
    isPending: a,
    hasNearbyLocations: l
  } = Xx(), {
    locationInputValue: u,
    locationError: c,
    selectedLocation: p,
    selectedLocationIndex: h,
    isDropdownOpen: x,
    shouldRenderLocationInput: v,
    jurisdictionQuestionDisplayed: w
  } = en(), [_, m] = S.useState(null), d = () => {
    t != null && t.current && m(t.current.getBoundingClientRect());
  };
  S.useEffect(() => {
    w && setTimeout(() => {
      if (t != null && t.current)
        t.current.focus();
      else {
        const f = document.getElementById("jurisdiction-input");
        f instanceof HTMLInputElement && f.focus();
      }
    }, 100);
  }, [t, w]), S.useEffect(() => (d(), window.addEventListener("resize", d), window.addEventListener("scroll", d, !0), () => {
    window.removeEventListener("resize", d), window.removeEventListener("scroll", d, !0);
  }), []), S.useEffect(() => {
    d();
  }, [x, e.length, u]);
  const y = () => {
    r(), d();
  }, b = e;
  return v ? /* @__PURE__ */ I.jsxs("div", { className: "space-y-2 px-4 my-1", children: [
    /* @__PURE__ */ I.jsxs("form", { onSubmit: o, className: "relative", children: [
      /* @__PURE__ */ I.jsx(
        rr,
        {
          id: "jurisdiction-input",
          ref: t,
          placeholder: w ? "Enter location (city, state, country)..." : "Please wait...",
          className: "w-full pr-16 rounded-lg border-2 border-gray-200 py-6 focus-visible:ring-2 focus-visible:ring-[#0a6fc2] focus-visible:ring-offset-2 focus-visible:ring-offset-white focus-visible:outline-none bg-white",
          value: u,
          onChange: i,
          onKeyDown: s,
          onFocus: y,
          disabled: !w,
          autoComplete: "off",
          autoFocus: !0
        }
      ),
      /* @__PURE__ */ I.jsx(
        go,
        {
          type: "submit",
          className: "absolute right-0 top-0 h-full w-12 rounded-r-lg rounded-l-none p-0 flex items-center justify-center bg-amber-400 hover:bg-amber-500",
          disabled: !p || a,
          children: /* @__PURE__ */ I.jsx(pc, { className: "h-6 w-6", color: "#fff" })
        }
      )
    ] }),
    c && /* @__PURE__ */ I.jsx("p", { className: "text-sm text-red-500", children: c }),
    /* @__PURE__ */ I.jsx(
      e1,
      {
        show: x && !p && (u.length >= 3 || !u && l),
        inputRect: _,
        locations: b,
        selectedIndex: h,
        onSelectLocation: n
      }
    )
  ] }) : null;
};
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nl = aa("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]), n1 = (e) => {
  const t = e.replace(/\D/g, "");
  return t.length < 4 ? t : t.length < 7 ? `(${t.slice(0, 3)}) ${t.slice(3)}` : `(${t.slice(0, 3)}) ${t.slice(3, 6)}-${t.slice(6, 10)}`;
}, r1 = () => {
  const {
    submissionId: e,
    uaDivisionId: t,
    jurisdictionUaRegionId: n,
    selectedLocation: r,
    formState: i,
    setFormState: o,
    setMessages: s,
    setContactInfo: a,
    editingContact: l,
    setEditingContact: u,
    onUpdateClassificationData: c,
    classifiedDivision: p,
    issue: h,
    languageCode: x,
    events: v,
    // Get the events from context
    showLastMessage: w
    // Get the showLastMessage flag
  } = en(), _ = ca({
    resolver: va(Zx),
    defaultValues: {
      fullName: "",
      email: "",
      phoneNumber: ""
    },
    mode: "onTouched",
    // Only validate on blur/focus and submit, not onChange
    reValidateMode: "onBlur"
    // Only re-validate on blur, not while typing
  }), m = mx(void 0, {
    onSuccess: (N) => {
      s((T) => T.filter((U) => U.type !== "loading")), o("completed"), w && s((T) => [...T, {
        type: "system",
        content: "Thank you! An attorney will be in touch with you soon."
      }]);
      const R = _.getValues(), j = {
        issue: h || void 0,
        jurisdiction: r || void 0,
        contact: {
          name: R.fullName,
          email: R.email,
          phone: R.phoneNumber
        },
        languageCode: x
      };
      v.onIntakeComplete && v.onIntakeComplete(j, N);
    },
    onError: (N) => {
      var R, j;
      if (s((T) => T.filter((U) => U.type !== "loading")), (j = (R = N.response) == null ? void 0 : R.data) != null && j.errors) {
        const T = N.response.data.errors, U = {
          full_name: "fullName",
          phone_number: "phoneNumber"
        };
        Object.entries(T).forEach(([z, K]) => {
          const ne = U[z] || z, le = K.join(". ");
          _.setError(ne, {
            type: "manual",
            message: le
          });
        });
      }
    }
  });
  return {
    contactForm: _,
    onContactSubmit: (N) => {
      if (N.phoneNumber.replace(/\D/g, "").length !== 10) {
        _.setError("phoneNumber", {
          type: "manual",
          message: "Phone number must be 10 digits"
        });
        return;
      }
      a(N);
      const j = `Here are your contact details:
Name: ${N.fullName}
Email: ${N.email}
Phone: ${N.phoneNumber}`;
      s((U) => [...U, {
        type: "user",
        content: j,
        editable: !0,
        // Make it editable even after final submission
        editType: "contact",
        id: "contact"
      }]), s((U) => [...U, { type: "loading", content: "" }]);
      const T = {
        submission_id: e || 0,
        full_name: N.fullName,
        email: N.email,
        phone_number: N.phoneNumber
      };
      v.onContactDetailsSubmitted && v.onContactDetailsSubmitted({
        name: N.fullName,
        email: N.email,
        phone: N.phoneNumber
      }), m.mutate({
        body: T
      }), c({
        submissionId: e,
        classifiedDivision: p,
        chainOfThought: null,
        summary: null,
        issue: null,
        divisionResolutionLog: [],
        jurisdictionRegion: (r == null ? void 0 : r.region_name) || null,
        jurisdictionState: (r == null ? void 0 : r.state_name) || null,
        locationName: (r == null ? void 0 : r.name) || null,
        contactInfo: N,
        uaDivisionId: t,
        uaRegionId: n,
        languageCode: x
      });
    },
    handlePhoneNumberChange: (N) => {
      const R = n1(N.target.value), j = R.replace(/\D/g, "");
      _.setValue("phoneNumber", R, { shouldValidate: !1 }), j.length === 10 && _.trigger(), v.onPhoneNumberUpdated && v.onPhoneNumberUpdated(R);
    },
    handleNameChange: (N) => {
      const R = N.target.value;
      if (_.setValue("fullName", R, { shouldValidate: !1 }), R.trim().length > 0) {
        _.trigger("fullName");
        const { email: j, phoneNumber: T } = _.getValues();
        j && T && T.replace(/\D/g, "").length === 10 && _.trigger();
      }
      v.onNameTextUpdated && v.onNameTextUpdated(R);
    },
    handleEmailChange: (N) => {
      const R = N.target.value;
      if (_.setValue("email", R, { shouldValidate: !1 }), /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(R)) {
        _.trigger("email");
        const { fullName: T, phoneNumber: U } = _.getValues();
        T && U && U.replace(/\D/g, "").length === 10 && _.trigger();
      }
      v.onEmailTextUpdated && v.onEmailTextUpdated(R);
    },
    handleEditContact: () => {
      (i === "contact_info" || i === "completed") && !l && (u(!0), i === "completed" && o("contact_info"));
    },
    isPending: m.isPending
  };
}, i1 = () => {
  const {
    contactForm: e,
    onContactSubmit: t,
    handlePhoneNumberChange: n,
    handleNameChange: r,
    handleEmailChange: i,
    isPending: o
  } = r1(), {
    shouldRenderContactForm: s
  } = en();
  return S.useEffect(() => {
    s && setTimeout(() => {
      const a = document.getElementById("contact-name-input");
      a instanceof HTMLInputElement && a.focus();
    }, 50);
  }, [s]), s ? /* @__PURE__ */ I.jsx(
    "div",
    {
      className: "contact-form-container transition-all duration-500 ease-in-out opacity-100 translate-y-0",
      children: /* @__PURE__ */ I.jsx(fc, { ...e, children: /* @__PURE__ */ I.jsxs(
        "form",
        {
          onSubmit: e.handleSubmit(t),
          className: "space-y-2 px-4",
          noValidate: !0,
          children: [
            /* @__PURE__ */ I.jsx("div", { className: "rounded-lg mb-2", children: /* @__PURE__ */ I.jsxs("div", { className: "grid gap-2", children: [
              /* @__PURE__ */ I.jsx(
                zi,
                {
                  control: e.control,
                  name: "fullName",
                  render: ({ field: a }) => /* @__PURE__ */ I.jsxs(Mi, { children: [
                    /* @__PURE__ */ I.jsxs("div", { className: "relative", children: [
                      /* @__PURE__ */ I.jsx(
                        rr,
                        {
                          id: "contact-name-input",
                          placeholder: o ? "Please wait..." : "Full Name",
                          className: `w-full rounded-lg border-2 py-6 focus-visible:ring-2 focus-visible:ring-[#0a6fc2] focus-visible:ring-offset-2 focus-visible:ring-offset-white focus-visible:outline-none bg-white ${e.formState.errors.fullName ? "border-red-500" : "border-gray-200"}`,
                          value: a.value,
                          onChange: r,
                          onBlur: a.onBlur,
                          name: a.name,
                          ref: a.ref,
                          disabled: o,
                          autoFocus: !0
                        }
                      ),
                      !e.formState.errors.fullName && a.value && /* @__PURE__ */ I.jsx(nl, { className: "absolute right-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-green-500" })
                    ] }),
                    /* @__PURE__ */ I.jsx(Ui, { className: "text-xs mt-1 ml-2 text-red-500" })
                  ] })
                }
              ),
              /* @__PURE__ */ I.jsx(
                zi,
                {
                  control: e.control,
                  name: "email",
                  render: ({ field: a }) => /* @__PURE__ */ I.jsxs(Mi, { children: [
                    /* @__PURE__ */ I.jsxs("div", { className: "relative", children: [
                      /* @__PURE__ */ I.jsx(
                        rr,
                        {
                          placeholder: o ? "Please wait..." : "Email",
                          type: "email",
                          className: `w-full rounded-lg border-2 py-6 focus-visible:ring-2 focus-visible:ring-[#0a6fc2] focus-visible:ring-offset-2 focus-visible:ring-offset-white focus-visible:outline-none bg-white ${e.formState.errors.email && e.formState.touchedFields.email ? "border-red-500" : "border-gray-200"}`,
                          value: a.value,
                          onChange: i,
                          onBlur: a.onBlur,
                          name: a.name,
                          ref: a.ref,
                          disabled: o
                        }
                      ),
                      !e.formState.errors.email && a.value && /* @__PURE__ */ I.jsx(nl, { className: "absolute right-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-green-500" })
                    ] }),
                    e.formState.errors.email && e.formState.touchedFields.email && /* @__PURE__ */ I.jsx(Ui, { className: "text-xs mt-1 ml-2 text-red-500" })
                  ] })
                }
              ),
              /* @__PURE__ */ I.jsx(
                zi,
                {
                  control: e.control,
                  name: "phoneNumber",
                  render: ({ field: a }) => /* @__PURE__ */ I.jsxs(Mi, { children: [
                    /* @__PURE__ */ I.jsxs("div", { className: "relative", children: [
                      /* @__PURE__ */ I.jsx(
                        rr,
                        {
                          placeholder: o ? "Please wait..." : "Mobile Number",
                          className: `w-full rounded-lg border-2 py-6 focus-visible:ring-2 focus-visible:ring-[#0a6fc2] focus-visible:ring-offset-2 focus-visible:ring-offset-white focus-visible:outline-none bg-white ${e.formState.errors.phoneNumber && e.formState.touchedFields.phoneNumber ? "border-red-500" : "border-gray-200"}`,
                          value: a.value,
                          onChange: (l) => n(l),
                          onBlur: a.onBlur,
                          name: a.name,
                          ref: a.ref,
                          maxLength: 14,
                          disabled: o
                        }
                      ),
                      !e.formState.errors.phoneNumber && a.value && a.value.length === 14 && /* @__PURE__ */ I.jsx(nl, { className: "absolute right-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-green-500" })
                    ] }),
                    e.formState.errors.phoneNumber && e.formState.touchedFields.phoneNumber && /* @__PURE__ */ I.jsx(Ui, { className: "text-xs mt-1 ml-2 text-red-500" })
                  ] })
                }
              )
            ] }) }),
            /* @__PURE__ */ I.jsx("p", { className: "text-sm px-2 text-neutral-500 pb-3", children: "By continuing, you agree to be contacted about this request via text message." }),
            /* @__PURE__ */ I.jsx(
              go,
              {
                type: "submit",
                className: "text-neutral-900 text-base w-full rounded-lg bg-amber-400 hover:bg-amber-500 py-6 font-bold tracking-wider uppercase focus:outline-none focus:ring-2 focus:ring-amber-400 focus:ring-offset-2 focus:ring-offset-white",
                disabled: !e.formState.isValid || o,
                tabIndex: 0,
                role: "button",
                "aria-label": "Find me a lawyer",
                children: "Find me a lawyer"
              }
            )
          ]
        }
      ) })
    }
  ) : null;
}, o1 = () => {
  const {
    formState: e,
    scrollToBottom: t,
    setIsInitialLoad: n,
    scrollContainerRef: r
  } = en();
  return S.useEffect(() => {
    r.current && t();
  }, [e]), S.useEffect(() => {
    n(!1);
  }, []), /* @__PURE__ */ I.jsx(Rh, { className: "mx-auto overflow-hidden border-none bg-transparent shadow-none", children: /* @__PURE__ */ I.jsx(Ih, { className: "p-0 flex flex-col border-none", children: /* @__PURE__ */ I.jsxs("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ I.jsx("div", { className: "flex-1 overflow-y-auto px-4 pt-6 pb-2", ref: r, children: /* @__PURE__ */ I.jsx(Kv, {}) }),
    /* @__PURE__ */ I.jsxs("div", { className: e === "new_issue" ? "-mt-1" : "", children: [
      e === "new_issue" && /* @__PURE__ */ I.jsx(qx, {}),
      e === "clarifying_questions" && /* @__PURE__ */ I.jsx(Kx, {}),
      e === "jurisdiction" && /* @__PURE__ */ I.jsx(t1, {}),
      e === "contact_info" && /* @__PURE__ */ I.jsx(i1, {})
    ] })
  ] }) }) });
}, Pm = S.forwardRef((e, t) => {
  const {
    onUpdateClassificationData: n,
    onReset: r,
    showInitialMessage: i = !1,
    showLastMessage: o = !0,
    // Default to showing the last message
    // Event handlers
    onLeadClickedIssueInput: s,
    onIssueTextUpdated: a,
    onIssueSubmitted: l,
    onJurisdictionTextUpdated: u,
    onJurisdictionSelectionChange: c,
    onJurisdictionSelectionSubmitted: p,
    onNameTextUpdated: h,
    onEmailTextUpdated: x,
    onPhoneNumberUpdated: v,
    onContactDetailsSubmitted: w,
    onIntakeComplete: _
  } = e;
  return S.useImperativeHandle(t, () => ({
    resetForm: () => {
    }
  }), []), /* @__PURE__ */ I.jsx(
    Wv,
    {
      onUpdateClassificationData: n,
      onReset: r,
      showInitialMessage: i,
      showLastMessage: o,
      events: {
        onLeadClickedIssueInput: s,
        onIssueTextUpdated: a,
        onIssueSubmitted: l,
        onJurisdictionTextUpdated: u,
        onJurisdictionSelectionChange: c,
        onJurisdictionSelectionSubmitted: p,
        onNameTextUpdated: h,
        onEmailTextUpdated: x,
        onPhoneNumberUpdated: v,
        onContactDetailsSubmitted: w,
        onIntakeComplete: _
      },
      children: /* @__PURE__ */ I.jsx(o1, {})
    }
  );
});
Pm.displayName = "IntakeForm";
const vc = {
  isDev: !1,
  apiUrl: "/api",
  showInitialMessage: !1,
  showLastMessage: !0,
  apiToken: void 0,
  theme: "light"
}, s1 = S.createContext(vc), a1 = ({ config: e, children: t }) => {
  const n = { ...vc, ...e };
  return /* @__PURE__ */ I.jsx(s1.Provider, { value: n, children: t });
}, l1 = `/**
 * Essential reset styles for Shadow DOM to ensure Tailwind works correctly
 */

/* Base reset for Shadow DOM */
:host {
  all: initial;
  display: block;
  contain: content;
  text-size-adjust: 100%;
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  color: #111827;
  font-size: 16px;
  line-height: 1.5;
  box-sizing: border-box;
  width: 100%;
}

/* Root container for widget */
.tw-widget-root {
  display: block;
  width: 100%;
}

/* Container for Tailwind classes */
.tw-widget-container {
  display: block;
  width: 100%;
  /* Ensure all Tailwind styles are properly contained */
  color-scheme: light;
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  line-height: 1.5;
  -webkit-text-size-adjust: 100%;
  -moz-tab-size: 4;
  tab-size: 4;
}

/* Basic box-model reset */
.tw-widget-container * {
  box-sizing: border-box;
  border-width: 0;
  border-style: solid;
}

/* Reset for interactive elements */
.tw-widget-container button,
.tw-widget-container [type='button'],
.tw-widget-container [type='reset'],
.tw-widget-container [type='submit'] {
  -webkit-appearance: button;
  appearance: button;
  background-color: transparent;
  background-image: none;
}

.tw-widget-container input,
.tw-widget-container textarea {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

/* Focus styles */
.tw-widget-container *:focus-visible {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

/* Ensure proper form inputs */
.tw-widget-container input::placeholder,
.tw-widget-container textarea::placeholder {
  color: #9ca3af;
  opacity: 1;
}

/* Preserve focus styles */
.tw-widget-container *:focus-visible {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

/* Ensure proper borders and backgrounds */
.tw-widget-container .border {
  border-width: 1px;
}

.tw-widget-container .bg-white {
  background-color: #ffffff;
}

.tw-widget-container .bg-neutral-200 {
  background-color: #e5e7eb;
}

.tw-widget-container .text-white {
  color: #ffffff;
}

.tw-widget-container .text-neutral-800 {
  color: #1f2937;
}

/* Essential widget styles */
.tw-widget-container .rounded-lg {
  border-radius: 0.5rem;
}

.tw-widget-container .px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.tw-widget-container .py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.tw-widget-container .my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}

.tw-widget-container .space-y-4 > * + * {
  margin-top: 1rem;
}

/* Styles for form elements */
.tw-widget-container .relative {
  position: relative;
}

.tw-widget-container .absolute {
  position: absolute;
}

.tw-widget-container .right-0 {
  right: 0;
}

.tw-widget-container .top-0 {
  top: 0;
}

.tw-widget-container .flex {
  display: flex;
}

.tw-widget-container .w-full {
  width: 100%;
}

.tw-widget-container .h-full {
  height: 100%;
}

.tw-widget-container .items-center {
  align-items: center;
}

.tw-widget-container .justify-center {
  justify-content: center;
}

.tw-widget-container .bg-amber-400 {
  background-color: #fbbf24;
}

.tw-widget-container .hover\\:bg-amber-500:hover {
  background-color: #f59e0b;
}

/* Specific widget colors */
.tw-widget-container .bg-\\[\\#0a6fc2\\] {
  background-color: #0a6fc2;
}

.tw-widget-container .text-neutral-800 {
  color: #1f2937;
}

.tw-widget-container .text-red-500 {
  color: #ef4444;
} `, u1 = `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box;
  /* 1 */
  border-width: 0;
  /* 2 */
  border-style: solid;
  /* 2 */
  border-color: #e5e7eb;
  /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5;
  /* 1 */
  -webkit-text-size-adjust: 100%;
  /* 2 */
  -moz-tab-size: 4;
  /* 3 */
  -o-tab-size: 4;
     tab-size: 4;
  /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  /* 4 */
  font-feature-settings: normal;
  /* 5 */
  font-variation-settings: normal;
  /* 6 */
  -webkit-tap-highlight-color: transparent;
  /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0;
  /* 1 */
  line-height: inherit;
  /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0;
  /* 1 */
  color: inherit;
  /* 2 */
  border-top-width: 1px;
  /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  /* 1 */
  font-feature-settings: normal;
  /* 2 */
  font-variation-settings: normal;
  /* 3 */
  font-size: 1em;
  /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0;
  /* 1 */
  border-color: inherit;
  /* 2 */
  border-collapse: collapse;
  /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  /* 1 */
  font-feature-settings: inherit;
  /* 1 */
  font-variation-settings: inherit;
  /* 1 */
  font-size: 100%;
  /* 1 */
  font-weight: inherit;
  /* 1 */
  line-height: inherit;
  /* 1 */
  letter-spacing: inherit;
  /* 1 */
  color: inherit;
  /* 1 */
  margin: 0;
  /* 2 */
  padding: 0;
  /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button;
  /* 1 */
  background-color: transparent;
  /* 2 */
  background-image: none;
  /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield;
  /* 1 */
  outline-offset: -2px;
  /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button;
  /* 1 */
  font: inherit;
  /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1;
  /* 1 */
  color: #9ca3af;
  /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1;
  /* 1 */
  color: #9ca3af;
  /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block;
  /* 1 */
  vertical-align: middle;
  /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

:root {
  --background: 0 0% 100%;
  --foreground: 0 0% 3.9%;
  --card: 0 0% 100%;
  --card-foreground: 0 0% 3.9%;
  --popover: 0 0% 100%;
  --popover-foreground: 0 0% 3.9%;
  --primary: 0 0% 9%;
  --primary-foreground: 0 0% 98%;
  --secondary: 0 0% 96.1%;
  --secondary-foreground: 0 0% 9%;
  --muted: 0 0% 96.1%;
  --muted-foreground: 0 0% 45.1%;
  --accent: 0 0% 96.1%;
  --accent-foreground: 0 0% 9%;
  --destructive: 0 84.2% 60.2%;
  --destructive-foreground: 0 0% 98%;
  --border: 0 0% 89.8%;
  --input: 0 0% 89.8%;
  --ring: 0 0% 3.9%;
  --chart-1: 12 76% 61%;
  --chart-2: 173 58% 39%;
  --chart-3: 197 37% 24%;
  --chart-4: 43 74% 66%;
  --chart-5: 27 87% 67%;
  --radius: 0.5rem;
}

.dark {
  --background: 0 0% 3.9%;
  --foreground: 0 0% 98%;
  --card: 0 0% 3.9%;
  --card-foreground: 0 0% 98%;
  --popover: 0 0% 3.9%;
  --popover-foreground: 0 0% 98%;
  --primary: 0 0% 98%;
  --primary-foreground: 0 0% 9%;
  --secondary: 0 0% 14.9%;
  --secondary-foreground: 0 0% 98%;
  --muted: 0 0% 14.9%;
  --muted-foreground: 0 0% 63.9%;
  --accent: 0 0% 14.9%;
  --accent-foreground: 0 0% 98%;
  --destructive: 0 62.8% 30.6%;
  --destructive-foreground: 0 0% 98%;
  --border: 0 0% 14.9%;
  --input: 0 0% 14.9%;
  --ring: 0 0% 83.1%;
  --chart-1: 220 70% 50%;
  --chart-2: 160 60% 45%;
  --chart-3: 30 80% 55%;
  --chart-4: 280 65% 60%;
  --chart-5: 340 75% 55%;
}

* {
  border-color: hsl(var(--border));
}

body {
  background-color: hsl(var(--background));
  color: hsl(var(--foreground));
}

.\\!container {
  width: 100% !important;
}

.container {
  width: 100%;
}

@media (min-width: 640px) {
  .\\!container {
    max-width: 640px !important;
  }

  .container {
    max-width: 640px;
  }
}

@media (min-width: 768px) {
  .\\!container {
    max-width: 768px !important;
  }

  .container {
    max-width: 768px;
  }
}

@media (min-width: 1024px) {
  .\\!container {
    max-width: 1024px !important;
  }

  .container {
    max-width: 1024px;
  }
}

@media (min-width: 1280px) {
  .\\!container {
    max-width: 1280px !important;
  }

  .container {
    max-width: 1280px;
  }
}

@media (min-width: 1536px) {
  .\\!container {
    max-width: 1536px !important;
  }

  .container {
    max-width: 1536px;
  }
}

.tw-widget-container .visible {
  visibility: visible;
}

.tw-widget-container .invisible {
  visibility: hidden;
}

.tw-widget-container .static {
  position: static;
}

.tw-widget-container .fixed {
  position: fixed;
}

.tw-widget-container .absolute {
  position: absolute;
}

.tw-widget-container .relative {
  position: relative;
}

.tw-widget-container .inset-0 {
  inset: 0px;
}

.tw-widget-container .right-0 {
  right: 0px;
}

.tw-widget-container .right-2 {
  right: 0.5rem;
}

.tw-widget-container .right-3 {
  right: 0.75rem;
}

.tw-widget-container .top-0 {
  top: 0px;
}

.tw-widget-container .top-1\\/2 {
  top: 50%;
}

.tw-widget-container .top-2 {
  top: 0.5rem;
}

.tw-widget-container .mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.tw-widget-container .my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}

.tw-widget-container .-mt-1 {
  margin-top: -0.25rem;
}

.tw-widget-container .mb-2 {
  margin-bottom: 0.5rem;
}

.tw-widget-container .ml-2 {
  margin-left: 0.5rem;
}

.tw-widget-container .mt-1 {
  margin-top: 0.25rem;
}

.tw-widget-container .block {
  display: block;
}

.tw-widget-container .flex {
  display: flex;
}

.tw-widget-container .inline-flex {
  display: inline-flex;
}

.tw-widget-container .grid {
  display: grid;
}

.tw-widget-container .h-10 {
  height: 2.5rem;
}

.tw-widget-container .h-2 {
  height: 0.5rem;
}

.tw-widget-container .h-3\\.5 {
  height: 0.875rem;
}

.tw-widget-container .h-5 {
  height: 1.25rem;
}

.tw-widget-container .h-6 {
  height: 1.5rem;
}

.tw-widget-container .h-8 {
  height: 2rem;
}

.tw-widget-container .h-9 {
  height: 2.25rem;
}

.tw-widget-container .h-full {
  height: 100%;
}

.tw-widget-container .min-h-\\[60px\\] {
  min-height: 60px;
}

.tw-widget-container .w-12 {
  width: 3rem;
}

.tw-widget-container .w-2 {
  width: 0.5rem;
}

.tw-widget-container .w-3\\.5 {
  width: 0.875rem;
}

.tw-widget-container .w-5 {
  width: 1.25rem;
}

.tw-widget-container .w-6 {
  width: 1.5rem;
}

.tw-widget-container .w-9 {
  width: 2.25rem;
}

.tw-widget-container .w-full {
  width: 100%;
}

.tw-widget-container .max-w-\\[80\\%\\] {
  max-width: 80%;
}

.tw-widget-container .flex-1 {
  flex: 1 1 0%;
}

.tw-widget-container .-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.tw-widget-container .translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.tw-widget-container .transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}

.tw-widget-container .animate-bounce {
  animation: bounce 1s infinite;
}

.tw-widget-container .resize {
  resize: both;
}

.tw-widget-container .flex-col {
  flex-direction: column;
}

.tw-widget-container .items-center {
  align-items: center;
}

.tw-widget-container .justify-start {
  justify-content: flex-start;
}

.tw-widget-container .justify-end {
  justify-content: flex-end;
}

.tw-widget-container .justify-center {
  justify-content: center;
}

.tw-widget-container .gap-2 {
  gap: 0.5rem;
}

.tw-widget-container :is(.space-x-1 > :not([hidden]) ~ :not([hidden])) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}

.tw-widget-container :is(.space-y-1\\.5 > :not([hidden]) ~ :not([hidden])) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}

.tw-widget-container :is(.space-y-2 > :not([hidden]) ~ :not([hidden])) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}

.tw-widget-container :is(.space-y-3 > :not([hidden]) ~ :not([hidden])) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}

.tw-widget-container :is(.space-y-4 > :not([hidden]) ~ :not([hidden])) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}

.tw-widget-container .overflow-hidden {
  overflow: hidden;
}

.tw-widget-container .overflow-y-auto {
  overflow-y: auto;
}

.tw-widget-container .whitespace-nowrap {
  white-space: nowrap;
}

.tw-widget-container .whitespace-pre-line {
  white-space: pre-line;
}

.tw-widget-container .break-words {
  overflow-wrap: break-word;
}

.tw-widget-container .rounded-full {
  border-radius: 9999px;
}

.tw-widget-container .rounded-lg {
  border-radius: var(--radius);
}

.tw-widget-container .rounded-md {
  border-radius: calc(var(--radius) - 2px);
}

.tw-widget-container .rounded-xl {
  border-radius: 0.75rem;
}

.tw-widget-container .rounded-b-lg {
  border-bottom-right-radius: var(--radius);
  border-bottom-left-radius: var(--radius);
}

.tw-widget-container .rounded-l-none {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

.tw-widget-container .rounded-r-lg {
  border-top-right-radius: var(--radius);
  border-bottom-right-radius: var(--radius);
}

.tw-widget-container .border {
  border-width: 1px;
}

.tw-widget-container .border-2 {
  border-width: 2px;
}

.tw-widget-container .border-t {
  border-top-width: 1px;
}

.tw-widget-container .border-none {
  border-style: none;
}

.tw-widget-container .border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}

.tw-widget-container .border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}

.tw-widget-container .border-input {
  border-color: hsl(var(--input));
}

.tw-widget-container .border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}

.tw-widget-container .bg-\\[\\#0a6fc2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(10 111 194 / var(--tw-bg-opacity, 1));
}

.tw-widget-container .bg-amber-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}

.tw-widget-container .bg-background {
  background-color: hsl(var(--background));
}

.tw-widget-container .bg-card {
  background-color: hsl(var(--card));
}

.tw-widget-container .bg-destructive {
  background-color: hsl(var(--destructive));
}

.tw-widget-container .bg-neutral-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
}

.tw-widget-container .bg-neutral-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(163 163 163 / var(--tw-bg-opacity, 1));
}

.tw-widget-container .bg-neutral-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}

.tw-widget-container .bg-primary {
  background-color: hsl(var(--primary));
}

.tw-widget-container .bg-secondary {
  background-color: hsl(var(--secondary));
}

.tw-widget-container .bg-transparent {
  background-color: transparent;
}

.tw-widget-container .bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.tw-widget-container .p-0 {
  padding: 0px;
}

.tw-widget-container .p-1\\.5 {
  padding: 0.375rem;
}

.tw-widget-container .p-4 {
  padding: 1rem;
}

.tw-widget-container .p-6 {
  padding: 1.5rem;
}

.tw-widget-container .px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.tw-widget-container .px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.tw-widget-container .px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.tw-widget-container .px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}

.tw-widget-container .py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.tw-widget-container .py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.tw-widget-container .py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.tw-widget-container .pb-0 {
  padding-bottom: 0px;
}

.tw-widget-container .pb-2 {
  padding-bottom: 0.5rem;
}

.tw-widget-container .pb-3 {
  padding-bottom: 0.75rem;
}

.tw-widget-container .pr-10 {
  padding-right: 2.5rem;
}

.tw-widget-container .pr-16 {
  padding-right: 4rem;
}

.tw-widget-container .pt-0 {
  padding-top: 0px;
}

.tw-widget-container .pt-6 {
  padding-top: 1.5rem;
}

.tw-widget-container .text-\\[0\\.8rem\\] {
  font-size: 0.8rem;
}

.tw-widget-container .text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}

.tw-widget-container .text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.tw-widget-container .text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}

.tw-widget-container .font-bold {
  font-weight: 700;
}

.tw-widget-container .font-medium {
  font-weight: 500;
}

.tw-widget-container .font-semibold {
  font-weight: 600;
}

.tw-widget-container .uppercase {
  text-transform: uppercase;
}

.tw-widget-container .leading-none {
  line-height: 1;
}

.tw-widget-container .tracking-tight {
  letter-spacing: -0.025em;
}

.tw-widget-container .tracking-wider {
  letter-spacing: 0.05em;
}

.tw-widget-container .text-card-foreground {
  color: hsl(var(--card-foreground));
}

.tw-widget-container .text-destructive {
  color: hsl(var(--destructive));
}

.tw-widget-container .text-destructive-foreground {
  color: hsl(var(--destructive-foreground));
}

.tw-widget-container .text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}

.tw-widget-container .text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}

.tw-widget-container .text-muted-foreground {
  color: hsl(var(--muted-foreground));
}

.tw-widget-container .text-neutral-500 {
  --tw-text-opacity: 1;
  color: rgb(115 115 115 / var(--tw-text-opacity, 1));
}

.tw-widget-container .text-neutral-600 {
  --tw-text-opacity: 1;
  color: rgb(82 82 82 / var(--tw-text-opacity, 1));
}

.tw-widget-container .text-neutral-800 {
  --tw-text-opacity: 1;
  color: rgb(38 38 38 / var(--tw-text-opacity, 1));
}

.tw-widget-container .text-neutral-900 {
  --tw-text-opacity: 1;
  color: rgb(23 23 23 / var(--tw-text-opacity, 1));
}

.tw-widget-container .text-primary {
  color: hsl(var(--primary));
}

.tw-widget-container .text-primary-foreground {
  color: hsl(var(--primary-foreground));
}

.tw-widget-container .text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}

.tw-widget-container .text-secondary-foreground {
  color: hsl(var(--secondary-foreground));
}

.tw-widget-container .text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.tw-widget-container .underline-offset-4 {
  text-underline-offset: 4px;
}

.tw-widget-container .antialiased {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.tw-widget-container .opacity-100 {
  opacity: 1;
}

.tw-widget-container .shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.tw-widget-container .shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.tw-widget-container .shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.tw-widget-container .outline {
  outline-style: solid;
}

.tw-widget-container .blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.tw-widget-container .grayscale {
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.tw-widget-container .filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.tw-widget-container .transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.tw-widget-container .transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.tw-widget-container .duration-500 {
  transition-duration: 500ms;
}

.tw-widget-container .ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes enter {
  from {
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}

@keyframes exit {
  to {
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}

.tw-widget-container .duration-500 {
  animation-duration: 500ms;
}

.tw-widget-container .ease-in-out {
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

/* Base styles */

.intake-form-container {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  color: #111827;
}

/* Messaging interface styles */

.messages-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  max-height: 70vh;
  overflow-y: auto;
  scroll-behavior: smooth;
}

.message {
  padding: 12px 16px;
  border-radius: 18px;
  max-width: 80%;
  animation: fadeIn 0.3s ease-in-out;
}

.message.system {
  background-color: #f3f4f6;
  align-self: flex-start;
  margin-right: auto;
}

.message.user {
  background-color: #0a6fc2;
  color: white;
  align-self: flex-end;
  margin-left: auto;
}

.message.loading {
  background-color: #f3f4f6;
  align-self: flex-start;
  margin-right: auto;
}

/* Form input styles */

.form-input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 16px;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.form-input:focus {
  border-color: #0a6fc2;
  box-shadow: 0 0 0 2px rgba(10, 111, 194, 0.2);
}

.form-button {
  background-color: #0a6fc2;
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.form-button:hover {
  background-color: #085a9d;
}

.form-button:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}

/* Animations */

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.5;
  }

  50% {
    opacity: 1;
  }
}

/* Loading indicator */

.loading-dots span {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: currentColor;
  margin: 0 2px;
  animation: pulse 1.4s infinite ease-in-out;
}

.loading-dots span:nth-child(2) {
  animation-delay: 0.2s;
}

.loading-dots span:nth-child(3) {
  animation-delay: 0.4s;
}

/* Shadow DOM specific styles - these will be included directly in the shadow DOM */

.shadow-dom {
  all: initial;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  color: #111827;
  font-size: 16px;
  line-height: 1.5;
}

/* Development-only styles */

.dev-indicator {
  display: none;
}

:host([dev-mode]) .dev-indicator {
  display: block;
  padding: 4px 8px;
  background-color: #fef3c7;
  color: #92400e;
  font-size: 12px;
  text-align: center;
}

/* Responsive adjustments */

@media (max-width: 768px) {
  .message {
    max-width: 85%;
  }
}

@media (max-width: 480px) {
  .messages-container {
    padding: 12px;
  }

  .message {
    max-width: 90%;
    padding: 10px 14px;
  }
}

.tw-widget-container .file\\:border-0::file-selector-button {
  border-width: 0px;
}

.tw-widget-container .file\\:bg-transparent::file-selector-button {
  background-color: transparent;
}

.tw-widget-container .file\\:text-sm::file-selector-button {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.tw-widget-container .file\\:font-medium::file-selector-button {
  font-weight: 500;
}

.tw-widget-container .file\\:text-foreground::file-selector-button {
  color: hsl(var(--foreground));
}

.tw-widget-container .placeholder\\:text-muted-foreground::-moz-placeholder {
  color: hsl(var(--muted-foreground));
}

.tw-widget-container .placeholder\\:text-muted-foreground::placeholder {
  color: hsl(var(--muted-foreground));
}

.tw-widget-container .hover\\:bg-\\[\\#035398\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(3 83 152 / var(--tw-bg-opacity, 1));
}

.tw-widget-container .hover\\:bg-accent:hover {
  background-color: hsl(var(--accent));
}

.tw-widget-container .hover\\:bg-amber-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}

.tw-widget-container .hover\\:bg-destructive\\/90:hover {
  background-color: hsl(var(--destructive) / 0.9);
}

.tw-widget-container .hover\\:bg-primary\\/90:hover {
  background-color: hsl(var(--primary) / 0.9);
}

.tw-widget-container .hover\\:bg-secondary\\/80:hover {
  background-color: hsl(var(--secondary) / 0.8);
}

.tw-widget-container .hover\\:text-accent-foreground:hover {
  color: hsl(var(--accent-foreground));
}

.tw-widget-container .hover\\:underline:hover {
  text-decoration-line: underline;
}

.tw-widget-container .focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.tw-widget-container .focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.tw-widget-container .focus\\:ring-amber-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(251 191 36 / var(--tw-ring-opacity, 1));
}

.tw-widget-container .focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}

.tw-widget-container .focus\\:ring-offset-white:focus {
  --tw-ring-offset-color: #fff;
}

.tw-widget-container .focus-visible\\:outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.tw-widget-container .focus-visible\\:ring-1:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.tw-widget-container .focus-visible\\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.tw-widget-container .focus-visible\\:ring-\\[\\#0a6fc2\\]:focus-visible {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(10 111 194 / var(--tw-ring-opacity, 1));
}

.tw-widget-container .focus-visible\\:ring-ring:focus-visible {
  --tw-ring-color: hsl(var(--ring));
}

.tw-widget-container .focus-visible\\:ring-offset-2:focus-visible {
  --tw-ring-offset-width: 2px;
}

.tw-widget-container .focus-visible\\:ring-offset-white:focus-visible {
  --tw-ring-offset-color: #fff;
}

.tw-widget-container .disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}

.tw-widget-container .disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.tw-widget-container .disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

.tw-widget-container :is(.peer:disabled ~ .peer-disabled\\:cursor-not-allowed) {
  cursor: not-allowed;
}

.tw-widget-container :is(.peer:disabled ~ .peer-disabled\\:opacity-70) {
  opacity: 0.7;
}

@media (min-width: 768px) {
  .tw-widget-container .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}

.tw-widget-container :is(.\\[\\&_svg\\]\\:pointer-events-none svg) {
  pointer-events: none;
}

.tw-widget-container :is(.\\[\\&_svg\\]\\:size-4 svg) {
  width: 1rem;
  height: 1rem;
}

.tw-widget-container :is(.\\[\\&_svg\\]\\:shrink-0 svg) {
  flex-shrink: 0;
} `, c1 = `/**
 * Explicit styles for the division form widget
 * These styles don't rely on Tailwind processing and provide direct CSS rules
 * for elements that need specific styling beyond what Tailwind offers
 */

/* === Component-specific styles === */

/* Message thread styles */
.message {
  padding: 12px 16px;
  border-radius: 18px;
  max-width: 80%;
  animation: fadeIn 0.3s ease-in-out;
}

.message.system {
  background-color: #f3f4f6;
  align-self: flex-start;
  margin-right: auto;
}

.message.user {
  background-color: #0a6fc2;
  color: white;
  align-self: flex-end;
  margin-left: auto;
}

.message.loading {
  background-color: #f3f4f6;
  align-self: flex-start;
  margin-right: auto;
}

/* Form specific styles */
.form-input:focus {
  border-color: #0a6fc2;
  box-shadow: 0 0 0 2px rgba(10, 111, 194, 0.2);
}

.form-button:hover {
  background-color: #085a9d;
}

.form-error {
  color: #dc2626;
  font-size: 14px;
  margin-top: 4px;
}

/* Loading indicator */
.loading-dots {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.loading-dots span {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: currentColor;
  animation: pulse 1.4s infinite ease-in-out;
}

.loading-dots span:nth-child(2) {
  animation-delay: 0.2s;
}

.loading-dots span:nth-child(3) {
  animation-delay: 0.4s;
}

/* Development mode indicator */
.dev-indicator {
  display: none;
  padding: 4px 8px;
  background-color: #fef3c7;
  color: #92400e;
  font-size: 12px;
  text-align: center;
}

:host([dev-mode]) .dev-indicator {
  display: block;
}

/* Animation keyframes */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
}

/* === Base Styles === */
.intake-form-root {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
  color: #333;
  line-height: 1.5;
  width: 100%;
}

/* === Card Styles === */
.card {
  border-radius: 0.5rem;
  background-color: transparent;
  width: 100%;
}

.card-content {
  display: flex;
  flex-direction: column;
  width: 100%;
}

/* === Input & Button Styles === */
.input {
  display: block;
  width: 100%;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #333;
  background-color: #fff;
  border: 2px solid #e2e8f0;
  border-radius: 0.5rem;
  transition: border-color 0.2s ease-in-out;
}

.input:focus {
  outline: none;
  border-color: #0a6fc2;
  box-shadow: 0 0 0 3px rgba(10, 111, 194, 0.1);
}

.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  border-radius: 0.5rem;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

/* === Message Styles === */
.flex {
  display: flex;
}

.flex-col {
  flex-direction: column;
}

.justify-start {
  justify-content: flex-start;
}

.justify-end {
  justify-content: flex-end;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.max-w-\\[80\\%\\] {
  max-width: 80%;
}

.bg-neutral-200 {
  background-color: #e5e7eb;
}

.text-neutral-800 {
  color: #1f2937;
}

.bg-\\[\\#0a6fc2\\] {
  background-color: #0a6fc2;
}

.text-white {
  color: #ffffff;
}

.space-y-4 > * + * {
  margin-top: 1rem;
}

.relative {
  position: relative;
}

.absolute {
  position: absolute;
}

.right-2 {
  right: 0.5rem;
}

.top-2 {
  top: 0.5rem;
}

.right-0 {
  right: 0;
}

.top-0 {
  top: 0;
}

.h-full {
  height: 100%;
}

.w-full {
  width: 100%;
}

.p-0 {
  padding: 0;
}

.p-1\\.5 {
  padding: 0.375rem;
}

.pr-16 {
  padding-right: 4rem;
}

.pr-10 {
  padding-right: 2.5rem;
}

.rounded-b-lg {
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}

.rounded-r-lg {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}

.rounded-l-none {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.w-12 {
  width: 3rem;
}

.h-6 {
  height: 1.5rem;
}

.w-6 {
  width: 1.5rem;
}

.bg-amber-400 {
  background-color: #fbbf24;
}

.hover\\:bg-amber-500:hover {
  background-color: #f59e0b;
}

.h-3\\.5 {
  height: 0.875rem;
}

.w-3\\.5 {
  width: 0.875rem;
}

.hover\\:bg-\\[\\#035398\\]:hover {
  background-color: #035398;
}

.transition-colors {
  transition-property: color, background-color, border-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.whitespace-pre-line {
  white-space: pre-line;
}

.break-words {
  overflow-wrap: break-word;
}

.border-2 {
  border-width: 2px;
}

.border-gray-200 {
  border-color: #e5e7eb;
}

.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.focus-visible\\:ring-2:focus-visible {
  box-shadow: 0 0 0 2px;
}

.focus-visible\\:ring-\\[\\#0a6fc2\\]:focus-visible {
  box-shadow: 0 0 0 2px #0a6fc2;
}

.focus-visible\\:ring-offset-2:focus-visible {
  box-shadow: 0 0 0 2px transparent;
}

.focus-visible\\:ring-offset-white:focus-visible {
  box-shadow: 0 0 0 2px white;
}

.focus-visible\\:outline-none:focus-visible {
  outline: none;
}

.text-sm {
  font-size: 0.875rem;
}

.text-red-500 {
  color: #ef4444;
}

.text-neutral-400 {
  color: #a3a3a3;
}

/* === Loading Indicator === */
.h-2 {
  height: 0.5rem;
}

.w-2 {
  width: 0.5rem;
}

.bg-neutral-400 {
  background-color: #a3a3a3;
}

.rounded-full {
  border-radius: 9999px;
}

.animate-bounce {
  animation: bounce 1s infinite;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  50% {
    transform: translateY(0);
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
}

.space-x-1 > * + * {
  margin-left: 0.25rem;
}

/* === Form Spacing === */
.space-y-2 > * + * {
  margin-top: 0.5rem;
}

.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}

.-mt-1 {
  margin-top: -0.25rem;
}

/* === Form Error === */
.form-error {
  font-size: 0.875rem;
  color: #ef4444;
  margin-top: 0.25rem;
}

/* === shadcn UI Component Styles === */

/* Card */
.ui-card {
  position: relative;
  border-radius: 0.5rem;
  background-color: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.ui-card-header {
  display: flex;
  flex-direction: column;
  padding: 1.5rem 1.5rem 0;
}

.ui-card-title {
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1.2;
  margin-bottom: 0.5rem;
}

.ui-card-content {
  padding: 1.5rem;
}

/* Form */
.ui-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.ui-form-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.ui-form-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #1f2937;
}

.ui-form-message {
  font-size: 0.75rem;
  color: #ef4444;
}

/* Textarea */
.ui-textarea {
  display: block;
  width: 100%;
  min-height: 80px;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #333;
  background-color: #fff;
  border: 2px solid #e2e8f0;
  border-radius: 0.5rem;
  resize: vertical;
  transition: border-color 0.2s ease-in-out;
}

.ui-textarea:focus {
  outline: none;
  border-color: #0a6fc2;
  box-shadow: 0 0 0 3px rgba(10, 111, 194, 0.1);
}

/* Button specific styles */
.ui-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  line-height: 1;
  border-radius: 0.5rem;
  text-align: center;
  transition-property: color, background-color, border-color, box-shadow;
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  border: none;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  background-color: #0a6fc2;
  color: white;
}

.ui-button:hover {
  background-color: #085a9d;
}

.ui-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.ui-button-outline {
  background-color: transparent;
  color: #0a6fc2;
  border: 1px solid #0a6fc2;
}

.ui-button-outline:hover {
  background-color: rgba(10, 111, 194, 0.1);
}

/* Message list container with scroll */
.overflow-y-auto {
  overflow-y: auto;
}

.pt-6 {
  padding-top: 1.5rem;
}

.pb-2 {
  padding-bottom: 0.5rem;
}

/* Add more specific widget styles */
.contact-form-container {
  transition-property: opacity, transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 500ms;
}

.opacity-100 {
  opacity: 1;
}

.opacity-0 {
  opacity: 0;
}

.translate-y-0 {
  transform: translateY(0);
}

.translate-y-8 {
  transform: translateY(2rem);
}

.max-h-0 {
  max-height: 0;
}

.overflow-hidden {
  overflow: hidden;
} `;
class d1 extends HTMLElement {
  constructor() {
    super(), this.root = null, this.mountPoint = null, this.config = { ...vc }, this.shadowContainer = this.attachShadow({ mode: "open" });
    const t = this.getCssVariables(), n = document.createElement("style");
    n.textContent = t + l1 + u1 + c1, this.shadowContainer.appendChild(n), this.mountPoint = document.createElement("div"), this.mountPoint.className = "intake-form-root tw-widget-root", this.shadowContainer.appendChild(this.mountPoint);
  }
  /**
   * Attributes to observe for changes.
   */
  static get observedAttributes() {
    return ["api-url", "dev-mode", "show-initial-message", "show-last-message", "api-token", "theme"];
  }
  /**
   * Gets CSS variables from the document and provides fallbacks for important styling properties.
   */
  getCssVariables() {
    const t = window.getComputedStyle(document.documentElement), n = (r, i) => t.getPropertyValue(r).trim() || i;
    return `
      :host {
        /* Border radius */
        --radius: ${n("--radius", "0.5rem")};
        
        /* Colors */
        --background: ${n("--background", "0 0% 100%")};
        --foreground: ${n("--foreground", "222.2 84% 4.9%")};
        --card: ${n("--card", "0 0% 100%")};
        --card-foreground: ${n("--card-foreground", "222.2 84% 4.9%")};
        --popover: ${n("--popover", "0 0% 100%")};
        --popover-foreground: ${n("--popover-foreground", "222.2 84% 4.9%")};
        --primary: ${n("--primary", "221.2 83.2% 53.3%")};
        --primary-foreground: ${n("--primary-foreground", "210 40% 98%")};
        --secondary: ${n("--secondary", "210 40% 96.1%")};
        --secondary-foreground: ${n("--secondary-foreground", "222.2 47.4% 11.2%")};
        --muted: ${n("--muted", "210 40% 96.1%")};
        --muted-foreground: ${n("--muted-foreground", "215.4 16.3% 46.9%")};
        --accent: ${n("--accent", "210 40% 96.1%")};
        --accent-foreground: ${n("--accent-foreground", "222.2 47.4% 11.2%")};
        --destructive: ${n("--destructive", "0 84.2% 60.2%")};
        --destructive-foreground: ${n("--destructive-foreground", "210 40% 98%")};
        --border: ${n("--border", "214.3 31.8% 91.4%")};
        --input: ${n("--input", "214.3 31.8% 91.4%")};
        --ring: ${n("--ring", "221.2 83.2% 53.3%")};
        
        /* Chart colors */
        --chart-1: ${n("--chart-1", "221.2 83.2% 53.3%")};
        --chart-2: ${n("--chart-2", "141.2 76.2% 36.3%")};
        --chart-3: ${n("--chart-3", "49.7 95.8% 46.7%")};
        --chart-4: ${n("--chart-4", "262.1 83.3% 57.8%")};
        --chart-5: ${n("--chart-5", "24.6 95% 53.1%")};
        
        /* Ensure font rendering is consistent */
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      }
    `;
  }
  /**
   * Component connected to DOM.
   */
  connectedCallback() {
    this.config = {
      ...this.config,
      apiUrl: this.getAttribute("api-url") || this.config.apiUrl,
      isDev: this.hasAttribute("dev-mode"),
      showInitialMessage: this.hasAttribute("show-initial-message"),
      showLastMessage: !!this.hasAttribute("show-last-message"),
      apiToken: this.getAttribute("api-token") || this.config.apiToken,
      theme: this.getAttribute("theme") || this.config.theme
    }, this.mountPoint && (this.root = rl.createRoot(this.mountPoint), this.renderComponent()), this.setupEventListeners();
  }
  /**
   * Component disconnected from DOM.
   */
  disconnectedCallback() {
    var t;
    (t = this.root) == null || t.unmount(), this.root = null;
  }
  /**
   * Handle attribute changes.
   */
  attributeChangedCallback(t, n, r) {
    if (n !== r) {
      switch (t) {
        case "api-url":
          this.config.apiUrl = r;
          break;
        case "dev-mode":
          this.config.isDev = this.hasAttribute("dev-mode");
          break;
        case "show-initial-message":
          this.config.showInitialMessage = this.hasAttribute("show-initial-message");
          break;
        case "show-last-message":
          this.config.showLastMessage = this.hasAttribute("show-last-message");
          break;
        case "api-token":
          this.config.apiToken = r;
          break;
        case "theme":
          this.config.theme = r;
          break;
      }
      this.renderComponent();
    }
  }
  /**
   * Render the React component with current config.
   */
  renderComponent() {
    if (!this.root) return;
    const t = ue.createElement(
      "div",
      { className: "tw-widget-container" },
      ue.createElement(
        a1,
        {
          config: this.config,
          children: ue.createElement(Pm, {
            onUpdateClassificationData: this.handleClassificationData.bind(this),
            onReset: this.handleReset.bind(this),
            showInitialMessage: this.config.showInitialMessage,
            showLastMessage: this.config.showLastMessage,
            // Add event handlers
            onLeadClickedIssueInput: this.handleLeadClickedIssueInput.bind(this),
            onIssueTextUpdated: this.handleIssueTextUpdated.bind(this),
            onIssueSubmitted: this.handleIssueSubmitted.bind(this),
            onJurisdictionTextUpdated: this.handleJurisdictionTextUpdated.bind(this),
            onJurisdictionSelectionChange: this.handleJurisdictionSelectionChange.bind(this),
            onJurisdictionSelectionSubmitted: this.handleJurisdictionSelectionSubmitted.bind(this),
            onNameTextUpdated: this.handleNameTextUpdated.bind(this),
            onEmailTextUpdated: this.handleEmailTextUpdated.bind(this),
            onPhoneNumberUpdated: this.handlePhoneNumberUpdated.bind(this),
            onContactDetailsSubmitted: this.handleContactDetailsSubmitted.bind(this),
            onIntakeComplete: this.handleIntakeComplete.bind(this)
          })
        }
      )
    );
    this.root.render(t);
  }
  /**
   * Create and dispatch a custom event
   */
  dispatchCustomEvent(t, n) {
    const r = new CustomEvent(t, {
      detail: n,
      bubbles: !0,
      composed: !0
      // Allows event to pass through shadow DOM boundary
    });
    this.dispatchEvent(r);
  }
  // Event handlers for the new event system
  handleLeadClickedIssueInput(t) {
    this.dispatchCustomEvent("leadClickedIssueInput", {
      isInitialLoad: t,
      isGenuineUserInteraction: !t,
      timestamp: (/* @__PURE__ */ new Date()).toISOString()
    });
  }
  handleIssueTextUpdated(t) {
    this.dispatchCustomEvent("issueTextUpdated", { text: t });
  }
  handleIssueSubmitted(t) {
    this.dispatchCustomEvent("issueSubmitted", { text: t });
  }
  handleJurisdictionTextUpdated(t) {
    this.dispatchCustomEvent("jurisdictionTextUpdated", { text: t });
  }
  handleJurisdictionSelectionChange(t) {
    this.dispatchCustomEvent("jurisdictionSelectionChange", { jurisdiction: t });
  }
  handleJurisdictionSelectionSubmitted(t) {
    this.dispatchCustomEvent("jurisdictionSelectionSubmitted", { jurisdiction: t });
  }
  handleNameTextUpdated(t) {
    this.dispatchCustomEvent("nameTextUpdated", { name: t });
  }
  handleEmailTextUpdated(t) {
    this.dispatchCustomEvent("emailTextUpdated", { email: t });
  }
  handlePhoneNumberUpdated(t) {
    this.dispatchCustomEvent("phoneNumberUpdated", { phoneNumber: t });
  }
  handleContactDetailsSubmitted(t) {
    this.dispatchCustomEvent("contactDetailsSubmitted", { contactData: t });
  }
  handleIntakeComplete(t, n) {
    this.dispatchCustomEvent("intakeComplete", { formData: t, apiResponse: n });
  }
  /**
   * Handle classification data updates.
   */
  handleClassificationData(t) {
    this.dispatchCustomEvent("classification-update", t);
  }
  /**
   * Handle form reset.
   */
  handleReset() {
    this.dispatchCustomEvent("form-reset", null);
  }
  /**
   * Set up event listeners for external communication.
   */
  setupEventListeners() {
    window.addEventListener("message", (t) => {
      if (t.data && t.data.target === "intake-form")
        switch (t.data.action) {
          case "reset":
            this.handleReset();
            break;
          case "update-config":
            this.config = { ...this.config, ...t.data.config }, this.renderComponent();
            break;
        }
    });
  }
}
customElements.define("intake-form", d1);
const f1 = {
  baseURL: "http://al-client-intake.test/api/v1"
};
ze.defaults.baseURL = f1.baseURL;
ze.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
ze.defaults.headers.common.Accept = "application/json";
ze.defaults.headers.common["Content-Type"] = "application/json";
ze.defaults.headers.common.Authorization = "Bearer 3|58SbcnDJYhta2J6IM1trLg5Qhb7QjUxdomOGEasq37b2f8ca";
ze.defaults.withCredentials = !0;
const p1 = "1.0.0";
function jm(e, t) {
  if (!e || !(e instanceof HTMLElement))
    throw new Error("Container must be a valid DOM element");
  const n = document.createElement("intake-form");
  if (t.apiUrl && (n.setAttribute("api-url", t.apiUrl), ze.defaults.baseURL = t.apiUrl), t.apiToken && (n.setAttribute("api-token", t.apiToken), ze.defaults.headers.common.Authorization = `Bearer ${t.apiToken}`), t.isDev && n.setAttribute("dev-mode", ""), t.theme && n.setAttribute("theme", t.theme), t.apiHeaders) {
    n.dataset.apiHeaders = JSON.stringify(t.apiHeaders);
    for (const [r, i] of Object.entries(t.apiHeaders))
      ze.defaults.headers.common[r] = i;
  }
  return e.appendChild(n), {
    reset: () => {
      window.postMessage({
        target: "intake-form",
        action: "reset"
      }, "*");
    },
    updateConfig: (r) => {
      if (window.postMessage({
        target: "intake-form",
        action: "update-config",
        config: r
      }, "*"), r.apiUrl && (n.setAttribute("api-url", r.apiUrl), ze.defaults.baseURL = r.apiUrl), r.apiToken && (n.setAttribute("api-token", r.apiToken), ze.defaults.headers.common.Authorization = `Bearer ${r.apiToken}`), r.isDev !== void 0 && (r.isDev ? n.setAttribute("dev-mode", "") : n.removeAttribute("dev-mode")), r.theme && n.setAttribute("theme", r.theme), r.apiHeaders) {
        n.dataset.apiHeaders = JSON.stringify(r.apiHeaders);
        for (const [i, o] of Object.entries(r.apiHeaders))
          ze.defaults.headers.common[i] = o;
      }
    },
    unmount: () => {
      e.removeChild(n);
    }
  };
}
const Lm = p1, O1 = {
  version: Lm,
  render: jm
};
typeof window < "u" && (window.IntakeFormWidget = {
  version: Lm,
  render: jm
});
export {
  d1 as IntakeFormElement,
  O1 as IntakeFormWidget,
  jm as render,
  Lm as version
};
